// compiled-operator:index.js
import * as React7 from "react";
import * as stylex2 from "@stylexjs/stylex";
import * as stylex from "@stylexjs/stylex";
import { jsx, jsxs } from "react/jsx-runtime";
import { jsx as jsx2 } from "react/jsx-runtime";
import { jsx as jsx3 } from "react/jsx-runtime";
import { jsx as jsx4 } from "react/jsx-runtime";
import * as stylex3 from "@stylexjs/stylex";
import { jsx as jsx5, jsxs as jsxs2 } from "react/jsx-runtime";
import * as stylex4 from "@stylexjs/stylex";
import { jsx as jsx6, jsxs as jsxs3 } from "react/jsx-runtime";
import * as stylex5 from "@stylexjs/stylex";
import { jsx as jsx7 } from "react/jsx-runtime";
import * as stylex8 from "@stylexjs/stylex";
import * as stylex6 from "@stylexjs/stylex";
import * as React27 from "react";
import * as React2 from "react";
import { jsx as jsx8 } from "react/jsx-runtime";
import * as React3 from "react";
import * as React26 from "react";
import * as React5 from "react";
import * as React4 from "react";
import * as React6 from "react";
import * as React22 from "react";
import * as React11 from "react";
import * as React9 from "react";
import * as React8 from "react";
import { jsx as jsx9 } from "react/jsx-runtime";
import * as React10 from "react";
import { jsx as jsx10 } from "react/jsx-runtime";
import * as React12 from "react";
import { jsx as jsx11 } from "react/jsx-runtime";
import * as React13 from "react";
import { jsx as jsx12 } from "react/jsx-runtime";
import * as React23 from "react";
import * as React14 from "react";
import * as React15 from "react";
import * as React24 from "react";
import * as React18 from "react";
import * as React16 from "react";
import { useState as useState72 } from "react";
import * as React17 from "react";
import * as React21 from "react";
import * as React20 from "react";
import * as React19 from "react";
import { Fragment as Fragment4, jsx as jsx13 } from "react/jsx-runtime";
import { jsx as jsx14 } from "react/jsx-runtime";
import { jsx as jsx15 } from "react/jsx-runtime";
import { Fragment as Fragment5, useSyncExternalStore } from "react";
import { jsx as jsx16, jsxs as jsxs4 } from "react/jsx-runtime";
import {
  createContext as createContext3,
  useContext as useContext3
} from "react";
import { useCallback as useCallback8, useEffect as useEffect13, useRef as useRef11, useState as useState10 } from "react";
import { Fragment as Fragment6 } from "react";
import * as stylex7 from "@stylexjs/stylex";
import { jsx as jsx17, jsxs as jsxs5, Fragment as Fragment7 } from "react/jsx-runtime";
import { jsx as jsx18, jsxs as jsxs6 } from "react/jsx-runtime";
import * as stylex9 from "@stylexjs/stylex";
import { jsx as jsx19, jsxs as jsxs7 } from "react/jsx-runtime";
import * as stylex10 from "@stylexjs/stylex";
import { jsx as jsx20, jsxs as jsxs8 } from "react/jsx-runtime";
import * as stylex11 from "@stylexjs/stylex";
import { jsx as jsx21, jsxs as jsxs9 } from "react/jsx-runtime";
import * as stylex13 from "@stylexjs/stylex";
import * as stylex12 from "@stylexjs/stylex";
import { jsx as jsx22, jsxs as jsxs10, Fragment as Fragment8 } from "react/jsx-runtime";
import { jsx as jsx23, jsxs as jsxs11 } from "react/jsx-runtime";
import * as stylex14 from "@stylexjs/stylex";
import { jsx as jsx24, jsxs as jsxs12 } from "react/jsx-runtime";
import * as stylex15 from "@stylexjs/stylex";
import { jsx as jsx25, jsxs as jsxs13 } from "react/jsx-runtime";
import { jsx as jsx26 } from "react/jsx-runtime";
import * as stylex16 from "@stylexjs/stylex";
import { jsx as jsx27, jsxs as jsxs14 } from "react/jsx-runtime";
import * as stylex17 from "@stylexjs/stylex";
import { jsx as jsx28, jsxs as jsxs15 } from "react/jsx-runtime";
import * as stylex18 from "@stylexjs/stylex";
import { jsx as jsx29, jsxs as jsxs16 } from "react/jsx-runtime";
import * as stylex19 from "@stylexjs/stylex";
import { jsx as jsx30, jsxs as jsxs17, Fragment as Fragment9 } from "react/jsx-runtime";
import * as stylex20 from "@stylexjs/stylex";
import { jsx as jsx31, jsxs as jsxs18, Fragment as Fragment10 } from "react/jsx-runtime";
import * as stylex21 from "@stylexjs/stylex";
import { jsx as jsx32, jsxs as jsxs19, Fragment as Fragment11 } from "react/jsx-runtime";
import { jsx as jsx33 } from "react/jsx-runtime";
import * as stylex24 from "@stylexjs/stylex";
import { useContext as useContext6, useEffect as useEffect14, useId as useId2, useRef as useRef12, useState as useState12 } from "react";
import { createContext as createContext4 } from "react";
import { jsx as jsx34, jsxs as jsxs20 } from "react/jsx-runtime";
import * as stylex22 from "@stylexjs/stylex";
import { useContext as useContext4 } from "react";
import { jsx as jsx35, jsxs as jsxs21 } from "react/jsx-runtime";
import { createElement as createElement6 } from "react";
import * as stylex23 from "@stylexjs/stylex";
import { useContext as useContext5, useState as useState11 } from "react";
import { jsx as jsx36, jsxs as jsxs22, Fragment as Fragment12 } from "react/jsx-runtime";
import { jsx as jsx37, jsxs as jsxs23, Fragment as Fragment13 } from "react/jsx-runtime";
import * as stylex36 from "@stylexjs/stylex";
import { useState as useState17 } from "react";
import * as stylex26 from "@stylexjs/stylex";
import * as stylex25 from "@stylexjs/stylex";
import { jsx as jsx38, jsxs as jsxs24 } from "react/jsx-runtime";
import { useContext as useContext8 } from "react";
import { useContext as useContext7 } from "react";
import { jsx as jsx39, Fragment as Fragment14 } from "react/jsx-runtime";
import { jsx as jsx40, jsxs as jsxs25 } from "react/jsx-runtime";
import { createElement as createElement7 } from "react";
import * as stylex27 from "@stylexjs/stylex";
import { jsx as jsx41, jsxs as jsxs26 } from "react/jsx-runtime";
import * as stylex28 from "@stylexjs/stylex";
import { useState as useState13 } from "react";
import { jsx as jsx42, jsxs as jsxs27 } from "react/jsx-runtime";
import * as stylex35 from "@stylexjs/stylex";
import { useContext as useContext11, useEffect as useEffect15, useRef as useRef13, useState as useState16 } from "react";
import * as stylex29 from "@stylexjs/stylex";
import { jsx as jsx43, jsxs as jsxs28 } from "react/jsx-runtime";
import * as stylex31 from "@stylexjs/stylex";
import { useContext as useContext9, useState as useState14 } from "react";
import * as stylex30 from "@stylexjs/stylex";
import { jsx as jsx44, jsxs as jsxs29 } from "react/jsx-runtime";
import { jsx as jsx45, jsxs as jsxs30, Fragment as Fragment15 } from "react/jsx-runtime";
import * as stylex32 from "@stylexjs/stylex";
import { useContext as useContext10, useState as useState15 } from "react";
import { jsx as jsx46, jsxs as jsxs31 } from "react/jsx-runtime";
import { createElement as createElement8 } from "react";
import * as stylex33 from "@stylexjs/stylex";
import { jsx as jsx47, jsxs as jsxs32, Fragment as Fragment16 } from "react/jsx-runtime";
import { createElement as createElement9 } from "react";
import * as stylex34 from "@stylexjs/stylex";
import { jsx as jsx48, jsxs as jsxs33 } from "react/jsx-runtime";
import { jsx as jsx49, jsxs as jsxs34, Fragment as Fragment17 } from "react/jsx-runtime";
import { createElement as createElement10 } from "react";
import { jsx as jsx50, jsxs as jsxs35 } from "react/jsx-runtime";
import { createElement as createElement11 } from "react";
var __create = Object.create;
var __getProtoOf = Object.getPrototypeOf;
var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
function __accessProp(key) {
  return this[key];
}
var __toESMCache_node;
var __toESMCache_esm;
var __toESM = (mod, isNodeMode, target) => {
  var canCache = mod != null && typeof mod === "object";
  if (canCache) {
    var cache = isNodeMode ? __toESMCache_node ??= new WeakMap : __toESMCache_esm ??= new WeakMap;
    var cached = cache.get(mod);
    if (cached)
      return cached;
  }
  target = mod != null ? __create(__getProtoOf(mod)) : {};
  const to = isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target;
  if (mod && typeof mod === "object" || typeof mod === "function") {
    for (let key of __getOwnPropNames(mod))
      if (!__hasOwnProp.call(to, key))
        __defProp(to, key, {
          get: __accessProp.bind(mod, key),
          enumerable: true
        });
  }
  if (canCache)
    cache.set(mod, to);
  return to;
};
var __commonJS = (cb, mod) => () => (mod || cb((mod = { exports: {} }).exports, mod), mod.exports);
var __returnValue = (v) => v;
function __exportSetter(name, newValue) {
  this[name] = __returnValue.bind(null, newValue);
}
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, {
      get: all[name],
      enumerable: true,
      configurable: true,
      set: __exportSetter.bind(all, name)
    });
};
var require_react_dom_development = __commonJS(function(exports) {
  (function() {
    function noop() {}
    function testStringCoercion(value) {
      return "" + value;
    }
    function createPortal$1(children, containerInfo, implementation) {
      var key = 3 < arguments.length && arguments[3] !== undefined ? arguments[3] : null;
      try {
        testStringCoercion(key);
        var JSCompiler_inline_result = false;
      } catch (e) {
        JSCompiler_inline_result = true;
      }
      JSCompiler_inline_result && (console.error("The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", typeof Symbol === "function" && Symbol.toStringTag && key[Symbol.toStringTag] || key.constructor.name || "Object"), testStringCoercion(key));
      return {
        $$typeof: REACT_PORTAL_TYPE,
        key: key == null ? null : "" + key,
        children,
        containerInfo,
        implementation
      };
    }
    function getCrossOriginStringAs(as, input) {
      if (as === "font")
        return "";
      if (typeof input === "string")
        return input === "use-credentials" ? input : "";
    }
    function getValueDescriptorExpectingObjectForWarning(thing) {
      return thing === null ? "`null`" : thing === undefined ? "`undefined`" : thing === "" ? "an empty string" : 'something with type "' + typeof thing + '"';
    }
    function getValueDescriptorExpectingEnumForWarning(thing) {
      return thing === null ? "`null`" : thing === undefined ? "`undefined`" : thing === "" ? "an empty string" : typeof thing === "string" ? JSON.stringify(thing) : typeof thing === "number" ? "`" + thing + "`" : 'something with type "' + typeof thing + '"';
    }
    function resolveDispatcher() {
      var dispatcher = ReactSharedInternals.H;
      dispatcher === null && console.error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return dispatcher;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Internals = {
      d: {
        f: noop,
        r: function() {
          throw Error("Invalid form element. requestFormReset must be passed a form that was rendered by React.");
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
      },
      p: 0,
      findDOMNode: null
    }, REACT_PORTAL_TYPE = Symbol.for("react.portal"), ReactSharedInternals = React7.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    typeof Map === "function" && Map.prototype != null && typeof Map.prototype.forEach === "function" && typeof Set === "function" && Set.prototype != null && typeof Set.prototype.clear === "function" && typeof Set.prototype.forEach === "function" || console.error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
    exports.createPortal = function(children, container) {
      var key = 2 < arguments.length && arguments[2] !== undefined ? arguments[2] : null;
      if (!container || container.nodeType !== 1 && container.nodeType !== 9 && container.nodeType !== 11)
        throw Error("Target container is not a DOM element.");
      return createPortal$1(children, container, null, key);
    };
    exports.flushSync = function(fn) {
      var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
      try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn)
          return fn();
      } finally {
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f() && console.error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
      }
    };
    exports.preconnect = function(href, options) {
      typeof href === "string" && href ? options != null && typeof options !== "object" ? console.error("ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.", getValueDescriptorExpectingEnumForWarning(options)) : options != null && typeof options.crossOrigin !== "string" && console.error("ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.", getValueDescriptorExpectingObjectForWarning(options.crossOrigin)) : console.error("ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
      typeof href === "string" && (options ? (options = options.crossOrigin, options = typeof options === "string" ? options === "use-credentials" ? options : "" : undefined) : options = null, Internals.d.C(href, options));
    };
    exports.prefetchDNS = function(href) {
      if (typeof href !== "string" || !href)
        console.error("ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
      else if (1 < arguments.length) {
        var options = arguments[1];
        typeof options === "object" && options.hasOwnProperty("crossOrigin") ? console.error("ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.", getValueDescriptorExpectingEnumForWarning(options)) : console.error("ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.", getValueDescriptorExpectingEnumForWarning(options));
      }
      typeof href === "string" && Internals.d.D(href);
    };
    exports.preinit = function(href, options) {
      typeof href === "string" && href ? options == null || typeof options !== "object" ? console.error("ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.", getValueDescriptorExpectingEnumForWarning(options)) : options.as !== "style" && options.as !== "script" && console.error('ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".', getValueDescriptorExpectingEnumForWarning(options.as)) : console.error("ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
      if (typeof href === "string" && options && typeof options.as === "string") {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = typeof options.integrity === "string" ? options.integrity : undefined, fetchPriority = typeof options.fetchPriority === "string" ? options.fetchPriority : undefined;
        as === "style" ? Internals.d.S(href, typeof options.precedence === "string" ? options.precedence : undefined, {
          crossOrigin,
          integrity,
          fetchPriority
        }) : as === "script" && Internals.d.X(href, {
          crossOrigin,
          integrity,
          fetchPriority,
          nonce: typeof options.nonce === "string" ? options.nonce : undefined
        });
      }
    };
    exports.preinitModule = function(href, options) {
      var encountered = "";
      typeof href === "string" && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
      options !== undefined && typeof options !== "object" ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : options && ("as" in options) && options.as !== "script" && (encountered += " The `as` option encountered was " + getValueDescriptorExpectingEnumForWarning(options.as) + ".");
      if (encountered)
        console.error("ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s", encountered);
      else
        switch (encountered = options && typeof options.as === "string" ? options.as : "script", encountered) {
          case "script":
            break;
          default:
            encountered = getValueDescriptorExpectingEnumForWarning(encountered), console.error('ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)', encountered, href);
        }
      if (typeof href === "string")
        if (typeof options === "object" && options !== null) {
          if (options.as == null || options.as === "script")
            encountered = getCrossOriginStringAs(options.as, options.crossOrigin), Internals.d.M(href, {
              crossOrigin: encountered,
              integrity: typeof options.integrity === "string" ? options.integrity : undefined,
              nonce: typeof options.nonce === "string" ? options.nonce : undefined
            });
        } else
          options == null && Internals.d.M(href);
    };
    exports.preload = function(href, options) {
      var encountered = "";
      typeof href === "string" && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
      options == null || typeof options !== "object" ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : typeof options.as === "string" && options.as || (encountered += " The `as` option encountered was " + getValueDescriptorExpectingObjectForWarning(options.as) + ".");
      encountered && console.error('ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s', encountered);
      if (typeof href === "string" && typeof options === "object" && options !== null && typeof options.as === "string") {
        encountered = options.as;
        var crossOrigin = getCrossOriginStringAs(encountered, options.crossOrigin);
        Internals.d.L(href, encountered, {
          crossOrigin,
          integrity: typeof options.integrity === "string" ? options.integrity : undefined,
          nonce: typeof options.nonce === "string" ? options.nonce : undefined,
          type: typeof options.type === "string" ? options.type : undefined,
          fetchPriority: typeof options.fetchPriority === "string" ? options.fetchPriority : undefined,
          referrerPolicy: typeof options.referrerPolicy === "string" ? options.referrerPolicy : undefined,
          imageSrcSet: typeof options.imageSrcSet === "string" ? options.imageSrcSet : undefined,
          imageSizes: typeof options.imageSizes === "string" ? options.imageSizes : undefined,
          media: typeof options.media === "string" ? options.media : undefined
        });
      }
    };
    exports.preloadModule = function(href, options) {
      var encountered = "";
      typeof href === "string" && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
      options !== undefined && typeof options !== "object" ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : options && ("as" in options) && typeof options.as !== "string" && (encountered += " The `as` option encountered was " + getValueDescriptorExpectingObjectForWarning(options.as) + ".");
      encountered && console.error('ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s', encountered);
      typeof href === "string" && (options ? (encountered = getCrossOriginStringAs(options.as, options.crossOrigin), Internals.d.m(href, {
        as: typeof options.as === "string" && options.as !== "script" ? options.as : undefined,
        crossOrigin: encountered,
        integrity: typeof options.integrity === "string" ? options.integrity : undefined
      })) : Internals.d.m(href));
    };
    exports.requestFormReset = function(form) {
      Internals.d.r(form);
    };
    exports.unstable_batchedUpdates = function(fn, a) {
      return fn(a);
    };
    exports.useFormState = function(action, initialState, permalink) {
      return resolveDispatcher().useFormState(action, initialState, permalink);
    };
    exports.useFormStatus = function() {
      return resolveDispatcher().useHostTransitionStatus();
    };
    exports.version = "19.2.7";
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })();
});
var require_react_dom = __commonJS(function(exports, module) {
  var react_dom_development = __toESM(require_react_dom_development());
  if (false) {} else {
    module.exports = react_dom_development;
  }
});
var disclosureStyles = {
  action: {
    kzqmXN: "x9redfm",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  primary: {
    kWkggS: "x15vqgvx",
    kVAM5u: "xawfzfr",
    kMwMTN: "x1um1dla",
    kInvED: "x1hl8ikr",
    $$css: true
  },
  link: {
    k1xSpc: "x78zum5 x1i5lizr",
    kGNEyG: "x6s0dn4",
    kH6xsr: "x3ct3a4",
    ks0D6T: "x193iq5w",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  trigger: {
    k1xSpc: "x1lliihq x1i5lizr",
    kzqmXN: "xeq5yr9",
    ks0D6T: "x193iq5w",
    kB7OPa: "x9f619",
    kAzted: "x2lwn1j x1c4ya5t",
    kmVPX3: "x1sbvpl4",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xmt0h0j",
    kaIpWk: "x1kogg8i",
    kWkggS: "x9kxhyz",
    kMwMTN: "x1myn341",
    kkrTdU: "x1ypdohk",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1k6wstc",
    k63SB2: "xo1l8bm",
    kLWn49: "xggjnk3",
    kb6lSQ: "x1vyo3qp",
    kH6xsr: "x3ct3a4",
    kHjlTd: "xj0a0fe",
    k1K539: "xat24cr xxfsjeb",
    kah6P1: "x1is36l8 x1461opg",
    km5ZXQ: "x1gz4iox",
    kMeerF: "x1k57tk5 x784prv",
    k3XXqK: "xaatb59",
    kjBf7l: "x1itw484",
    kInvED: "x2ssjo2",
    $$css: true
  }
};
function styledProps(props210, ...styles) {
  const css = stylex.props(...styles);
  return {
    ...props210,
    ...css,
    className: [props210.className, css.className].filter(Boolean).join(" ")
  };
}
var actionLayoutStyles = {
  group: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kGNEyG: "x6s0dn4",
    kOIVth: "x883omv",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  end: {
    kjj79g: "x13a6bvl",
    $$css: true
  },
  menu: {
    k1xSpc: "xrvj5dj",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1v2ro7d",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  link: {
    kMzoRj: "xc342km",
    kmVPX3: "x1717udv",
    kAzted: "x21xpn4 x1c4ya5t",
    kWkggS: "xjbqb8w",
    kMwMTN: "x1myn341",
    kMv6JI: "x5ddh9m",
    kGuDYH: "xfifm61",
    k63SB2: "x1s688f",
    kkrTdU: "x1ypdohk",
    k9WMMc: "x1yc453h",
    kdSwXR: "x1sur9pj",
    k3Woio: "x16dl9wz",
    kiEn40: "x7s97pk",
    kWCcOm: "xijokvz",
    kYPGJ8: "x1s07b3s",
    $$css: true
  }
};
function OperatorDisclosure(props37) {
  const {
    triggerLabel,
    presentation,
    triggerVariant,
    children,
    ...attributes
  } = props37;
  return /* @__PURE__ */ jsxs("details", {
    ...styledProps(attributes, presentation === "action" && disclosureStyles.action),
    children: [
      /* @__PURE__ */ jsx("summary", {
        ...stylex2.props((presentation === "action" || triggerVariant === "outline" || triggerVariant === "primary") && disclosureStyles.trigger, triggerVariant === "primary" && disclosureStyles.primary, triggerVariant === "link" && [actionLayoutStyles.link, disclosureStyles.link]),
        children: triggerLabel
      }),
      children
    ]
  });
}
var segmentedStyles = {
  group: {
    k1xSpc: "x3nfvp2 xvgho8r",
    kwnvtZ: "x1a02dak",
    kGNEyG: "x6s0dn4",
    kOIVth: "x195vfkc",
    k1K539: "x1u7kmwd",
    kmVPX3: "x9ms5i6",
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    kB7OPa: "x9f619",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h",
    kaIpWk: "xur7f20",
    kWkggS: "xfr4rvh",
    $$css: true
  },
  attention: {
    kMwMTN: "x1ra7g20 xzavvr5 x7bxtm6 x1vkqd3q",
    $$css: true
  },
  button: {
    kAzted: "xe0p6wg x1c4ya5t",
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    kmVPX3: "xhwt3jn",
    kMzoRj: "xc342km",
    kaIpWk: "x1kogg8i",
    kWkggS: "xjbqb8w xxhr8im",
    kMwMTN: "x1ar3pfp x18m2ztq x19ix0zw x2y8ynj",
    k63SB2: "xo1l8bm xxdvuf2",
    kkrTdU: "x1ypdohk",
    kMv6JI: "x5ddh9m",
    kGuDYH: "xfifm61",
    kHjlTd: "xj0a0fe",
    khDVqt: "xeaf4i8",
    kMeerF: "x1k57tk5 x784prv",
    k3XXqK: "xaatb59",
    kjBf7l: "x1itw484",
    kInvED: "x2ssjo2",
    k1xSpc: "x1rg5ohu xvgho8r",
    $$css: true
  }
};
function OperatorSegmentedGroup(props37) {
  return /* @__PURE__ */ jsx2("div", {
    ...styledProps(props37, segmentedStyles.group)
  });
}
function OperatorSegmentedButton(props37) {
  const { emphasis, ...attributes } = props37;
  return /* @__PURE__ */ jsx2("button", {
    type: "button",
    ...styledProps(attributes, segmentedStyles.button, emphasis === "attention" && segmentedStyles.attention)
  });
}
var tabStripStyles = {
  list: {
    k1xSpc: "x78zum5",
    kOIVth: "x1665zp3 x1tdawcz",
    k1K539: "xieb3on",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xpqg30t",
    kGO01o: "x1120s5i",
    k7Eaqz: "xeuugli",
    kXHlph: "xw2csxc",
    kwDfHU: "x1pqk8vl",
    k5wCbM: "x1rohswg",
    kOuLrU: "xfk6m8",
    $$css: true
  },
  button: {
    k1xSpc: "x3nfvp2",
    kGNEyG: "x1pha0wt",
    kOIVth: "x167g77z",
    kmuXW: "x2lah0s",
    k1K539: "x1jyxor1",
    kLKAdn: "x1nn3v0j",
    kpe85a: "x1xpa7k",
    kGO01o: "x1a8lsjc",
    kE3dHu: "x1uhho1l",
    kAzted: "x2lwn1j x1c4ya5t",
    kEafiO: "x972fbf",
    kWqL5O: "xgfja2r",
    kZ1KPB: "xyj58a3",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "x16stqrj x1xiyr0g",
    kWkggS: "xjbqb8w",
    kMwMTN: "x1v3krkk xhwcb5i xkfincm xivsve2",
    kkrTdU: "x1ypdohk",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1s31vzs",
    k63SB2: "xk50ysn",
    kb6lSQ: "xribhvm",
    kP9fke: "xtvhhri",
    k1ekBW: "xrf8owv",
    kIyJzY: "x13dflua x12w9bfk",
    kAMwcw: "xwji4o3",
    k3XXqK: "x1t137rt x9v5kkp",
    kMeerF: "x1de99jn",
    kInvED: "x2ssjo2",
    kjBf7l: "x1itw484",
    $$css: true
  },
  count: {
    kMwMTN: "x1ar3pfp x1lza6gs",
    kGuDYH: "x1k6wstc",
    kcqcaj: "xss6m8b",
    kb6lSQ: "x1vyo3qp",
    $$css: true
  }
};
function OperatorTabStrip(props37) {
  return /* @__PURE__ */ jsx3("div", {
    role: "tablist",
    ...styledProps(props37, tabStripStyles.list)
  });
}
function OperatorTabButton(props37) {
  return /* @__PURE__ */ jsx3("button", {
    type: "button",
    role: "tab",
    ...styledProps(props37, {
      "x-default-marker": "x-default-marker",
      $$css: true
    }, tabStripStyles.button)
  });
}
function OperatorTabCount(props37) {
  return /* @__PURE__ */ jsx3("span", {
    ...styledProps(props37, tabStripStyles.count)
  });
}
var choiceStyles = {
  group: {
    k1xSpc: "x78zum5 xvgho8r",
    kwnvtZ: "x1a02dak",
    kOIVth: "x167g77z",
    k1K539: "x1u7kmwd",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  compactGroup: {
    k1K539: "xod5an3",
    $$css: true
  },
  button: {
    k1xSpc: "x3nfvp2 xvgho8r",
    kGNEyG: "x6s0dn4",
    kOIVth: "x17d4w8g",
    kLKAdn: "x123j3cw",
    kpe85a: "xcicffo",
    kGO01o: "xs9asl8",
    kE3dHu: "x1lqa7cf",
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    kAzted: "x2lwn1j x1c4ya5t",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h x1jokge8 x19a6ijj",
    kaIpWk: "x1xwekrv",
    kWkggS: "xjbqb8w xuvuc2f x1x89ub9 x156vuz7",
    kMwMTN: "x1v3krkk x18m2ztq xa4mcpc",
    kkrTdU: "x1ypdohk",
    kMv6JI: "xa9opjo",
    kGuDYH: "xfmn3hh",
    kb6lSQ: "x9pfba7",
    kP9fke: "xtvhhri",
    k1ekBW: "x1eaenvl",
    kIyJzY: "xx6bhzk x12w9bfk",
    kAMwcw: "xwji4o3",
    $$css: true
  },
  compactButton: {
    kE3dHu: "x163pfp",
    kpe85a: "xy13l1i",
    $$css: true
  },
  label: {
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    kMwMTN: "x1ar3pfp x1ezoiy0",
    $$css: true
  },
  count: {
    kMwMTN: "xqvuw85",
    kGuDYH: "x1j6dyjg",
    kcqcaj: "xss6m8b",
    kmuXW: "x2lah0s",
    $$css: true
  },
  attention: {
    kMwMTN: "x1ra7g20",
    $$css: true
  },
  tools: {
    k1xSpc: "x78zum5 xvgho8r",
    kGNEyG: "x6s0dn4 xmrrqfi x1o3peri",
    kXwgrk: "x1q0g3np xlrawni x17cst73",
    kOIVth: "x883omv",
    k1K539: "xyorhqc",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  search: {
    kzqmXN: "xvi13v7 x1amo615 x1dbdljh",
    k7Eaqz: "xeuugli",
    kAzted: "x2lwn1j x1c4ya5t",
    kB7OPa: "x9f619",
    kmVPX3: "x2lkgqm",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h xbghsdc",
    kaIpWk: "x12oqio5",
    kWkggS: "xgwc49v",
    kMwMTN: "xqvuw85",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1j6dyjg",
    k8Qsv1: "x3lbmcd",
    $$css: true
  },
  toggle: {
    kmVPX3: "xokocfn",
    kMzoRj: "xc342km",
    kWkggS: "xjbqb8w",
    kMwMTN: "x1ar3pfp x18m2ztq",
    kkrTdU: "x1ypdohk",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1k6wstc",
    kb6lSQ: "x1dgsrnt",
    kP9fke: "xtvhhri",
    kAzted: "x2lwn1j x1c4ya5t",
    kSGwAc: "x1oa3qoh x1uk5d4i x1ryrld4",
    $$css: true
  },
  focus: {
    k3XXqK: "x1t137rt x9v5kkp",
    kMeerF: "x1de99jn",
    kInvED: "x2ssjo2",
    kjBf7l: "x1itw484",
    $$css: true
  }
};
function OperatorChoiceGroup(props37) {
  const {
    compact,
    ...attributes
  } = props37;
  return /* @__PURE__ */ jsx4("div", {
    ...styledProps(attributes, choiceStyles.group, compact && choiceStyles.compactGroup)
  });
}
function OperatorChoiceButton(props37) {
  const {
    compact,
    ...attributes
  } = props37;
  return /* @__PURE__ */ jsx4("button", {
    type: "button",
    ...styledProps(attributes, {
      "x-default-marker": "x-default-marker",
      $$css: true
    }, choiceStyles.button, compact && choiceStyles.compactButton, choiceStyles.focus)
  });
}
function OperatorChoiceLabel(props37) {
  return /* @__PURE__ */ jsx4("span", {
    ...styledProps(props37, choiceStyles.label)
  });
}
function OperatorChoiceCount(props37) {
  const {
    attention,
    ...attributes
  } = props37;
  return /* @__PURE__ */ jsx4("span", {
    ...styledProps(attributes, choiceStyles.count, attention && choiceStyles.attention)
  });
}
function OperatorChoiceTools(props37) {
  return /* @__PURE__ */ jsx4("div", {
    ...styledProps(props37, choiceStyles.tools)
  });
}
function OperatorChoiceSearch(props37) {
  return /* @__PURE__ */ jsx4("input", {
    type: "search",
    autoComplete: "off",
    ...styledProps(props37, choiceStyles.search, choiceStyles.focus)
  });
}
function OperatorChoiceToggle(props37) {
  return /* @__PURE__ */ jsx4("button", {
    type: "button",
    ...styledProps(props37, choiceStyles.toggle, choiceStyles.focus)
  });
}
var actionLinkStyles = {
  group: {
    k1xSpc: "x78zum5 xvgho8r",
    kwnvtZ: "x1a02dak",
    kGNEyG: "x6s0dn4",
    kOIVth: "x167g77z",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  link: {
    k1xSpc: "x3nfvp2 xvgho8r",
    kGNEyG: "x6s0dn4",
    kjj79g: "x1qughib",
    kOIVth: "x1af02g3",
    kB7OPa: "x9f619",
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    kAzted: "xu0aao5 x1c4ya5t",
    kmVPX3: "x1q773pt",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h x1jokge8",
    kaIpWk: "x1kogg8i",
    kWkggS: "xjbqb8w xuvuc2f",
    kMwMTN: "xgi1xjn x1711cle",
    kMv6JI: "xa9opjo",
    kGuDYH: "xfmn3hh",
    kb6lSQ: "x1vyo3qp",
    kybGjl: "x1hl2dhg",
    k1ekBW: "x163lptb",
    kIyJzY: "xx6bhzk x12w9bfk",
    kAMwcw: "xwji4o3",
    k3XXqK: "x1t137rt x9v5kkp",
    kMeerF: "x1de99jn",
    kjBf7l: "x1itw484",
    kInvED: "x2ssjo2",
    $$css: true
  },
  primary: {
    kVAM5u: "xmt0h0j",
    kWkggS: "x9kxhyz",
    kMwMTN: "x1myn341",
    $$css: true
  },
  label: {
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  indicator: {
    kmuXW: "x2lah0s",
    kMwMTN: "x1myn341",
    k3aq6I: "x1c071of xozkggm",
    k1ekBW: "x11xpdln",
    kIyJzY: "xx6bhzk x12w9bfk",
    kAMwcw: "xwji4o3",
    $$css: true
  }
};
function OperatorActionLinks(props42) {
  return /* @__PURE__ */ jsx5("nav", {
    ...styledProps(props42, actionLinkStyles.group)
  });
}
function OperatorActionLink(props42) {
  const {
    emphasis = "secondary",
    indicator,
    children,
    ...attributes
  } = props42;
  return /* @__PURE__ */ jsxs2("a", {
    ...styledProps(attributes, {
      "x-default-marker": "x-default-marker",
      $$css: true
    }, actionLinkStyles.link, emphasis === "primary" && actionLinkStyles.primary),
    children: [
      /* @__PURE__ */ jsx5("span", {
        ...stylex3.props(actionLinkStyles.label),
        children
      }),
      indicator !== undefined && indicator !== null && indicator !== false && /* @__PURE__ */ jsx5("span", {
        ...stylex3.props(actionLinkStyles.indicator),
        "data-action-indicator": true,
        "aria-hidden": "true",
        children: indicator
      })
    ]
  });
}
var summaryListStyles = {
  list: {
    kB88ic: "xe8uvvx",
    kmVPX3: "x1717udv",
    kogj98: "x1ghz6dp",
    k1xSpc: "x78zum5 xvgho8r",
    kXwgrk: "xdt5ytf",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  item: {
    k1xSpc: "xrvj5dj xvgho8r",
    kumcoG: "x1jxfsdd",
    kOIVth: "xou54vl x1d3ddqg",
    kGNEyG: "x1pha0wt",
    kLKAdn: "xz9dl7a x2egep",
    kGO01o: "xsag5q8 xu4eg61",
    kE3dHu: "x6wrskw",
    kpe85a: "xmzs88n",
    k7Eaqz: "xeuugli",
    kEafiO: "x178xt8z x1g31smg",
    kPef9Z: "x13fuv20",
    kLZC3w: "xvg7k2t",
    kWkggS: "xjbqb8w xuvuc2f",
    k1ekBW: "x15406qy",
    kIyJzY: "xx6bhzk x12w9bfk",
    kAMwcw: "xwji4o3",
    $$css: true
  },
  copy: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1jnr06f",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  heading: {
    kMv6JI: "x5ddh9m",
    kGuDYH: "x1j61zf2",
    k63SB2: "xk50ysn",
    kLWn49: "x1xfvgam",
    kMwMTN: "xqvuw85",
    khDVqt: "xuxw1ft x1uv6r69 x1i1s3md",
    kVQacm: "xb3r6kr",
    kg5iWk: "xlyipyv",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  description: {
    kGuDYH: "xfifm61",
    kMwMTN: "xgi1xjn",
    kLWn49: "xfrs9s4",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  metadata: {
    kMv6JI: "xa9opjo",
    kGuDYH: "x1j6dyjg",
    kb6lSQ: "x1vyo3qp",
    kMwMTN: "x1ar3pfp",
    keoZOQ: "x7r5mf7",
    kcqcaj: "xss6m8b",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  separator: {
    kMwMTN: "x1v3krkk",
    koQZXg: "x16vho4v",
    km5ZXQ: "x15ku74s",
    $$css: true
  },
  tags: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "x1jnr06f",
    keoZOQ: "xr9ek0c",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  tag: {
    kMv6JI: "xa9opjo",
    kGuDYH: "xfmn3hh",
    kb6lSQ: "x1dor1uw",
    kP9fke: "x1kyqaxf",
    kMwMTN: "x1ar3pfp",
    kmVPX3: "xpzpvjg",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h",
    kaIpWk: "x1xwekrv",
    ks0D6T: "x193iq5w",
    k7Eaqz: "xeuugli",
    kB7OPa: "x9f619",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  trailing: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kGNEyG: "x6s0dn4",
    kOIVth: "x17d4w8g",
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    kSGwAc: "x1oa3qoh x1uk5d4i x1ryrld4",
    $$css: true
  }
};
function OperatorSummaryList(props52) {
  return /* @__PURE__ */ jsx6("ul", {
    ...styledProps(props52, summaryListStyles.list)
  });
}
function OperatorSummaryItem(props52) {
  const {
    heading,
    description,
    metadata,
    tags,
    trailing,
    ...attributes
  } = props52;
  return /* @__PURE__ */ jsxs3("li", {
    ...styledProps(attributes, summaryListStyles.item),
    children: [
      /* @__PURE__ */ jsxs3("div", {
        ...stylex4.props(summaryListStyles.copy),
        "data-summary-copy": true,
        children: [
          /* @__PURE__ */ jsx6("span", {
            ...stylex4.props(summaryListStyles.heading),
            "data-summary-heading": true,
            title: typeof heading === "string" ? heading : undefined,
            children: heading
          }),
          description !== undefined && description !== null && description !== false && /* @__PURE__ */ jsx6("span", {
            ...stylex4.props(summaryListStyles.description),
            "data-summary-description": true,
            children: description
          }),
          metadata,
          tags
        ]
      }),
      trailing !== undefined && trailing !== null && trailing !== false && /* @__PURE__ */ jsx6("div", {
        ...stylex4.props(summaryListStyles.trailing),
        "data-summary-trailing": true,
        children: trailing
      })
    ]
  });
}
function OperatorSummaryMetadata(props52) {
  return /* @__PURE__ */ jsx6("span", {
    ...styledProps(props52, summaryListStyles.metadata)
  });
}
function OperatorSummarySeparator(props52) {
  return /* @__PURE__ */ jsx6("span", {
    ...styledProps(props52, summaryListStyles.separator)
  });
}
function OperatorSummaryTags(props52) {
  return /* @__PURE__ */ jsx6("div", {
    ...styledProps(props52, summaryListStyles.tags)
  });
}
function OperatorSummaryTag(props52) {
  return /* @__PURE__ */ jsx6("span", {
    ...styledProps(props52, summaryListStyles.tag)
  });
}
var documentStyles = {
  application: {
    kZKoxP: "x5yr21d",
    k1xSpc: "x78zum5 x1h1zc6f",
    kXwgrk: "xdt5ytf",
    kWkggS: "x1dd94t5",
    kY2c9j: "xgyh6op",
    kSiTet: "x1dd49dr x8z062v",
    k9M9Na: "x1cg4o4v x1ubcw10",
    kKwaWg: "x16luk3d",
    $$css: true
  },
  mount: {
    kUk6DE: "x98rzlu",
    kAzted: "x2lwn1j",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    $$css: true
  },
  boot: {
    kMv6JI: "xa9opjo",
    kGuDYH: "xfifm61",
    kb6lSQ: "x1labic3",
    kP9fke: "xtvhhri",
    kMwMTN: "x1ar3pfp",
    kmVPX3: "x1o8uwn5",
    $$css: true
  },
  body: {
    kAzted: "x1us19tq",
    ks0D6T: "x193iq5w",
    kogj98: "x1ghz6dp",
    kmVPX3: "x1717udv",
    kB7OPa: "x9f619",
    kMv6JI: "x5ddh9m",
    kGuDYH: "xif65rj",
    kLWn49: "x1evy7pa",
    kWkggS: "xec3sqm",
    kMwMTN: "xqvuw85",
    khiITx: "xvmahel",
    kXHlph: "x101abm8",
    kVAEAm: "x1n2onr6 x1g2j9el x1fjj3yw",
    kah6P1: "x1cpjm7i x1s928wv",
    kpwlN0: "xxx281p xarstr8",
    kfzvcC: "xkk1bqk x2q1x1w",
    kY2c9j: "x2hztxu x1r0yslu",
    kSiTet: "x1ifdjg0 x37q5d8 x1y5f1pj xnyr4az",
    k9M9Na: "xan9qf5 xesi0um",
    kKwaWg: "x139fdmx x1c3dc77 x1f1btj5",
    $$css: true
  }
};
function operatorApplicationDocumentClasses() {
  return {
    body: stylex5.props(documentStyles.body, documentStyles.application).className ?? "",
    mount: stylex5.props(documentStyles.mount).className ?? "",
    boot: stylex5.props(documentStyles.boot).className ?? ""
  };
}
function OperatorDocumentBody(props62) {
  return /* @__PURE__ */ jsx7("body", {
    ...styledProps(props62, documentStyles.body)
  });
}
var exports_dist2 = {};
__export(exports_dist2, {
  Action: () => Action,
  AlertDialog: () => AlertDialog,
  AlertDialogAction: () => AlertDialogAction,
  AlertDialogCancel: () => AlertDialogCancel,
  AlertDialogContent: () => AlertDialogContent,
  AlertDialogDescription: () => AlertDialogDescription,
  AlertDialogOverlay: () => AlertDialogOverlay,
  AlertDialogPortal: () => AlertDialogPortal,
  AlertDialogTitle: () => AlertDialogTitle,
  AlertDialogTrigger: () => AlertDialogTrigger,
  Cancel: () => Cancel,
  Content: () => Content2,
  Description: () => Description2,
  Overlay: () => Overlay2,
  Portal: () => Portal2,
  Root: () => Root2,
  Title: () => Title2,
  Trigger: () => Trigger2,
  createAlertDialogScope: () => createAlertDialogScope
});
function createContextScope(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function createContext32(rootComponentName, defaultContext) {
    const BaseContext = React2.createContext(defaultContext);
    BaseContext.displayName = rootComponentName + "Context";
    const index = defaultContexts.length;
    defaultContexts = [...defaultContexts, defaultContext];
    const Provider = (props62) => {
      const { scope, children, ...context } = props62;
      const Context = scope?.[scopeName]?.[index] || BaseContext;
      const value = React2.useMemo(() => context, Object.values(context));
      return /* @__PURE__ */ jsx8(Context.Provider, { value, children });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext22(consumerName, scope, options = {}) {
      const { optional = false } = options;
      const Context = scope?.[scopeName]?.[index] || BaseContext;
      const context = React2.useContext(Context);
      if (context)
        return context;
      if (defaultContext !== undefined)
        return defaultContext;
      if (optional)
        return;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [Provider, useContext22];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return React2.createContext(defaultContext);
    });
    return function useScope(scope) {
      const contexts = scope?.[scopeName] || scopeContexts;
      return React2.useMemo(() => ({ [`__scope${scopeName}`]: { ...scope, [scopeName]: contexts } }), [scope, contexts]);
    };
  };
  createScope.scopeName = scopeName;
  return [createContext32, composeContextScopes(createScope, ...createContextScopeDeps)];
}
function composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1)
    return baseScope;
  const createScope = () => {
    const scopeHooks = scopes.map((createScope2) => ({
      useScope: createScope2(),
      scopeName: createScope2.scopeName
    }));
    return function useComposedScopes(overrideScopes) {
      const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return { ...nextScopes2, ...currentScope };
      }, {});
      return React2.useMemo(() => ({ [`__scope${baseScope.scopeName}`]: nextScopes }), [nextScopes]);
    };
  };
  createScope.scopeName = baseScope.scopeName;
  return createScope;
}
function setRef(ref, value) {
  if (typeof ref === "function") {
    return ref(value);
  } else if (ref !== null && ref !== undefined) {
    ref.current = value;
  }
}
function composeRefs(...refs) {
  return (node) => {
    let hasCleanup = false;
    const cleanups = refs.map((ref) => {
      const cleanup = setRef(ref, node);
      if (!hasCleanup && typeof cleanup == "function") {
        hasCleanup = true;
      }
      return cleanup;
    });
    if (hasCleanup) {
      return () => {
        for (let i = 0;i < cleanups.length; i++) {
          const cleanup = cleanups[i];
          if (typeof cleanup == "function") {
            cleanup();
          } else {
            setRef(refs[i], null);
          }
        }
      };
    }
  };
}
function useComposedRefs(...refs) {
  return React3.useCallback(composeRefs(...refs), refs);
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function composeEventHandlers(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler?.(event);
    if (checkForDefaultPrevented === false || !event || !event.defaultPrevented) {
      return ourEventHandler?.(event);
    }
  };
}
var useLayoutEffect22 = globalThis?.document ? React4.useLayoutEffect : () => {};
var useReactId = React5[" useId ".trim().toString()] || (() => {
  return;
});
var count = 0;
function useId(deterministicId) {
  const [id, setId] = React5.useState(useReactId());
  useLayoutEffect22(() => {
    if (!deterministicId)
      setId((reactId) => reactId ?? String(count++));
  }, [deterministicId]);
  return deterministicId || (id ? `radix-${id}` : "");
}
var useInsertionEffect = React6[" useInsertionEffect ".trim().toString()] || useLayoutEffect22;
function useControllableState({
  prop,
  defaultProp,
  onChange = () => {},
  caller
}) {
  const [uncontrolledProp, setUncontrolledProp, onChangeRef] = useUncontrolledState({
    defaultProp,
    onChange
  });
  const isControlled = prop !== undefined;
  const value = isControlled ? prop : uncontrolledProp;
  if (true) {
    const isControlledRef = React6.useRef(prop !== undefined);
    React6.useEffect(() => {
      const wasControlled = isControlledRef.current;
      if (wasControlled !== isControlled) {
        const from = wasControlled ? "controlled" : "uncontrolled";
        const to = isControlled ? "controlled" : "uncontrolled";
        console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
      }
      isControlledRef.current = isControlled;
    }, [isControlled, caller]);
  }
  const setValue = React6.useCallback((nextValue) => {
    if (isControlled) {
      const value2 = isFunction(nextValue) ? nextValue(prop) : nextValue;
      if (value2 !== prop) {
        onChangeRef.current?.(value2);
      }
    } else {
      setUncontrolledProp(nextValue);
    }
  }, [isControlled, prop, setUncontrolledProp, onChangeRef]);
  return [value, setValue];
}
function useUncontrolledState({
  defaultProp,
  onChange
}) {
  const [value, setValue] = React6.useState(defaultProp);
  const prevValueRef = React6.useRef(value);
  const onChangeRef = React6.useRef(onChange);
  useInsertionEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);
  React6.useEffect(() => {
    if (prevValueRef.current !== value) {
      onChangeRef.current?.(value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef]);
  return [value, setValue, onChangeRef];
}
function isFunction(value) {
  return typeof value === "function";
}
var SYNC_STATE = Symbol("RADIX:SYNC_STATE");
var ReactDOM = __toESM(require_react_dom(), 1);
var exports_dist = {};
__export(exports_dist, {
  Root: () => Slot,
  Slot: () => Slot,
  Slottable: () => Slottable,
  createSlot: () => createSlot,
  createSlottable: () => createSlottable
});
function createSlot(ownerName) {
  const Slot2 = React8.forwardRef((props62, forwardedRef) => {
    let { children, ...slotProps } = props62;
    let slottableElement = null;
    let hasSlottable = false;
    const newChildren = [];
    if (isLazyComponent(children) && typeof use === "function") {
      children = use(children._payload);
    }
    React8.Children.forEach(children, (maybeSlottable) => {
      if (isSlottable(maybeSlottable)) {
        hasSlottable = true;
        const slottable = maybeSlottable;
        let child = "child" in slottable.props ? slottable.props.child : slottable.props.children;
        if (isLazyComponent(child) && typeof use === "function") {
          child = use(child._payload);
        }
        slottableElement = getSlottableElementFromSlottable(slottable, child);
        newChildren.push(slottableElement?.props?.children);
      } else {
        newChildren.push(maybeSlottable);
      }
    });
    if (slottableElement) {
      slottableElement = React8.cloneElement(slottableElement, undefined, newChildren);
    } else if (!hasSlottable && React8.Children.count(children) === 1 && React8.isValidElement(children)) {
      slottableElement = children;
    }
    const slottableElementRef = slottableElement ? getElementRef(slottableElement) : undefined;
    const composedRef = useComposedRefs(forwardedRef, slottableElementRef);
    if (!slottableElement) {
      if (children || children === 0) {
        throw new Error(hasSlottable ? createSlottableError(ownerName) : createSlotError(ownerName));
      }
      return children;
    }
    const mergedProps = mergeProps(slotProps, slottableElement.props ?? {});
    if (slottableElement.type !== React8.Fragment) {
      mergedProps.ref = forwardedRef ? composedRef : slottableElementRef;
    }
    return React8.cloneElement(slottableElement, mergedProps);
  });
  Slot2.displayName = `${ownerName}.Slot`;
  return Slot2;
}
var Slot = /* @__PURE__ */ createSlot("Slot");
var SLOTTABLE_IDENTIFIER = Symbol.for("radix.slottable");
function createSlottable(ownerName) {
  const Slottable2 = (props62) => ("child" in props62) ? props62.children(props62.child) : props62.children;
  Slottable2.displayName = `${ownerName}.Slottable`;
  Slottable2.__radixId = SLOTTABLE_IDENTIFIER;
  return Slottable2;
}
var Slottable = /* @__PURE__ */ createSlottable("Slottable");
var getSlottableElementFromSlottable = (slottable, child) => {
  if ("child" in slottable.props) {
    const child2 = slottable.props.child;
    if (!React8.isValidElement(child2))
      return null;
    return React8.cloneElement(child2, undefined, slottable.props.children(child2.props.children));
  }
  return React8.isValidElement(child) ? child : null;
};
function mergeProps(slotProps, childProps) {
  const overrideProps = { ...childProps };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = (...args) => {
          const result = childPropValue(...args);
          slotPropValue(...args);
          return result;
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === "style") {
      overrideProps[propName] = { ...slotPropValue, ...childPropValue };
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  }
  return { ...slotProps, ...overrideProps };
}
function getElementRef(element) {
  let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
function isSlottable(child) {
  return React8.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === SLOTTABLE_IDENTIFIER;
}
var REACT_LAZY_TYPE = Symbol.for("react.lazy");
function isLazyComponent(element) {
  return element != null && typeof element === "object" && "$$typeof" in element && element.$$typeof === REACT_LAZY_TYPE && "_payload" in element && isPromiseLike(element._payload);
}
function isPromiseLike(value) {
  return typeof value === "object" && value !== null && "then" in value;
}
var createSlotError = (ownerName) => {
  return `${ownerName} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`;
};
var createSlottableError = (ownerName) => {
  return `${ownerName} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`;
};
var use = React8[" use ".trim().toString()];
var NODES = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
];
var Primitive = NODES.reduce((primitive, node) => {
  const Slot2 = createSlot(`Primitive.${node}`);
  const Node2 = React9.forwardRef((props62, forwardedRef) => {
    const { asChild, ...primitiveProps } = props62;
    const Comp = asChild ? Slot2 : node;
    if (typeof window !== "undefined") {
      window[Symbol.for("radix-ui")] = true;
    }
    return /* @__PURE__ */ jsx9(Comp, { ...primitiveProps, ref: forwardedRef });
  });
  Node2.displayName = `Primitive.${node}`;
  return { ...primitive, [node]: Node2 };
}, {});
function dispatchDiscreteCustomEvent(target, event) {
  if (target)
    ReactDOM.flushSync(() => target.dispatchEvent(event));
}
function useCallbackRef(callback) {
  const callbackRef = React10.useRef(callback);
  React10.useEffect(() => {
    callbackRef.current = callback;
  });
  return React10.useMemo(() => (...args) => callbackRef.current?.(...args), []);
}
var DISMISSABLE_LAYER_NAME = "DismissableLayer";
var CONTEXT_UPDATE = "dismissableLayer.update";
var POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var originalBodyPointerEvents;
var DismissableLayerContext = React11.createContext({
  layers: /* @__PURE__ */ new Set,
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set,
  branches: /* @__PURE__ */ new Set,
  dismissableSurfaces: /* @__PURE__ */ new Set
});
var DismissableLayer = React11.forwardRef((props62, forwardedRef) => {
  const {
    disableOutsidePointerEvents = false,
    deferPointerDownOutside = false,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside,
    onInteractOutside,
    onDismiss,
    ...layerProps
  } = props62;
  const context = React11.useContext(DismissableLayerContext);
  const [node, setNode] = React11.useState(null);
  const ownerDocument = node?.ownerDocument ?? globalThis?.document;
  const [, force] = React11.useState({});
  const composedRefs = useComposedRefs(forwardedRef, setNode);
  const layers = Array.from(context.layers);
  const [highestLayerWithOutsidePointerEventsDisabled] = [
    ...context.layersWithOutsidePointerEventsDisabled
  ].slice(-1);
  const highestLayerWithOutsidePointerEventsDisabledIndex = highestLayerWithOutsidePointerEventsDisabled ? layers.indexOf(highestLayerWithOutsidePointerEventsDisabled) : -1;
  const index = node ? layers.indexOf(node) : -1;
  const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
  const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
  const isDeferredPointerDownOutsideRef = React11.useRef(false);
  const pointerDownOutside = usePointerDownOutside((event) => {
    onPointerDownOutside?.(event);
    onInteractOutside?.(event);
    if (!event.defaultPrevented)
      onDismiss?.();
  }, {
    ownerDocument,
    deferPointerDownOutside,
    isDeferredPointerDownOutsideRef,
    dismissableSurfaces: context.dismissableSurfaces,
    shouldHandlePointerDownOutside: React11.useCallback((target) => {
      if (!(target instanceof Node)) {
        return false;
      }
      const isPointerDownOnBranch = [...context.branches].some((branch) => branch.contains(target));
      return isPointerEventsEnabled && !isPointerDownOnBranch;
    }, [context.branches, isPointerEventsEnabled])
  });
  const focusOutside = useFocusOutside((event) => {
    if (deferPointerDownOutside && isDeferredPointerDownOutsideRef.current) {
      return;
    }
    const target = event.target;
    const isFocusInBranch = [...context.branches].some((branch) => branch.contains(target));
    if (isFocusInBranch)
      return;
    onFocusOutside?.(event);
    onInteractOutside?.(event);
    if (!event.defaultPrevented)
      onDismiss?.();
  }, ownerDocument);
  const isHighestLayer = node ? index === layers.length - 1 : false;
  const handleKeyDown = useCallbackRef((event) => {
    if (event.key !== "Escape") {
      return;
    }
    onEscapeKeyDown?.(event);
    if (!event.defaultPrevented && onDismiss) {
      event.preventDefault();
      onDismiss();
    }
  });
  React11.useEffect(() => {
    if (!isHighestLayer) {
      return;
    }
    ownerDocument.addEventListener("keydown", handleKeyDown, { capture: true });
    return () => ownerDocument.removeEventListener("keydown", handleKeyDown, { capture: true });
  }, [ownerDocument, isHighestLayer, handleKeyDown]);
  React11.useEffect(() => {
    if (!node)
      return;
    if (disableOutsidePointerEvents) {
      if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
        originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
        ownerDocument.body.style.pointerEvents = "none";
      }
      context.layersWithOutsidePointerEventsDisabled.add(node);
    }
    context.layers.add(node);
    dispatchUpdate();
    return () => {
      if (disableOutsidePointerEvents) {
        context.layersWithOutsidePointerEventsDisabled.delete(node);
        if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
          ownerDocument.body.style.pointerEvents = originalBodyPointerEvents;
        }
      }
    };
  }, [node, ownerDocument, disableOutsidePointerEvents, context]);
  React11.useEffect(() => {
    return () => {
      if (!node)
        return;
      context.layers.delete(node);
      context.layersWithOutsidePointerEventsDisabled.delete(node);
      dispatchUpdate();
    };
  }, [node, context]);
  React11.useEffect(() => {
    const handleUpdate = () => force({});
    document.addEventListener(CONTEXT_UPDATE, handleUpdate);
    return () => document.removeEventListener(CONTEXT_UPDATE, handleUpdate);
  }, []);
  return /* @__PURE__ */ jsx10(Primitive.div, {
    ...layerProps,
    ref: composedRefs,
    style: {
      pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
      ...props62.style
    },
    onFocusCapture: composeEventHandlers(props62.onFocusCapture, focusOutside.onFocusCapture),
    onBlurCapture: composeEventHandlers(props62.onBlurCapture, focusOutside.onBlurCapture),
    onPointerDownCapture: composeEventHandlers(props62.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
  });
});
DismissableLayer.displayName = DISMISSABLE_LAYER_NAME;
var BRANCH_NAME = "DismissableLayerBranch";
var DismissableLayerBranch = React11.forwardRef((props62, forwardedRef) => {
  const context = React11.useContext(DismissableLayerContext);
  const ref = React11.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  React11.useEffect(() => {
    const node = ref.current;
    if (node) {
      context.branches.add(node);
      return () => {
        context.branches.delete(node);
      };
    }
  }, [context.branches]);
  return /* @__PURE__ */ jsx10(Primitive.div, { ...props62, ref: composedRefs });
});
DismissableLayerBranch.displayName = BRANCH_NAME;
function useDismissableLayerSurface() {
  const context = React11.useContext(DismissableLayerContext);
  const [node, setNode] = React11.useState(null);
  React11.useEffect(() => {
    if (!node) {
      return;
    }
    context.dismissableSurfaces.add(node);
    return () => {
      context.dismissableSurfaces.delete(node);
    };
  }, [node, context.dismissableSurfaces]);
  return setNode;
}
var IS_TRUE = () => true;
function usePointerDownOutside(onPointerDownOutside, args) {
  const {
    ownerDocument = globalThis?.document,
    deferPointerDownOutside = false,
    isDeferredPointerDownOutsideRef,
    dismissableSurfaces,
    shouldHandlePointerDownOutside = IS_TRUE
  } = args;
  const handlePointerDownOutside = useCallbackRef(onPointerDownOutside);
  const isPointerInsideReactTreeRef = React11.useRef(false);
  const isPointerDownOutsideRef = React11.useRef(false);
  const interceptedOutsideInteractionEventsRef = React11.useRef(/* @__PURE__ */ new Map);
  const handleClickRef = React11.useRef(() => {});
  React11.useEffect(() => {
    function resetOutsideInteraction() {
      isPointerDownOutsideRef.current = false;
      isDeferredPointerDownOutsideRef.current = false;
      interceptedOutsideInteractionEventsRef.current.clear();
    }
    function isOutsideInteractionIntercepted() {
      return Array.from(interceptedOutsideInteractionEventsRef.current.values()).some(Boolean);
    }
    function handleInteractionCapture(event) {
      if (!isPointerDownOutsideRef.current) {
        return;
      }
      const target = event.target;
      const isDismissableSurface = target instanceof Node && [...dismissableSurfaces].some((surface) => surface.contains(target));
      if (!isDismissableSurface) {
        interceptedOutsideInteractionEventsRef.current.set(event.type, true);
      }
      if (event.type === "click") {
        window.setTimeout(() => {
          if (isPointerDownOutsideRef.current) {
            handleClickRef.current();
          }
        }, 0);
      }
    }
    function handleInteractionBubble(event) {
      if (isPointerDownOutsideRef.current) {
        interceptedOutsideInteractionEventsRef.current.set(event.type, false);
      }
    }
    const handlePointerDown = (event) => {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        let handleAndDispatchPointerDownOutsideEvent2 = function() {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          const wasOutsideInteractionIntercepted = isOutsideInteractionIntercepted();
          resetOutsideInteraction();
          if (!wasOutsideInteractionIntercepted) {
            handleAndDispatchCustomEvent(POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, { discrete: true });
          }
        };
        var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
        if (!shouldHandlePointerDownOutside(event.target)) {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          resetOutsideInteraction();
          isPointerInsideReactTreeRef.current = false;
          return;
        }
        const eventDetail = { originalEvent: event };
        isPointerDownOutsideRef.current = true;
        isDeferredPointerDownOutsideRef.current = deferPointerDownOutside && event.button === 0;
        interceptedOutsideInteractionEventsRef.current.clear();
        if (!deferPointerDownOutside || event.button !== 0) {
          handleAndDispatchPointerDownOutsideEvent2();
        } else {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
          ownerDocument.addEventListener("click", handleClickRef.current, { once: true });
        }
      } else {
        ownerDocument.removeEventListener("click", handleClickRef.current);
        resetOutsideInteraction();
      }
      isPointerInsideReactTreeRef.current = false;
    };
    const outsideInteractionEvents = [
      "pointerup",
      "mousedown",
      "mouseup",
      "touchstart",
      "touchend",
      "click"
    ];
    for (const eventName of outsideInteractionEvents) {
      ownerDocument.addEventListener(eventName, handleInteractionCapture, true);
      ownerDocument.addEventListener(eventName, handleInteractionBubble);
    }
    const timerId = window.setTimeout(() => {
      ownerDocument.addEventListener("pointerdown", handlePointerDown);
    }, 0);
    return () => {
      window.clearTimeout(timerId);
      ownerDocument.removeEventListener("pointerdown", handlePointerDown);
      ownerDocument.removeEventListener("click", handleClickRef.current);
      for (const eventName of outsideInteractionEvents) {
        ownerDocument.removeEventListener(eventName, handleInteractionCapture, true);
        ownerDocument.removeEventListener(eventName, handleInteractionBubble);
      }
    };
  }, [
    ownerDocument,
    handlePointerDownOutside,
    deferPointerDownOutside,
    isDeferredPointerDownOutsideRef,
    dismissableSurfaces,
    shouldHandlePointerDownOutside
  ]);
  return {
    onPointerDownCapture: () => isPointerInsideReactTreeRef.current = true
  };
}
function useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
  const handleFocusOutside = useCallbackRef(onFocusOutside);
  const isFocusInsideReactTreeRef = React11.useRef(false);
  React11.useEffect(() => {
    const handleFocus = (event) => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = { originalEvent: event };
        handleAndDispatchCustomEvent(FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    ownerDocument.addEventListener("focusin", handleFocus);
    return () => ownerDocument.removeEventListener("focusin", handleFocus);
  }, [ownerDocument, handleFocusOutside]);
  return {
    onFocusCapture: () => isFocusInsideReactTreeRef.current = true,
    onBlurCapture: () => isFocusInsideReactTreeRef.current = false
  };
}
function dispatchUpdate() {
  const event = new CustomEvent(CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
function handleAndDispatchCustomEvent(name, handler, detail, { discrete }) {
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name, { bubbles: false, cancelable: true, detail });
  if (handler)
    target.addEventListener(name, handler, { once: true });
  if (discrete) {
    dispatchDiscreteCustomEvent(target, event);
  } else {
    target.dispatchEvent(event);
  }
}
var AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var EVENT_OPTIONS = { bubbles: false, cancelable: true };
var FOCUS_SCOPE_NAME = "FocusScope";
var FocusScope = React12.forwardRef((props62, forwardedRef) => {
  const {
    loop = false,
    trapped = false,
    onMountAutoFocus: onMountAutoFocusProp,
    onUnmountAutoFocus: onUnmountAutoFocusProp,
    ...scopeProps
  } = props62;
  const [container, setContainer] = React12.useState(null);
  const onMountAutoFocus = useCallbackRef(onMountAutoFocusProp);
  const onUnmountAutoFocus = useCallbackRef(onUnmountAutoFocusProp);
  const lastFocusedElementRef = React12.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, setContainer);
  const focusScope = React12.useRef({
    paused: false,
    pause() {
      this.paused = true;
    },
    resume() {
      this.paused = false;
    }
  }).current;
  React12.useEffect(() => {
    if (trapped) {
      let handleFocusIn2 = function(event) {
        if (focusScope.paused || !container)
          return;
        const target = event.target;
        if (container.contains(target)) {
          lastFocusedElementRef.current = target;
        } else {
          focus(lastFocusedElementRef.current, { select: true });
        }
      }, handleFocusOut2 = function(event) {
        if (focusScope.paused || !container)
          return;
        const relatedTarget = event.relatedTarget;
        if (relatedTarget === null)
          return;
        if (!container.contains(relatedTarget)) {
          focus(lastFocusedElementRef.current, { select: true });
        }
      }, handleMutations2 = function(mutations) {
        const focusedElement = document.activeElement;
        if (focusedElement !== document.body)
          return;
        for (const mutation of mutations) {
          if (mutation.removedNodes.length > 0)
            focus(container);
        }
      };
      var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
      document.addEventListener("focusin", handleFocusIn2);
      document.addEventListener("focusout", handleFocusOut2);
      const mutationObserver = new MutationObserver(handleMutations2);
      if (container)
        mutationObserver.observe(container, { childList: true, subtree: true });
      return () => {
        document.removeEventListener("focusin", handleFocusIn2);
        document.removeEventListener("focusout", handleFocusOut2);
        mutationObserver.disconnect();
      };
    }
  }, [trapped, container, focusScope.paused]);
  React12.useEffect(() => {
    if (container) {
      focusScopesStack.add(focusScope);
      const previouslyFocusedElement = document.activeElement;
      const hasFocusedCandidate = container.contains(previouslyFocusedElement);
      if (!hasFocusedCandidate) {
        const mountEvent = new CustomEvent(AUTOFOCUS_ON_MOUNT, EVENT_OPTIONS);
        container.addEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        container.dispatchEvent(mountEvent);
        if (!mountEvent.defaultPrevented) {
          focusFirst(removeLinks(getTabbableCandidates(container)), { select: true });
          if (document.activeElement === previouslyFocusedElement) {
            focus(container);
          }
        }
      }
      return () => {
        container.removeEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        setTimeout(() => {
          const unmountEvent = new CustomEvent(AUTOFOCUS_ON_UNMOUNT, EVENT_OPTIONS);
          container.addEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          container.dispatchEvent(unmountEvent);
          if (!unmountEvent.defaultPrevented) {
            focus(previouslyFocusedElement ?? document.body, { select: true });
          }
          container.removeEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          focusScopesStack.remove(focusScope);
        }, 0);
      };
    }
  }, [container, onMountAutoFocus, onUnmountAutoFocus, focusScope]);
  const handleKeyDown = React12.useCallback((event) => {
    if (!loop && !trapped)
      return;
    if (focusScope.paused)
      return;
    const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
    const focusedElement = document.activeElement;
    if (isTabKey && focusedElement) {
      const container2 = event.currentTarget;
      const [first, last] = getTabbableEdges(container2);
      const hasTabbableElementsInside = first && last;
      if (!hasTabbableElementsInside) {
        if (focusedElement === container2)
          event.preventDefault();
      } else {
        if (!event.shiftKey && focusedElement === last) {
          event.preventDefault();
          if (loop)
            focus(first, { select: true });
        } else if (event.shiftKey && focusedElement === first) {
          event.preventDefault();
          if (loop)
            focus(last, { select: true });
        }
      }
    }
  }, [loop, trapped, focusScope.paused]);
  return /* @__PURE__ */ jsx11(Primitive.div, { tabIndex: -1, ...scopeProps, ref: composedRefs, onKeyDown: handleKeyDown });
});
FocusScope.displayName = FOCUS_SCOPE_NAME;
function focusFirst(candidates, { select = false } = {}) {
  const previouslyFocusedElement = document.activeElement;
  for (const candidate of candidates) {
    focus(candidate, { select });
    if (document.activeElement !== previouslyFocusedElement)
      return;
  }
}
function getTabbableEdges(container) {
  const candidates = getTabbableCandidates(container);
  const first = findVisible(candidates, container);
  const last = findVisible(candidates.reverse(), container);
  return [first, last];
}
function getTabbableCandidates(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (node) => {
      const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
      if (node.disabled || node.hidden || isHiddenInput)
        return NodeFilter.FILTER_SKIP;
      return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode())
    nodes.push(walker.currentNode);
  return nodes;
}
function findVisible(elements, container) {
  const canUseCheckVisibility = typeof container.checkVisibility === "function" && container.checkVisibility({ checkVisibilityCSS: true });
  for (const element of elements) {
    const hidden = canUseCheckVisibility ? !element.checkVisibility({ checkVisibilityCSS: true }) : isHidden(element, { upTo: container });
    if (!hidden) {
      return element;
    }
  }
}
function isHidden(node, { upTo }) {
  if (getComputedStyle(node).visibility === "hidden")
    return true;
  while (node) {
    if (upTo !== undefined && node === upTo)
      return false;
    if (getComputedStyle(node).display === "none")
      return true;
    node = node.parentElement;
  }
  return false;
}
function isSelectableInput(element) {
  return element instanceof HTMLInputElement && "select" in element;
}
function focus(element, { select = false } = {}) {
  if (element && element.focus) {
    const previouslyFocusedElement = document.activeElement;
    element.focus({ preventScroll: true });
    if (element !== previouslyFocusedElement && isSelectableInput(element) && select)
      element.select();
  }
}
var focusScopesStack = createFocusScopesStack();
function createFocusScopesStack() {
  let stack = [];
  return {
    add(focusScope) {
      const activeFocusScope = stack[0];
      if (focusScope !== activeFocusScope) {
        activeFocusScope?.pause();
      }
      stack = arrayRemove(stack, focusScope);
      stack.unshift(focusScope);
    },
    remove(focusScope) {
      stack = arrayRemove(stack, focusScope);
      stack[0]?.resume();
    }
  };
}
function arrayRemove(array, item) {
  const updatedArray = [...array];
  const index = updatedArray.indexOf(item);
  if (index !== -1) {
    updatedArray.splice(index, 1);
  }
  return updatedArray;
}
function removeLinks(items) {
  return items.filter((item) => item.tagName !== "A");
}
var ReactDOM2 = __toESM(require_react_dom(), 1);
var PORTAL_NAME = "Portal";
var Portal = React13.forwardRef((props62, forwardedRef) => {
  const { container: containerProp, ...portalProps } = props62;
  const [mounted, setMounted] = React13.useState(false);
  useLayoutEffect22(() => setMounted(true), []);
  const container = containerProp || mounted && globalThis?.document?.body;
  return container ? ReactDOM2.createPortal(/* @__PURE__ */ jsx12(Primitive.div, { ...portalProps, ref: forwardedRef }), container) : null;
});
Portal.displayName = PORTAL_NAME;
function useStateMachine(initialState, machine) {
  return React14.useReducer((state, event) => {
    const nextState = machine[state][event];
    return nextState ?? state;
  }, initialState);
}
var Presence = (props62) => {
  const { present, children } = props62;
  const presence = usePresence(present);
  const child = typeof children === "function" ? children({ present: presence.isPresent }) : React23.Children.only(children);
  const ref = useStableComposedRefs(presence.ref, getElementRef2(child));
  const forceMount = typeof children === "function";
  return forceMount || presence.isPresent ? React23.cloneElement(child, { ref }) : null;
};
Presence.displayName = "Presence";
function usePresence(present) {
  const [node, setNode] = React23.useState();
  const stylesRef = React23.useRef(null);
  const prevPresentRef = React23.useRef(present);
  const prevAnimationNameRef = React23.useRef("none");
  const mountAnimationNameRef = React23.useRef(undefined);
  const initialState = present ? "mounted" : "unmounted";
  const [state, send] = useStateMachine(initialState, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  React23.useEffect(() => {
    if (state === "mounted") {
      prevAnimationNameRef.current = mountAnimationNameRef.current ?? getAnimationName(stylesRef.current);
      mountAnimationNameRef.current = undefined;
    } else {
      prevAnimationNameRef.current = "none";
    }
  }, [state]);
  useLayoutEffect22(() => {
    const styles = stylesRef.current;
    const wasPresent = prevPresentRef.current;
    const hasPresentChanged = wasPresent !== present;
    if (hasPresentChanged) {
      const prevAnimationName = prevAnimationNameRef.current;
      const currentAnimationName = getAnimationName(styles);
      if (present) {
        mountAnimationNameRef.current = currentAnimationName;
        send("MOUNT");
      } else if (currentAnimationName === "none" || styles?.display === "none") {
        send("UNMOUNT");
      } else {
        const isAnimating = prevAnimationName !== currentAnimationName;
        if (wasPresent && isAnimating) {
          send("ANIMATION_OUT");
        } else {
          send("UNMOUNT");
        }
      }
      prevPresentRef.current = present;
    }
  }, [present, send]);
  useLayoutEffect22(() => {
    if (node) {
      let timeoutId;
      const ownerWindow = node.ownerDocument.defaultView ?? window;
      const handleAnimationEnd = (event) => {
        const currentAnimationName = getAnimationName(stylesRef.current);
        const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
        if (event.target === node && isCurrentAnimation) {
          send("ANIMATION_END");
          if (!prevPresentRef.current) {
            const currentFillMode = node.style.animationFillMode;
            node.style.animationFillMode = "forwards";
            timeoutId = ownerWindow.setTimeout(() => {
              if (node.style.animationFillMode === "forwards") {
                node.style.animationFillMode = currentFillMode;
              }
            });
          }
        }
      };
      const handleAnimationStart = (event) => {
        if (event.target === node) {
          prevAnimationNameRef.current = getAnimationName(stylesRef.current);
        }
      };
      node.addEventListener("animationstart", handleAnimationStart);
      node.addEventListener("animationcancel", handleAnimationEnd);
      node.addEventListener("animationend", handleAnimationEnd);
      return () => {
        ownerWindow.clearTimeout(timeoutId);
        node.removeEventListener("animationstart", handleAnimationStart);
        node.removeEventListener("animationcancel", handleAnimationEnd);
        node.removeEventListener("animationend", handleAnimationEnd);
      };
    } else {
      send("ANIMATION_END");
    }
  }, [node, send]);
  return {
    isPresent: ["mounted", "unmountSuspended"].includes(state),
    ref: React23.useCallback((node2) => {
      if (node2) {
        const styles = getComputedStyle(node2);
        stylesRef.current = styles;
        mountAnimationNameRef.current = getAnimationName(styles);
      } else {
        stylesRef.current = null;
      }
      setNode(node2);
    }, [])
  };
}
function setRef2(ref, value) {
  if (typeof ref === "function") {
    return ref(value);
  } else if (ref !== null && ref !== undefined) {
    ref.current = value;
  }
}
function useStableComposedRefs(...refs) {
  const refsRef = React23.useRef(refs);
  refsRef.current = refs;
  return React23.useCallback((node) => {
    const currentRefs = refsRef.current;
    let hasCleanup = false;
    const cleanups = currentRefs.map((ref) => {
      const cleanup = setRef2(ref, node);
      if (!hasCleanup && typeof cleanup === "function") {
        hasCleanup = true;
      }
      return cleanup;
    });
    if (hasCleanup) {
      return () => {
        for (let i = 0;i < cleanups.length; i++) {
          const cleanup = cleanups[i];
          if (typeof cleanup === "function") {
            cleanup();
          } else {
            setRef2(currentRefs[i], null);
          }
        }
      };
    }
  }, []);
}
function getAnimationName(styles) {
  return styles?.animationName || "none";
}
function getElementRef2(element) {
  let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
var count2 = 0;
var guards = null;
function useFocusGuards() {
  React15.useEffect(() => {
    if (!guards) {
      guards = { start: createFocusGuard(), end: createFocusGuard() };
    }
    const { start, end } = guards;
    if (document.body.firstElementChild !== start) {
      document.body.insertAdjacentElement("afterbegin", start);
    }
    if (document.body.lastElementChild !== end) {
      document.body.insertAdjacentElement("beforeend", end);
    }
    count2++;
    return () => {
      if (count2 === 1) {
        guards?.start.remove();
        guards?.end.remove();
        guards = null;
      }
      count2 = Math.max(0, count2 - 1);
    };
  }, []);
}
function createFocusGuard() {
  const element = document.createElement("span");
  element.setAttribute("data-radix-focus-guard", "");
  element.tabIndex = 0;
  element.style.outline = "none";
  element.style.opacity = "0";
  element.style.position = "fixed";
  element.style.pointerEvents = "none";
  return element;
}
var __assign = function() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length;i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s)
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s);i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i = 0, l = from.length, ar;i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var zeroRightClassName = "right-scroll-bar-position";
var fullWidthClassName = "width-before-scroll-bar";
var noScrollbarsClassName = "with-scroll-bars-hidden";
var removedBarSizeVariable = "--removed-body-scroll-bar-size";
function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
  return ref;
}
function useCallbackRef2(initialValue, callback) {
  var ref = useState72(function() {
    return {
      value: initialValue,
      callback,
      facade: {
        get current() {
          return ref.value;
        },
        set current(value) {
          var last = ref.value;
          if (last !== value) {
            ref.value = value;
            ref.callback(value, last);
          }
        }
      }
    };
  })[0];
  ref.callback = callback;
  return ref.facade;
}
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? React16.useLayoutEffect : React16.useEffect;
var currentValues = new WeakMap;
function useMergeRefs(refs, defaultValue) {
  var callbackRef = useCallbackRef2(defaultValue || null, function(newValue) {
    return refs.forEach(function(ref) {
      return assignRef(ref, newValue);
    });
  });
  useIsomorphicLayoutEffect(function() {
    var oldValue = currentValues.get(callbackRef);
    if (oldValue) {
      var prevRefs_1 = new Set(oldValue);
      var nextRefs_1 = new Set(refs);
      var current_1 = callbackRef.current;
      prevRefs_1.forEach(function(ref) {
        if (!nextRefs_1.has(ref)) {
          assignRef(ref, null);
        }
      });
      nextRefs_1.forEach(function(ref) {
        if (!prevRefs_1.has(ref)) {
          assignRef(ref, current_1);
        }
      });
    }
    currentValues.set(callbackRef, refs);
  }, [refs]);
  return callbackRef;
}
function ItoI(a) {
  return a;
}
function innerCreateMedium(defaults, middleware) {
  if (middleware === undefined) {
    middleware = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function() {
      if (assigned) {
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults;
    },
    useMedium: function(data) {
      var item = middleware(data, assigned);
      buffer.push(item);
      return function() {
        buffer = buffer.filter(function(x) {
          return x !== item;
        });
      };
    },
    assignSyncMedium: function(cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function(x) {
          return cb(x);
        },
        filter: function() {
          return buffer;
        }
      };
    },
    assignMedium: function(cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function() {
        var cbs2 = pendingQueue;
        pendingQueue = [];
        cbs2.forEach(cb);
      };
      var cycle = function() {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function(x) {
          pendingQueue.push(x);
          cycle();
        },
        filter: function(filter) {
          pendingQueue = pendingQueue.filter(filter);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createSidecarMedium(options) {
  if (options === undefined) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = __assign({ async: true, ssr: false }, options);
  return medium;
}
var SideCar = function(_a) {
  var sideCar = _a.sideCar, rest = __rest(_a, ["sideCar"]);
  if (!sideCar) {
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  }
  var Target = sideCar.read();
  if (!Target) {
    throw new Error("Sidecar medium not found");
  }
  return React17.createElement(Target, __assign({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
  medium.useMedium(exported);
  return SideCar;
}
var effectCar = createSidecarMedium();
var nothing = function() {
  return;
};
var RemoveScroll = React18.forwardRef(function(props62, parentRef) {
  var ref = React18.useRef(null);
  var _a = React18.useState({
    onScrollCapture: nothing,
    onWheelCapture: nothing,
    onTouchMoveCapture: nothing
  }), callbacks = _a[0], setCallbacks = _a[1];
  var { forwardProps, children, className, removeScrollBar, enabled, shards, sideCar, noRelative, noIsolation, inert, allowPinchZoom, as: _b } = props62, Container = _b === undefined ? "div" : _b, gapMode = props62.gapMode, rest = __rest(props62, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]);
  var SideCar2 = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);
  var containerProps = __assign(__assign({}, rest), callbacks);
  return React18.createElement(React18.Fragment, null, enabled && React18.createElement(SideCar2, { sideCar: effectCar, removeScrollBar, shards, noRelative, noIsolation, inert, setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref, gapMode }), forwardProps ? React18.cloneElement(React18.Children.only(children), __assign(__assign({}, containerProps), { ref: containerRef })) : React18.createElement(Container, __assign({}, containerProps, { className, ref: containerRef }), children));
});
RemoveScroll.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};
RemoveScroll.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};
var currentNonce;
var getNonce = function() {
  if (currentNonce) {
    return currentNonce;
  }
  if (typeof __webpack_nonce__ !== "undefined") {
    return __webpack_nonce__;
  }
  return;
};
function makeStyleTag() {
  if (!document)
    return null;
  var tag = document.createElement("style");
  tag.type = "text/css";
  var nonce = getNonce();
  if (nonce) {
    tag.setAttribute("nonce", nonce);
  }
  return tag;
}
function injectStyles(tag, css) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(tag);
}
var stylesheetSingleton = function() {
  var counter = 0;
  var stylesheet = null;
  return {
    add: function(style) {
      if (counter == 0) {
        if (stylesheet = makeStyleTag()) {
          injectStyles(stylesheet, style);
          insertStyleTag(stylesheet);
        }
      }
      counter++;
    },
    remove: function() {
      counter--;
      if (!counter && stylesheet) {
        stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
        stylesheet = null;
      }
    }
  };
};
var styleHookSingleton = function() {
  var sheet = stylesheetSingleton();
  return function(styles, isDynamic) {
    React19.useEffect(function() {
      sheet.add(styles);
      return function() {
        sheet.remove();
      };
    }, [styles && isDynamic]);
  };
};
var styleSingleton = function() {
  var useStyle = styleHookSingleton();
  var Sheet = function(_a) {
    var { styles, dynamic } = _a;
    useStyle(styles, dynamic);
    return null;
  };
  return Sheet;
};
var zeroGap = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
};
var parse = function(x) {
  return parseInt(x || "", 10) || 0;
};
var getOffset = function(gapMode) {
  var cs = window.getComputedStyle(document.body);
  var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
  var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
  var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
  return [parse(left), parse(top), parse(right)];
};
var getGapWidth = function(gapMode) {
  if (gapMode === undefined) {
    gapMode = "margin";
  }
  if (typeof window === "undefined") {
    return zeroGap;
  }
  var offsets = getOffset(gapMode);
  var documentWidth = document.documentElement.clientWidth;
  var windowWidth = window.innerWidth;
  return {
    left: offsets[0],
    top: offsets[1],
    right: offsets[2],
    gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
  };
};
var Style = styleSingleton();
var lockAttribute = "data-scroll-locked";
var getStyles = function(_a, allowRelative, gapMode, important) {
  var { left, top, right, gap } = _a;
  if (gapMode === undefined) {
    gapMode = "margin";
  }
  return `
  .`.concat(noScrollbarsClassName, ` {
   overflow: hidden `).concat(important, `;
   padding-right: `).concat(gap, "px ").concat(important, `;
  }
  body[`).concat(lockAttribute, `] {
    overflow: hidden `).concat(important, `;
    overscroll-behavior: contain;
    `).concat([
    allowRelative && "position: relative ".concat(important, ";"),
    gapMode === "margin" && `
    padding-left: `.concat(left, `px;
    padding-top: `).concat(top, `px;
    padding-right: `).concat(right, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(gap, "px ").concat(important, `;
    `),
    gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(zeroRightClassName, ` {
    right: `).concat(gap, "px ").concat(important, `;
  }
  
  .`).concat(fullWidthClassName, ` {
    margin-right: `).concat(gap, "px ").concat(important, `;
  }
  
  .`).concat(zeroRightClassName, " .").concat(zeroRightClassName, ` {
    right: 0 `).concat(important, `;
  }
  
  .`).concat(fullWidthClassName, " .").concat(fullWidthClassName, ` {
    margin-right: 0 `).concat(important, `;
  }
  
  body[`).concat(lockAttribute, `] {
    `).concat(removedBarSizeVariable, ": ").concat(gap, `px;
  }
`);
};
var getCurrentUseCounter = function() {
  var counter = parseInt(document.body.getAttribute(lockAttribute) || "0", 10);
  return isFinite(counter) ? counter : 0;
};
var useLockAttribute = function() {
  React20.useEffect(function() {
    document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
    return function() {
      var newCounter = getCurrentUseCounter() - 1;
      if (newCounter <= 0) {
        document.body.removeAttribute(lockAttribute);
      } else {
        document.body.setAttribute(lockAttribute, newCounter.toString());
      }
    };
  }, []);
};
var RemoveScrollBar = function(_a) {
  var { noRelative, noImportant, gapMode: _b } = _a, gapMode = _b === undefined ? "margin" : _b;
  useLockAttribute();
  var gap = React20.useMemo(function() {
    return getGapWidth(gapMode);
  }, [gapMode]);
  return React20.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "") });
};
var passiveSupported = false;
if (typeof window !== "undefined") {
  try {
    options = Object.defineProperty({}, "passive", {
      get: function() {
        passiveSupported = true;
        return true;
      }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
  } catch (err) {
    passiveSupported = false;
  }
}
var options;
var nonPassive = passiveSupported ? { passive: false } : false;
var alwaysContainsScroll = function(node) {
  return node.tagName === "TEXTAREA";
};
var elementCanBeScrolled = function(node, overflow) {
  if (!(node instanceof Element)) {
    return false;
  }
  var styles = window.getComputedStyle(node);
  return styles[overflow] !== "hidden" && !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === "visible");
};
var elementCouldBeVScrolled = function(node) {
  return elementCanBeScrolled(node, "overflowY");
};
var elementCouldBeHScrolled = function(node) {
  return elementCanBeScrolled(node, "overflowX");
};
var locationCouldBeScrolled = function(axis, node) {
  var ownerDocument = node.ownerDocument;
  var current = node;
  do {
    if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) {
      current = current.host;
    }
    var isScrollable = elementCouldBeScrolled(axis, current);
    if (isScrollable) {
      var _a = getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
      if (scrollHeight > clientHeight) {
        return true;
      }
    }
    current = current.parentNode;
  } while (current && current !== ownerDocument.body);
  return false;
};
var getVScrollVariables = function(_a) {
  var { scrollTop, scrollHeight, clientHeight } = _a;
  return [
    scrollTop,
    scrollHeight,
    clientHeight
  ];
};
var getHScrollVariables = function(_a) {
  var { scrollLeft, scrollWidth, clientWidth } = _a;
  return [
    scrollLeft,
    scrollWidth,
    clientWidth
  ];
};
var elementCouldBeScrolled = function(axis, node) {
  return axis === "v" ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function(axis, node) {
  return axis === "v" ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function(axis, direction) {
  return axis === "h" && direction === "rtl" ? -1 : 1;
};
var handleScroll = function(axis, endTarget, event, sourceDelta, noOverscroll) {
  var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
  var delta = directionFactor * sourceDelta;
  var target = event.target;
  var targetInLock = endTarget.contains(target);
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    if (!target) {
      break;
    }
    var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
    var elementScroll = scroll_1 - capacity - directionFactor * position;
    if (position || elementScroll) {
      if (elementCouldBeScrolled(axis, target)) {
        availableScroll += elementScroll;
        availableScrollTop += position;
      }
    }
    var parent_1 = target.parentNode;
    target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
  } while (!targetInLock && target !== document.body || targetInLock && (endTarget.contains(target) || endTarget === target));
  if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) {
    shouldCancelScroll = true;
  }
  return shouldCancelScroll;
};
var getTouchXY = function(event) {
  return "changedTouches" in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function(event) {
  return [event.deltaX, event.deltaY];
};
var extractRef = function(ref) {
  return ref && "current" in ref ? ref.current : ref;
};
var deltaCompare = function(x, y) {
  return x[0] === y[0] && x[1] === y[1];
};
var generateStyle = function(id) {
  return `
  .block-interactivity-`.concat(id, ` {pointer-events: none;}
  .allow-interactivity-`).concat(id, ` {pointer-events: all;}
`);
};
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props62) {
  var shouldPreventQueue = React21.useRef([]);
  var touchStartRef = React21.useRef([0, 0]);
  var activeAxis = React21.useRef();
  var id = React21.useState(idCounter++)[0];
  var Style2 = React21.useState(styleSingleton)[0];
  var lastProps = React21.useRef(props62);
  React21.useEffect(function() {
    lastProps.current = props62;
  }, [props62]);
  React21.useEffect(function() {
    if (props62.inert) {
      document.body.classList.add("block-interactivity-".concat(id));
      var allow_1 = __spreadArray([props62.lockRef.current], (props62.shards || []).map(extractRef), true).filter(Boolean);
      allow_1.forEach(function(el) {
        return el.classList.add("allow-interactivity-".concat(id));
      });
      return function() {
        document.body.classList.remove("block-interactivity-".concat(id));
        allow_1.forEach(function(el) {
          return el.classList.remove("allow-interactivity-".concat(id));
        });
      };
    }
    return;
  }, [props62.inert, props62.lockRef.current, props62.shards]);
  var shouldCancelEvent = React21.useCallback(function(event, parent) {
    if ("touches" in event && event.touches.length === 2 || event.type === "wheel" && event.ctrlKey) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY(event);
    var touchStart = touchStartRef.current;
    var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
    if ("touches" in event && moveDirection === "h" && target.type === "range") {
      return false;
    }
    var selection = window.getSelection();
    var anchorNode = selection && selection.anchorNode;
    var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
    if (isTouchingSelection) {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === "v" ? "h" : "v";
      canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    }
    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
  }, []);
  var shouldPrevent = React21.useCallback(function(_event) {
    var event = _event;
    if (!lockStack.length || lockStack[lockStack.length - 1] !== Style2) {
      return;
    }
    var delta = "deltaY" in event ? getDeltaXY(event) : getTouchXY(event);
    var sourceEvent = shouldPreventQueue.current.filter(function(e) {
      return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && deltaCompare(e.delta, delta);
    })[0];
    if (sourceEvent && sourceEvent.should) {
      if (event.cancelable) {
        event.preventDefault();
      }
      return;
    }
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function(node) {
        return node.contains(event.target);
      });
      var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
      if (shouldStop) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }
    }
  }, []);
  var shouldCancel = React21.useCallback(function(name, delta, target, should) {
    var event = { name, delta, target, should, shadowParent: getOutermostShadowParent(target) };
    shouldPreventQueue.current.push(event);
    setTimeout(function() {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
        return e !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = React21.useCallback(function(event) {
    touchStartRef.current = getTouchXY(event);
    activeAxis.current = undefined;
  }, []);
  var scrollWheel = React21.useCallback(function(event) {
    shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props62.lockRef.current));
  }, []);
  var scrollTouchMove = React21.useCallback(function(event) {
    shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props62.lockRef.current));
  }, []);
  React21.useEffect(function() {
    lockStack.push(Style2);
    props62.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove
    });
    document.addEventListener("wheel", shouldPrevent, nonPassive);
    document.addEventListener("touchmove", shouldPrevent, nonPassive);
    document.addEventListener("touchstart", scrollTouchStart, nonPassive);
    return function() {
      lockStack = lockStack.filter(function(inst) {
        return inst !== Style2;
      });
      document.removeEventListener("wheel", shouldPrevent, nonPassive);
      document.removeEventListener("touchmove", shouldPrevent, nonPassive);
      document.removeEventListener("touchstart", scrollTouchStart, nonPassive);
    };
  }, []);
  var { removeScrollBar, inert } = props62;
  return React21.createElement(React21.Fragment, null, inert ? React21.createElement(Style2, { styles: generateStyle(id) }) : null, removeScrollBar ? React21.createElement(RemoveScrollBar, { noRelative: props62.noRelative, gapMode: props62.gapMode }) : null);
}
function getOutermostShadowParent(node) {
  var shadowParent = null;
  while (node !== null) {
    if (node instanceof ShadowRoot) {
      shadowParent = node.host;
      node = node.host;
    }
    node = node.parentNode;
  }
  return shadowParent;
}
var sidecar_default = exportSidecar(effectCar, RemoveScrollSideCar);
var ReactRemoveScroll = React24.forwardRef(function(props62, ref) {
  return React24.createElement(RemoveScroll, __assign({}, props62, { ref, sideCar: sidecar_default }));
});
ReactRemoveScroll.classNames = RemoveScroll.classNames;
var Combination_default = ReactRemoveScroll;
var getDefaultParent = function(originalTarget) {
  if (typeof document === "undefined") {
    return null;
  }
  var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
  return sampleTarget.ownerDocument.body;
};
var counterMap = new WeakMap;
var uncontrolledNodes = new WeakMap;
var markerMap = {};
var lockCount = 0;
var unwrapHost = function(node) {
  return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function(parent, targets) {
  return targets.map(function(target) {
    if (parent.contains(target)) {
      return target;
    }
    var correctedTarget = unwrapHost(target);
    if (correctedTarget && parent.contains(correctedTarget)) {
      return correctedTarget;
    }
    console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
    return null;
  }).filter(function(x) {
    return Boolean(x);
  });
};
var applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
  var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  if (!markerMap[markerName]) {
    markerMap[markerName] = new WeakMap;
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var elementsToKeep = new Set;
  var elementsToStop = new Set(targets);
  var keep = function(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    keep(el.parentNode);
  };
  targets.forEach(keep);
  var deep = function(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function(node) {
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        try {
          var attr = node.getAttribute(controlAttribute);
          var alreadyHidden = attr !== null && attr !== "false";
          var counterValue = (counterMap.get(node) || 0) + 1;
          var markerValue = (markerCounter.get(node) || 0) + 1;
          counterMap.set(node, counterValue);
          markerCounter.set(node, markerValue);
          hiddenNodes.push(node);
          if (counterValue === 1 && alreadyHidden) {
            uncontrolledNodes.set(node, true);
          }
          if (markerValue === 1) {
            node.setAttribute(markerName, "true");
          }
          if (!alreadyHidden) {
            node.setAttribute(controlAttribute, "true");
          }
        } catch (e) {
          console.error("aria-hidden: cannot operate on ", node, e);
        }
      }
    });
  };
  deep(parentNode);
  elementsToKeep.clear();
  lockCount++;
  return function() {
    hiddenNodes.forEach(function(node) {
      var counterValue = counterMap.get(node) - 1;
      var markerValue = markerCounter.get(node) - 1;
      counterMap.set(node, counterValue);
      markerCounter.set(node, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node)) {
          node.removeAttribute(controlAttribute);
        }
        uncontrolledNodes.delete(node);
      }
      if (!markerValue) {
        node.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = new WeakMap;
      counterMap = new WeakMap;
      uncontrolledNodes = new WeakMap;
      markerMap = {};
    }
  };
};
var hideOthers = function(originalTarget, parentNode, markerName) {
  if (markerName === undefined) {
    markerName = "data-aria-hidden";
  }
  var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  var activeParentNode = parentNode || getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function() {
      return null;
    };
  }
  targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live], script")));
  return applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var DIALOG_NAME = "Dialog";
var [createDialogContext, createDialogScope] = createContextScope(DIALOG_NAME);
var [DialogProvider, useDialogContext] = createDialogContext(DIALOG_NAME);
var Dialog = (props62) => {
  const {
    __scopeDialog,
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    modal = true
  } = props62;
  const triggerRef = React26.useRef(null);
  const contentRef = React26.useRef(null);
  const [open, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen ?? false,
    onChange: onOpenChange,
    caller: DIALOG_NAME
  });
  return /* @__PURE__ */ jsx13(DialogProvider, {
    scope: __scopeDialog,
    triggerRef,
    contentRef,
    contentId: useId(),
    titleId: useId(),
    descriptionId: useId(),
    open,
    onOpenChange: setOpen,
    onOpenToggle: React26.useCallback(() => setOpen((prevOpen) => !prevOpen), [setOpen]),
    modal,
    children
  });
};
Dialog.displayName = DIALOG_NAME;
var TRIGGER_NAME = "DialogTrigger";
var DialogTrigger = React26.forwardRef((props62, forwardedRef) => {
  const { __scopeDialog, ...triggerProps } = props62;
  const context = useDialogContext(TRIGGER_NAME, __scopeDialog);
  const composedTriggerRef = useComposedRefs(forwardedRef, context.triggerRef);
  return /* @__PURE__ */ jsx13(Primitive.button, {
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": context.open,
    "aria-controls": context.open ? context.contentId : undefined,
    "data-state": getState(context.open),
    ...triggerProps,
    ref: composedTriggerRef,
    onClick: composeEventHandlers(props62.onClick, context.onOpenToggle)
  });
});
DialogTrigger.displayName = TRIGGER_NAME;
var PORTAL_NAME2 = "DialogPortal";
var [PortalProvider, usePortalContext] = createDialogContext(PORTAL_NAME2, {
  forceMount: undefined
});
var DialogPortal = (props62) => {
  const { __scopeDialog, forceMount, children, container } = props62;
  const context = useDialogContext(PORTAL_NAME2, __scopeDialog);
  return /* @__PURE__ */ jsx13(PortalProvider, { scope: __scopeDialog, forceMount, children: React26.Children.map(children, (child) => /* @__PURE__ */ jsx13(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ jsx13(Portal, { asChild: true, container, children: child }) })) });
};
DialogPortal.displayName = PORTAL_NAME2;
var OVERLAY_NAME = "DialogOverlay";
var DialogOverlay = React26.forwardRef((props62, forwardedRef) => {
  const portalContext = usePortalContext(OVERLAY_NAME, props62.__scopeDialog);
  const { forceMount = portalContext.forceMount, ...overlayProps } = props62;
  const context = useDialogContext(OVERLAY_NAME, props62.__scopeDialog);
  return context.modal ? /* @__PURE__ */ jsx13(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ jsx13(DialogOverlayImpl, { ...overlayProps, ref: forwardedRef }) }) : null;
});
DialogOverlay.displayName = OVERLAY_NAME;
var Slot2 = createSlot("DialogOverlay.RemoveScroll");
var DialogOverlayImpl = React26.forwardRef((props62, forwardedRef) => {
  const { __scopeDialog, ...overlayProps } = props62;
  const context = useDialogContext(OVERLAY_NAME, __scopeDialog);
  const registerDismissableSurface = useDismissableLayerSurface();
  const composedRefs = useComposedRefs(forwardedRef, registerDismissableSurface);
  return /* @__PURE__ */ jsx13(Combination_default, { as: Slot2, allowPinchZoom: true, shards: [context.contentRef], children: /* @__PURE__ */ jsx13(Primitive.div, {
    "data-state": getState(context.open),
    ...overlayProps,
    ref: composedRefs,
    style: { pointerEvents: "auto", ...overlayProps.style }
  }) });
});
var CONTENT_NAME = "DialogContent";
var DialogContent = React26.forwardRef((props62, forwardedRef) => {
  const portalContext = usePortalContext(CONTENT_NAME, props62.__scopeDialog);
  const { forceMount = portalContext.forceMount, ...contentProps } = props62;
  const context = useDialogContext(CONTENT_NAME, props62.__scopeDialog);
  return /* @__PURE__ */ jsx13(Presence, { present: forceMount || context.open, children: context.modal ? /* @__PURE__ */ jsx13(DialogContentModal, { ...contentProps, ref: forwardedRef }) : /* @__PURE__ */ jsx13(DialogContentNonModal, { ...contentProps, ref: forwardedRef }) });
});
DialogContent.displayName = CONTENT_NAME;
var DialogContentModal = React26.forwardRef((props62, forwardedRef) => {
  const context = useDialogContext(CONTENT_NAME, props62.__scopeDialog);
  const contentRef = React26.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, context.contentRef, contentRef);
  React26.useEffect(() => {
    const content = contentRef.current;
    if (content)
      return hideOthers(content);
  }, []);
  return /* @__PURE__ */ jsx13(DialogContentImpl, {
    ...props62,
    ref: composedRefs,
    trapFocus: context.open,
    disableOutsidePointerEvents: context.open,
    onCloseAutoFocus: composeEventHandlers(props62.onCloseAutoFocus, (event) => {
      event.preventDefault();
      context.triggerRef.current?.focus();
    }),
    onPointerDownOutside: composeEventHandlers(props62.onPointerDownOutside, (event) => {
      const originalEvent = event.detail.originalEvent;
      const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
      const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
      if (isRightClick)
        event.preventDefault();
    }),
    onFocusOutside: composeEventHandlers(props62.onFocusOutside, (event) => event.preventDefault())
  });
});
var DialogContentNonModal = React26.forwardRef((props62, forwardedRef) => {
  const context = useDialogContext(CONTENT_NAME, props62.__scopeDialog);
  const hasInteractedOutsideRef = React26.useRef(false);
  const hasPointerDownOutsideRef = React26.useRef(false);
  return /* @__PURE__ */ jsx13(DialogContentImpl, {
    ...props62,
    ref: forwardedRef,
    trapFocus: false,
    disableOutsidePointerEvents: false,
    onCloseAutoFocus: (event) => {
      props62.onCloseAutoFocus?.(event);
      if (!event.defaultPrevented) {
        if (!hasInteractedOutsideRef.current)
          context.triggerRef.current?.focus();
        event.preventDefault();
      }
      hasInteractedOutsideRef.current = false;
      hasPointerDownOutsideRef.current = false;
    },
    onInteractOutside: (event) => {
      props62.onInteractOutside?.(event);
      if (!event.defaultPrevented) {
        hasInteractedOutsideRef.current = true;
        if (event.detail.originalEvent.type === "pointerdown") {
          hasPointerDownOutsideRef.current = true;
        }
      }
      const target = event.target;
      const targetIsTrigger = context.triggerRef.current?.contains(target);
      if (targetIsTrigger)
        event.preventDefault();
      if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) {
        event.preventDefault();
      }
    }
  });
});
var DialogContentImpl = React26.forwardRef((props62, forwardedRef) => {
  const { __scopeDialog, trapFocus, onOpenAutoFocus, onCloseAutoFocus, ...contentProps } = props62;
  const context = useDialogContext(CONTENT_NAME, __scopeDialog);
  useFocusGuards();
  return /* @__PURE__ */ jsx13(Fragment4, { children: /* @__PURE__ */ jsx13(FocusScope, {
    asChild: true,
    loop: true,
    trapped: trapFocus,
    onMountAutoFocus: onOpenAutoFocus,
    onUnmountAutoFocus: onCloseAutoFocus,
    children: /* @__PURE__ */ jsx13(DismissableLayer, {
      role: "dialog",
      id: context.contentId,
      "aria-describedby": context.descriptionId,
      "aria-labelledby": context.titleId,
      "data-state": getState(context.open),
      ...contentProps,
      ref: forwardedRef,
      deferPointerDownOutside: true,
      onDismiss: () => context.onOpenChange(false)
    })
  }) });
});
var TITLE_NAME = "DialogTitle";
var DialogTitle = React26.forwardRef((props62, forwardedRef) => {
  const { __scopeDialog, ...titleProps } = props62;
  const context = useDialogContext(TITLE_NAME, __scopeDialog);
  return /* @__PURE__ */ jsx13(Primitive.h2, { id: context.titleId, ...titleProps, ref: forwardedRef });
});
DialogTitle.displayName = TITLE_NAME;
var DESCRIPTION_NAME = "DialogDescription";
var DialogDescription = React26.forwardRef((props62, forwardedRef) => {
  const { __scopeDialog, ...descriptionProps } = props62;
  const context = useDialogContext(DESCRIPTION_NAME, __scopeDialog);
  return /* @__PURE__ */ jsx13(Primitive.p, { id: context.descriptionId, ...descriptionProps, ref: forwardedRef });
});
DialogDescription.displayName = DESCRIPTION_NAME;
var CLOSE_NAME = "DialogClose";
var DialogClose = React26.forwardRef((props62, forwardedRef) => {
  const { __scopeDialog, ...closeProps } = props62;
  const context = useDialogContext(CLOSE_NAME, __scopeDialog);
  return /* @__PURE__ */ jsx13(Primitive.button, {
    type: "button",
    ...closeProps,
    ref: forwardedRef,
    onClick: composeEventHandlers(props62.onClick, () => context.onOpenChange(false))
  });
});
DialogClose.displayName = CLOSE_NAME;
function getState(open) {
  return open ? "open" : "closed";
}
var ROOT_NAME = "AlertDialog";
var [createAlertDialogContext, createAlertDialogScope] = createContextScope(ROOT_NAME, [
  createDialogScope
]);
var useDialogScope = createDialogScope();
var AlertDialog = (props62) => {
  const { __scopeAlertDialog, ...alertDialogProps } = props62;
  const dialogScope = useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ jsx14(Dialog, { ...dialogScope, ...alertDialogProps, modal: true });
};
AlertDialog.displayName = ROOT_NAME;
var TRIGGER_NAME2 = "AlertDialogTrigger";
var AlertDialogTrigger = React27.forwardRef((props62, forwardedRef) => {
  const { __scopeAlertDialog, ...triggerProps } = props62;
  const dialogScope = useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ jsx14(DialogTrigger, { ...dialogScope, ...triggerProps, ref: forwardedRef });
});
AlertDialogTrigger.displayName = TRIGGER_NAME2;
var PORTAL_NAME3 = "AlertDialogPortal";
var AlertDialogPortal = (props62) => {
  const { __scopeAlertDialog, ...portalProps } = props62;
  const dialogScope = useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ jsx14(DialogPortal, { ...dialogScope, ...portalProps });
};
AlertDialogPortal.displayName = PORTAL_NAME3;
var OVERLAY_NAME2 = "AlertDialogOverlay";
var AlertDialogOverlay = React27.forwardRef((props62, forwardedRef) => {
  const { __scopeAlertDialog, ...overlayProps } = props62;
  const dialogScope = useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ jsx14(DialogOverlay, { ...dialogScope, ...overlayProps, ref: forwardedRef });
});
AlertDialogOverlay.displayName = OVERLAY_NAME2;
var CONTENT_NAME2 = "AlertDialogContent";
var [AlertDialogContentProvider, useAlertDialogContentContext] = createAlertDialogContext(CONTENT_NAME2);
var AlertDialogContent = React27.forwardRef((props62, forwardedRef) => {
  const { __scopeAlertDialog, children, ...contentProps } = props62;
  const dialogScope = useDialogScope(__scopeAlertDialog);
  const contentRef = React27.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, contentRef);
  const cancelRef = React27.useRef(null);
  return /* @__PURE__ */ jsx14(AlertDialogContentProvider, { scope: __scopeAlertDialog, cancelRef, children: /* @__PURE__ */ jsx14(DialogContent, {
    role: "alertdialog",
    ...dialogScope,
    ...contentProps,
    ref: composedRefs,
    onOpenAutoFocus: composeEventHandlers(contentProps.onOpenAutoFocus, (event) => {
      event.preventDefault();
      cancelRef.current?.focus({ preventScroll: true });
    }),
    onPointerDownOutside: (event) => event.preventDefault(),
    onInteractOutside: (event) => event.preventDefault(),
    children
  }) });
});
AlertDialogContent.displayName = CONTENT_NAME2;
var TITLE_NAME2 = "AlertDialogTitle";
var AlertDialogTitle = React27.forwardRef((props62, forwardedRef) => {
  const { __scopeAlertDialog, ...titleProps } = props62;
  const dialogScope = useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ jsx14(DialogTitle, { ...dialogScope, ...titleProps, ref: forwardedRef });
});
AlertDialogTitle.displayName = TITLE_NAME2;
var DESCRIPTION_NAME2 = "AlertDialogDescription";
var AlertDialogDescription = React27.forwardRef((props62, forwardedRef) => {
  const { __scopeAlertDialog, ...descriptionProps } = props62;
  const dialogScope = useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ jsx14(DialogDescription, { ...dialogScope, ...descriptionProps, ref: forwardedRef });
});
AlertDialogDescription.displayName = DESCRIPTION_NAME2;
var ACTION_NAME = "AlertDialogAction";
var AlertDialogAction = React27.forwardRef((props62, forwardedRef) => {
  const { __scopeAlertDialog, ...actionProps } = props62;
  const dialogScope = useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ jsx14(DialogClose, { ...dialogScope, ...actionProps, ref: forwardedRef });
});
AlertDialogAction.displayName = ACTION_NAME;
var CANCEL_NAME = "AlertDialogCancel";
var AlertDialogCancel = React27.forwardRef((props62, forwardedRef) => {
  const { __scopeAlertDialog, ...cancelProps } = props62;
  const { cancelRef } = useAlertDialogContentContext(CANCEL_NAME, __scopeAlertDialog);
  const dialogScope = useDialogScope(__scopeAlertDialog);
  const ref = useComposedRefs(forwardedRef, cancelRef);
  return /* @__PURE__ */ jsx14(DialogClose, { ...dialogScope, ...cancelProps, ref });
});
AlertDialogCancel.displayName = CANCEL_NAME;
var Root2 = AlertDialog;
var Trigger2 = AlertDialogTrigger;
var Portal2 = AlertDialogPortal;
var Overlay2 = AlertDialogOverlay;
var Content2 = AlertDialogContent;
var Action = AlertDialogAction;
var Cancel = AlertDialogCancel;
var Title2 = AlertDialogTitle;
var Description2 = AlertDialogDescription;
function classes(...values) {
  const value = values.filter(Boolean).join(" ");
  return value || undefined;
}
var styles = {
  button: {
    kGNEyG: "x6s0dn4",
    kysU6D: "xjyslct",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kaIpWk: "xu4hgxq",
    kB7OPa: "x9f619",
    kkrTdU: "x1ypdohk",
    k1xSpc: "x3nfvp2",
    kmuXW: "x2lah0s",
    kMv6JI: "x5ddh9m",
    kGuDYH: "x4z9k3i",
    k63SB2: "x1s688f",
    kOIVth: "x167g77z",
    kjj79g: "xl56j7k",
    kLWn49: "xo5v014",
    kAzted: "xu0aao5",
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    kHjlTd: "xj0a0fe",
    kI3sdo: "x1a2a7pz",
    k8WAf4: "x1vvogim",
    kg3NbH: "xqin4a2",
    kybGjl: "x1hl2dhg",
    kmkexE: "x5gjymy x9kvfbb",
    khDVqt: "xeaf4i8",
    kEtg5x: "x1a2sn02",
    kYPGJ8: "x1s07b3s",
    kWCcOm: "xijokvz",
    kEVmhK: "x1gl3shj",
    kTWfjk: "x126n28w",
    $$css: true
  },
  primary: {
    kWkggS: "x15vqgvx",
    kVAM5u: "xawfzfr",
    kMwMTN: "x1um1dla",
    k3aq6I: "x1nlf60j x6wgdar",
    kI3sdo: "x1a2a7pz x1f1sp5 x7iwzyl",
    kInvED: "xr2mjdv",
    kIa11j: "xvs6z26",
    kLmhY5: "xliqn1l",
    kD2jPA: "x163vtw",
    kdODIN: "xcysz91",
    kWC4TW: "x1bi1fg1",
    kWCcOm: "x1fzehxr",
    $$css: true
  },
  secondary: {
    kWkggS: "xbslqsl",
    kVAM5u: "x8tuc8h",
    kMwMTN: "xqvuw85",
    kGzVvX: "x1uvu3ev",
    kaVNsj: "x1jokge8",
    $$css: true
  },
  outline: {
    kWkggS: "xjbqb8w",
    kVAM5u: "x8tuc8h",
    kMwMTN: "xgi1xjn",
    kGzVvX: "xgvbf8n",
    kaVNsj: "x1jokge8",
    kDPRdz: "x18m2ztq",
    $$css: true
  },
  ghost: {
    kWkggS: "xjbqb8w",
    kVAM5u: "x9r1u3d",
    kMwMTN: "xgi1xjn",
    kGzVvX: "xgvbf8n",
    kDPRdz: "x18m2ztq",
    $$css: true
  },
  danger: {
    kWkggS: "xjbqb8w",
    kVAM5u: "x1ezim0c",
    kMwMTN: "x1mel2pz",
    kGzVvX: "xo6m4nm",
    kaVNsj: "xu43hr4",
    kEtg5x: "xfmqteo",
    $$css: true
  },
  link: {
    kWkggS: "xjbqb8w",
    kVAM5u: "x9r1u3d",
    kMwMTN: "x1myn341",
    kAzted: "x65nank",
    k8WAf4: "xj8oexa",
    kg3NbH: "xnjsko4",
    k67Jb4: "xt0b8zv",
    $$css: true
  },
  sizeXs: {
    kaIpWk: "x1kogg8i",
    kGuDYH: "x1j6dyjg",
    kOIVth: "x1nejdyq",
    kAzted: "xe0p6wg",
    k8WAf4: "xifx94n",
    kg3NbH: "x1q4txso",
    $$css: true
  },
  sizeSm: {
    kGuDYH: "xfifm61",
    kAzted: "x21xpn4",
    k8WAf4: "x1t0vds8",
    kg3NbH: "xfoe8qy",
    $$css: true
  },
  sizeLg: {
    kGuDYH: "xif65rj",
    kAzted: "xgujvf1",
    k8WAf4: "xp59q4u",
    kg3NbH: "x17qtykl",
    $$css: true
  },
  icon: {
    kZKoxP: "xc9qbxq",
    kAzted: "xu0aao5",
    kmVPX3: "x1717udv",
    khDVqt: "xuxw1ft",
    kzqmXN: "x14qfxbe",
    $$css: true
  },
  iconXs: {
    kZKoxP: "x1fgtraw",
    kAzted: "xe0p6wg",
    kmVPX3: "x1717udv",
    khDVqt: "xuxw1ft",
    kzqmXN: "xgd8bvy",
    $$css: true
  },
  iconSm: {
    kZKoxP: "x10w6t97",
    kAzted: "x21xpn4",
    kmVPX3: "x1717udv",
    khDVqt: "xuxw1ft",
    kzqmXN: "x1td3qas",
    $$css: true
  },
  iconLg: {
    kZKoxP: "x5kalc8",
    kAzted: "xgujvf1",
    khDVqt: "xuxw1ft",
    kmVPX3: "x1717udv",
    kzqmXN: "x10h3iyq",
    $$css: true
  },
  touchIcon: {
    k7Eaqz: "xeuugli x160ygfx",
    $$css: true
  },
  control: {
    kysU6D: "xjyslct",
    kWkggS: "x18s3upu",
    kVAM5u: "x8tuc8h",
    kaIpWk: "xu4hgxq",
    ksu8eU: "x1y0btm7",
    kMzoRj: "xmkeg23",
    kB7OPa: "x9f619",
    kMwMTN: "xqvuw85",
    kMv6JI: "x5ddh9m",
    kGuDYH: "x4z9k3i xhhd8f x1yr6pw4",
    kLWn49: "x1xfvgam",
    kAzted: "x1ba4aug",
    k7Eaqz: "xeuugli",
    kI3sdo: "x1a2a7pz",
    k8WAf4: "x1vvogim",
    kg3NbH: "xfoe8qy",
    kmkexE: "x1p5amsn",
    kzqmXN: "xh8yej3",
    k8Qsv1: "x1wku8z5",
    k4mVRr: "xf77ohz",
    kWEjV4: "x6q9x63",
    kYPGJ8: "x1s07b3s",
    kWCcOm: "xk0mbs4",
    kHRqo9: "xck444f",
    kSaF8F: "x10ve9f0",
    $$css: true
  },
  select: {
    kKwaWg: "x18wh80x",
    k1YJky: "xqbhmck",
    kz484i: "xiy17q3",
    kgSjnq: "x6khlng",
    kwRFfy: "x5zjp28",
    $$css: true
  },
  textarea: {
    kAzted: "xefclja",
    kHenm0: "x288g5",
    $$css: true
  }
};
function buttonStyles(variant, size) {
  const tone = variant === "default" || variant === "primary" ? styles.primary : variant === "destructive" || variant === "danger" ? styles.danger : variant === "secondary" ? styles.secondary : variant === "ghost" ? styles.ghost : variant === "link" ? styles.link : styles.outline;
  const sizeStyle = size === "xs" ? styles.sizeXs : size === "sm" ? styles.sizeSm : size === "lg" ? styles.sizeLg : size === "icon" ? styles.icon : size === "icon-xs" ? styles.iconXs : size === "icon-sm" ? styles.iconSm : size === "icon-lg" ? styles.iconLg : undefined;
  return sizeStyle ? [styles.button, tone, sizeStyle, size.startsWith("icon") && styles.touchIcon] : [styles.button, tone];
}
function Button({
  className,
  variant = "default",
  size = "default",
  asChild = false,
  xstyle,
  style,
  ...props72
}) {
  const Component = asChild ? exports_dist.Root : "button";
  const styleProps = stylex6.props(...buttonStyles(variant, size), xstyle);
  return /* @__PURE__ */ jsx15(Component, {
    "data-slot": "button",
    "data-variant": variant,
    "data-size": size,
    className: classes(styleProps.className, className),
    style: {
      ...styleProps.style,
      ...style
    },
    ...props72
  });
}
function classes2(...values) {
  const value = values.filter(Boolean).join(" ");
  return value || undefined;
}
function subscribeToClient() {
  return () => {};
}
function clientSnapshot() {
  return true;
}
function serverSnapshot() {
  return false;
}
function ConfirmDialog(props72) {
  const pending = props72.pending === true;
  const client = useSyncExternalStore(subscribeToClient, clientSnapshot, serverSnapshot);
  const Surface = client ? exports_dist2.Portal : Fragment5;
  return /* @__PURE__ */ jsx16(exports_dist2.Root, {
    open: true,
    onOpenChange: (open) => {
      if (!open && !pending)
        props72.onCancel();
    },
    children: /* @__PURE__ */ jsxs4(Surface, {
      ...client ? {
        container: document.body
      } : {},
      children: [
        /* @__PURE__ */ jsx16(exports_dist2.Overlay, {
          className: {
            className: "x779uuu xpivpjv x10a8y8t xixxii4 xfo81ep"
          }.className,
          onPointerDown: props72.dismissOnOutside && !pending ? props72.onCancel : undefined
        }),
        /* @__PURE__ */ jsxs4(exports_dist2.Content, {
          className: classes2({
            className: "x18s3upu x8tuc8h xixl9f9 x1y0btm7 xmkeg23 x1b3fvf2 xqvuw85 xj0a0fe xrvj5dj xou54vl x1nrll8i xojfs98 xw7nakj x1a2a7pz x1odjw0f xggk2y7 xixxii4 xwa60dl x11lhmoz xv9tjks x1bkdxzg x1lclwwd xgrp7ii x1imafyg x1lgz1aq x172uiah xxnk3sr xeyi6kz x1lak8av x1qa1qnr xl7365u x1mji7za x1dbdljh"
          }.className, "delete-modal", props72.sectionClassName),
          "aria-labelledby": props72.titleId,
          children: [
            /* @__PURE__ */ jsx16("span", {
              className: {
                className: "x6s0dn4 xu2kkqm x16rqkct x1mel2pz x3nfvp2 xa9opjo xosj86m xc9qbxq xl56j7k x14qfxbe"
              }.className,
              "aria-hidden": true,
              children: props72.mark
            }),
            /* @__PURE__ */ jsx16(exports_dist2.Title, {
              id: props72.titleId,
              className: {
                className: "xqvuw85 xssy22x x1i1m3gp xk50ysn x1uo3zyz x1ghz6dp"
              }.className,
              children: props72.title
            }),
            /* @__PURE__ */ jsx16(exports_dist2.Description, {
              asChild: true,
              children: /* @__PURE__ */ jsx16("div", {
                children: props72.children
              })
            }),
            /* @__PURE__ */ jsxs4("div", {
              className: {
                className: "x78zum5 x883omv x13a6bvl x10acg2q x5z33oq"
              }.className,
              children: [
                /* @__PURE__ */ jsx16(exports_dist2.Cancel, {
                  asChild: true,
                  children: /* @__PURE__ */ jsx16(Button, {
                    type: "button",
                    variant: "outline",
                    disabled: pending,
                    children: props72.cancelLabel
                  })
                }),
                /* @__PURE__ */ jsx16(Button, {
                  type: "button",
                  variant: props72.confirmVariant ?? "primary",
                  className: props72.confirmClassName,
                  disabled: pending,
                  onClick: props72.onConfirm,
                  children: props72.confirmLabel
                })
              ]
            })
          ]
        })
      ]
    })
  });
}
var AppFetchContext = createContext3(undefined);
var text = {
  good: {
    kMwMTN: "x19k5i5u",
    $$css: true
  },
  warn: {
    kMwMTN: "x1ra7g20",
    $$css: true
  },
  error: {
    kMwMTN: "x1mel2pz",
    $$css: true
  }
};
var fill = {
  good: {
    kDwRjp: "x1s7eawt",
    $$css: true
  },
  warn: {
    kDwRjp: "x1v1fulq",
    $$css: true
  },
  error: {
    kDwRjp: "xp8jjoe",
    $$css: true
  }
};
function toneText(tone) {
  return tone !== undefined && tone !== "neutral" && text[tone];
}
function toneFill(tone) {
  return tone !== undefined && tone !== "neutral" && fill[tone];
}
var factStyles = {
  root: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x27jn57",
    k1C7PZ: "x1wh94ac",
    kGNEyG: "x7a106z",
    kogj98: "x1ghz6dp",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  compactRoot: {
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "xltl5i9",
    $$css: true
  },
  row: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kjj79g: "x1qughib",
    kGNEyG: "x1pha0wt",
    kOIVth: "x1vtxxvk",
    k8WAf4: "x1b9wmvo",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xpqg30t",
    $$css: true
  },
  compactRow: {
    k8WAf4: "x1m7iz9m",
    $$css: true
  },
  label: {
    kUk6DE: "xkz0k9k",
    k7Eaqz: "xeuugli",
    kMv6JI: "x5ddh9m",
    kGuDYH: "xfifm61",
    kLWn49: "x1dbl2gt",
    kMwMTN: "x1ar3pfp",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  value: {
    kUk6DE: "x12lumcd",
    k7Eaqz: "xeuugli",
    kogj98: "x1ghz6dp",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1j6dyjg",
    kLWn49: "x1dbl2gt",
    kcqcaj: "xss6m8b",
    k9WMMc: "x1hr2gdg",
    kMwMTN: "xqvuw85",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  compactValue: {
    kGuDYH: "xfifm61",
    k9WMMc: "xdpxx8g",
    $$css: true
  },
  caption: {
    kBCFzs: "x1osaytk",
    kCS8Yb: "x1l7klhg",
    kogj98: "x1ghz6dp",
    k7Eaqz: "xeuugli",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "x5ddh9m",
    kGuDYH: "xfifm61",
    kLWn49: "x1dbl2gt",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  referenceRoot: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kEafiO: "x972fbf",
    $$css: true
  },
  referenceRow: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x8tdwv4",
    kOIVth: "x1v2ro7d",
    k8WAf4: "x1vvogim",
    kg3NbH: "xnjsko4",
    kt9PQ7: "x1qhh985",
    kEafiO: "x178xt8z x1g31smg",
    kPef9Z: "x13fuv20",
    kLZC3w: "xvg7k2t",
    $$css: true
  },
  referenceLabel: {
    kMv6JI: "xa9opjo",
    kGuDYH: "xfmn3hh",
    kLWn49: "x1evy7pa",
    kb6lSQ: "xwhmn0f",
    kP9fke: "xtvhhri",
    $$css: true
  },
  referenceValue: {
    kGuDYH: "x1s31vzs",
    kLWn49: "x1evy7pa",
    kcqcaj: "xj8fevo",
    k9WMMc: "x1hr2gdg",
    kMwMTN: "xgi1xjn",
    $$css: true
  }
};
var recordStyles = {
  copy: {
    k7Eaqz: "xeuugli",
    kUk6DE: "x845mor",
    $$css: true
  },
  title: {
    k1xSpc: "x1lliihq",
    kMv6JI: "x5ddh9m",
    kGuDYH: "x1j61zf2",
    k63SB2: "xk50ysn",
    kLWn49: "x37zpob",
    kb6lSQ: "x12oo3zp",
    kMwMTN: "xqvuw85",
    kHjlTd: "x1mzt3pk",
    $$css: true
  },
  compactTitle: {
    kMv6JI: "xssy22x",
    k63SB2: "x11zgcw",
    kb6lSQ: "x1ixy4ik",
    $$css: true
  },
  editorial: {
    kMv6JI: "xssy22x",
    kGuDYH: "xwsyq91",
    k63SB2: "xo1l8bm",
    kLWn49: "x1xfvgam",
    kb6lSQ: "x1xte0cv",
    $$css: true
  },
  attention: {
    kGuDYH: "xosj86m",
    k63SB2: "xk50ysn",
    kLWn49: "x1xfvgam",
    kb6lSQ: "x1xte0cv",
    $$css: true
  },
  primaryAttention: {
    k63SB2: "x1xlr1w8",
    $$css: true
  },
  activity: {
    kGuDYH: "xif65rj",
    k63SB2: "xk50ysn",
    kLWn49: "xfrs9s4",
    $$css: true
  },
  activityDescription: {
    kLWn49: "x1dbl2gt",
    $$css: true
  },
  compactDescription: {
    kGuDYH: "x1ct8sxb",
    kLWn49: "x1evy7pa",
    $$css: true
  },
  timestamp: {
    kMv6JI: "xa9opjo",
    kGuDYH: "x1j6dyjg",
    k63SB2: "xo1l8bm",
    kLWn49: "x1dbl2gt",
    kcqcaj: "x1j4x3al",
    kb6lSQ: "x1xte0cv",
    $$css: true
  },
  clamped: {
    k1xSpc: "x104kibb",
    kgKLqz: "x1ua5tub",
    kJFfOR: "x1h7i4cw",
    kVQacm: "xb3r6kr",
    $$css: true
  },
  description: {
    kogj98: "x1pz56wa",
    kMv6JI: "x5ddh9m",
    kGuDYH: "xfifm61",
    kLWn49: "xa7kkou",
    kMwMTN: "xgi1xjn",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  metadata: {
    k1xSpc: "x1lliihq",
    keoZOQ: "x1xmf6yo",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1j6dyjg",
    kLWn49: "x1dbl2gt",
    kMwMTN: "x1ar3pfp",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  compactMetadata: {
    kMv6JI: "xa9opjo",
    kGuDYH: "x1s31vzs",
    $$css: true
  },
  link: {
    kmVPX3: "x1717udv",
    kMzoRj: "xc342km",
    kWkggS: "xjbqb8w",
    kMwMTN: "x1myn341",
    kMv6JI: "xjb2p0i",
    kGuDYH: "x1qlqyl8",
    k63SB2: "x1pd3egz",
    kb6lSQ: "x4gjf66",
    k9WMMc: "x16tdsg8",
    kMnn75: "xkrqix3 x1sur9pj",
    kcSHmL: "xda060z",
    k1TLXF: "x1ua538i",
    kkrTdU: "x1ypdohk",
    kHjlTd: "xj0a0fe",
    kInvED: "x1hl8ikr",
    k3XXqK: "x1t137rt x9v5kkp",
    kMeerF: "x1de99jn",
    kjBf7l: "x1itw484",
    $$css: true
  },
  stretchedLink: {
    kVAEAm: "x1uhb9sk",
    k3XXqK: "x1t137rt",
    k5JduY: "x1s928wv",
    kwXMNM: "x1j6awrg",
    kv0HGH: "xarstr8",
    k9Ux3I: "x13k4006",
    $$css: true
  },
  titleLink: {
    kMwMTN: "x1heor9g xz2iokx",
    $$css: true
  },
  quietLink: {
    kMwMTN: "xgi1xjn xz2iokx",
    kHdLCk: "x13v5x0x",
    kdLj2q: "xp7j7s0",
    kTWfjk: "x1c4ya5t",
    $$css: true
  }
};
function OperatorMetadata({
  values,
  stackDates = false
}) {
  return /* @__PURE__ */ jsx17(Fragment7, {
    children: values.map((value, index) => {
      const match = /^(.*?)(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2}))$/.exec(value);
      const timestamp = match?.[2];
      const date = timestamp ? new Date(timestamp) : null;
      return /* @__PURE__ */ jsxs5(Fragment6, {
        children: [
          index > 0 ? stackDates && date && Number.isFinite(date.getTime()) ? /* @__PURE__ */ jsx17("br", {}) : " · " : "",
          date && timestamp && Number.isFinite(date.getTime()) ? /* @__PURE__ */ jsxs5(Fragment7, {
            children: [
              match[1],
              /* @__PURE__ */ jsx17("time", {
                ...stylex7.props(recordStyles.timestamp),
                dateTime: timestamp,
                title: timestamp,
                children: new Intl.DateTimeFormat(undefined, {
                  year: date.getFullYear() === new Date().getFullYear() ? undefined : "numeric",
                  month: "short",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  timeZoneName: "short"
                }).format(date)
              })
            ]
          }) : value
        ]
      }, `${index}:${value}`);
    })
  });
}
function OperatorFacts(props92) {
  const compact = props92.density === "compact";
  const reference = props92.presentation === "reference";
  const root = stylex8.props(factStyles.root, compact && factStyles.compactRoot, reference && factStyles.referenceRoot);
  return /* @__PURE__ */ jsx18("dl", {
    ...root,
    "data-facts": "",
    "data-facts-presentation": props92.presentation,
    children: props92.items.map((item, index) => /* @__PURE__ */ jsxs6("div", {
      ...stylex8.props(factStyles.row, compact && factStyles.compactRow, reference && factStyles.referenceRow),
      "data-tone": item.tone ?? "neutral",
      children: [
        /* @__PURE__ */ jsx18("dt", {
          ...stylex8.props(factStyles.label, reference && factStyles.referenceLabel),
          children: item.label
        }),
        item.value !== undefined && /* @__PURE__ */ jsx18("dd", {
          ...stylex8.props(factStyles.value, compact && factStyles.compactValue, reference && factStyles.referenceValue, toneText(item.tone)),
          children: typeof item.value === "string" ? /* @__PURE__ */ jsx18(OperatorMetadata, {
            values: [item.value]
          }) : item.value
        }),
        item.caption && /* @__PURE__ */ jsx18("dd", {
          ...stylex8.props(factStyles.caption),
          children: item.caption
        })
      ]
    }, `${item.label}:${index}`))
  });
}
var layoutStyles = {
  card: {
    k7Eaqz: "xeuugli",
    $$css: true
  },
  labeledDisclosure: {
    k1xSpc: "xrvj5dj",
    kumcoG: "xju1xpo x79gikr x1c2rghm x4jmfmw",
    kGNEyG: "x6s0dn4",
    kOIVth: "xou54vl",
    $$css: true
  },
  disclosureHeading: {
    k1xSpc: "x1lliihq",
    kt9PQ7: "x1qhh985",
    kGO01o: "x18d9i69",
    k1K539: "xat24cr",
    kb6lSQ: "x12oo3zp",
    kP9fke: "x6mezaz",
    $$css: true
  },
  compactCard: {
    kmVPX3: "x1k10g7g",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h",
    kaIpWk: "xur7f20",
    kWkggS: "x18s3upu",
    $$css: true
  },
  feature: {
    kmVPX3: "xggk2y7 xwn745a",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xy1lt07",
    kaIpWk: "x1sxf85j",
    kWkggS: "x18s3upu",
    $$css: true
  },
  featureHeading: {
    kMv6JI: "xssy22x",
    kGuDYH: "xswp564",
    k63SB2: "x1e5oar2",
    ka26j: "xkhxzli",
    kLWn49: "xd0avp8",
    kb6lSQ: "x12rpand",
    kP9fke: "x6mezaz",
    k1K539: "x1yztbdb",
    kGO01o: "x18d9i69",
    kt9PQ7: "x1qhh985",
    kMwMTN: "xqvuw85",
    $$css: true
  },
  headingLabel: {
    kogj98: "x1ghz6dp",
    k7Eaqz: "xeuugli",
    kMv6JI: "xjb2p0i",
    kGuDYH: "x1qlqyl8",
    k63SB2: "x1pd3egz",
    kLWn49: "x15bjb6t",
    kb6lSQ: "x4gjf66",
    kP9fke: "x5ftkge",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  headingMetadata: {
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1j6dyjg",
    k63SB2: "xo1l8bm",
    kLWn49: "x1dbl2gt",
    kP9fke: "x6mezaz",
    kb6lSQ: "x12oo3zp",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  heading: {
    k1xSpc: "x78zum5",
    kGNEyG: "x1pha0wt",
    kjj79g: "x1qughib",
    kOIVth: "xou54vl",
    kogj98: "x1ghz6dp",
    kGO01o: "xsag5q8",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xna4lh4",
    kMv6JI: "x2hta5a",
    kGuDYH: "x125tp1q",
    k63SB2: "x17l7a04",
    kLWn49: "x1xfvgam",
    kMwMTN: "xqvuw85",
    $$css: true
  },
  compactHeading: {
    k1K539: "xyorhqc",
    kGO01o: "x18d9i69",
    kt9PQ7: "x1qhh985",
    kMv6JI: "xa9opjo",
    kGuDYH: "x121jh6c",
    k63SB2: "x1bgvhw5",
    kb6lSQ: "x1r16saa",
    kP9fke: "xtvhhri",
    kMwMTN: "x1ar3pfp",
    $$css: true
  },
  summary: {
    kkrTdU: "x1ypdohk",
    kMv6JI: "x5ddh9m",
    kGuDYH: "x4z9k3i",
    kLWn49: "x1dbl2gt",
    kMwMTN: "xgi1xjn",
    kInvED: "x1hl8ikr",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  disclosure: {
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xpqg30t",
    kGO01o: "x18d9i69 x15m6qhz",
    $$css: true
  },
  comfortableSummary: {
    kB7OPa: "x9f619",
    kAzted: "x1wxaq2x",
    kmVPX3: "x1g8o3q3",
    kGuDYH: "xfifm61",
    kMwMTN: "x1ar3pfp",
    $$css: true
  },
  attentionSummary: {
    kGuDYH: "xosj86m",
    k63SB2: "xk50ysn",
    kLWn49: "x1xfvgam",
    kMwMTN: "xqvuw85",
    $$css: true
  },
  attentionMetadata: {
    k1xSpc: "x1lliihq",
    keoZOQ: "x1xmf6yo",
    $$css: true
  },
  figuresSummary: {
    kGuDYH: "x1jvydc1",
    k63SB2: "x1s688f",
    kMwMTN: "xqvuw85",
    $$css: true
  },
  figures: {
    kyUFMd: "x18mqm2i",
    k1xSpc: "x78zum5",
    kOIVth: "xaobbuh",
    kogj98: "x1ghz6dp",
    keTefX: "xyqm7xq",
    $$css: true
  },
  figure: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kGNEyG: "xuk3077",
    k7Eaqz: "x1fns5xo",
    $$css: true
  },
  figureLabel: {
    kayTVb: "x14yy4lh",
    kMwMTN: "x1ar3pfp",
    kGuDYH: "x1qt5hsa",
    k63SB2: "xo1l8bm",
    kLWn49: "xwn7fz2",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  figureValue: {
    kayTVb: "x9ek82g",
    kogj98: "x1ghz6dp",
    kMwMTN: "xqvuw85",
    kGuDYH: "x1q7jzdg",
    k63SB2: "xk50ysn",
    kcqcaj: "xss6m8b",
    kLWn49: "x1159mfc",
    $$css: true
  },
  body: {
    k1xSpc: "xrvj5dj",
    kOIVth: "xou54vl",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  disclosedBody: {
    kLKAdn: "xyamay9",
    $$css: true
  },
  warn: {
    kZ1KPB: "x19sr0n1",
    k4WBpm: "x19ypqd9",
    kaZRDh: "xzxeg27",
    kE3dHu: "xnm25rq",
    $$css: true
  },
  error: {
    kZ1KPB: "x19sr0n1",
    k4WBpm: "x19ypqd9",
    kaZRDh: "xju8803",
    kE3dHu: "xnm25rq",
    $$css: true
  },
  good: {
    kZ1KPB: "x19sr0n1",
    k4WBpm: "x19ypqd9",
    kaZRDh: "xan25v",
    $$css: true
  },
  columns: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x13ryq8l",
    kGNEyG: "x7a106z",
    kOIVth: "xv5gsod",
    kjdo94: "xirox3h",
    kAkjA9: "x1mlu5rb",
    kDFLj8: "xtpkkxw",
    ke58cn: "xpodh61",
    $$css: true
  },
  compactColumns: {
    kumcoG: "x1m2f7u7 xtpkkxw xirox3h",
    kOIVth: "xseyljb",
    $$css: true
  },
  region: {
    k1xSpc: "xrvj5dj",
    kfiyM8: "x10ukxgv",
    kOIVth: "x1jaupxr",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  joinedRegion: {
    kOIVth: "xxhr3t",
    $$css: true
  },
  compactAside: {
    kOIVth: "x1qg7m3j",
    $$css: true
  },
  asideRegion: {
    kanfag: "xmzwrfy",
    k9g6sI: "x12h1iku",
    $$css: true
  }
};
var panelColumnsStyles = {
  root: {
    k1xSpc: "xrvj5dj",
    kGNEyG: "x7a106z",
    kumcoG: "xpr710q xirox3h",
    kOIVth: "x1af02g3",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  primary: {
    kumcoG: "xnby9oq x57k0db",
    kOIVth: "x1af02g3",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  aside: {
    k1xSpc: "x78zum5 x1dtk984",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1af02g3",
    k7Eaqz: "xeuugli",
    kumcoG: "x11pl5mh x57k0db",
    $$css: true
  }
};
function OperatorColumns(props102) {
  const compact = props102.density === "compact";
  const panelLayout = props102.presentation === "panels";
  const Aside = panelLayout ? "aside" : "div";
  const root = stylex9.props(panelLayout ? panelColumnsStyles.root : layoutStyles.columns, !panelLayout && compact && layoutStyles.compactColumns);
  const primary = stylex9.props(layoutStyles.region, props102.joined && layoutStyles.joinedRegion, panelLayout && panelColumnsStyles.primary);
  const aside = stylex9.props(layoutStyles.asideRegion, layoutStyles.region, compact && layoutStyles.compactAside, props102.joined && layoutStyles.joinedRegion, panelLayout && panelColumnsStyles.aside);
  return /* @__PURE__ */ jsxs7("div", {
    ...root,
    "data-columns": "",
    "data-columns-presentation": props102.presentation,
    children: [
      /* @__PURE__ */ jsx19("div", {
        ...primary,
        "data-column": "primary",
        children: props102.primary
      }),
      /* @__PURE__ */ jsx19(Aside, {
        ...aside,
        "data-column": "aside",
        children: props102.aside
      })
    ]
  });
}
var statsStyles = {
  root: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "xkagz3p",
    kogj98: "x1ghz6dp",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  captioned: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x1g9xdvi",
    kGNEyG: "x7a106z",
    $$css: true
  },
  item: {
    k1xSpc: "x78zum5",
    kGNEyG: "x1pha0wt",
    kwnvtZ: "x1a02dak",
    kOIVth: "x1nejdyq",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  label: {
    kMwMTN: "xgi1xjn",
    kMv6JI: "x5ddh9m",
    kGuDYH: "xfifm61",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  value: {
    kogj98: "x1ghz6dp",
    kMwMTN: "xqvuw85",
    kMv6JI: "xa9opjo",
    kGuDYH: "xfifm61",
    k63SB2: "x1s688f",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  caption: {
    kCS8Yb: "x1l7klhg",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1j6dyjg",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  compact: {
    k1xSpc: "xrvj5dj",
    kumcoG: "xp2hupy",
    kOIVth: "x12mrbbr",
    kWkggS: "xg47p5g",
    $$css: true
  },
  compactItem: {
    k1xSpc: "x1lliihq",
    kmVPX3: "xp0g775",
    kWkggS: "x1dd94t5",
    $$css: true
  },
  compactLabel: {
    kMv6JI: "xa9opjo",
    kGuDYH: "xfmn3hh",
    kb6lSQ: "x1labic3",
    kP9fke: "xtvhhri",
    $$css: true
  },
  compactValue: {
    keoZOQ: "x1k70j0n",
    kMv6JI: "xssy22x",
    kGuDYH: "x5heo1l",
    ka26j: "x1nqv8xj",
    k63SB2: "xmvyi9x",
    kLWn49: "xo5v014",
    $$css: true
  },
  head: {
    k1xSpc: "x78zum5",
    kGNEyG: "xuk3077",
    kwnvtZ: "x1a02dak",
    kOIVth: "xaobbuh",
    kWkggS: "xjbqb8w",
    $$css: true
  },
  headItem: {
    kmVPX3: "x1717udv",
    kWkggS: "xjbqb8w",
    $$css: true
  },
  headValue: {
    kGuDYH: "x3vlhr4",
    $$css: true
  },
  ledger: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x1sipb5g x1nae48y xou8obv",
    kOIVth: "xxhr3t",
    kGNEyG: "x1qjc9v5",
    kWkggS: "xjbqb8w",
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "xvg7k2t",
    kZ1KPB: "xe0pwq",
    k4WBpm: "x19ypqd9",
    kaZRDh: "xz6lizu",
    $$css: true
  },
  ledgerItem: {
    k1xSpc: "x1lliihq",
    kmVPX3: "xe2wrrw",
    kWkggS: "xjbqb8w",
    kWqL5O: "xs1s249",
    kSWEuD: "x32b0ac",
    k26BEO: "x3a9l4s",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xpqg30t",
    $$css: true
  },
  ledgerLabel: {
    kVQacm: "xb3r6kr",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "xlp3en2",
    kb6lSQ: "x1dor1uw",
    kg5iWk: "xlyipyv",
    kP9fke: "xtvhhri",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  ledgerValue: {
    keoZOQ: "x1ok221b",
    kMv6JI: "xssy22x",
    kGuDYH: "xneq65o x1kth5g4",
    ka26j: "x1nymx6x",
    k63SB2: "x184j2wm",
    kLWn49: "xo5v014",
    $$css: true
  }
};
var statsBandStyles = {
  root: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x185a7wo x57k0db",
    kogj98: "x17y8zlc",
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "xvg7k2t",
    kWkggS: "xe04znv",
    $$css: true
  },
  item: {
    k7Eaqz: "xeuugli",
    kmVPX3: "x16euas4",
    kZ1KPB: "xe0pwq x1e5dqpa x1n97idq",
    k4WBpm: "x19ypqd9",
    kaZRDh: "xz6lizu",
    kEafiO: "x972fbf xnc2tav x6gzigo",
    kPef9Z: "x13fuv20",
    kLZC3w: "xvg7k2t",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  label: {
    k1xSpc: "x1lliihq",
    kMwMTN: "x1v3krkk",
    kMv6JI: "xa9opjo",
    kGuDYH: "xlp3en2",
    kb6lSQ: "x2hcs4w",
    kP9fke: "xtvhhri",
    $$css: true
  },
  value: {
    k1xSpc: "x1rg5ohu",
    kogj98: "xqe1szj",
    kMwMTN: "xqvuw85",
    kMv6JI: "xssy22x",
    kGuDYH: "x5heo1l",
    k63SB2: "xk50ysn",
    $$css: true
  },
  caption: {
    k1xSpc: "x1rg5ohu",
    kogj98: "x1fylewd",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "xlp3en2",
    kb6lSQ: "x9pfba7",
    kP9fke: "xtvhhri",
    $$css: true
  }
};
function OperatorStats(props112) {
  const compact = props112.density === "compact", head = props112.placement === "head", ledger = props112.presentation === "ledger", band = props112.presentation === "band";
  const Caption = band ? "dd" : "small";
  return /* @__PURE__ */ jsx20("dl", {
    ...stylex10.props(band ? statsBandStyles.root : statsStyles.root, !band && !compact && props112.items.length > 1 && props112.items.every((item) => item.caption) && statsStyles.captioned, !band && compact && statsStyles.compact, !band && head && statsStyles.head, ledger && statsStyles.ledger),
    "data-stats-placement": props112.placement ?? "body",
    "data-stats-presentation": props112.presentation,
    children: props112.items.map((item, index) => /* @__PURE__ */ jsxs8("div", {
      "data-tone": item.tone ?? "neutral",
      ...stylex10.props(band ? statsBandStyles.item : statsStyles.item, !band && compact && statsStyles.compactItem, !band && head && statsStyles.headItem, ledger && statsStyles.ledgerItem),
      children: [
        /* @__PURE__ */ jsx20("dt", {
          ...stylex10.props(band ? statsBandStyles.label : statsStyles.label, !band && compact && statsStyles.compactLabel, ledger && statsStyles.ledgerLabel),
          children: item.label
        }),
        /* @__PURE__ */ jsx20("dd", {
          ...stylex10.props(band ? statsBandStyles.value : statsStyles.value, !band && compact && statsStyles.compactValue, !band && head && statsStyles.headValue, ledger && statsStyles.ledgerValue, toneText(item.tone)),
          children: item.value
        }),
        item.caption && /* @__PURE__ */ jsx20(Caption, {
          ...stylex10.props(band ? statsBandStyles.caption : statsStyles.caption, toneText(item.captionTone)),
          children: item.caption
        })
      ]
    }, `${item.label}:${index}`))
  });
}
var noticeStyles = {
  root: {
    k7Eaqz: "xeuugli",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "x1qughib",
    kOIVth: "xmt3bw4",
    k8WAf4: "xf4egzd",
    kE3dHu: "x5tiur9",
    kpe85a: "x1xpa7k",
    kdLj2q: "x1fpodaz",
    kf00j: "xzbubq",
    kLyoy9: "xd9d3ul",
    kfGByI: "x1tkp2ng",
    kCt4T7: "x1xy9y68",
    kzgltN: "x1i03alp",
    k4qugS: "x1unfst4",
    k5CjWM: "xcxuj3u",
    kMzoRj: "xc342km",
    kaIpWk: "x2u8bby",
    kMwMTN: "xgi1xjn",
    kZ1KPB: "x19sr0n1",
    k4WBpm: "x19ypqd9",
    $$css: true
  },
  copy: {
    k7Eaqz: "xeuugli",
    $$css: true
  },
  actions: {
    kmuXW: "x2lah0s",
    ks0D6T: "x193iq5w",
    $$css: true
  },
  comfortable: {
    kWkggS: "xjbqb8w",
    $$css: true
  },
  compact: {
    k1xSpc: "x1lliihq",
    k8WAf4: "xrii95j",
    kE3dHu: "xzjhap9",
    kpe85a: "x19tmk5i",
    $$css: true
  },
  neutral: {
    kaZRDh: "xs4majh",
    kWkggS: "x382npu",
    $$css: true
  },
  good: {
    kaZRDh: "xan25v",
    kWkggS: "x153t6mt",
    $$css: true
  },
  warn: {
    kaZRDh: "xzxeg27",
    kWkggS: "xc1c755",
    $$css: true
  },
  error: {
    kaZRDh: "xju8803",
    kWkggS: "xdo6va6",
    $$css: true
  },
  title: {
    k1xSpc: "x1lliihq",
    kMv6JI: "x5ddh9m",
    kGuDYH: "xosj86m",
    k63SB2: "xk50ysn",
    kLWn49: "x1xfvgam",
    kb6lSQ: "x1xte0cv",
    kMwMTN: "xqvuw85",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  compactTitle: {
    kGuDYH: "x4z9k3i",
    k63SB2: "xh88oxj",
    $$css: true
  },
  text: {
    kogj98: "x1ghz6dp",
    kMv6JI: "x5ddh9m",
    kGuDYH: "xfifm61",
    kLWn49: "xa7kkou",
    kMwMTN: "xgi1xjn",
    khDVqt: "x1fj9vlw",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  compactText: {
    kGuDYH: "x1ct8sxb",
    kLWn49: "x1evy7pa",
    $$css: true
  },
  afterTitle: {
    keoZOQ: "xzbgwbi",
    $$css: true
  }
};
function OperatorNotice(props122) {
  const compact = props122.density === "compact";
  const root = stylex11.props(noticeStyles.root, noticeStyles[props122.tone], compact ? noticeStyles.compact : noticeStyles.comfortable);
  return /* @__PURE__ */ jsxs9("aside", {
    ...root,
    "data-tone": props122.tone,
    children: [
      /* @__PURE__ */ jsxs9("div", {
        ...stylex11.props(noticeStyles.copy),
        children: [
          props122.title && /* @__PURE__ */ jsx21("strong", {
            ...stylex11.props(noticeStyles.title, compact && noticeStyles.compactTitle),
            children: props122.title
          }),
          /* @__PURE__ */ jsx21("p", {
            ...stylex11.props(noticeStyles.text, compact && noticeStyles.compactText, Boolean(props122.title) && noticeStyles.afterTitle),
            children: props122.text
          })
        ]
      }),
      props122.children && /* @__PURE__ */ jsx21("div", {
        ...stylex11.props(noticeStyles.actions),
        children: props122.children
      })
    ]
  });
}
var statusStyles = {
  dot: {
    k1xSpc: "x1rg5ohu",
    kmuXW: "x2lah0s",
    kzqmXN: "x1v4s8kt",
    kZKoxP: "xols6we",
    km5ZXQ: "x15ku74s",
    kaIpWk: "x16rqkct",
    kWkggS: "xtwfq29",
    kGVxlE: "x1b33ckz",
    kXLuUW: "xiygsch",
    $$css: true
  },
  cautionGlow: {
    kGVxlE: "x17y309f",
    $$css: true
  },
  row: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "x1qughib",
    k7Eaqz: "xeuugli",
    kOIVth: "x167g77z",
    kmVPX3: "x1ica2du",
    kEafiO: "x178xt8z x1g31smg",
    kPef9Z: "x13fuv20",
    kLZC3w: "xvg7k2t",
    $$css: true
  },
  copy: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x195vfkc",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  label: {
    kMwMTN: "xgi1xjn",
    kGuDYH: "xfifm61",
    k63SB2: "xk50ysn",
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  status: {
    kMv6JI: "xa9opjo",
    kGuDYH: "xlp3en2",
    kb6lSQ: "x1dor1uw",
    kP9fke: "xtvhhri",
    kmuXW: "x2lah0s",
    ks0D6T: "x1y8h3ww",
    kHjlTd: "xj0a0fe",
    $$css: true
  }
};
var panelContentStyles = {
  muted: {
    kogj98: "x1ghz6dp",
    kMwMTN: "x1ar3pfp",
    kGuDYH: "x4z9k3i",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  note: {
    kogj98: "x1ghz6dp",
    kMwMTN: "x1ar3pfp",
    kGuDYH: "x1qt5hsa",
    kLWn49: "x1jjo3f5",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  paragraph: {
    ks0D6T: "x1qp14f0",
    kogj98: "xjgi5au",
    kMwMTN: "xgi1xjn",
    kGuDYH: "xif65rj x1yzm3l3",
    kLWn49: "x1dbl2gt",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  lead: {
    kMwMTN: "xqvuw85",
    k63SB2: "xmvyi9x",
    $$css: true
  },
  status: {
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    kOIVth: "x167g77z",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1j6dyjg",
    kb6lSQ: "x9pfba7",
    kHjlTd: "xj0a0fe",
    kgeoSG: "x1cpjm7i",
    kOlAkY: "x1x7x01p",
    kgzTxl: "xf3jtlm",
    kIuGQ2: "xtbmc8j",
    kPB484: "x9msap3",
    kLkRvE: "x15h7rrt",
    ktNmms: "x12jnsxg",
    $$css: true
  },
  empty: {
    kogj98: "x1ghz6dp",
    kmVPX3: "x1ica2du",
    kMwMTN: "x1ar3pfp",
    kGuDYH: "x4z9k3i",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  list: {
    kogj98: "x1ghz6dp",
    kmVPX3: "x1717udv",
    kH6xsr: "x3ct3a4",
    $$css: true
  },
  row: {
    k1xSpc: "x78zum5",
    kGNEyG: "x1pha0wt",
    kjj79g: "x1qughib",
    kOIVth: "x1v2ro7d",
    k7Eaqz: "xeuugli",
    kLKAdn: "x1y1aw1k x17ezhci",
    kpe85a: "x1xpa7k",
    kGO01o: "xwib8y2",
    kE3dHu: "x1uhho1l",
    kEafiO: "x178xt8z x1g31smg",
    kPef9Z: "x13fuv20",
    kLZC3w: "xvg7k2t",
    $$css: true
  },
  link: {
    k1xSpc: "x78zum5",
    kGNEyG: "x1pha0wt",
    kjj79g: "x1qughib",
    kOIVth: "x1v2ro7d",
    kzqmXN: "xh8yej3",
    k7Eaqz: "xeuugli",
    kMwMTN: "x1heor9g",
    kMnn75: "xkrqix3",
    kAzted: "x1c4ya5t",
    kPJHz1: "x784prv",
    k7shQP: "x9v5kkp",
    kZs9gx: "xxh1od1",
    kiEn40: "x7s97pk",
    $$css: true
  },
  copy: {
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  label: {
    k1xSpc: "x1lliihq",
    kMwMTN: "xqvuw85 xat1s67",
    kGuDYH: "x2ouz8m",
    k63SB2: "xmvyi9x",
    k1ekBW: "xt3l3uh",
    kIyJzY: "xx6bhzk",
    kAMwcw: "xwji4o3",
    $$css: true
  },
  description: {
    k1xSpc: "x1lliihq",
    ks0D6T: "x15qx0h6",
    keoZOQ: "xvijh9v",
    kMwMTN: "x1ar3pfp",
    kGuDYH: "x1qt5hsa xxgfmko",
    kKX8nH: "x1j61x8r",
    $$css: true
  },
  badge: {
    kUk6DE: "x3psx0u",
    k7Eaqz: "xeuugli",
    ks0D6T: "x8jryan",
    kHjlTd: "xj0a0fe",
    kmVPX3: "xpzpvjg",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h",
    kaIpWk: "x12oqio5",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "xdzlmae",
    kb6lSQ: "x7447wj",
    kP9fke: "xtvhhri",
    $$css: true
  },
  secondaryBadge: {
    kVAM5u: "x1p4dqwe",
    kMwMTN: "x724ina",
    $$css: true
  },
  goodBadge: {
    kVAM5u: "xb3wpjg",
    kMwMTN: "x19k5i5u",
    $$css: true
  },
  marker: {
    k1xSpc: "x1rg5ohu",
    kzqmXN: "xci0xqf",
    kZKoxP: "x1hagigm",
    km5ZXQ: "x193lsj1",
    kaIpWk: "x16rqkct",
    kWkggS: "x1wztykf",
    kXLuUW: "xiygsch",
    $$css: true
  }
};
function OperatorPanelParagraph(props132) {
  const {
    lead,
    children,
    presentation,
    ...attributes
  } = props132;
  return /* @__PURE__ */ jsxs10("p", {
    ...styledProps(attributes, presentation === "note" ? panelContentStyles.note : presentation === "muted" ? panelContentStyles.muted : panelContentStyles.paragraph),
    children: [
      lead !== undefined && /* @__PURE__ */ jsx22("b", {
        ...stylex12.props(panelContentStyles.lead),
        children: lead
      }),
      children
    ]
  });
}
function OperatorPanelStatus(props132) {
  return /* @__PURE__ */ jsx22("span", {
    ...stylex12.props(panelContentStyles.status, toneText(props132.tone)),
    "data-tone": props132.tone ?? "neutral",
    children: props132.children
  });
}
function OperatorPanelEmpty(props132) {
  return /* @__PURE__ */ jsx22("p", {
    ...stylex12.props(panelContentStyles.empty),
    children: props132.children
  });
}
function OperatorPanelList(props132) {
  return /* @__PURE__ */ jsx22("ul", {
    ...stylex12.props(panelContentStyles.list),
    children: props132.children
  });
}
var _temp = {
  "x-default-marker": "x-default-marker",
  $$css: true
};
function OperatorPanelListItem(props132) {
  const {
    label,
    description,
    badge,
    href,
    tone,
    ...attributes
  } = props132;
  const content = /* @__PURE__ */ jsxs10(Fragment8, {
    children: [
      /* @__PURE__ */ jsxs10("span", {
        ...stylex12.props(panelContentStyles.copy),
        children: [
          /* @__PURE__ */ jsxs10("strong", {
            ...stylex12.props(panelContentStyles.label),
            children: [
              tone === "good" && /* @__PURE__ */ jsx22("span", {
                ...stylex12.props(panelContentStyles.marker),
                "aria-hidden": "true"
              }),
              label
            ]
          }),
          description !== undefined && /* @__PURE__ */ jsx22("em", {
            ...stylex12.props(panelContentStyles.description),
            children: description
          })
        ]
      }),
      /* @__PURE__ */ jsx22("small", {
        ...stylex12.props(panelContentStyles.badge, tone === "secondary" && panelContentStyles.secondaryBadge, tone === "good" && panelContentStyles.goodBadge),
        children: badge
      })
    ]
  });
  return /* @__PURE__ */ jsx22("li", {
    ...styledProps(attributes, panelContentStyles.row),
    "data-tone": tone ?? "neutral",
    children: href !== undefined ? /* @__PURE__ */ jsx22("a", {
      href,
      ...stylex12.props(_temp, panelContentStyles.link),
      children: content
    }) : content
  });
}
function OperatorStatusDot(props142) {
  return /* @__PURE__ */ jsx23("span", {
    ...stylex13.props(statusStyles.dot, toneText(props142.tone), props142.tone !== "good" && statusStyles.cautionGlow),
    "aria-hidden": "true"
  });
}
function OperatorStatusList(props142) {
  return /* @__PURE__ */ jsx23(OperatorPanelList, {
    children: props142.items.map((item) => /* @__PURE__ */ jsxs11("li", {
      ...stylex13.props(statusStyles.row),
      "data-tone": item.tone,
      children: [
        /* @__PURE__ */ jsxs11("span", {
          ...stylex13.props(statusStyles.copy),
          children: [
            /* @__PURE__ */ jsx23(OperatorStatusDot, {
              tone: item.tone
            }),
            /* @__PURE__ */ jsx23("strong", {
              ...stylex13.props(statusStyles.label),
              children: item.label
            })
          ]
        }),
        /* @__PURE__ */ jsx23("small", {
          ...stylex13.props(statusStyles.status, toneText(item.tone)),
          children: item.status
        })
      ]
    }, item.id))
  });
}
var statusContentStyles = {
  good: {
    kMwMTN: "x19k5i5u",
    $$css: true
  },
  warn: {
    kMwMTN: "x1ra7g20",
    $$css: true
  },
  error: {
    kMwMTN: "x1mel2pz",
    $$css: true
  },
  neutral: {
    kMwMTN: "x1v3krkk",
    $$css: true
  },
  pill: {
    k1xSpc: "x1rg5ohu",
    kmVPX3: "x1x7i2cb",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xx1zzhd",
    kaIpWk: "x1xwekrv",
    kMv6JI: "xa9opjo",
    kGuDYH: "xvwhms9",
    kb6lSQ: "x7447wj",
    kP9fke: "xtvhhri",
    ks0D6T: "x193iq5w",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  labelPill: {
    kmVPX3: "x1asu97y",
    kaIpWk: "x1cum3z5",
    kGuDYH: "xfmn3hh",
    kb6lSQ: "x11fj6oh",
    kVAM5u: "x8tuc8h",
    kB7OPa: "x9f619",
    $$css: true
  },
  labelNeutral: {
    kMwMTN: "x1ar3pfp",
    $$css: true
  },
  labelGood: {
    kVAM5u: "xwpv6la",
    $$css: true
  },
  labelWarn: {
    kVAM5u: "xuy1tgj",
    $$css: true
  },
  labelError: {
    kVAM5u: "x1sqyqg8",
    $$css: true
  },
  softPill: {
    kmVPX3: "xmfpazt",
    kMzoRj: "xc342km",
    kGuDYH: "xlp3en2",
    kb6lSQ: "x9pfba7",
    kWkggS: "xbjheo3",
    $$css: true
  },
  goodSoft: {
    kWkggS: "x153t6mt",
    $$css: true
  },
  lead: {
    k1xSpc: "xrvj5dj",
    kumcoG: "xx9t13c xxljim5 x1gc00kl",
    kOIVth: "x1af02g3",
    kGNEyG: "x6s0dn4",
    kmVPX3: "x11onut9",
    $$css: true
  },
  orbit: {
    kB7OPa: "x9f619",
    kVAEAm: "x1n2onr6",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kzqmXN: "x10h3iyq",
    kZKoxP: "x5kalc8",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x7k9j60",
    kaIpWk: "x16rqkct",
    kWkggS: "xbjheo3",
    $$css: true
  },
  orbitInner: {
    kVAEAm: "x10l6tqk",
    kpwlN0: "x6mrcm",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x2xzz1h",
    kaIpWk: "x16rqkct",
    $$css: true
  },
  orbitCore: {
    kzqmXN: "x1xc55vz",
    kZKoxP: "xdk7pt",
    kaIpWk: "x16rqkct",
    kWkggS: "xtwfq29",
    kGVxlE: "x11svnkv",
    $$css: true
  },
  leadCopy: {
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  leadTitle: {
    k1xSpc: "x1lliihq",
    kMwMTN: "xqvuw85",
    kMv6JI: "xssy22x",
    kGuDYH: "xwsyq91",
    ka26j: "x1nqv8xj",
    k63SB2: "x11zgcw",
    $$css: true
  },
  leadDescription: {
    kogj98: "x1cpde12",
    kMwMTN: "x1ar3pfp",
    kGuDYH: "x1ct8sxb",
    $$css: true
  },
  leadStatus: {
    k1xSpc: "x78zum5",
    kBCFzs: "xbzj6x0 x16ohsbj",
    kFhvOy: "x1lqcxt8",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  readiness: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4 x6ssbkw",
    kOIVth: "xou54vl",
    kAzted: "x1edz59j",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  ring: {
    k1xSpc: "xrvj5dj",
    kmuXW: "x2lah0s",
    kgQiWS: "x1ku5rj1",
    kzqmXN: "xgbm1jk xuwcrnf",
    kZKoxP: "xuzvuw4 x14vkcg0",
    kaIpWk: "x16rqkct",
    kWkggS: "x3ee1ji",
    $$css: true
  },
  ringGood: {
    kWkggS: "x1wztykf",
    kGVxlE: "xkeuntj",
    $$css: true
  },
  ringText: {
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kzqmXN: "xeepkih xbfdvwu",
    kZKoxP: "x1x0gksc x1li4m8q",
    kaIpWk: "x16rqkct",
    kWkggS: "x18s3upu",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1j6dyjg",
    kb6lSQ: "x1vyo3qp",
    kP9fke: "xtvhhri",
    kHjlTd: "xj0a0fe",
    k9WMMc: "x2b8uid",
    $$css: true
  },
  readinessTitle: {
    kMwMTN: "xqvuw85",
    kGuDYH: "xif65rj",
    k63SB2: "xk50ysn",
    $$css: true
  },
  readinessDescription: {
    kogj98: "x1g76kxt",
    kMwMTN: "x1ar3pfp",
    kGuDYH: "xfifm61",
    $$css: true
  },
  tags: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "x1nejdyq",
    keoZOQ: "x1aawmmo",
    $$css: true
  },
  tag: {
    kmVPX3: "x1dumkz1",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xy1lt07",
    kaIpWk: "x1cum3z5",
    kMwMTN: "x1v3krkk",
    kMv6JI: "xa9opjo",
    kGuDYH: "xlp3en2",
    kP9fke: "xtvhhri",
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  steps: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1j9xkj6",
    kogj98: "x1l1fhan",
    kmVPX3: "x1bo8gzv",
    kB88ic: "xe8uvvx",
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "xvg7k2t",
    kMwMTN: "x1v3krkk",
    kMv6JI: "xa9opjo",
    kGuDYH: "xlp3en2",
    kP9fke: "xtvhhri",
    $$css: true
  },
  step: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kUk6DE: "x98rzlu",
    k7Eaqz: "xeuugli",
    kOIVth: "x1j9xkj6",
    kgeoSG: "x1cpjm7i",
    kLB3ol: "xl5i350",
    kDxQxW: "x1o45bfl",
    kgzTxl: "xy80zi5",
    kLkRvE: "xrtr2zh",
    $$css: true
  },
  stepFirst: {
    kUk6DE: "xkz0k9k",
    kP1sEF: "x15ozc13",
    $$css: true
  },
  stepLabel: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1nejdyq",
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  stepDone: {
    kMwMTN: "x1ar3pfp",
    $$css: true
  },
  stepDot: {
    kmuXW: "x2lah0s",
    kzqmXN: "x1ftt334",
    kZKoxP: "x1ycjhwn",
    kaIpWk: "x16rqkct",
    kWkggS: "x3ee1ji",
    $$css: true
  },
  stepDotDone: {
    kWkggS: "x1wztykf",
    $$css: true
  },
  checks: {
    k1xSpc: "x1lliihq",
    kzqmXN: "xh8yej3",
    kLvRdT: "x1mwwwfo",
    k9WMMc: "xdpxx8g",
    $$css: true
  },
  checksHead: {
    k1xSpc: "x1lliihq",
    kVAEAm: "x1uhb9sk xget08e",
    kz4h6p: "x1gj8qfm x1uno8h5",
    kzqmXN: "x14atkfc x1dtpofi",
    kZKoxP: "xt7dq6l xwj557x",
    kVQacm: "xb3r6kr",
    $$css: true
  },
  checkBody: {
    k1xSpc: "x1lliihq",
    $$css: true
  },
  checkHeaderCell: {
    k9WMMc: "xdpxx8g",
    kmVPX3: "x1717udv",
    k7Eaqz: "xeuugli",
    k63SB2: "xo1l8bm",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  checkRow: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x1ibodrf x159c1az",
    kOIVth: "x1v2ro7d x66wd9j",
    kGNEyG: "x6s0dn4",
    kmVPX3: "x1jlzkty",
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "xvg7k2t",
    $$css: true
  },
  checkHeading: {
    kmVPX3: "xu19mh5",
    kEafiO: "x972fbf",
    kMwMTN: "x1v3krkk",
    kMv6JI: "xa9opjo",
    kGuDYH: "xdzlmae",
    kb6lSQ: "x7447wj",
    kP9fke: "xtvhhri",
    $$css: true
  },
  checkCopy: {
    k9WMMc: "xdpxx8g",
    k7Eaqz: "xeuugli",
    kmVPX3: "x1717udv",
    k63SB2: "xo1l8bm",
    kBCFzs: "xgkxs2y",
    kbNqZ1: "x1ms6mhf",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  checkName: {
    k1xSpc: "x1lliihq",
    kMwMTN: "xgi1xjn",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1s31vzs",
    k63SB2: "xk50ysn",
    $$css: true
  },
  checkDescription: {
    k1xSpc: "x1lliihq",
    keoZOQ: "xr9ek0c",
    kMwMTN: "x1v3krkk",
    kGuDYH: "x1k6wstc",
    $$css: true
  },
  checkUpdated: {
    kmVPX3: "x1717udv",
    k63SB2: "xo1l8bm",
    k7Eaqz: "xeuugli",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "xfmn3hh",
    kBCFzs: "x1npkx4u xy0nd2e",
    kbNqZ1: "x1ms6mhf x9zojqa",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  checkStatus: {
    kmVPX3: "x1717udv",
    k63SB2: "xo1l8bm",
    k7Eaqz: "xeuugli",
    kFhvOy: "x1lqcxt8",
    kBCFzs: "x1k3v4rp x1yfacwp",
    kbNqZ1: "x1ms6mhf",
    $$css: true
  }
};
function OperatorStatusPill(props152) {
  const {
    tone,
    presentation,
    ...attributes
  } = props152;
  return /* @__PURE__ */ jsx24("span", {
    ...styledProps(attributes, statusContentStyles.pill, statusContentStyles[tone === "muted" ? "neutral" : tone], presentation === "label" && statusContentStyles.labelPill, presentation === "label" && tone === "neutral" && statusContentStyles.labelNeutral, presentation === "label" && tone === "good" && statusContentStyles.labelGood, presentation === "label" && tone === "warn" && statusContentStyles.labelWarn, presentation === "label" && tone === "error" && statusContentStyles.labelError, presentation === "soft" && statusContentStyles.softPill, presentation === "soft" && tone === "good" && statusContentStyles.goodSoft)
  });
}
function OperatorStatusSummary(props152) {
  return /* @__PURE__ */ jsxs12("div", {
    ...stylex14.props(statusContentStyles.lead, statusContentStyles[props152.tone]),
    "data-status-summary": props152.tone,
    children: [
      /* @__PURE__ */ jsxs12("span", {
        ...stylex14.props(statusContentStyles.orbit, props152.tone === "good" && statusContentStyles.goodSoft),
        "aria-hidden": "true",
        children: [
          /* @__PURE__ */ jsx24("i", {
            ...stylex14.props(statusContentStyles.orbitInner)
          }),
          /* @__PURE__ */ jsx24("i", {
            ...stylex14.props(statusContentStyles.orbitCore)
          })
        ]
      }),
      /* @__PURE__ */ jsxs12("div", {
        ...stylex14.props(statusContentStyles.leadCopy),
        children: [
          /* @__PURE__ */ jsx24("strong", {
            ...stylex14.props(statusContentStyles.leadTitle),
            children: props152.title
          }),
          /* @__PURE__ */ jsx24("p", {
            ...stylex14.props(statusContentStyles.leadDescription),
            children: props152.description
          })
        ]
      }),
      /* @__PURE__ */ jsx24("span", {
        ...stylex14.props(statusContentStyles.leadStatus),
        children: /* @__PURE__ */ jsx24(OperatorStatusPill, {
          tone: props152.tone,
          children: props152.status
        })
      })
    ]
  });
}
function OperatorReadiness(props152) {
  return /* @__PURE__ */ jsxs12("div", {
    ...stylex14.props(statusContentStyles.readiness),
    "data-readiness-tone": props152.tone,
    children: [
      /* @__PURE__ */ jsx24("div", {
        ...stylex14.props(statusContentStyles.ring, props152.tone === "good" && statusContentStyles.ringGood),
        role: "img",
        "aria-label": props152.indicatorLabel,
        children: /* @__PURE__ */ jsx24("span", {
          ...stylex14.props(statusContentStyles.ringText, statusContentStyles[props152.tone]),
          children: props152.indicator
        })
      }),
      /* @__PURE__ */ jsxs12("div", {
        ...stylex14.props(statusContentStyles.leadCopy),
        children: [
          /* @__PURE__ */ jsx24("strong", {
            ...stylex14.props(statusContentStyles.readinessTitle),
            children: props152.title
          }),
          /* @__PURE__ */ jsx24("p", {
            ...stylex14.props(statusContentStyles.readinessDescription),
            children: props152.description
          }),
          /* @__PURE__ */ jsx24("div", {
            ...stylex14.props(statusContentStyles.tags),
            children: props152.facts.map((fact, index) => /* @__PURE__ */ jsx24("span", {
              ...stylex14.props(statusContentStyles.tag),
              children: fact
            }, `${index}:${fact}`))
          })
        ]
      })
    ]
  });
}
function OperatorSteps(props152) {
  return /* @__PURE__ */ jsx24("ol", {
    ...stylex14.props(statusContentStyles.steps),
    "aria-label": props152.label,
    children: props152.items.map((item, index) => /* @__PURE__ */ jsx24("li", {
      ...stylex14.props(statusContentStyles.step, index === 0 && statusContentStyles.stepFirst),
      "data-complete": item.complete,
      children: /* @__PURE__ */ jsxs12("span", {
        ...stylex14.props(statusContentStyles.stepLabel, item.complete && statusContentStyles.stepDone),
        children: [
          /* @__PURE__ */ jsx24("i", {
            ...stylex14.props(statusContentStyles.stepDot, item.complete && statusContentStyles.stepDotDone),
            "aria-hidden": "true"
          }),
          item.label
        ]
      })
    }, `${index}:${item.label}`))
  });
}
function OperatorChecks(props152) {
  return /* @__PURE__ */ jsxs12("table", {
    ...stylex14.props(statusContentStyles.checks),
    "aria-label": props152.label,
    children: [
      /* @__PURE__ */ jsx24("thead", {
        ...stylex14.props(statusContentStyles.checksHead),
        children: /* @__PURE__ */ jsx24("tr", {
          ...stylex14.props(statusContentStyles.checkRow, statusContentStyles.checkHeading),
          children: props152.headings.map((heading, index) => /* @__PURE__ */ jsx24("th", {
            scope: "col",
            ...stylex14.props(statusContentStyles.checkHeaderCell),
            children: heading
          }, index))
        })
      }),
      /* @__PURE__ */ jsx24("tbody", {
        ...stylex14.props(statusContentStyles.checkBody),
        children: props152.items.map((item, index) => /* @__PURE__ */ jsxs12("tr", {
          ...stylex14.props(statusContentStyles.checkRow),
          "data-tone": item.tone,
          children: [
            /* @__PURE__ */ jsxs12("th", {
              scope: "row",
              ...stylex14.props(statusContentStyles.checkCopy),
              children: [
                /* @__PURE__ */ jsx24("strong", {
                  ...stylex14.props(statusContentStyles.checkName),
                  children: item.name
                }),
                /* @__PURE__ */ jsx24("small", {
                  ...stylex14.props(statusContentStyles.checkDescription),
                  children: item.description
                })
              ]
            }),
            /* @__PURE__ */ jsx24("td", {
              ...stylex14.props(statusContentStyles.checkUpdated),
              children: item.updated
            }),
            /* @__PURE__ */ jsx24("td", {
              ...stylex14.props(statusContentStyles.checkStatus),
              children: /* @__PURE__ */ jsx24(OperatorStatusPill, {
                tone: item.tone,
                presentation: "soft",
                children: item.status
              })
            })
          ]
        }, `${index}:${item.name}`))
      })
    ]
  });
}
var panelStyles = {
  panel: {
    kWkggS: "x18s3upu",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h",
    kaIpWk: "x1q4ynmn x1olvxk8",
    kmVPX3: "xng7wty xqqny65",
    kVAEAm: "x1n2onr6",
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    kHjlTd: "xj0a0fe",
    kanfag: "xdy16ns",
    k9g6sI: "x12h1iku",
    $$css: true
  },
  tight: {
    kmVPX3: "xng7wty x10erhnk",
    $$css: true
  },
  flushBottom: {
    kmVPX3: "x1m5bfbp",
    kVQacm: "xb3r6kr",
    $$css: true
  },
  fullWidth: {
    kBCFzs: "x1osaytk",
    $$css: true
  },
  neutralWash: {
    kKwaWg: "xcovpgk",
    $$css: true
  },
  goodWash: {
    kKwaWg: "x6dee8v",
    $$css: true
  },
  heading: {
    k1xSpc: "x78zum5",
    kGNEyG: "x1pha0wt x14p79m1 xelgs58",
    kjj79g: "x1qughib",
    kOIVth: "x883omv",
    k1K539: "xod5an3 xzzd6q",
    $$css: true
  },
  title: {
    k7Eaqz: "xeuugli",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1s31vzs",
    k63SB2: "xk50ysn",
    kb6lSQ: "xa7ig63",
    kP9fke: "xtvhhri",
    kMwMTN: "x1ar3pfp",
    $$css: true
  },
  source: {
    k7Eaqz: "xeuugli",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1k6wstc xbewnxd",
    kb6lSQ: "x1vyo3qp",
    kMwMTN: "x1v3krkk",
    $$css: true
  },
  grid: {
    k1xSpc: "xrvj5dj",
    kumcoG: "xnby9oq xtpkkxw xirox3h",
    kOIVth: "x1af02g3 xdueovt",
    kGNEyG: "x7a106z",
    $$css: true
  }
};
function OperatorPanel(props162) {
  const {
    heading,
    source,
    accessory,
    inset,
    fullWidth,
    wash,
    children,
    ...attributes
  } = props162;
  return /* @__PURE__ */ jsxs13("article", {
    ...styledProps(attributes, panelStyles.panel, inset === "tight" && panelStyles.tight, inset === "flush-bottom" && panelStyles.flushBottom, fullWidth && panelStyles.fullWidth, wash === "neutral" && panelStyles.neutralWash, wash === "good" && panelStyles.goodWash),
    children: [
      /* @__PURE__ */ jsxs13("header", {
        ...stylex15.props(panelStyles.heading),
        children: [
          /* @__PURE__ */ jsx25("span", {
            ...stylex15.props(panelStyles.title),
            children: heading
          }),
          source !== undefined && source !== null ? /* @__PURE__ */ jsx25("span", {
            ...stylex15.props(panelStyles.source),
            children: source
          }) : accessory
        ]
      }),
      children
    ]
  });
}
function OperatorPanelGrid(props162) {
  return /* @__PURE__ */ jsx25("div", {
    ...styledProps(props162, panelStyles.grid)
  });
}
var mapSvgStyles = {
  trace: {
    kDwRjp: "xbh8q5q",
    kjVXCG: "x1qq6ajq",
    kU5bRw: "x1owpc8m",
    k5rJSQ: "xnq1ati",
    kDRTOe: "xaiuoaf x1nwy2jz",
    kSiTet: "xao0n3f x16dpw5u",
    kfJifR: "x17z8gs",
    $$css: true
  },
  major: {
    kSiTet: "x19pb5yz x16dpw5u",
    k5rJSQ: "x10ozs9j",
    $$css: true
  },
  contour: {
    kDwRjp: "x6p09lz x126iy1i",
    kjVXCG: "x1qq6ajq",
    kU5bRw: "x1owpc8m",
    k5rJSQ: "xnq1ati",
    kDRTOe: "xaiuoaf x1nwy2jz",
    kDd8S0: "xbu8dtm x1umrh6z",
    kfJifR: "x17oo0nu",
    $$css: true
  },
  middle: {
    kDwRjp: "xjo5mhf x126iy1i",
    kDd8S0: "xnh1ke0 x1umrh6z",
    $$css: true
  },
  inner: {
    kDd8S0: "x160jiv6 x1umrh6z",
    $$css: true
  },
  draw: {
    kKVMdj: "xk7vdms x1aquc0h",
    k44tkh: "x10dgwld",
    kyAemX: "x1qvsx5j",
    kWV6AL: "x10e4vud",
    $$css: true
  },
  bloom: {
    kR8GR0: "x1764fhq",
    k3nNDw: "x1g0ag68",
    kKVMdj: "x181y1b3 x1aquc0h",
    kSiTet: "x1hc1fzr",
    k3aq6I: "x1c071of",
    k44tkh: "xl8t4ro",
    kyAemX: "xwk33p5",
    kWV6AL: "x1u6ievf",
    $$css: true
  },
  anchor: {
    kDwRjp: "x1gohjtw",
    kSiTet: "xf9vgkq",
    $$css: true
  },
  point: {
    kDwRjp: "xgpbuzi",
    $$css: true
  },
  pointGood: {
    kDwRjp: "x1s7eawt",
    $$css: true
  },
  pointWarn: {
    kDwRjp: "x1v1fulq",
    $$css: true
  },
  hollow: {
    kDwRjp: "xbh8q5q",
    kjVXCG: "x1n4f4kz",
    kfJifR: "xnpr05h",
    $$css: true
  },
  pointSecondary: {
    kDwRjp: "x1gohjtw",
    $$css: true
  },
  nodeGood: {
    kDwRjp: "x1s7eawt",
    kjVXCG: "xdez00i",
    $$css: true
  },
  distance: {
    kDwRjp: "xbh8q5q",
    kjVXCG: "x4vhfi8",
    k5rJSQ: "x1gjz8bi",
    kfJifR: "xunsu2d",
    $$css: true
  },
  region: {
    kDwRjp: "x1sgapc2",
    kjVXCG: "x1qq6ajq",
    k5rJSQ: "x1b0q7pt",
    kDd8S0: "xif8wax",
    kfJifR: "x17mlvpq",
    $$css: true
  },
  spore: {
    kDwRjp: "xgpbuzi",
    kSiTet: "xg01cxk x16dpw5u",
    k3aq6I: "x1c071of",
    kKVMdj: "x1bjh57s x1aquc0h",
    k44tkh: "x1q41ro2",
    kyAemX: "x1esw782",
    ko0y90: "xa4qsjk",
    $$css: true
  },
  connector: {
    kDwRjp: "xbh8q5q",
    kjVXCG: "xdez00i",
    kDd8S0: "x1jxw0no",
    kfJifR: "x17mlvpq",
    $$css: true
  },
  identity: {
    kDwRjp: "x8eu9n",
    ku685b: "x1gy9feu",
    $$css: true
  },
  halo: {
    kR8GR0: "x1764fhq",
    k3nNDw: "x1g0ag68",
    kKVMdj: "x1sris66 x1aquc0h",
    kSiTet: "x1hc1fzr",
    k3aq6I: "x1c071of",
    k44tkh: "x16zzmm9",
    kyAemX: "x4hg4is",
    ko0y90: "xa4qsjk",
    $$css: true
  },
  glow: {
    kDwRjp: "x1v1fulq",
    kSiTet: "x5dmra7 x16dpw5u",
    kKVMdj: "xpoaoud x1aquc0h",
    k44tkh: "xhzpukf",
    kyAemX: "x4hg4is",
    ko0y90: "xa4qsjk",
    $$css: true
  },
  stem: {
    kDwRjp: "xbh8q5q",
    kjVXCG: "xnbuhn4",
    kU5bRw: "x1owpc8m",
    kfJifR: "x1dt3t4y",
    $$css: true
  },
  node: {
    kDwRjp: "x1h8g7wf",
    kjVXCG: "x1n4f4kz",
    kfJifR: "xnpr05h",
    $$css: true
  },
  nodeWarn: {
    kDwRjp: "x1v1fulq",
    kjVXCG: "x1mjy2a4",
    $$css: true
  },
  nodeSecondary: {
    kDwRjp: "x1gohjtw",
    kjVXCG: "x1qq6ajq",
    $$css: true
  },
  dimmed: {
    kSiTet: "xvpkmg4",
    $$css: true
  },
  labelBase: {
    kjVXCG: "x1jgmy94",
    kfJifR: "x17ld789",
    kCrYw0: "x1x0jnz8",
    kMv6JI: "xa9opjo",
    kP9fke: "xtvhhri",
    $$css: true
  },
  regionText: {
    kDwRjp: "x1r5g2pm",
    kGuDYH: "xlp3en2 x1vq3b3y",
    k63SB2: "xk50ysn",
    kb6lSQ: "x9pfba7",
    $$css: true
  },
  count: {
    kDwRjp: "x1gohjtw",
    kGuDYH: "xvwhms9 x1vq3b3y",
    k63SB2: "x1s688f",
    $$css: true
  },
  axisText: {
    kDwRjp: "xgpbuzi",
    kGuDYH: "x6ijxsv",
    kb6lSQ: "x1dor1uw",
    $$css: true
  },
  distanceText: {
    kDwRjp: "xgpbuzi",
    kMv6JI: "xa9opjo",
    kGuDYH: "xdzlmae xo9lxqq",
    kb6lSQ: "x9pfba7",
    $$css: true
  },
  groupText: {
    kDwRjp: "x1gohjtw",
    kGuDYH: "xdzlmae xo9lxqq",
    k63SB2: "x1s688f",
    kb6lSQ: "xa7ig63",
    $$css: true
  },
  identityText: {
    kDwRjp: "x1r5g2pm",
    kMv6JI: "xa9opjo",
    kGuDYH: "xdzlmae xo9lxqq",
    kb6lSQ: "x1qv67nb",
    kP9fke: "xtvhhri",
    $$css: true
  },
  nodeText: {
    kDwRjp: "x1h8g7wf",
    kjVXCG: "x1jgmy94",
    kfJifR: "xqjr0vm",
    kCrYw0: "x1x0jnz8",
    kMv6JI: "xa9opjo",
    kGuDYH: "xvwhms9 xxae97u",
    kb6lSQ: "x1dgsrnt",
    $$css: true
  }
};
function OperatorMapGroup(props162) {
  const {
    bloom,
    dimmed,
    ...attributes
  } = props162;
  return /* @__PURE__ */ jsx26("g", {
    ...styledProps(attributes, {
      "x-default-marker": "x-default-marker",
      $$css: true
    }, bloom && mapSvgStyles.bloom, dimmed && mapSvgStyles.dimmed)
  });
}
function OperatorMapPath(props162) {
  const {
    presentation,
    emphasis,
    tone,
    ...attributes
  } = props162;
  return /* @__PURE__ */ jsx26("path", {
    ...styledProps(attributes, mapSvgStyles[presentation], (presentation === "trace" || presentation === "contour") && mapSvgStyles.draw, presentation === "trace" && emphasis === "major" && mapSvgStyles.major, presentation === "contour" && emphasis === "middle" && mapSvgStyles.middle, presentation === "contour" && emphasis === "inner" && mapSvgStyles.inner, presentation === "node" && tone === "warn" && mapSvgStyles.nodeWarn, presentation === "node" && tone === "secondary" && mapSvgStyles.nodeSecondary)
  });
}
function OperatorMapCircle(props162) {
  const {
    presentation,
    tone,
    hollow,
    ...attributes
  } = props162;
  return /* @__PURE__ */ jsx26("circle", {
    ...styledProps(attributes, mapSvgStyles[presentation], presentation === "point" && tone === "good" && mapSvgStyles.pointGood, presentation === "point" && tone === "warn" && mapSvgStyles.pointWarn, presentation === "point" && tone === "secondary" && mapSvgStyles.pointSecondary, presentation === "point" && hollow && mapSvgStyles.hollow, presentation === "node" && tone === "warn" && mapSvgStyles.nodeWarn, presentation === "node" && tone === "secondary" && mapSvgStyles.nodeSecondary, presentation === "node" && tone === "good" && mapSvgStyles.nodeGood)
  });
}
function OperatorMapText(props162) {
  const {
    presentation,
    ...attributes
  } = props162;
  return /* @__PURE__ */ jsx26("text", {
    ...styledProps(attributes, (presentation === "region" || presentation === "axis" || presentation === "group") && mapSvgStyles.labelBase, presentation === "region" && mapSvgStyles.regionText, presentation === "axis" && mapSvgStyles.axisText, presentation === "distance" && mapSvgStyles.distanceText, presentation === "group" && mapSvgStyles.groupText, presentation === "identity" && mapSvgStyles.identityText, presentation === "node" && mapSvgStyles.nodeText)
  });
}
function OperatorMapCount(props162) {
  return /* @__PURE__ */ jsx26("tspan", {
    ...styledProps(props162, mapSvgStyles.labelBase, mapSvgStyles.count)
  });
}
var mapDetailsStyles = {
  index: {
    kVAEAm: "x1n2onr6",
    kY2c9j: "xhtitgo",
    k7Eaqz: "xeuugli",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kAzted: "x65nank xql4057",
    kZ1KPB: "xe0pwq x1n97idq",
    k4WBpm: "x19ypqd9",
    kaZRDh: "xlsyykk",
    kEafiO: "x972fbf xnc2tav",
    kPef9Z: "x13fuv20",
    kLZC3w: "xltl5i9",
    kKwaWg: "xesruxm",
    $$css: true
  },
  heading: {
    kmuXW: "x2lah0s",
    kmVPX3: "xd5164",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xpqg30t",
    $$css: true
  },
  title: {
    kogj98: "x1ghz6dp",
    kMwMTN: "xqvuw85",
    kMv6JI: "xssy22x",
    kGuDYH: "xwsyq91",
    ka26j: "xfl3al2",
    k63SB2: "xo1h6xc",
    kLWn49: "x1159mfc",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  description: {
    kogj98: "xqe1szj",
    kMwMTN: "x1ar3pfp",
    kGuDYH: "x1j6dyjg",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  list: {
    kmuXW: "x2lah0s",
    k1xSpc: "x1lliihq x6i8fqm",
    kumcoG: "xnby9oq",
    kogj98: "x1ghz6dp",
    kmVPX3: "xokocfn",
    kB88ic: "xe8uvvx",
    $$css: true
  },
  item: {
    k7Eaqz: "xeuugli",
    $$css: true
  },
  control: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x1pjqied",
    kGNEyG: "x6s0dn4",
    kzqmXN: "xh8yej3",
    k7Eaqz: "xeuugli",
    kAzted: "xse5ku5 x1xb6689",
    kLKAdn: "xexx8yu",
    kGO01o: "x18d9i69",
    kE3dHu: "xzjhap9 xj0nzd3",
    kpe85a: "xyfqnmn x1jt3kna",
    kEafiO: "x972fbf",
    kWqL5O: "xgfja2r",
    kt9PQ7: "x1qhh985",
    kZ1KPB: "x19sr0n1",
    k4WBpm: "x19ypqd9",
    kaZRDh: "x1g4hjc xdeuen4 x178oq3p x1qdoa1",
    kMeerF: "x1k57tk5",
    kWkggS: "xjbqb8w x1i2kobs x1foxddj x7u1vw9",
    kMwMTN: "x1ar3pfp x18m2ztq x1kxcxhl x8bb6ue",
    kkrTdU: "x1ypdohk",
    k9WMMc: "xdpxx8g",
    $$css: true
  },
  rank: {
    kMwMTN: "x1v3krkk",
    kMv6JI: "xa9opjo",
    kGuDYH: "xdzlmae",
    $$css: true
  },
  label: {
    k7Eaqz: "xeuugli",
    kVQacm: "xb3r6kr",
    kMwMTN: "x15rks2t",
    kMv6JI: "xa9opjo",
    kGuDYH: "xfmn3hh",
    k63SB2: "xk50ysn",
    kb6lSQ: "x1eg57nh",
    kg5iWk: "xlyipyv",
    kP9fke: "xtvhhri",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  value: {
    k7Eaqz: "xg3ba1e",
    kMwMTN: "x724ina",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1j6dyjg",
    k63SB2: "xk50ysn",
    k9WMMc: "x1hr2gdg",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  remainder: {
    kmuXW: "x2lah0s",
    kogj98: "x1ghz6dp",
    kmVPX3: "x17mb830",
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "xvg7k2t",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xssy22x",
    kGuDYH: "x1j6dyjg",
    kKX8nH: "x1k4tb9n",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  note: {
    kmuXW: "x2lah0s",
    k1xSpc: "x1lliihq x49x15t",
    kogj98: "x1j0re3k",
    kLKAdn: "xz9dl7a",
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "xvg7k2t",
    kMwMTN: "x1v3krkk",
    kMv6JI: "xa9opjo",
    kGuDYH: "xdzlmae",
    kb6lSQ: "x9pfba7",
    kLWn49: "x1jjo3f5",
    kP9fke: "xtvhhri",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  legend: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kGNEyG: "x6s0dn4",
    kOIVth: "xyqssrz x1hsl0lv",
    keoZOQ: "x14vqqas",
    k7Eaqz: "xeuugli",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "xvwhms9",
    kb6lSQ: "x1g5djsm",
    kP9fke: "xtvhhri",
    $$css: true
  },
  legendItem: {
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1j9xkj6",
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  marker: {
    kzqmXN: "x1xc55vz",
    kZKoxP: "xdk7pt",
    kmuXW: "x2lah0s",
    kB7OPa: "x9f619",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1r7ld26",
    kaIpWk: "x16rqkct",
    kWkggS: "xjbqb8w",
    $$css: true
  },
  dot: {
    kVAM5u: "x9r1u3d",
    kWkggS: "xtwfq29",
    $$css: true
  },
  dashed: {
    ksu8eU: "xbsl7fq",
    $$css: true
  },
  neutral: {
    kMwMTN: "x1v3krkk",
    $$css: true
  },
  secondary: {
    kMwMTN: "x724ina",
    $$css: true
  },
  good: {
    kMwMTN: "x19k5i5u",
    $$css: true
  },
  warn: {
    kMwMTN: "x1ra7g20",
    $$css: true
  },
  legendNote: {
    koQZXg: "x8x9d4c xzbafmd",
    kCS8Yb: "xdl72j9 x1gue55y",
    k7Eaqz: "xeuugli",
    kMwMTN: "xgi1xjn",
    kMv6JI: "xssy22x",
    kGuDYH: "xfifm61",
    kKX8nH: "x1k4tb9n",
    kb6lSQ: "x12oo3zp",
    kP9fke: "x6mezaz",
    kHjlTd: "xj0a0fe",
    $$css: true
  }
};
function OperatorMapIndex(props172) {
  const {
    heading,
    description,
    remainder,
    note,
    children,
    ...attributes
  } = props172;
  return /* @__PURE__ */ jsxs14("aside", {
    ...styledProps(attributes, mapDetailsStyles.index),
    "data-map-index": true,
    children: [
      /* @__PURE__ */ jsxs14("header", {
        ...stylex16.props(mapDetailsStyles.heading),
        children: [
          /* @__PURE__ */ jsx27("h3", {
            ...stylex16.props(mapDetailsStyles.title),
            children: heading
          }),
          /* @__PURE__ */ jsx27("p", {
            ...stylex16.props(mapDetailsStyles.description),
            children: description
          })
        ]
      }),
      /* @__PURE__ */ jsx27("ol", {
        ...stylex16.props(mapDetailsStyles.list),
        children
      }),
      remainder !== undefined && remainder !== null && remainder !== false && /* @__PURE__ */ jsx27("p", {
        ...stylex16.props(mapDetailsStyles.remainder),
        "data-map-index-remainder": true,
        children: remainder
      }),
      note !== undefined && note !== null && note !== false && /* @__PURE__ */ jsx27("p", {
        ...stylex16.props(mapDetailsStyles.note),
        "data-map-index-note": true,
        children: note
      })
    ]
  });
}
function OperatorMapIndexItem(props172) {
  const {
    rank,
    label,
    count: count3,
    ...attributes
  } = props172;
  return /* @__PURE__ */ jsx27("li", {
    ...stylex16.props(mapDetailsStyles.item),
    children: /* @__PURE__ */ jsxs14("button", {
      ...styledProps(attributes, mapDetailsStyles.control),
      type: attributes.type ?? "button",
      title: attributes.title ?? label,
      children: [
        /* @__PURE__ */ jsx27("span", {
          ...stylex16.props(mapDetailsStyles.rank),
          children: rank
        }),
        /* @__PURE__ */ jsx27("strong", {
          ...stylex16.props(mapDetailsStyles.label),
          children: label
        }),
        /* @__PURE__ */ jsx27("b", {
          ...stylex16.props(mapDetailsStyles.value),
          children: count3
        })
      ]
    })
  });
}
function OperatorMapLegend(props172) {
  return /* @__PURE__ */ jsx27("div", {
    ...styledProps(props172, mapDetailsStyles.legend),
    role: props172.role ?? "group"
  });
}
function OperatorMapLegendItem(props172) {
  return /* @__PURE__ */ jsxs14("span", {
    ...stylex16.props(mapDetailsStyles.legendItem),
    "data-map-marker": props172.marker,
    "data-tone": props172.tone,
    children: [
      /* @__PURE__ */ jsx27("i", {
        ...stylex16.props(mapDetailsStyles.marker, mapDetailsStyles[props172.tone], props172.marker === "dot" && mapDetailsStyles.dot, props172.marker === "dashed-ring" && mapDetailsStyles.dashed),
        "aria-hidden": "true"
      }),
      props172.label
    ]
  });
}
function OperatorMapLegendNote(props172) {
  return /* @__PURE__ */ jsx27("span", {
    ...styledProps(props172, mapDetailsStyles.legendNote)
  });
}
var mapStyles = {
  frame: {
    kVAEAm: "x1n2onr6",
    k7Eaqz: "xeuugli",
    kAzted: "x1dby22o x1en03wu",
    kVQacm: "xb3r6kr",
    kHBbk8: "xc8icb0",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h",
    kaIpWk: "xur7f20",
    kWkggS: "xlt2929",
    kGVxlE: "x1yrie1r x1m85y3v",
    $$css: true
  },
  split: {
    k1xSpc: "xrvj5dj",
    kumcoG: "xar548p x57k0db",
    kAzted: "x5mc7k8 xxt49dy",
    $$css: true
  },
  joined: {
    kaIpWk: "x120k5d4",
    $$css: true
  },
  ambient: {
    kKwaWg: "x1fk7bw7",
    $$css: true
  },
  canvas: {
    kVAEAm: "x1n2onr6",
    k7Eaqz: "xeuugli",
    kAzted: "x2lwn1j xa6uzjl",
    kVQacm: "xb3r6kr",
    kKwaWg: "x1jfd41i",
    kgSjnq: "xopnk0n",
    kwXMNM: "x1j6awrg",
    kv0HGH: "xarstr8",
    k5JduY: "x1s928wv",
    kloYau: "x2q1x1w",
    kNctxI: "x12rlhj3",
    kypkao: "xf8owqi",
    $$css: true
  },
  coordinates: {
    kVAEAm: "x10l6tqk",
    kY2c9j: "xhtitgo",
    kpwlN0: "xg4khjk",
    k1xSpc: "x78zum5",
    kjj79g: "x1qughib",
    kOIVth: "x167g77z",
    kMwMTN: "x1v3krkk",
    kMv6JI: "xa9opjo",
    kGuDYH: "x6ijxsv",
    kb6lSQ: "x7447wj",
    kP9fke: "xtvhhri",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  graphic: {
    k1xSpc: "x1lliihq",
    kzqmXN: "xh8yej3 xn7okfr",
    kZKoxP: "xt7dq6l",
    kAzted: "x1dby22o x1en03wu",
    ks0D6T: "x15a9oh8",
    k3aq6I: "x1c071of x22pbl2",
    $$css: true
  },
  tallGraphic: {
    kVAEAm: "x1n2onr6",
    kY2c9j: "x1vjfegm",
    kzqmXN: "xh8yej3 x1w3b8m9",
    kAzted: "x5mc7k8 xa6uzjl",
    k3aq6I: "x1c071of x1d7nh58",
    $$css: true
  },
  empty: {
    k1xSpc: "xrvj5dj",
    kBCFzs: "x1osaytk",
    k7Eaqz: "xeuugli",
    kAzted: "x1dby22o x1en03wu",
    kgQiWS: "x1ku5rj1",
    kmVPX3: "x10xs6qf",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xssy22x",
    kGuDYH: "x19d36u7",
    kKX8nH: "x1k4tb9n",
    k9WMMc: "x2b8uid",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  summary: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x1bf0hkk x1otivht",
    kGNEyG: "x6s0dn4",
    k7Eaqz: "xeuugli",
    kAzted: "x8nclml",
    k1K539: "xyorhqc",
    kVQacm: "xb3r6kr",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h",
    kaIpWk: "x2s36sz",
    kWkggS: "xxvg2ug",
    $$css: true
  },
  metric: {
    k1xSpc: "x78zum5",
    kXwgrk: "x3ieub6",
    k7Eaqz: "xeuugli",
    kogj98: "x1ghz6dp",
    kmVPX3: "x5b5r1n xe3jge6",
    kWqL5O: "xs1s249",
    kSWEuD: "x32b0ac",
    k26BEO: "x3a9l4s",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  valueCell: {
    kogj98: "x1ghz6dp",
    $$css: true
  },
  value: {
    kogj98: "x1ghz6dp",
    kMwMTN: "xqvuw85",
    kMv6JI: "xssy22x",
    kGuDYH: "x5heo1l xn29b5y",
    ka26j: "xo5mvrd",
    k63SB2: "x17xjjk",
    kLWn49: "xo5v014",
    $$css: true
  },
  label: {
    keoZOQ: "x1k70j0n",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "xdzlmae x1ogbdcq",
    kLWn49: "x1evy7pa x1u6zlfl",
    kb6lSQ: "x2hcs4w",
    kP9fke: "xtvhhri",
    $$css: true
  },
  status: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "xmmi0ta",
    kogj98: "xzmzwx2 x1yemgb7",
    kmVPX3: "x1717udv xe3jge6",
    k7Eaqz: "xeuugli",
    kAzted: "x2lwn1j xsz8nvi",
    kBCFzs: "xm5moh1 x1mny9qk",
    kEafiO: "x972fbf xnc2tav",
    kPef9Z: "x13fuv20",
    kLZC3w: "xvg7k2t",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "xvwhms9",
    kb6lSQ: "x7447wj",
    kP9fke: "xtvhhri",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  statusDot: {
    kzqmXN: "x1v4s8kt",
    kZKoxP: "xols6we",
    kmuXW: "x2lah0s",
    kaIpWk: "x16rqkct",
    kWkggS: "xtwfq29",
    kGVxlE: "xh2qvui",
    $$css: true
  }
};
function OperatorMapFrame(props182) {
  const {
    layout,
    joined,
    ambient,
    ...attributes
  } = props182;
  return /* @__PURE__ */ jsx28("div", {
    ...styledProps(attributes, mapStyles.frame, layout === "split" && mapStyles.split, joined && mapStyles.joined, ambient && mapStyles.ambient)
  });
}
function OperatorMapCanvas(props182) {
  return /* @__PURE__ */ jsx28("div", {
    ...styledProps(props182, mapStyles.canvas)
  });
}
function OperatorMapCoordinates(props182) {
  return /* @__PURE__ */ jsxs15("div", {
    ...stylex17.props(mapStyles.coordinates),
    "aria-hidden": "true",
    children: [
      /* @__PURE__ */ jsx28("span", {
        children: props182.start
      }),
      /* @__PURE__ */ jsx28("span", {
        children: props182.end
      })
    ]
  });
}
function OperatorMapGraphic(props182) {
  const {
    presentation,
    ...attributes
  } = props182;
  return /* @__PURE__ */ jsx28("svg", {
    ...styledProps(attributes, mapStyles.graphic, presentation === "tall" && mapStyles.tallGraphic)
  });
}
function OperatorMapEmpty(props182) {
  return /* @__PURE__ */ jsx28("div", {
    ...styledProps(props182, mapStyles.empty)
  });
}
function OperatorMapSummary(props182) {
  const {
    metrics,
    status,
    tone,
    ...attributes
  } = props182;
  return /* @__PURE__ */ jsxs15("div", {
    ...styledProps(attributes, mapStyles.summary),
    role: attributes.role ?? "group",
    children: [
      metrics.map((metric, index) => /* @__PURE__ */ jsxs15("dl", {
        ...stylex17.props(mapStyles.metric),
        children: [
          /* @__PURE__ */ jsx28("dt", {
            ...stylex17.props(mapStyles.label),
            children: metric.label
          }),
          /* @__PURE__ */ jsx28("dd", {
            ...stylex17.props(mapStyles.valueCell),
            children: /* @__PURE__ */ jsx28("strong", {
              ...stylex17.props(mapStyles.value),
              children: metric.value
            })
          })
        ]
      }, `${index}:${metric.label}`)),
      /* @__PURE__ */ jsxs15("p", {
        ...stylex17.props(mapStyles.status, toneText(tone)),
        "data-tone": tone,
        children: [
          /* @__PURE__ */ jsx28("i", {
            ...stylex17.props(mapStyles.statusDot),
            "aria-hidden": "true"
          }),
          status
        ]
      })
    ]
  });
}
var frameStyles = {
  page: {
    kVAEAm: "x1n2onr6",
    kY2c9j: "x1vjfegm",
    kzqmXN: "xh8yej3",
    kogj98: "x19bbpc0",
    kmVPX3: "x1sjuclm xfc0hut",
    $$css: true
  },
  frame: {
    kzqmXN: "x10fmqn2",
    kAzted: "xgqnoi5",
    kogj98: "x19bbpc0",
    kWkggS: "x1dd94t5",
    kEafiO: "x178xt8z",
    kt9PQ7: "xso031l",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h",
    kZ1KPB: "xe0pwq x171z6dy",
    kWqL5O: "xs1s249 x13ymtvt",
    kaIpWk: "x1q4ynmn x17i0p7j",
    kVQacm: "xb3r6kr",
    kGVxlE: "xkv9d8c x13hqkim xlc8tcj x1vbiuae",
    $$css: true
  },
  canvas: {
    kmVPX3: "xor4a8r xqqny65",
    $$css: true
  },
  sections: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x1kxjhzz xjgfjw9",
    $$css: true
  },
  section: {
    k1xSpc: "x1lliihq xvgho8r",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  sectionHeading: {
    k1xSpc: "x1lliihq x1lp4ypu",
    k1K539: "x1yztbdb",
    kGO01o: "x1a8lsjc",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xpqg30t",
    $$css: true
  },
  sectionTitle: {
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    kogj98: "x1ghz6dp",
    kMv6JI: "xssy22x",
    ka26j: "x1nqv8xj",
    k63SB2: "x11zgcw",
    kGuDYH: "x1i1m3gp",
    kMwMTN: "xqvuw85",
    $$css: true
  },
  footer: {
    k7Eaqz: "xeuugli",
    keoZOQ: "xg87l8a",
    kmVPX3: "x1glq3gq x1pnj9ld",
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "xvg7k2t",
    kWkggS: "xbslqsl",
    k1xSpc: "x78zum5",
    kjj79g: "x1qughib",
    kGNEyG: "x1pha0wt x1pftkvw",
    kXwgrk: "x1q0g3np x1g3ag0e",
    kOIVth: "xaobbuh",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1k6wstc",
    kb6lSQ: "x11fj6oh",
    kP9fke: "xtvhhri",
    kMwMTN: "x1v3krkk",
    $$css: true
  },
  footerMark: {
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  footerActions: {
    k1xSpc: "x3nfvp2",
    kwnvtZ: "x1a02dak",
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    kHjlTd: "xj0a0fe",
    kOIVth: "xou54vl",
    kjj79g: "x13a6bvl xx5kb6y",
    $$css: true
  },
  footerLink: {
    kMwMTN: "x1ar3pfp x1711cle",
    kWkggS: "xjbqb8w",
    kMzoRj: "xc342km",
    kMv6JI: "xjb2p0i",
    kGuDYH: "x1qlqyl8",
    k63SB2: "x1pd3egz",
    kLWn49: "x15bjb6t",
    kb6lSQ: "x4gjf66",
    kP9fke: "x5ftkge",
    kkrTdU: "x1ypdohk",
    kmVPX3: "x1717udv",
    kMnn75: "xkrqix3",
    kHjlTd: "xj0a0fe",
    k1xSpc: "x13v5x0x",
    kGNEyG: "xp7j7s0",
    kAzted: "x1c4ya5t",
    kPJHz1: "x784prv",
    k7shQP: "x9v5kkp",
    kZs9gx: "xxh1od1",
    kiEn40: "x7s97pk",
    $$css: true
  }
};
function OperatorPage(props192) {
  return /* @__PURE__ */ jsx29("main", {
    ...styledProps(props192, frameStyles.page)
  });
}
function OperatorFrame(props192) {
  return /* @__PURE__ */ jsx29("div", {
    ...styledProps(props192, frameStyles.frame)
  });
}
function OperatorCanvas(props192) {
  return /* @__PURE__ */ jsx29("div", {
    ...styledProps(props192, frameStyles.canvas)
  });
}
function OperatorSections(props192) {
  return /* @__PURE__ */ jsx29("div", {
    ...styledProps(props192, frameStyles.sections)
  });
}
function OperatorSection(props192) {
  return /* @__PURE__ */ jsx29("section", {
    ...styledProps(props192, frameStyles.section)
  });
}
function OperatorSectionHeading(props192) {
  return /* @__PURE__ */ jsx29("header", {
    ...stylex18.props(frameStyles.sectionHeading),
    children: /* @__PURE__ */ jsx29("h2", {
      ...stylex18.props(frameStyles.sectionTitle),
      children: props192.children
    })
  });
}
function OperatorFooter(props192) {
  return /* @__PURE__ */ jsxs16("footer", {
    ...styledProps({
      className: props192.className
    }, frameStyles.footer),
    children: [
      /* @__PURE__ */ jsx29("span", {
        ...stylex18.props(frameStyles.footerMark),
        children: props192.mark
      }),
      /* @__PURE__ */ jsx29("span", {
        ...stylex18.props(frameStyles.footerActions),
        children: props192.children
      })
    ]
  });
}
function OperatorFooterLink(props192) {
  return /* @__PURE__ */ jsx29("a", {
    ...styledProps(props192, frameStyles.footerLink)
  });
}
function OperatorRecordDescription(props202) {
  return /* @__PURE__ */ jsxs17(Fragment9, {
    children: [
      /* @__PURE__ */ jsx30("p", {
        ...stylex19.props(recordStyles.description, props202.density === "compact" && recordStyles.compactDescription, props202.activity && recordStyles.activityDescription, props202.clamp && recordStyles.clamped),
        children: props202.text
      }),
      props202.children
    ]
  });
}
function OperatorRecordCopy(props202) {
  const compact = props202.density === "compact";
  return /* @__PURE__ */ jsxs17("div", {
    ...stylex19.props(recordStyles.copy),
    children: [
      props202.lead,
      /* @__PURE__ */ jsx30("strong", {
        ...stylex19.props(recordStyles.title, compact && !props202.presentation && recordStyles.compactTitle, props202.presentation === "editorial" && recordStyles.editorial, props202.presentation === "attention" && recordStyles.attention, props202.presentation === "attention" && props202.primary && recordStyles.primaryAttention, props202.presentation === "activity" && recordStyles.activity, props202.clamp && recordStyles.clamped),
        children: props202.title
      }),
      typeof props202.description === "string" ? /* @__PURE__ */ jsx30(OperatorRecordDescription, {
        text: props202.description,
        density: compact && !props202.presentation ? "compact" : "comfortable",
        activity: props202.presentation === "activity",
        clamp: props202.clamp
      }) : props202.description,
      props202.metadata.length > 0 && /* @__PURE__ */ jsx30("small", {
        ...stylex19.props(recordStyles.metadata, compact && recordStyles.compactMetadata),
        children: /* @__PURE__ */ jsx30(OperatorMetadata, {
          values: props202.metadata,
          stackDates: props202.presentation === "activity"
        })
      }),
      props202.children
    ]
  });
}
function OperatorTextLink(props202) {
  const compiled = stylex19.props(props202.emphasis !== "action" && recordStyles.link, props202.stretch && recordStyles.stretchedLink, props202.emphasis === "title" && recordStyles.titleLink, props202.emphasis === "quiet" && recordStyles.quietLink);
  const className = `declarative-inline-link operator-inline-link ${compiled.className ?? ""}`;
  const link = props202.href !== undefined ? /* @__PURE__ */ jsx30("a", {
    ...compiled,
    className,
    href: props202.href,
    "data-row-link": props202.stretch ? "" : undefined,
    ...props202.external ? {
      target: "_blank",
      rel: "noreferrer"
    } : {},
    children: props202.children
  }) : /* @__PURE__ */ jsx30("button", {
    ...compiled,
    className,
    type: "button",
    onClick: props202.onClick,
    "data-row-link": props202.stretch ? "" : undefined,
    children: props202.children
  });
  return props202.emphasis === "action" ? /* @__PURE__ */ jsx30(Button, {
    asChild: true,
    variant: "outline",
    children: link
  }) : link;
}
function OperatorCard(props212) {
  const compact = props212.density === "compact";
  const attention = !compact && (props212.tone === "warn" || props212.tone === "error");
  const metadata = props212.metadata?.length ? /* @__PURE__ */ jsx31("small", {
    ...stylex20.props(layoutStyles.headingMetadata, (attention || props212.renderDisclosure) && props212.presentation === "disclosure" && layoutStyles.attentionMetadata),
    children: /* @__PURE__ */ jsx31(OperatorMetadata, {
      values: props212.metadata
    })
  }) : null;
  const root = stylex20.props(layoutStyles.card, compact && props212.framed !== false && layoutStyles.compactCard, !compact && props212.presentation === "disclosure" && !props212.renderDisclosure && layoutStyles.disclosure, props212.renderDisclosure && layoutStyles.labeledDisclosure, props212.presentation === "feature" && props212.framed !== false && layoutStyles.feature, props212.tone === "warn" && layoutStyles.warn, props212.tone === "error" && layoutStyles.error, compact && props212.tone === "good" && layoutStyles.good);
  const body = /* @__PURE__ */ jsxs18("div", {
    "data-operator-card-body": "",
    ...stylex20.props(layoutStyles.body, compact && props212.presentation === "disclosure" && layoutStyles.disclosedBody),
    children: [
      props212.children,
      props212.footer && /* @__PURE__ */ jsx31("div", {
        ...stylex20.props(actionLayoutStyles.group),
        "data-card-controls": "",
        children: props212.footer
      })
    ]
  });
  return props212.presentation === "disclosure" && !props212.renderDisclosure ? /* @__PURE__ */ jsxs18("details", {
    ...root,
    "data-card": "",
    "data-tone": props212.tone ?? "neutral",
    children: [
      /* @__PURE__ */ jsxs18("summary", {
        ...stylex20.props(layoutStyles.summary, !compact && layoutStyles.comfortableSummary, Boolean(props212.summary?.length) && layoutStyles.figuresSummary, attention && layoutStyles.attentionSummary),
        children: [
          props212.summary && props212.summary.length > 0 && /* @__PURE__ */ jsx31("dl", {
            "data-card-summary": "",
            ...stylex20.props(layoutStyles.figures),
            children: props212.summary.map((figure, index) => /* @__PURE__ */ jsxs18("div", {
              "data-tone": figure.tone ?? "neutral",
              ...stylex20.props(layoutStyles.figure),
              children: [
                /* @__PURE__ */ jsx31("dt", {
                  ...stylex20.props(layoutStyles.figureLabel),
                  children: figure.label
                }),
                /* @__PURE__ */ jsx31("dd", {
                  ...stylex20.props(layoutStyles.figureValue, toneText(figure.tone)),
                  children: figure.value
                })
              ]
            }, `${figure.label}:${index}`))
          }),
          props212.label,
          metadata && /* @__PURE__ */ jsxs18(Fragment10, {
            children: [
              " ",
              metadata
            ]
          })
        ]
      }),
      body
    ]
  }) : /* @__PURE__ */ jsxs18("section", {
    ...root,
    "data-card": "",
    "data-tone": props212.tone ?? "neutral",
    children: [
      /* @__PURE__ */ jsxs18("header", {
        ...stylex20.props(layoutStyles.heading, compact && layoutStyles.compactHeading, props212.presentation === "feature" && layoutStyles.featureHeading, props212.renderDisclosure && layoutStyles.disclosureHeading, props212.renderDisclosure && attention && layoutStyles.attentionSummary),
        children: [
          /* @__PURE__ */ jsx31("h2", {
            ...stylex20.props(layoutStyles.headingLabel),
            children: props212.label
          }),
          metadata
        ]
      }),
      props212.renderDisclosure ? props212.renderDisclosure(body) : body
    ]
  });
}
var chromeStyles = {
  header: {
    kVAEAm: "x1n2onr6",
    kY2c9j: "xzkaem6",
    k1xSpc: "x78zum5",
    kAzted: "xcr9lap",
    kGNEyG: "x6s0dn4",
    kjj79g: "x1qughib",
    kOIVth: "x1665zp3",
    kmVPX3: "x1yel030",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xna4lh4",
    kWkggS: "x1xlsm2u",
    kTWfjk: "xdnb5l2",
    kRugJJ: "xrutqb",
    kLyoy9: "xd9d3ul",
    $$css: true
  },
  brandLink: {
    k1xSpc: "x3nfvp2",
    k7Eaqz: "xeuugli",
    kAzted: "x2lwn1j x1c4ya5t",
    kGNEyG: "x6s0dn4",
    kOIVth: "x15gj94b x1otypdl",
    kMwMTN: "xqvuw85",
    kMnn75: "xkrqix3",
    $$css: true
  },
  mark: {
    k1xSpc: "xrvj5dj",
    kzqmXN: "xgd8bvy xjjy2jw",
    kZKoxP: "x1fgtraw x1iwbelc",
    kUk6DE: "x3psx0u",
    kgQiWS: "x1ku5rj1",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xawfzfr",
    kaIpWk: "x16rqkct",
    kMwMTN: "x1myn341",
    kMv6JI: "xssy22x",
    kGuDYH: "xfifm61",
    k63SB2: "x1im5e5j",
    $$css: true
  },
  brandTitle: {
    k7Eaqz: "xeuugli",
    kVQacm: "xb3r6kr",
    kMv6JI: "xssy22x",
    kGuDYH: "xosj86m x1sgj8az",
    ks0D6T: "x1x1rfll xb4vn5r",
    ka26j: "x1umjory",
    k63SB2: "xlpn31b",
    kg5iWk: "xlyipyv",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  accent: {
    kMwMTN: "x1myn341",
    kKX8nH: "x1k4tb9n",
    k63SB2: "x184j2wm",
    $$css: true
  },
  displayAccent: {
    ka26j: "x62unnn",
    $$css: true
  },
  headerActions: {
    k1xSpc: "x78zum5",
    kmuXW: "x2lah0s",
    kGNEyG: "x6s0dn4",
    kOIVth: "x167g77z x15j3ira",
    $$css: true
  },
  control: {
    k1xSpc: "x3nfvp2",
    kAzted: "xu0aao5 x1c4ya5t",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    kaIpWk: "xu4hgxq",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1k6wstc x155ir8z",
    k63SB2: "x1s688f",
    kb6lSQ: "xwhmn0f",
    kMnn75: "xkrqix3",
    kP9fke: "xtvhhri",
    kwmNyF: "x14ow2ja",
    $$css: true
  },
  primary: {
    kOIVth: "x1j9xkj6",
    kmVPX3: "x1tzdv60 x1xnq73d",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xawfzfr",
    kWkggS: "x15vqgvx",
    kMwMTN: "x1um1dla",
    $$css: true
  },
  secondary: {
    kmVPX3: "x1csxjeb x1xnq73d",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h",
    kMwMTN: "xqvuw85",
    kaVNsj: "x8bwlc1",
    kDPRdz: "xz2iokx",
    $$css: true
  },
  icon: {
    kzqmXN: "x14qfxbe xzy26m8",
    kmVPX3: "x1717udv",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h",
    kWkggS: "xjbqb8w",
    kMwMTN: "xgi1xjn",
    kkrTdU: "x1ypdohk",
    kaVNsj: "x8bwlc1",
    kDPRdz: "xz2iokx",
    $$css: true
  },
  desktopOnly: {
    k1xSpc: "x3nfvp2 xkaaz9w",
    $$css: true
  },
  focus: {
    kInvED: "x1hl8ikr",
    k3Woio: "x16dl9wz",
    kiEn40: "x7s97pk",
    $$css: true
  },
  masthead: {
    k1xSpc: "x78zum5",
    k7Eaqz: "xeuugli",
    kGNEyG: "xuk3077",
    kOIVth: "x1665zp3",
    kmVPX3: "xjpj6cu",
    kaRhUE: "xvabu7y",
    kAkjA9: "x13osz58",
    kdLj2q: "xp7j7s0",
    kLyoy9: "x1dbyxhg",
    kRugJJ: "x11h1smq",
    $$css: true
  },
  title: {
    kogj98: "x1ghz6dp",
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    kMv6JI: "xssy22x",
    ka26j: "x3n8r9z",
    k63SB2: "xmvyi9x",
    kGuDYH: "x155jak9 x1i2bv8g",
    kLWn49: "xo5v014 x13bdqmg",
    kb6lSQ: "xjat59b",
    kMwMTN: "xqvuw85",
    $$css: true
  },
  description: {
    kogj98: "x1ghz6dp",
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    kMwMTN: "x1ar3pfp",
    kGuDYH: "x2ouz8m",
    kGO01o: "xs9asl8 x1yy75ev",
    ks0D6T: "x1qbr2yc",
    k9hNLj: "x1iqbltf",
    koRygp: "x1dbdljh",
    k76vLx: "xyv2k2f",
    kr4CYY: "xqjcjlm",
    $$css: true
  },
  tabs: {
    k1xSpc: "x78zum5",
    k7Eaqz: "xeuugli",
    kGNEyG: "xuk3077",
    kOIVth: "x195vfkc",
    kmVPX3: "x6vc9w5 xg8tid0",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xna4lh4",
    kaRhUE: "xxsmavh",
    k3bwnL: "xm9l3w6",
    k9lfMF: "xbfx0k3",
    kygrvt: "xsbd0l1",
    kOuLrU: "xfk6m8",
    $$css: true
  },
  tab: {
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    kmuXW: "x2lah0s",
    kOIVth: "x167g77z",
    kMv6JI: "xa9opjo",
    kGuDYH: "xfifm61",
    kb6lSQ: "x2ujxvm",
    kMwMTN: "x1ar3pfp",
    kmVPX3: "x1b28kx2",
    kt9PQ7: "xlxy82",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "x16stqrj",
    k3aq6I: "xavs3du",
    kMnn75: "xkrqix3",
    khDVqt: "xuxw1ft",
    kDPRdz: "xhwcb5i",
    kOoaD6: "xivsve2",
    kylRue: "x1xiyr0g",
    kTWfjk: "x126n28w",
    k1xoom: "xtwf3lw",
    kRugJJ: "x1ab9136",
    kr4CYY: "xxgfmko",
    $$css: true
  },
  badge: {
    kMv6JI: "xa9opjo",
    kGuDYH: "x1k6wstc",
    kaIpWk: "x1e6avla",
    kmVPX3: "xst3r74",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h",
    kMwMTN: "x1ar3pfp",
    $$css: true
  }
};
function BrandText(props222) {
  const title = props222.title.trim();
  const split = title.lastIndexOf(" ");
  if (split <= 0)
    return /* @__PURE__ */ jsx32(Fragment11, {
      children: title
    });
  return /* @__PURE__ */ jsxs19(Fragment11, {
    children: [
      title.slice(0, split),
      " ",
      /* @__PURE__ */ jsx32("em", {
        ...stylex21.props(chromeStyles.accent, props222.display && chromeStyles.displayAccent),
        children: title.slice(split + 1)
      })
    ]
  });
}
function OperatorHeader(props222) {
  return /* @__PURE__ */ jsxs19("header", {
    ...styledProps({
      className: props222.className
    }, chromeStyles.header),
    "aria-label": props222.label,
    children: [
      /* @__PURE__ */ jsxs19("a", {
        ...stylex21.props(chromeStyles.brandLink, chromeStyles.focus),
        href: props222.homeHref,
        children: [
          /* @__PURE__ */ jsx32("span", {
            ...stylex21.props(chromeStyles.mark),
            "aria-hidden": "true",
            children: props222.mark
          }),
          /* @__PURE__ */ jsx32("strong", {
            ...stylex21.props(chromeStyles.brandTitle),
            children: /* @__PURE__ */ jsx32(BrandText, {
              title: props222.title
            })
          })
        ]
      }),
      /* @__PURE__ */ jsx32("nav", {
        ...stylex21.props(chromeStyles.headerActions),
        "aria-label": props222.actionsLabel,
        children: props222.children
      })
    ]
  });
}
function OperatorHeaderLink({
  variant,
  ...props222
}) {
  return /* @__PURE__ */ jsx32("a", {
    ...styledProps(props222, chromeStyles.control, chromeStyles[variant], chromeStyles.focus)
  });
}
function OperatorHeaderButton({
  desktopOnly,
  ...props222
}) {
  return /* @__PURE__ */ jsx32("button", {
    type: "button",
    ...styledProps(props222, chromeStyles.control, chromeStyles.icon, desktopOnly && chromeStyles.desktopOnly, chromeStyles.focus)
  });
}
function OperatorMasthead(props222) {
  return /* @__PURE__ */ jsxs19("header", {
    ...styledProps({
      className: props222.className
    }, chromeStyles.masthead),
    children: [
      /* @__PURE__ */ jsx32("h1", {
        ...stylex21.props(chromeStyles.title),
        children: /* @__PURE__ */ jsx32(BrandText, {
          title: props222.title,
          display: true
        })
      }),
      props222.description && /* @__PURE__ */ jsx32("p", {
        ...stylex21.props(chromeStyles.description),
        children: props222.description
      })
    ]
  });
}
function OperatorSectionTabs(props222) {
  return /* @__PURE__ */ jsx32("nav", {
    ...styledProps({
      className: props222.className
    }, chromeStyles.tabs),
    "aria-label": props222.label,
    role: "tablist",
    children: props222.children
  });
}
function OperatorSectionTab({
  selected,
  count: count3,
  children,
  ...props222
}) {
  return /* @__PURE__ */ jsxs19("a", {
    ...styledProps(props222, chromeStyles.tab, chromeStyles.focus),
    role: "tab",
    "aria-selected": selected,
    children: [
      /* @__PURE__ */ jsx32("span", {
        children
      }),
      count3 !== undefined && count3 > 0 && /* @__PURE__ */ jsx32("span", {
        ...stylex21.props(chromeStyles.badge),
        children: count3
      })
    ]
  });
}
function ConfirmDialog2(props222) {
  return /* @__PURE__ */ jsx33(ConfirmDialog, {
    ...props222,
    dismissOnOutside: true
  });
}
var formLayoutStyles = {
  form: {
    k1xSpc: "xrvj5dj",
    kumcoG: "xnby9oq x1c2rghm x1ram2ln x4jmfmw",
    kOIVth: "x1v2ro7d",
    kzqmXN: "x9redfm x10x3x5a",
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    kB7OPa: "x9f619",
    $$css: true
  },
  submit: {
    kSGwAc: "x7fd4wk",
    kFhvOy: "x1lqcxt8",
    $$css: true
  }
};
var rendererLayoutStyles = {
  head: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kGNEyG: "x1cy8zhl",
    kjj79g: "x1qughib",
    kOIVth: "x1lblyuz",
    kGO01o: "x1l90r2v",
    kt9PQ7: "xlxy82",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "x1594w68",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  copy: {
    ks0D6T: "x148vls7",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  title: {
    kogj98: "x1ghz6dp",
    kMwMTN: "xqvuw85",
    kMv6JI: "xssy22x",
    kGuDYH: "x1m6oxru x1mg0i68",
    ka26j: "x17owtcr",
    k63SB2: "xseu7c4",
    kb6lSQ: "x5sy3j4",
    kLWn49: "x1f41ap9",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  kicker: {
    k1xSpc: "x1lliihq",
    k1K539: "xzueoph",
    kMwMTN: "x1myn341",
    kMv6JI: "xa9opjo",
    kGuDYH: "xvwhms9",
    kb6lSQ: "x11fj6oh",
    kP9fke: "xtvhhri",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  description: {
    keoZOQ: "x1rhet7l",
    kMwMTN: "xgi1xjn",
    kGuDYH: "x4z9k3i",
    kLWn49: "x1evy7pa",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  standing: {
    k1xSpc: "xrvj5dj",
    kAPf3g: "x4xo5sw",
    kOIVth: "x1v2ro7d",
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    $$css: true
  },
  status: {
    k1xSpc: "xrvj5dj",
    kAPf3g: "x4xo5sw",
    kOIVth: "x1ed6fcf",
    kMwMTN: "xqvuw85 xh9rmbx x16a6thm x1mvgbya",
    kGuDYH: "x1ct8sxb",
    k63SB2: "xh88oxj",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  statusDetail: {
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "xfmn3hh",
    k63SB2: "xo1l8bm",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  control: {
    k1xSpc: "xwz0xwf",
    kGNEyG: "x7a106z",
    kOIVth: "x167g77z",
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    $$css: true
  },
  message: {
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1k6wstc",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  error: {
    kMwMTN: "x1mel2pz",
    $$css: true
  },
  empty: {
    kogj98: "x1ghz6dp",
    kmVPX3: "x3sov96",
    kMwMTN: "x1ar3pfp",
    kGuDYH: "x1ct8sxb",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  cellEmpty: {
    kmVPX3: "x1toko95",
    $$css: true
  },
  links: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1j9xkj6 xvtq9v3 x1g79t40",
    kGuDYH: "xs9z77v",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  matrixFrame: {
    kanfag: "xzxxqnc",
    k9g6sI: "x12h1iku",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  matrix: {
    k1xSpc: "xrvj5dj",
    kOIVth: "xaobbuh",
    k7Eaqz: "xeuugli",
    kumcoG: "x1mkdm3x x1q3wkif x1gbo546 xkyyx2n xchmvhn x1mqdp8p x16lgxdz x1gjrsil",
    $$css: true
  },
  cell: {
    kanfag: "x17il9kl",
    k9g6sI: "x12h1iku",
    k7Eaqz: "xeuugli",
    kmVPX3: "xbxpdvy",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h",
    kEafiO: "xamhcws",
    kLZC3w: "x172wxxo xvw7cn x1qaj2f5 xoy5xpq",
    kaIpWk: "xur7f20",
    kWkggS: "x18s3upu",
    $$css: true
  },
  dropAllowed: {
    ksu8eU: "xbsl7fq",
    kVAM5u: "xawfzfr",
    kWkggS: "x9kxhyz",
    $$css: true
  },
  caption: {
    kogj98: "x8o5f6s",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xv6m45y",
    kGuDYH: "x4nd1th",
    k63SB2: "xjgl48g",
    kb6lSQ: "x19vr2a4",
    kP9fke: "xel79qc",
    kHjlTd: "xj0a0fe",
    $$css: true
  }
};
function CssButton({
  variant = "primary",
  xstyle,
  ...props222
}) {
  if (variant !== "link")
    return /* @__PURE__ */ jsx34(Button, {
      variant,
      xstyle,
      ...props222
    });
  return /* @__PURE__ */ jsx34("button", {
    ...styledProps(props222, actionLayoutStyles.link, xstyle)
  });
}
function CssInput({
  xstyle,
  ...props222
}) {
  return /* @__PURE__ */ jsx34("input", {
    ...styledProps(props222, xstyle)
  });
}
function CssSelect({
  xstyle,
  ...props222
}) {
  return /* @__PURE__ */ jsx34("select", {
    ...styledProps(props222, xstyle)
  });
}
function CssTextarea({
  xstyle,
  ...props222
}) {
  return /* @__PURE__ */ jsx34("textarea", {
    ...styledProps(props222, xstyle)
  });
}
function CssDisclosure(props222) {
  return /* @__PURE__ */ jsx34(OperatorDisclosure, {
    className: props222.className,
    triggerLabel: props222.triggerLabel,
    triggerVariant: props222.triggerVariant,
    presentation: props222.presentation,
    children: props222.children
  });
}
function CssTabs(props222) {
  const active = props222.tabs.find((tab) => tab.value === props222.value);
  return /* @__PURE__ */ jsxs20("div", {
    "data-tabs": "",
    children: [
      /* @__PURE__ */ jsx34(OperatorSegmentedGroup, {
        role: "tablist",
        "aria-label": props222.label,
        children: props222.tabs.map((tab) => /* @__PURE__ */ jsxs20(OperatorSegmentedButton, {
          type: "button",
          role: "tab",
          "aria-selected": tab.value === active?.value,
          onClick: () => props222.onValueChange(tab.value),
          children: [
            tab.label,
            tab.count !== undefined ? ` (${tab.count})` : ""
          ]
        }, tab.value))
      }),
      active && /* @__PURE__ */ jsx34("div", {
        role: "tabpanel",
        children: active.content
      })
    ]
  });
}
function StaticAllTabs(props222) {
  return /* @__PURE__ */ jsxs20("div", {
    "data-ui-tabs": true,
    "data-ui-tabs-default": props222.defaultValue,
    children: [
      /* @__PURE__ */ jsx34(OperatorTabStrip, {
        "aria-label": props222.label,
        children: props222.tabs.map((tab) => {
          const active = tab.value === props222.defaultValue;
          return /* @__PURE__ */ jsxs20(OperatorTabButton, {
            id: `${props222.id}-tab-${tab.value}`,
            type: "button",
            role: "tab",
            "data-ui-tab": tab.value,
            "aria-controls": `${props222.id}-panel-${tab.value}`,
            "aria-selected": active,
            children: [
              tab.label,
              tab.count !== undefined && /* @__PURE__ */ jsx34(OperatorTabCount, {
                children: tab.count
              })
            ]
          }, tab.value);
        })
      }),
      props222.tabs.map((tab) => {
        const active = tab.value === props222.defaultValue;
        return /* @__PURE__ */ jsx34("div", {
          id: `${props222.id}-panel-${tab.value}`,
          className: active ? "is-active" : undefined,
          "data-ui-panel": tab.value,
          role: "tabpanel",
          "aria-labelledby": `${props222.id}-tab-${tab.value}`,
          hidden: !active,
          children: tab.content
        }, tab.value);
      })
    ]
  });
}
var CSS_COMPONENTS = {
  engine: "css",
  density: "compact",
  Button: CssButton,
  Input: CssInput,
  Select: CssSelect,
  Textarea: CssTextarea,
  ConfirmDialog: ConfirmDialog2,
  Disclosure: CssDisclosure,
  Tabs: CssTabs
};
var OperatorRendererHostContext = createContext4({
  renderAllTabs: false,
  components: CSS_COMPONENTS
});
var OpenDetailContext = createContext4(null);
var actionResultStyles = {
  frame: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x167g77z",
    kzqmXN: "x9redfm",
    k7Eaqz: "xeuugli",
    kB7OPa: "x9f619",
    kmVPX3: "xc7ga6q",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xmt0h0j",
    kaIpWk: "xur7f20",
    kWkggS: "x9kxhyz",
    kpvhgV: "x14c6fbn x16e9dwd",
    kg5VkO: "x126usnh",
    k21Pnn: "x10spfxb",
    kgLgug: "x1q652j",
    kJLzUl: "x6imu0b xq4oo3n",
    kxlVUH: "x1ffza42 x17vqpdp",
    k1OL56: "xhesz8g x8wqbq1",
    kYsyRH: "xsucau6 x1ga0ivm",
    kAh4Fn: "xkktd5z x9as3ks",
    kvvOh: "x1yweesi",
    $$css: true
  },
  title: {
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  list: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x1j9xkj6",
    kogj98: "x1ghz6dp",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  row: {
    k1xSpc: "xrvj5dj",
    kumcoG: "xw1czmm x1c2rghm x4jmfmw",
    kOIVth: "x883omv xv2j0n9 x1kis1tw",
    kGNEyG: "x6s0dn4",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  term: {
    kMwMTN: "x1ar3pfp",
    kGuDYH: "xvwhms9",
    kMv6JI: "xa9opjo",
    k63SB2: "xo1l8bm",
    kLWn49: "xggjnk3",
    kP9fke: "xtvhhri",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  value: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x167g77z",
    k7Eaqz: "xeuugli",
    kogj98: "x1ghz6dp",
    $$css: true
  },
  code: {
    kVQacm: "xb3r6kr",
    k7Eaqz: "xeuugli",
    kMwMTN: "xqvuw85",
    kg5iWk: "xlyipyv",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  copy: {
    kmuXW: "x2lah0s",
    kAzted: "x1c4ya5t",
    k7Eaqz: "x1wkdlc4",
    $$css: true
  }
};
function isJsonValue(value) {
  if (value === null || typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return true;
  }
  if (Array.isArray(value))
    return value.every(isJsonValue);
  if (typeof value !== "object")
    return false;
  return Object.values(value).every(isJsonValue);
}
function plainRecord(value) {
  if (value === null || typeof value !== "object" || Array.isArray(value)) {
    return;
  }
  const result = {};
  for (const [key, candidate] of Object.entries(value)) {
    if (!isJsonValue(candidate))
      return;
    result[key] = candidate;
  }
  return result;
}
function actionFailureMessage(error) {
  const reason = error instanceof Error ? error.message.trim() : "";
  return reason ? `Action failed: ${reason}` : "Action failed.";
}
function presentedActionResult(action, value) {
  if (!action.result)
    return null;
  const output = plainRecord(value);
  if (!output)
    return null;
  const fields = action.result.fields.flatMap((field) => {
    const candidate = output[field.name];
    if (candidate === undefined)
      return [];
    if (candidate !== null && typeof candidate !== "string" && typeof candidate !== "number" && typeof candidate !== "boolean") {
      return [];
    }
    return [{
      name: field.name,
      label: field.label,
      value: candidate === null ? "—" : String(candidate),
      copyable: field.copyable === true,
      sensitive: field.sensitive === true
    }];
  });
  return fields.length > 0 ? {
    title: action.result.title,
    fields
  } : null;
}
function ActionResult(props232) {
  const {
    Button: Button2
  } = useContext4(OperatorRendererHostContext).components;
  const frame = stylex22.props(actionResultStyles.frame);
  return /* @__PURE__ */ jsxs21("section", {
    ...frame,
    "data-action-result": "",
    "data-operator-action-result": "",
    "aria-live": "polite",
    children: [
      /* @__PURE__ */ jsx35("strong", {
        ...stylex22.props(actionResultStyles.title),
        children: props232.result.title
      }),
      /* @__PURE__ */ jsx35("dl", {
        ...stylex22.props(actionResultStyles.list),
        children: props232.result.fields.map((field) => /* @__PURE__ */ createElement6("div", {
          ...stylex22.props(actionResultStyles.row),
          key: field.name,
          "data-sensitive": field.sensitive || undefined
        }, /* @__PURE__ */ jsx35("dt", {
          ...stylex22.props(actionResultStyles.term),
          children: field.label
        }), /* @__PURE__ */ jsxs21("dd", {
          ...stylex22.props(actionResultStyles.value),
          children: [
            /* @__PURE__ */ jsx35("code", {
              ...stylex22.props(actionResultStyles.code),
              title: field.value,
              children: field.value
            }),
            field.copyable && /* @__PURE__ */ jsx35(Button2, {
              type: "button",
              variant: "ghost",
              onClick: () => void navigator.clipboard.writeText(field.value),
              xstyle: actionResultStyles.copy,
              children: "Copy"
            })
          ]
        })))
      }),
      props232.onDismiss && /* @__PURE__ */ jsx35(Button2, {
        type: "button",
        variant: "ghost",
        onClick: props232.onDismiss,
        children: "Dismiss"
      })
    ]
  });
}
var formFieldStyles = {
  label: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x1nejdyq",
    k7Eaqz: "xeuugli",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1k6wstc",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  wideLabel: {
    kBCFzs: "x1osaytk",
    $$css: true
  },
  control: {
    kAzted: "x141feeh x1c4ya5t",
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    kB7OPa: "x9f619",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h",
    kaIpWk: "xu4hgxq",
    kWkggS: "xbslqsl",
    kMwMTN: "xqvuw85",
    kmVPX3: "x1160tuk",
    kMv6JI: "x5ddh9m",
    kGuDYH: "xfifm61",
    kMeerF: "x1k57tk5 x784prv",
    k3XXqK: "xaatb59",
    kjBf7l: "x1itw484",
    kInvED: "x2ssjo2",
    $$css: true
  },
  textarea: {
    kAzted: "xefclja",
    kHenm0: "x288g5",
    kLWn49: "xfrs9s4",
    $$css: true
  },
  checkboxLabel: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x167g77z",
    kAzted: "x2lwn1j x1c4ya5t",
    $$css: true
  },
  checkbox: {
    kAzted: "x65nank xn3zsfb",
    kmuXW: "x2lah0s",
    $$css: true
  }
};
function actionFormInput(action, data) {
  const input = {};
  for (const [name, value] of Object.entries(plainRecord(action.input) ?? {})) {
    if (value !== undefined)
      input[name] = value;
  }
  for (const field of action.form?.fields ?? []) {
    if (field.control === "checkbox") {
      input[field.name] = data.has(field.name);
      continue;
    }
    const value = data.get(field.name);
    if (typeof value !== "string")
      continue;
    if (!field.required && value === "") {
      delete input[field.name];
      continue;
    }
    input[field.name] = field.control === "number" ? Number(value) : value;
  }
  return input;
}
function clearSecretFormFields(action, form) {
  for (const field of action.form?.fields ?? []) {
    if (!field.secret)
      continue;
    const control = form.elements.namedItem(field.name);
    if (control && "value" in control)
      control.value = "";
  }
}
function ActionFormFields(props242) {
  const {
    Input: Input2,
    Select: Select2,
    Textarea: Textarea2,
    engine
  } = useContext5(OperatorRendererHostContext).components;
  const controlStyles = {
    xstyle: engine === "css" && formFieldStyles.control
  };
  const initial = plainRecord(props242.action.input) ?? {};
  const [selected, setSelected] = useState11(() => Object.fromEntries((props242.action.form?.fields ?? []).flatMap((field) => {
    if (field.control !== "select")
      return [];
    const value = initial[field.name];
    const selectedValue = typeof value === "string" ? value : field.required ? field.options?.[0]?.value : undefined;
    return selectedValue ? [[field.name, selectedValue]] : [];
  })));
  return /* @__PURE__ */ jsx36(Fragment12, {
    children: props242.action.form?.fields.map((field) => {
      const value = initial[field.name];
      const label = field.labelBy?.values.find((candidate) => candidate.value === selected[field.labelBy?.field ?? ""])?.label ?? field.label;
      if (field.control === "checkbox") {
        return /* @__PURE__ */ jsxs22("label", {
          ...stylex23.props(formFieldStyles.label, formFieldStyles.checkboxLabel),
          children: [
            /* @__PURE__ */ jsx36("input", {
              ...stylex23.props(engine === "css" && formFieldStyles.control, formFieldStyles.checkbox),
              name: field.name,
              type: "checkbox",
              defaultChecked: value === true
            }),
            /* @__PURE__ */ jsx36("span", {
              children: label
            })
          ]
        }, field.name);
      }
      if (field.control === "select") {
        return /* @__PURE__ */ jsxs22("label", {
          ...stylex23.props(formFieldStyles.label),
          children: [
            /* @__PURE__ */ jsx36("span", {
              children: label
            }),
            /* @__PURE__ */ jsxs22(Select2, {
              ...controlStyles,
              name: field.name,
              defaultValue: typeof value === "string" ? value : field.required ? undefined : "",
              required: field.required,
              onChange: (event) => setSelected((current) => ({
                ...current,
                [field.name]: event.target.value
              })),
              children: [
                !field.required && /* @__PURE__ */ jsx36("option", {
                  value: "",
                  children: "None"
                }),
                field.options?.map((option) => /* @__PURE__ */ jsx36("option", {
                  value: option.value,
                  children: option.label
                }, option.value))
              ]
            })
          ]
        }, field.name);
      }
      if (field.control === "textarea") {
        return /* @__PURE__ */ jsxs22("label", {
          ...stylex23.props(formFieldStyles.label, formFieldStyles.wideLabel),
          children: [
            /* @__PURE__ */ jsx36("span", {
              children: label
            }),
            /* @__PURE__ */ jsx36(Textarea2, {
              xstyle: engine === "css" && [formFieldStyles.control, formFieldStyles.textarea],
              name: field.name,
              defaultValue: typeof value === "string" ? value : "",
              required: field.required,
              rows: 4
            })
          ]
        }, field.name);
      }
      const defaultValue = !field.secret && (typeof value === "string" || typeof value === "number") ? value : "";
      return /* @__PURE__ */ jsxs22("label", {
        ...stylex23.props(formFieldStyles.label),
        children: [
          /* @__PURE__ */ jsx36("span", {
            children: label
          }),
          /* @__PURE__ */ jsx36(Input2, {
            ...controlStyles,
            name: field.name,
            type: field.secret ? "password" : field.control === "url" ? "url" : field.control === "number" ? "number" : "text",
            defaultValue,
            required: field.required,
            autoComplete: field.secret ? "new-password" : undefined
          })
        ]
      }, field.name);
    })
  });
}
function isPreparedConfirmation(value) {
  if (typeof value !== "object" || value === null)
    return false;
  return "kind" in value && value.kind === "prepared-confirmation" && "token" in value && typeof value.token === "string" && "summary" in value && typeof value.summary === "string" && "expiresAt" in value && typeof value.expiresAt === "string";
}
function actionVariant(action, subordinate, primary) {
  if (action.confirmation)
    return "danger";
  return subordinate ? "link" : primary ? "primary" : "secondary";
}
function OperatorActionButton(props252) {
  const host = useContext6(OperatorRendererHostContext);
  const components = props252.components ?? host.components;
  const {
    Button: Button2,
    ConfirmDialog: ConfirmDialog3,
    Disclosure
  } = components;
  const titleId = useId2();
  const actionKey = `${props252.action.actionId}:${JSON.stringify(props252.action.input)}`;
  const mounted = useRef12(true);
  const [pending, setPending] = useState12(false);
  const [message, setMessage] = useState12("");
  const [failed, setFailed] = useState12(false);
  const [awaiting, setAwaiting] = useState12(null);
  const [result, setResult] = useState12(null);
  const [completions, setCompletions] = useState12(0);
  useEffect14(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  useEffect14(() => {
    setResult(null);
  }, [actionKey]);
  const run = async (invocation) => {
    setPending(true);
    setMessage("");
    setFailed(false);
    setResult(null);
    try {
      const output = await props252.onAction(invocation);
      const presented = presentedActionResult(invocation, output);
      if (mounted.current) {
        setResult(presented);
        if (presented || !invocation.form) {
          setMessage("Completed.");
        } else {
          setCompletions((count3) => count3 + 1);
        }
      } else if (presented) {
        host.onDetachedActionResult?.(presented);
      }
    } catch (error) {
      if (mounted.current) {
        setMessage(actionFailureMessage(error));
        setFailed(true);
      }
    } finally {
      if (mounted.current) {
        setPending(false);
        setAwaiting(null);
      }
    }
  };
  const start = async (invocation) => {
    const confirmation = invocation.confirmation;
    if (confirmation?.kind === "static") {
      setAwaiting({
        summary: confirmation.message,
        invocation
      });
      return;
    }
    if (confirmation?.kind !== "prepared") {
      await run(invocation);
      return;
    }
    setPending(true);
    setMessage("");
    setFailed(false);
    try {
      const prepared = await props252.onAction({
        ...invocation,
        invocation: {
          mode: "prepare"
        }
      });
      if (!isPreparedConfirmation(prepared)) {
        throw new Error("Invalid prepared confirmation");
      }
      setAwaiting({
        summary: prepared.summary,
        invocation: {
          ...invocation,
          invocation: {
            mode: "execute",
            token: prepared.token
          }
        }
      });
    } catch (error) {
      setMessage(actionFailureMessage(error));
      setFailed(true);
    } finally {
      setPending(false);
    }
  };
  const ActionControl = props252.action.form ? "div" : "span";
  const formStyles = stylex24.props(formLayoutStyles.form);
  const actionForm = props252.action.form ? /* @__PURE__ */ jsxs23("form", {
    ...formStyles,
    "data-action-form": "",
    onSubmit: (event) => {
      event.preventDefault();
      const input = actionFormInput(props252.action, new FormData(event.currentTarget));
      clearSecretFormFields(props252.action, event.currentTarget);
      start({
        ...props252.action,
        input
      });
    },
    children: [
      /* @__PURE__ */ jsx37(ActionFormFields, {
        action: props252.action
      }),
      /* @__PURE__ */ jsx37(Button2, {
        xstyle: formLayoutStyles.submit,
        type: "submit",
        variant: actionVariant(props252.action, props252.subordinate === true, props252.primary === true),
        disabled: pending || props252.action.disabled === true,
        children: pending ? "Working…" : props252.action.form.submitLabel ?? props252.action.label
      }),
      message && /* @__PURE__ */ jsx37("small", {
        className: failed ? "status status-error" : "status",
        "aria-live": "polite",
        children: message
      }),
      result && /* @__PURE__ */ jsx37(ActionResult, {
        result
      })
    ]
  }, `${actionKey}:${completions}`) : null;
  return /* @__PURE__ */ jsxs23(Fragment13, {
    children: [
      /* @__PURE__ */ jsxs23(ActionControl, {
        ...stylex24.props(rendererLayoutStyles.control),
        "data-control-engine": components.engine,
        children: [
          props252.action.form ? props252.action.form.presentation === "disclosure" ? /* @__PURE__ */ jsx37(Disclosure, {
            className: "declarative-action-disclosure",
            presentation: "action",
            triggerVariant: props252.primary ? "primary" : undefined,
            title: props252.action.label,
            triggerLabel: props252.action.label,
            children: actionForm
          }, `${actionKey}:${completions}`) : actionForm : /* @__PURE__ */ jsx37(Button2, {
            type: "button",
            variant: actionVariant(props252.action, props252.subordinate === true, props252.primary === true),
            disabled: pending || props252.action.disabled === true,
            onClick: () => void start(props252.action),
            children: pending ? "Working…" : props252.action.label
          }),
          !props252.action.form && message && /* @__PURE__ */ jsx37("small", {
            ...stylex24.props(rendererLayoutStyles.message, failed && rendererLayoutStyles.error),
            "aria-live": "polite",
            children: message
          }),
          !props252.action.form && result && /* @__PURE__ */ jsx37(ActionResult, {
            result
          })
        ]
      }),
      awaiting && /* @__PURE__ */ jsx37(ConfirmDialog3, {
        mark: "!",
        title: "Run this workspace action?",
        titleId,
        cancelLabel: "Cancel",
        confirmLabel: pending ? "Working…" : "Confirm action",
        pending,
        onCancel: () => setAwaiting(null),
        onConfirm: () => void run(awaiting.invocation),
        children: /* @__PURE__ */ jsx37("p", {
          children: awaiting.summary
        })
      })
    ]
  });
}
function Actions(props252) {
  const {
    Disclosure
  } = useContext6(OperatorRendererHostContext).components;
  if (props252.actions.length === 0)
    return null;
  const grouped = props252.subordinate === true && props252.actions.length > 1;
  const layout = stylex24.props(grouped ? actionLayoutStyles.menu : actionLayoutStyles.group, props252.align === "end" && actionLayoutStyles.end);
  const content = /* @__PURE__ */ jsx37("div", {
    ...layout,
    "data-actions": "",
    children: props252.actions.map((action, index) => /* @__PURE__ */ jsx37(OperatorActionButton, {
      action,
      onAction: props252.onAction,
      subordinate: props252.subordinate === true && !grouped
    }, `${action.actionId}:${action.capabilityId ?? "static"}:${index}`))
  });
  return grouped ? /* @__PURE__ */ jsx37(Disclosure, {
    title: props252.label ?? "Available actions",
    triggerLabel: props252.triggerLabel ?? "Options",
    triggerVariant: "link",
    className: "operator-actions-options",
    children: content
  }) : content;
}
var workspaceStyles = {
  frame: {
    kAzted: "x2lwn1j",
    ks0D6T: "x186ixgm",
    kmVPX3: "xdbnglg",
    kORKVm: "x1odjw0f",
    kMF7Lf: "x1cb063g",
    $$css: true
  },
  embedded: {
    kanfag: "x1foj65r",
    k9g6sI: "x12h1iku",
    kAzted: "x65nank",
    kmVPX3: "x1717udv",
    kXHlph: "x1plvlek",
    kORKVm: "xryxfnj",
    kMF7Lf: "xb1114b",
    $$css: true
  },
  sections: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x1jsv65m",
    kGNEyG: "x7a106z",
    kOIVth: "x14i4cvt",
    kLKAdn: "x1p5oq8j",
    k1JLwA: "x4jmfmw",
    kLyoy9: "x62c7l",
    k3VDzK: "xugsc6q",
    kSbKWw: "x1c2rghm",
    k4qugS: "xyedrc3",
    kRXiju: "x1tkkb8",
    $$css: true
  },
  comfortableSections: {
    kOIVth: "x1jaupxr",
    kLKAdn: "x7sb2j6",
    kLyoy9: "xqca30q",
    k3VDzK: "xugsc6q",
    k4qugS: "x1wlbpn8",
    kRXiju: "x1tkkb8",
    $$css: true
  },
  section: {
    k7Eaqz: "xeuugli",
    $$css: true
  },
  sectionAfter: {
    keoZOQ: "xaqh0s9",
    $$css: true
  },
  wide: {
    kBCFzs: "x1osaytk",
    $$css: true
  },
  query: {
    keoZOQ: "xifccgj",
    $$css: true
  }
};
var sourceStyles = {
  root: {
    k7Eaqz: "xeuugli",
    $$css: true
  },
  frame: {
    kmVPX3: "x1ctc5qj",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h",
    kaIpWk: "xur7f20",
    kWkggS: "x18s3upu",
    $$css: true
  },
  heading: {
    kogj98: "x8o5f6s",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "x5ddh9m",
    kGuDYH: "xif65rj",
    k63SB2: "x19s9jnd",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  compactHeading: {
    kMv6JI: "xa9opjo",
    kGuDYH: "xfmn3hh",
    k63SB2: "xk50ysn",
    kb6lSQ: "xa7ig63",
    kP9fke: "xtvhhri",
    $$css: true
  },
  text: {
    kskxy: "xgw0a1n",
    kogj98: "x1ghz6dp",
    kVQacm: "xysyzu8",
    kMwMTN: "xgi1xjn",
    kMv6JI: "xa9opjo",
    kGuDYH: "xfifm61",
    kLWn49: "x11m8ghp",
    khDVqt: "x126k92a",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  caption: {
    k1xSpc: "x1lliihq",
    keoZOQ: "x1aawmmo",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1k6wstc",
    $$css: true
  }
};
function OperatorSource(props262) {
  const root = stylex25.props(sourceStyles.root, props262.framed !== false && sourceStyles.frame);
  return /* @__PURE__ */ jsxs24("article", {
    ...root,
    "data-source": "",
    children: [
      props262.label && /* @__PURE__ */ jsx38("h3", {
        ...stylex25.props(sourceStyles.heading, props262.density === "compact" && sourceStyles.compactHeading),
        children: props262.label
      }),
      /* @__PURE__ */ jsx38("pre", {
        ...stylex25.props(sourceStyles.text),
        children: props262.text
      }),
      props262.truncated && /* @__PURE__ */ jsx38("small", {
        ...stylex25.props(sourceStyles.caption),
        children: "Source content was truncated by its provider."
      })
    ]
  });
}
var progressStyles = {
  meters: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x1lelaru x1w43bmf",
    kOIVth: "xiv87he xps7s55",
    kogj98: "x1ghz6dp",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  meter: {
    k7Eaqz: "xeuugli",
    $$css: true
  },
  label: {
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "xfmn3hh",
    kb6lSQ: "x1labic3",
    kP9fke: "xtvhhri",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  value: {
    kogj98: "x1pz56wa",
    kMwMTN: "xqvuw85",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1jvydc1",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  frame: {
    k7Eaqz: "xeuugli",
    kmVPX3: "xbxpdvy",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h",
    kaIpWk: "xur7f20",
    kWkggS: "x18s3upu",
    $$css: true
  },
  header: {
    k1xSpc: "x78zum5",
    kGNEyG: "x1pha0wt",
    kjj79g: "x1qughib",
    kOIVth: "x1af02g3",
    kwnvtZ: "x1a02dak",
    $$css: true
  },
  title: {
    kMwMTN: "xqvuw85",
    kGuDYH: "x2ouz8m",
    k63SB2: "xh88oxj",
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  state: {
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1k6wstc",
    kb6lSQ: "x1dor1uw",
    kP9fke: "xtvhhri",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  detail: {
    kogj98: "xe6w4ck",
    kMwMTN: "xgi1xjn",
    kGuDYH: "x1ct8sxb",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  time: {
    k1xSpc: "x1lliihq",
    keoZOQ: "x1anpbxc",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1k6wstc",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  bar: {
    k1xSpc: "x1lliihq",
    kzqmXN: "xh8yej3",
    kZKoxP: "xqu0tyb",
    keoZOQ: "x1xmf6yo",
    kysU6D: "xjyslct",
    kMzoRj: "xc342km",
    kaIpWk: "x1e6avla xdyxp2i xeqdbg4 xbmcqy5",
    kWkggS: "xg47p5g x15jglqw x1h2yhso x1qjdyzq",
    keaTxX: "x1q9s9ta",
    $$css: true
  }
};
var flowStyles = {
  root: {
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    $$css: true
  },
  heading: {
    k1xSpc: "x1lliihq xbckst3",
    kogj98: "x8o5f6s",
    kMwMTN: "x1ar3pfp",
    kGuDYH: "x4nd1th",
    k63SB2: "xjgl48g",
    kb6lSQ: "x19vr2a4",
    kP9fke: "xel79qc",
    kMv6JI: "xv6m45y",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  track: {
    k1xSpc: "x78zum5 x1w305zg x10acg2q",
    kOIVth: "xxhr3t x16qsdag x1d3ddqg",
    kogj98: "x1ghz6dp",
    kmVPX3: "x9ms5i6",
    kH6xsr: "x3ct3a4",
    kXHlph: "xw2csxc x10774h0 xdayf2q",
    ks0D6T: "x193iq5w",
    $$css: true
  },
  step: {
    kVAEAm: "x1n2onr6 x1j6awrg",
    kB7OPa: "x9f619",
    kmuXW: "x2lah0s",
    k7Eaqz: "xeuugli",
    kzqmXN: "x1ghds7r xe0affe x1ll1jh2 x1prkmhq x9nnsnq",
    kpe85a: "x1s7jvk7 x11uxfgx x33yvzk",
    kE3dHu: "x1uhho1l x1h1edae x1316j",
    kGO01o: "x18d9i69 xm1vsfr x1ckun3f",
    kMwMTN: "x1ar3pfp",
    kah6P1: "x1s928wv xguj015",
    k87sOh: "x5jc7rz x7hj2ou x1wdcn98",
    kbCHJM: "x12bpigw x44p448 x1e70te5",
    kCIrl2: "x14cqbmr x2e6dpv x194c2x1",
    krVfgx: "xxw6uw7 x1ujw8yj",
    kZKoxP: "xcock1l xpldujj x15t6rfx",
    kWkggS: "x1y3k7d7",
    $$css: true
  },
  mark: {
    kVAEAm: "x1uhb9sk x18of6z9 x1nck5sx",
    k87sOh: "x190b9kf xz59zry",
    kbCHJM: "xxdgi2x x172uiah",
    k1xSpc: "x1lliihq",
    kB7OPa: "x9f619",
    kzqmXN: "x1wc42o8",
    kZKoxP: "xegnrdp",
    k1K539: "xfitlp5",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kaIpWk: "x16rqkct",
    kVAM5u: "x1vw2y1n x6cfppn xym8ms8",
    kWkggS: "x1dd94t5 xn4j7m4 x1amwds0",
    kGVxlE: "x1gnnqk1 xyx7rhw",
    $$css: true
  },
  label: {
    k1xSpc: "x1lliihq",
    kGuDYH: "x1ct8sxb",
    k63SB2: "xk50ysn",
    kHjlTd: "xj0a0fe",
    kMwMTN: "xgi1xjn xn6wv7h x1vjhw47",
    $$css: true
  },
  detail: {
    k1xSpc: "x1lliihq",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1k6wstc",
    kHjlTd: "xj0a0fe",
    $$css: true
  }
};
var queryStyles = {
  root: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kGNEyG: "xuk3077",
    kjj79g: "x1qughib",
    kOIVth: "x1avw0xy",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  controls: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "x1af02g3",
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    kHdLCk: "x10acg2q",
    k1JLwA: "xou8obv",
    koRygp: "x1dbdljh",
    kFASis: "x1w305zg",
    kSbKWw: "x1nae48y",
    kXOHwa: "x1amo615",
    $$css: true
  },
  label: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x17d4w8g",
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    kMwMTN: "xgi1xjn",
    kMv6JI: "x5ddh9m",
    kGuDYH: "xfifm61",
    kLWn49: "x37zpob",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  compactLabel: {
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "xfmn3hh",
    kb6lSQ: "x1labic3",
    kP9fke: "xtvhhri",
    $$css: true
  },
  control: {
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    koRygp: "x1dbdljh",
    kTWfjk: "x126n28w",
    kr4CYY: "xf2x79s",
    $$css: true
  },
  cssSelect: {
    kAzted: "x21xpn4",
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    kzqmXN: "xh8yej3",
    kmVPX3: "x1astma3",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h",
    kaIpWk: "xu4hgxq",
    kWkggS: "x18s3upu",
    kMwMTN: "xqvuw85",
    kMv6JI: "x5ddh9m",
    kGuDYH: "x1ct8sxb",
    $$css: true
  },
  footer: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1af02g3",
    koQZXg: "x8x9d4c",
    k7Eaqz: "xeuugli",
    koRygp: "x1dbdljh",
    kEh2j3: "x703316",
    kGOSNy: "x1s9bmkn",
    kXOHwa: "x1amo615",
    kGaPYi: "x1m2ds42",
    kUR4Rz: "xq86nrr",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1j6dyjg",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  standaloneFooter: {
    koQZXg: "xj3b58b",
    kjj79g: "x1qughib",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  pager: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "x167g77z",
    $$css: true
  }
};
function displayScalar(value) {
  if (value === null)
    return "—";
  if (typeof value === "boolean")
    return value ? "Yes" : "No";
  return String(value);
}
function isStringArray(value) {
  return Array.isArray(value);
}
function displayCell(value) {
  return isStringArray(value) ? value.join(", ") : displayScalar(value === undefined ? null : value);
}
function OperatorLink(props262) {
  const openDetail = useContext7(OpenDetailContext);
  const host = useContext7(OperatorRendererHostContext);
  const target = props262.target;
  const resolvedHref = host.resolveLink?.(target);
  if (resolvedHref || target.kind === "external")
    return /* @__PURE__ */ jsx39(OperatorTextLink, {
      href: resolvedHref ?? (target.kind === "external" ? target.href : ""),
      external: target.kind === "external",
      emphasis: props262.emphasis,
      children: props262.children
    });
  if (target.kind === "detail")
    return openDetail ? /* @__PURE__ */ jsx39(OperatorTextLink, {
      onClick: () => openDetail(target.itemId),
      emphasis: props262.emphasis,
      stretch: props262.emphasis === "title",
      children: props262.children
    }) : /* @__PURE__ */ jsx39(Fragment14, {
      children: props262.children
    });
  return /* @__PURE__ */ jsx39(OperatorTextLink, {
    onClick: () => target.kind === "launch" ? props262.onLaunch(target.launch) : props262.onOpenEntity(target.entityType, target.id),
    emphasis: props262.emphasis,
    children: props262.children
  });
}
function StatsBlock({
  block,
  placement = "body"
}) {
  const {
    components
  } = useContext8(OperatorRendererHostContext);
  return /* @__PURE__ */ jsx40(OperatorStats, {
    items: block.items,
    density: components.density,
    placement
  });
}
function KeyValuesBlock({
  block
}) {
  const {
    components
  } = useContext8(OperatorRendererHostContext);
  return /* @__PURE__ */ jsx40(OperatorFacts, {
    density: components.density,
    items: block.items.map((item) => ({
      label: item.label,
      value: displayScalar(item.value)
    }))
  });
}
function NoticeBlock({
  block
}) {
  const {
    components
  } = useContext8(OperatorRendererHostContext);
  const {
    Disclosure
  } = components;
  return /* @__PURE__ */ jsx40(OperatorNotice, {
    title: block.title,
    text: block.text,
    tone: block.tone ?? "neutral",
    density: components.density,
    children: block.details && block.details.length > 0 && /* @__PURE__ */ jsx40(Disclosure, {
      title: block.title ?? "Diagnostics",
      triggerLabel: "View diagnostics",
      className: "operator-notice-details",
      children: /* @__PURE__ */ jsx40(OperatorSource, {
        text: block.details.join(`

`),
        density: components.density,
        framed: false
      })
    })
  });
}
function TextBlock({
  block
}) {
  const {
    components
  } = useContext8(OperatorRendererHostContext);
  return /* @__PURE__ */ jsx40(OperatorSource, {
    label: block.label,
    text: block.text,
    truncated: block.truncated,
    density: components.density
  });
}
function LinksBlock(props272) {
  return /* @__PURE__ */ jsx40("nav", {
    ...stylex26.props(rendererLayoutStyles.links),
    "aria-label": "Workspace links",
    children: props272.block.items.map((item, index) => /* @__PURE__ */ jsx40(OperatorLink, {
      target: item.target,
      emphasis: "action",
      onOpenEntity: props272.onOpenEntity,
      onLaunch: props272.onLaunch,
      children: item.label
    }, `${item.label}:${index}`))
  });
}
function GroupBlock(props272) {
  const {
    components
  } = useContext8(OperatorRendererHostContext);
  return /* @__PURE__ */ jsx40(OperatorCard, {
    label: props272.block.label,
    density: components.density,
    framed: false,
    children: /* @__PURE__ */ jsx40(OperatorFacts, {
      density: components.density,
      items: props272.block.items.map((item) => ({
        label: item.label,
        value: item.value === undefined ? undefined : displayScalar(item.value),
        caption: item.description,
        tone: item.tone
      }))
    })
  });
}
function FlowBlock(props272) {
  return /* @__PURE__ */ jsxs25("section", {
    ...stylex26.props(flowStyles.root),
    "aria-labelledby": `${props272.block.id}-title`,
    children: [
      /* @__PURE__ */ jsx40("h3", {
        ...stylex26.props(flowStyles.heading),
        id: `${props272.block.id}-title`,
        children: props272.block.label
      }),
      /* @__PURE__ */ jsx40("ol", {
        ...stylex26.props(flowStyles.track),
        "data-direction": props272.block.direction ?? "forward",
        children: props272.block.steps.map((step) => /* @__PURE__ */ createElement7("li", {
          ...stylex26.props(flowStyles.step),
          key: step.id,
          "data-status": step.status
        }, /* @__PURE__ */ jsx40("span", {
          ...stylex26.props(flowStyles.mark),
          "aria-hidden": "true"
        }), /* @__PURE__ */ jsx40("strong", {
          ...stylex26.props(flowStyles.label),
          children: step.label
        }), step.detail && /* @__PURE__ */ jsx40("small", {
          ...stylex26.props(flowStyles.detail),
          children: step.detail
        })))
      })
    ]
  });
}
function MetersBlock(props272) {
  return /* @__PURE__ */ jsx40("dl", {
    ...stylex26.props(progressStyles.meters),
    children: props272.block.items.map((item) => /* @__PURE__ */ createElement7("div", {
      ...stylex26.props(progressStyles.meter),
      key: item.id,
      "data-tone": item.tone ?? "neutral"
    }, /* @__PURE__ */ jsx40("dt", {
      ...stylex26.props(progressStyles.label),
      children: item.label
    }), /* @__PURE__ */ jsxs25("dd", {
      ...stylex26.props(progressStyles.value, toneText(item.tone)),
      children: [
        /* @__PURE__ */ jsxs25("span", {
          children: [
            item.value,
            item.unit ? ` ${item.unit}` : ""
          ]
        }),
        item.max !== undefined && /* @__PURE__ */ jsxs25("progress", {
          ...stylex26.props(progressStyles.bar),
          "aria-label": item.label,
          value: item.value,
          max: item.max,
          children: [
            item.value,
            " / ",
            item.max
          ]
        })
      ]
    })))
  });
}
function ProgressBlock(props272) {
  return /* @__PURE__ */ jsxs25("section", {
    ...stylex26.props(progressStyles.frame),
    "data-tone": props272.block.tone ?? "neutral",
    children: [
      /* @__PURE__ */ jsxs25("header", {
        ...stylex26.props(progressStyles.header),
        children: [
          /* @__PURE__ */ jsx40("strong", {
            ...stylex26.props(progressStyles.title),
            children: props272.block.label
          }),
          /* @__PURE__ */ jsx40("span", {
            ...stylex26.props(progressStyles.state, toneText(props272.block.tone)),
            children: props272.block.state
          })
        ]
      }),
      props272.block.progress !== undefined && /* @__PURE__ */ jsxs25("progress", {
        ...stylex26.props(progressStyles.bar),
        "aria-label": props272.block.label,
        value: props272.block.progress,
        max: 1,
        children: [
          Math.round(props272.block.progress * 100),
          "%"
        ]
      }),
      props272.block.detail && /* @__PURE__ */ jsx40("p", {
        ...stylex26.props(progressStyles.detail),
        children: props272.block.detail
      }),
      (props272.block.startedAt ?? props272.block.updatedAt) && /* @__PURE__ */ jsxs25("small", {
        ...stylex26.props(progressStyles.time),
        children: [
          props272.block.startedAt ? `Started ${props272.block.startedAt}` : "",
          props272.block.startedAt && props272.block.updatedAt ? " · " : "",
          props272.block.updatedAt ? `Updated ${props272.block.updatedAt}` : ""
        ]
      })
    ]
  });
}
function QueryBlock(props272) {
  const {
    Button: Button2,
    Select: Select2,
    density,
    engine
  } = useContext8(OperatorRendererHostContext).components;
  const change = (key, value) => {
    const next = {
      ...props272.query,
      offset: 0
    };
    if (value === "")
      delete next[key];
    else
      next[key] = value;
    props272.onQueryChange(next);
  };
  const pagination = props272.block.pagination;
  const shown = pagination ? Math.min(pagination.offset + pagination.limit, pagination.total) : 0;
  return /* @__PURE__ */ jsxs25("section", {
    ...stylex26.props(queryStyles.root),
    "aria-label": props272.block.controls.length ? "Workspace filters" : "Collection pages",
    children: [
      props272.block.controls.length > 0 && /* @__PURE__ */ jsx40("div", {
        ...stylex26.props(queryStyles.controls),
        children: props272.block.controls.map((control) => /* @__PURE__ */ createElement7("label", {
          ...stylex26.props(queryStyles.label, density === "compact" && queryStyles.compactLabel),
          key: control.key
        }, /* @__PURE__ */ jsx40("span", {
          children: control.label
        }), /* @__PURE__ */ jsxs25(Select2, {
          xstyle: [engine === "css" && queryStyles.cssSelect, queryStyles.control],
          value: control.value ?? "",
          onChange: (event) => change(control.key, event.target.value),
          children: [
            /* @__PURE__ */ jsx40("option", {
              value: "",
              children: control.allLabel ?? "All"
            }),
            control.options.map((option) => /* @__PURE__ */ jsxs25("option", {
              value: option.value,
              children: [
                option.label,
                option.count === undefined ? "" : ` (${option.count})`
              ]
            }, option.value))
          ]
        })))
      }),
      pagination && /* @__PURE__ */ jsxs25("footer", {
        ...stylex26.props(queryStyles.footer, props272.block.controls.length === 0 && queryStyles.standaloneFooter),
        children: [
          /* @__PURE__ */ jsx40("span", {
            children: pagination.total === 0 ? "Nothing to show" : pagination.offset >= pagination.total ? `No items on this page · ${pagination.total} total` : `Showing ${pagination.offset + 1}–${shown} of ${pagination.total}`
          }),
          (pagination.offset > 0 || shown < pagination.total) && /* @__PURE__ */ jsxs25("span", {
            ...stylex26.props(queryStyles.pager),
            children: [
              /* @__PURE__ */ jsx40(Button2, {
                type: "button",
                variant: "ghost",
                disabled: pagination.offset === 0,
                onClick: () => props272.onQueryChange({
                  ...props272.query,
                  offset: Math.max(0, pagination.offset - pagination.limit),
                  limit: pagination.limit
                }),
                children: "Previous"
              }),
              /* @__PURE__ */ jsx40(Button2, {
                type: "button",
                variant: "ghost",
                disabled: shown >= pagination.total,
                onClick: () => props272.onQueryChange({
                  ...props272.query,
                  offset: pagination.offset + pagination.limit,
                  limit: pagination.limit
                }),
                children: pagination.label ?? "Next"
              })
            ]
          })
        ]
      })
    ]
  });
}
var seriesStyles = {
  figure: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x167g77z",
    kogj98: "x1ghz6dp",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  caption: {
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1k6wstc",
    kb6lSQ: "x7447wj",
    kP9fke: "xtvhhri",
    $$css: true
  },
  chart: {
    k1xSpc: "x1lliihq",
    kzqmXN: "xh8yej3",
    kZKoxP: "xhjk10j",
    kVQacm: "x1rea2x4",
    $$css: true
  },
  flat: {
    kZKoxP: "xxk0z11",
    $$css: true
  },
  hit: {
    kDwRjp: "xy6m8k3",
    $$css: true
  },
  marker: {
    kDwRjp: "xgeoyvb",
    $$css: true
  },
  bar: {
    kDwRjp: "x1rw6qo9 xg7jwtm",
    kmkexE: "xzjk7dm",
    $$css: true
  },
  missing: {
    kDwRjp: "xbh8q5q",
    kjVXCG: "x4vhfi8",
    k5rJSQ: "xbw2l0c",
    $$css: true
  },
  axis: {
    k1xSpc: "x78zum5",
    kjj79g: "x1qughib",
    kOIVth: "x1v2ro7d",
    kMwMTN: "x1v3krkk",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1k6wstc",
    kb6lSQ: "x1dgsrnt",
    $$css: true
  },
  peak: {
    kMwMTN: "x1ar3pfp",
    $$css: true
  }
};
var COLUMN = 10;
var BAR = 8;
var HEIGHT = 100;
var FLAT_HEIGHT = 10;
var MIN_BAR = 0.75;
function reading(point, unit) {
  const value = point.value === null ? "no data" : `${point.value}${unit ? ` ${unit}` : ""}`;
  return `${point.label}: ${value}${point.marker ? ` · ${point.marker}` : ""}`;
}
function SeriesBlock(props282) {
  const {
    label,
    unit,
    points
  } = props282.block;
  const peak = Math.max(0, ...points.map((point) => point.value ?? 0));
  const first = points[0];
  const last = points[points.length - 1];
  const width = points.length * COLUMN;
  const flat = peak === 0;
  const chartHeight = flat ? FLAT_HEIGHT : HEIGHT;
  return /* @__PURE__ */ jsxs26("figure", {
    ...stylex27.props(seriesStyles.figure),
    "data-series": props282.block.id,
    children: [
      /* @__PURE__ */ jsx41("figcaption", {
        ...stylex27.props(seriesStyles.caption),
        children: label
      }),
      /* @__PURE__ */ jsx41("svg", {
        ...stylex27.props(seriesStyles.chart, flat && seriesStyles.flat),
        role: "img",
        "aria-label": `${label}: ${points.length} points, peak ${peak}${unit ? ` ${unit}` : ""}`,
        viewBox: `0 0 ${width} ${chartHeight}`,
        preserveAspectRatio: "none",
        children: points.map((point, index) => {
          const x = index * COLUMN;
          const height = point.value === null || peak === 0 ? MIN_BAR : Math.max(MIN_BAR, point.value / peak * chartHeight);
          return /* @__PURE__ */ jsxs26("g", {
            "data-series-point": point.id,
            "data-missing": point.value === null ? "true" : undefined,
            "data-tone": point.tone,
            children: [
              /* @__PURE__ */ jsx41("title", {
                children: reading(point, unit)
              }),
              point.marker && /* @__PURE__ */ jsx41("rect", {
                ...stylex27.props(seriesStyles.marker),
                "data-series-marker": "",
                x,
                y: 0,
                width: COLUMN,
                height: chartHeight
              }),
              /* @__PURE__ */ jsx41("rect", {
                ...stylex27.props(seriesStyles.hit),
                x,
                y: 0,
                width: COLUMN,
                height: chartHeight
              }),
              point.value === null ? /* @__PURE__ */ jsx41("rect", {
                ...stylex27.props(seriesStyles.missing),
                x: x + (COLUMN - BAR) / 2,
                y: chartHeight - 2,
                width: BAR,
                height: 2
              }) : /* @__PURE__ */ jsx41("rect", {
                ...stylex27.props(seriesStyles.bar, toneFill(point.tone)),
                x: x + (COLUMN - BAR) / 2,
                y: chartHeight - height,
                width: BAR,
                height
              })
            ]
          }, point.id);
        })
      }),
      /* @__PURE__ */ jsxs26("div", {
        ...stylex27.props(seriesStyles.axis),
        "data-series-axis": "",
        children: [
          /* @__PURE__ */ jsx41("span", {
            children: first?.label
          }),
          /* @__PURE__ */ jsx41("span", {
            ...stylex27.props(seriesStyles.peak),
            children: flat ? `no ${unit ?? "values"}` : `peak ${peak}${unit ? ` ${unit}` : ""}`
          }),
          /* @__PURE__ */ jsx41("span", {
            children: last?.label
          })
        ]
      })
    ]
  });
}
var timelineStyles = {
  root: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x883omv",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  head: {
    k1xSpc: "x78zum5",
    kjj79g: "x1qughib",
    kGNEyG: "x1pha0wt",
    kOIVth: "x1v2ro7d",
    kMv6JI: "x5ddh9m",
    kGuDYH: "x4z9k3i",
    kMwMTN: "x1ar3pfp",
    $$css: true
  },
  label: {
    k63SB2: "x1s688f",
    kMwMTN: "xqvuw85",
    $$css: true
  },
  count: {
    kcqcaj: "xss6m8b",
    $$css: true
  },
  band: {
    kVAEAm: "x1n2onr6",
    kZKoxP: "x1dr9wh",
    kVQacm: "xb3r6kr",
    kaIpWk: "xur7f20",
    kWkggS: "xlt2929",
    kGVxlE: "x1mpwnwh",
    kya2p2: "x1b4kqk5",
    $$css: true
  },
  tick: {
    kVAEAm: "x10l6tqk",
    k87sOh: "x13vifvy",
    krVfgx: "x1ey2m1c",
    kZ1KPB: "xe0pwq",
    k4WBpm: "xsxj2vf",
    kaZRDh: "xlsyykk",
    $$css: true
  },
  tickLabel: {
    kVAEAm: "x10l6tqk",
    krVfgx: "xrb244j",
    kbCHJM: "xxwu3sf",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1j6dyjg",
    kMwMTN: "x1ar3pfp",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  now: {
    kVAEAm: "x10l6tqk",
    k87sOh: "x13vifvy",
    krVfgx: "x1ey2m1c",
    kbCHJM: "x1aqb8qb",
    kzqmXN: "xfo62xy",
    kWkggS: "x15vqgvx",
    $$css: true
  },
  light: {
    kVAEAm: "x10l6tqk",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kzqmXN: "xgd8bvy",
    kZKoxP: "x1fgtraw",
    kmVPX3: "x1717udv",
    kMzoRj: "xc342km",
    kaIpWk: "x16rqkct",
    kWkggS: "xjbqb8w",
    kMwMTN: "x1ar3pfp",
    kkrTdU: "x1ypdohk",
    k3aq6I: "x11lhmoz",
    kInvED: "x1hl8ikr",
    $$css: true
  },
  dot: {
    kzqmXN: "xsmyaan",
    kZKoxP: "x1kpxq89",
    kaIpWk: "x16rqkct",
    kWkggS: "xtwfq29",
    kGVxlE: "xohzo4b",
    k3aq6I: "x3oybdh x1kobeir",
    k1ekBW: "x11xpdln",
    kIyJzY: "xx6bhzk",
    kKVMdj: "x1ugrwat",
    k44tkh: "xxkxylk",
    kWV6AL: "xskzprw",
    kyAemX: "xa3vuyk",
    kjO2d4: "x1aquc0h",
    k6CgDc: "x12w9bfk",
    $$css: true
  },
  failedDot: {
    kzqmXN: "x1kky2od",
    kZKoxP: "xlup9mm",
    kGVxlE: "xzvbwyp",
    $$css: true
  },
  activeDot: {
    k3aq6I: "x1omdec3",
    $$css: true
  },
  legend: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "xx06bmz",
    kogj98: "x1ghz6dp",
    kmVPX3: "x1717udv",
    kB88ic: "xe8uvvx",
    kMv6JI: "x5ddh9m",
    kGuDYH: "xfifm61",
    kMwMTN: "x1ar3pfp",
    $$css: true
  },
  legendItem: {
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    kOIVth: "x17d4w8g",
    $$css: true
  },
  legendMark: {
    kzqmXN: "xci0xqf",
    kZKoxP: "x1hagigm",
    kaIpWk: "x16rqkct",
    kWkggS: "xtwfq29",
    $$css: true
  },
  empty: {
    kMwMTN: "x1ar3pfp",
    $$css: true
  }
};
var TICKS = 4;
var CROWDED_MS = 40 * 60 * 1000;
var LANE_TOPS = ["50%", "28%", "72%"];
var LIGHT_STAGGER_MS = 70;
var clock = new Intl.DateTimeFormat(undefined, {
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23"
});
function inset(fraction) {
  return `calc(18px + (100% - 36px) * ${Number(fraction.toFixed(4))})`;
}
function place(block) {
  const start = Date.parse(block.start);
  const span = Date.parse(block.end) - start;
  return block.items.map((item) => ({
    item,
    time: Date.parse(item.at)
  })).filter(({
    time
  }) => time >= start && time <= start + span).sort((left, right) => left.time - right.time).reduce((state, {
    item,
    time
  }) => {
    const lane = time - state.previous < CROWDED_MS ? (state.lane + 1) % LANE_TOPS.length : 0;
    return {
      placed: [...state.placed, {
        item,
        fraction: (time - start) / span,
        lane
      }],
      previous: time,
      lane
    };
  }, {
    placed: [],
    previous: Number.NEGATIVE_INFINITY,
    lane: 0
  }).placed;
}
function highlightRow(source, target) {
  const scope = source.closest("[data-operator-view]") ?? document;
  for (const marked of scope.querySelectorAll("[data-timeline-active]"))
    marked.removeAttribute("data-timeline-active");
  const row = Array.from(scope.querySelectorAll("[data-row-id]")).find((candidate) => candidate.getAttribute("data-row-id") === target);
  if (!row)
    return;
  row.setAttribute("data-timeline-active", "");
  const still = typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  row.scrollIntoView({
    block: "nearest",
    behavior: still ? "auto" : "smooth"
  });
}
function TimelineBlock(props292) {
  const [active, setActive] = useState13(null);
  const start = Date.parse(props292.block.start);
  const span = Date.parse(props292.block.end) - start;
  const events = place(props292.block);
  const choose = (item, event) => {
    setActive(item.id);
    if (item.target)
      highlightRow(event.currentTarget, item.target);
  };
  return /* @__PURE__ */ jsxs27("section", {
    "aria-label": props292.block.label,
    ...stylex28.props(timelineStyles.root),
    children: [
      /* @__PURE__ */ jsxs27("div", {
        ...stylex28.props(timelineStyles.head),
        children: [
          /* @__PURE__ */ jsx42("strong", {
            ...stylex28.props(timelineStyles.label),
            children: props292.block.label
          }),
          /* @__PURE__ */ jsxs27("span", {
            ...stylex28.props(timelineStyles.count),
            children: [
              events.length,
              " ",
              events.length === 1 ? "event" : "events"
            ]
          })
        ]
      }),
      /* @__PURE__ */ jsxs27("div", {
        ...stylex28.props(timelineStyles.band),
        children: [
          Array.from({
            length: TICKS
          }, (_, index) => {
            const fraction = index / TICKS;
            return /* @__PURE__ */ jsx42("div", {
              "data-timeline-tick": "",
              "aria-hidden": "true",
              ...stylex28.props(timelineStyles.tick),
              style: {
                left: inset(fraction)
              },
              children: /* @__PURE__ */ jsx42("span", {
                ...stylex28.props(timelineStyles.tickLabel),
                children: clock.format(new Date(start + span * fraction))
              })
            }, index);
          }),
          /* @__PURE__ */ jsx42("div", {
            "aria-hidden": "true",
            ...stylex28.props(timelineStyles.now)
          }),
          events.map(({
            item,
            fraction,
            lane
          }, index) => {
            const label = `${clock.format(new Date(item.at))} ${item.title}`;
            return /* @__PURE__ */ jsx42("button", {
              type: "button",
              "data-tone": item.tone ?? "neutral",
              "aria-label": label,
              title: label,
              "aria-pressed": active === item.id,
              onClick: (event) => choose(item, event),
              ...stylex28.props(timelineStyles.light, toneText(item.tone)),
              style: {
                left: inset(fraction),
                top: LANE_TOPS[lane]
              },
              children: /* @__PURE__ */ jsx42("span", {
                "aria-hidden": "true",
                ...stylex28.props(timelineStyles.dot, item.tone === "error" && timelineStyles.failedDot, active === item.id && timelineStyles.activeDot),
                style: {
                  animationDelay: `${index * LIGHT_STAGGER_MS}ms`
                }
              })
            }, item.id);
          })
        ]
      }),
      props292.block.legend && props292.block.legend.length > 0 && /* @__PURE__ */ jsx42("ul", {
        ...stylex28.props(timelineStyles.legend),
        children: props292.block.legend.map((entry) => /* @__PURE__ */ jsxs27("li", {
          "data-tone": entry.tone ?? "neutral",
          ...stylex28.props(timelineStyles.legendItem),
          children: [
            /* @__PURE__ */ jsx42("span", {
              "aria-hidden": "true",
              ...stylex28.props(timelineStyles.legendMark, toneText(entry.tone))
            }),
            entry.label
          ]
        }, entry.label))
      })
    ]
  });
}
var detailStyles = {
  root: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x1mkdm3x",
    kGNEyG: "x7a106z",
    kOIVth: "x33pbmt",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  split: {
    kumcoG: "x1bu5on4 xtpkkxw xirox3h",
    $$css: true
  },
  master: {
    k7Eaqz: "xeuugli",
    $$css: true
  },
  hiddenMaster: {
    k7Eaqz: "xeuugli",
    kOgw8m: "xzd29fr",
    k8iPdO: "xsu5lmx",
    $$css: true
  },
  pane: {
    k7Eaqz: "xeuugli",
    kmVPX3: "xggk2y7 xwn745a",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xy1lt07",
    kaIpWk: "x1sxf85j",
    kWkggS: "x18s3upu",
    $$css: true
  },
  heading: {
    kogj98: "x1qe5pcq",
    kMv6JI: "xssy22x",
    kGuDYH: "x1pvqxga",
    k63SB2: "xo1l8bm",
    ka26j: "xkhxzli",
    kLWn49: "xwn7fz2",
    kMwMTN: "xqvuw85",
    kHjlTd: "xj0a0fe",
    kI3sdo: "x1a2a7pz",
    kEtg5x: "x1uqgcet",
    $$css: true
  },
  back: {
    k1xSpc: "x1s85apg x1yu2ybr x168i3sl",
    kGNEyG: "x6s0dn4",
    kAzted: "x1eguyfn",
    k1K539: "xod5an3",
    kmVPX3: "x1717udv",
    kMzoRj: "xc342km",
    kWkggS: "xjbqb8w",
    kMv6JI: "x5ddh9m",
    kGuDYH: "xfifm61",
    kMwMTN: "x1myn341",
    kkrTdU: "x1ypdohk",
    k3Woio: "x16dl9wz",
    kiEn40: "x7s97pk",
    $$css: true
  },
  body: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x1c1vhfx",
    k7Eaqz: "xeuugli",
    $$css: true
  }
};
var selectionStyles = {
  current: {
    kWkggS: "x18jj7c1",
    kGVxlE: "xfv7mty",
    $$css: true
  }
};
var listStyles = {
  list: {
    kB88ic: "xe8uvvx",
    kogj98: "x1ghz6dp",
    kmVPX3: "x1717udv",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  compactList: {
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "xltl5i9",
    $$css: true
  },
  row: {
    k1xSpc: "x78zum5",
    kXwgrk: "x1q0g3np xyil5ud",
    kwnvtZ: "xozqiw3 x1i03alp xzbubq",
    kGNEyG: "x6s0dn4 x1ovenir",
    kjj79g: "x1qughib",
    kOIVth: "x1c1vhfx x1unfst4 x5cqck7 xd9d3ul",
    kmVPX3: "x1t7086c x1xukwvs x10e8r38",
    kt9PQ7: "xso031l x1z10cro",
    k3XXqK: "x1t137rt xokuw57",
    kMeerF: "x1de99jn",
    kjBf7l: "x1itw484",
    kInvED: "x8wkva7",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xpqg30t",
    k7Eaqz: "xeuugli",
    kVAEAm: "x1n2onr6",
    kWkggS: "xpalnk2",
    kGVxlE: "x1xyv72o",
    k1ekBW: "x106061f",
    kIyJzY: "x13dflua",
    $$css: true
  },
  railed: {
    kE3dHu: "xnm25rq",
    kZ1KPB: "x1vo0akb",
    k4WBpm: "x19ypqd9",
    kaZRDh: "xzxeg27 xkzz1zq",
    $$css: true
  },
  compactRow: {
    kmVPX3: "x1vgkc3a",
    kGNEyG: "x7a106z",
    krbiMz: "x1g3ag0e",
    kkwO13: "x1943nhg",
    kqJkrk: "x1n3jums",
    kt4jb9: "xlw4hyx",
    kZMVlr: "x9awmtd",
    kZPUVn: "x1k72cru",
    $$css: true
  },
  master: {
    kGNEyG: "x7a106z",
    kE3dHu: "xzjhap9",
    kpe85a: "x19tmk5i",
    $$css: true
  },
  stacked: {
    kXwgrk: "xdt5ytf",
    kGNEyG: "x1qjc9v5",
    kOIVth: "x1v2ro7d",
    $$css: true
  },
  stackedTrailing: {
    ks0D6T: "x193iq5w",
    kjj79g: "x1nhvcw1",
    $$css: true
  },
  interactive: {
    kWkggS: "xjbqb8w xd8d5gp",
    $$css: true
  },
  trailing: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kGNEyG: "x6s0dn4",
    kjj79g: "x13a6bvl x1aoecvx x6z9i88 xmn758v",
    kOIVth: "x167g77z",
    k7Eaqz: "xeuugli",
    ks0D6T: "x8jryan x1uikkot xdq2x6k xjjsibu",
    kmuXW: "x2lah0s",
    kVAEAm: "x1n2onr6",
    kY2c9j: "x1vjfegm",
    $$css: true
  },
  controls: {
    kVAEAm: "x1n2onr6",
    kY2c9j: "x1vjfegm",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  count: {
    k7Eaqz: "xeuugli",
    kMwMTN: "xgi1xjn",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1j6dyjg",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  links: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "x3phc52",
    kGuDYH: "xfifm61",
    kVAEAm: "x1n2onr6",
    kY2c9j: "x1vjfegm",
    $$css: true
  },
  footerMetadata: {
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1j6dyjg",
    kLWn49: "x1dbl2gt",
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  tags: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "x1nejdyq",
    keoZOQ: "x1rhet7l",
    $$css: true
  },
  badge: {
    ks0D6T: "x193iq5w",
    kMwMTN: "xgi1xjn",
    kMv6JI: "x5ddh9m",
    kGuDYH: "xfifm61",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  compactBadge: {
    kmVPX3: "xbjd7y",
    kaIpWk: "x1e6avla",
    kWkggS: "x1ghvq8m",
    kMv6JI: "xa9opjo",
    kGuDYH: "xfmn3hh",
    kb6lSQ: "x9pfba7",
    kP9fke: "xtvhhri",
    $$css: true
  },
  compactGood: {
    kWkggS: "x153t6mt",
    $$css: true
  },
  compactWarn: {
    kWkggS: "x1mh3lbe",
    $$css: true
  },
  compactError: {
    kWkggS: "x42um7s",
    $$css: true
  }
};
function OperatorList(props302) {
  const root = stylex29.props(listStyles.list, props302.density === "compact" && listStyles.compactList);
  return /* @__PURE__ */ jsx43("ol", {
    ...root,
    "data-record-list": "",
    "data-presentation": props302.presentation,
    children: props302.children
  });
}
function OperatorRecordRow(props302) {
  return /* @__PURE__ */ jsxs28("li", {
    draggable: props302.drag ? true : undefined,
    onDragStart: props302.drag?.onStart,
    onDragEnd: props302.drag?.onEnd,
    ...stylex29.props(listStyles.row, props302.density === "compact" && listStyles.compactRow, props302.master && listStyles.master, props302.stacked && listStyles.stacked, props302.railed && listStyles.railed, props302.interactive && listStyles.interactive, props302.selected && selectionStyles.current),
    "data-row-id": props302.rowId,
    "data-tone": props302.tone ?? "neutral",
    "aria-current": props302.selected ? "true" : undefined,
    children: [
      props302.children,
      props302.trailing && /* @__PURE__ */ jsx43("div", {
        ...stylex29.props(listStyles.trailing, props302.stacked && listStyles.stackedTrailing),
        "data-record-trailing": "true",
        children: props302.trailing
      })
    ]
  });
}
function OperatorBadge(props302) {
  const tone = props302.tone ?? "neutral";
  const compact = props302.density === "compact";
  return /* @__PURE__ */ jsx43("span", {
    ...stylex29.props(listStyles.badge, compact && listStyles.compactBadge, toneText(tone), compact && tone === "good" && listStyles.compactGood, compact && tone === "warn" && listStyles.compactWarn, compact && tone === "error" && listStyles.compactError),
    "data-tone": tone,
    "data-record-badge": "true",
    children: props302.children
  });
}
var logStyles = {
  root: {
    k1xSpc: "xrvj5dj",
    kOIVth: "xmt3bw4",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  group: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x1jnr06f",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  groupLabel: {
    kogj98: "xwd23ue",
    kMv6JI: "x5ddh9m",
    kGuDYH: "x4z9k3i",
    k63SB2: "xk50ysn",
    kMwMTN: "x1ar3pfp",
    $$css: true
  },
  rows: {
    k1xSpc: "xrvj5dj",
    kogj98: "x1ghz6dp",
    kmVPX3: "x1717udv",
    kB88ic: "xe8uvvx",
    $$css: true
  },
  row: {
    kVAEAm: "x1n2onr6",
    k1xSpc: "xrvj5dj",
    kumcoG: "x9ztcg1",
    kGNEyG: "x1pha0wt",
    kOIVth: "x1jnr06f",
    kmVPX3: "x1ruevkc",
    kaIpWk: "x1kogg8i",
    kWkggS: "xpalnk2",
    k1ekBW: "x15406qy",
    kIyJzY: "x13dflua",
    $$css: true
  },
  time: {
    kMv6JI: "xa9opjo",
    kGuDYH: "xfifm61",
    kMwMTN: "x1ar3pfp",
    kcqcaj: "xss6m8b",
    $$css: true
  },
  mark: {
    kzqmXN: "xci0xqf",
    kZKoxP: "x1hagigm",
    kaIpWk: "x16rqkct",
    kWkggS: "xtwfq29",
    kMwMTN: "x1ar3pfp",
    k3aq6I: "x1uqg51p",
    $$css: true
  },
  copy: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x195vfkc",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  title: {
    kMv6JI: "x5ddh9m",
    kGuDYH: "x1jvydc1",
    k63SB2: "xk50ysn",
    kMwMTN: "xqvuw85",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  description: {
    kogj98: "x1ghz6dp",
    kGuDYH: "xif65rj",
    kMwMTN: "xgi1xjn",
    $$css: true
  },
  metadata: {
    kGuDYH: "x4z9k3i",
    kMwMTN: "x1ar3pfp",
    $$css: true
  }
};
var HOUR_MS = 60 * 60 * 1000;
var DAY_MS = 24 * HOUR_MS;
var clock2 = new Intl.DateTimeFormat(undefined, {
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23"
});
function period(item, now) {
  const time = item.at ? Date.parse(item.at) : Number.NaN;
  if (!Number.isFinite(time))
    return "Earlier";
  if (now - time < HOUR_MS)
    return "This hour";
  const day = (value) => new Date(value).toDateString();
  if (day(time) === day(now))
    return "Earlier today";
  if (day(time) === day(now - DAY_MS))
    return "Yesterday";
  return "Earlier";
}
function groups(items, now) {
  return items.reduce((grouped, item) => {
    const label = period(item, now);
    const last = grouped.at(-1);
    return last?.label === label ? [...grouped.slice(0, -1), {
      label,
      items: [...last.items, item]
    }] : [...grouped, {
      label,
      items: [item]
    }];
  }, []);
}
function LogList(props312) {
  return /* @__PURE__ */ jsx44("div", {
    ...stylex30.props(logStyles.root),
    children: groups(props312.items, Date.now()).map((group) => /* @__PURE__ */ jsxs29("section", {
      ...stylex30.props(logStyles.group),
      children: [
        /* @__PURE__ */ jsx44("h3", {
          ...stylex30.props(logStyles.groupLabel),
          children: group.label
        }),
        /* @__PURE__ */ jsx44("ol", {
          ...stylex30.props(logStyles.rows),
          children: group.items.map((item) => /* @__PURE__ */ jsxs29("li", {
            "data-row-id": item.id,
            "data-tone": item.tone ?? "neutral",
            ...stylex30.props(logStyles.row),
            children: [
              item.at ? /* @__PURE__ */ jsx44("time", {
                dateTime: item.at,
                ...stylex30.props(logStyles.time),
                children: clock2.format(new Date(item.at))
              }) : /* @__PURE__ */ jsx44("span", {}),
              /* @__PURE__ */ jsx44("span", {
                "aria-hidden": "true",
                ...stylex30.props(logStyles.mark, toneText(item.tone))
              }),
              /* @__PURE__ */ jsxs29("div", {
                ...stylex30.props(logStyles.copy),
                children: [
                  /* @__PURE__ */ jsx44("strong", {
                    ...stylex30.props(logStyles.title),
                    children: item.link ? /* @__PURE__ */ jsx44(OperatorLink, {
                      target: item.link,
                      emphasis: "title",
                      onOpenEntity: props312.onOpenEntity,
                      onLaunch: props312.onLaunch,
                      children: item.title
                    }) : item.title
                  }),
                  item.description && /* @__PURE__ */ jsx44("p", {
                    ...stylex30.props(logStyles.description),
                    children: item.description
                  }),
                  item.metadata && item.metadata.length > 0 && /* @__PURE__ */ jsx44("small", {
                    ...stylex30.props(logStyles.metadata),
                    children: /* @__PURE__ */ jsx44(OperatorMetadata, {
                      values: item.metadata
                    })
                  })
                ]
              })
            ]
          }, item.id))
        })
      ]
    }, group.label))
  });
}
function ListItems(props322) {
  const {
    components
  } = useContext9(OperatorRendererHostContext);
  const drag = props322.drag;
  const {
    Disclosure
  } = components;
  const master = useContext9(OpenDetailContext) !== null;
  return /* @__PURE__ */ jsx45(OperatorList, {
    density: components.density,
    presentation: props322.presentation,
    children: props322.items.map((item, index) => {
      const metadata = [...item.meta ? [item.meta] : [], ...item.metadata ?? []];
      return /* @__PURE__ */ jsx45(OperatorRecordRow, {
        rowId: item.id,
        density: components.density,
        tone: item.tone,
        selected: props322.openId === item.id,
        master: master && props322.openId !== undefined,
        stacked: props322.presentation === "activity" || props322.presentation === "attention",
        railed: props322.presentation === "attention" && (item.tone === "warn" || item.tone === "error"),
        interactive: Boolean(item.link ?? item.links?.length),
        drag: drag && dropActions(item).length > 0 ? {
          onStart: (event) => {
            event.dataTransfer.setData("text/plain", item.id);
            drag.start(item);
          },
          onEnd: drag.end
        } : undefined,
        trailing: item.count !== undefined || Boolean(item.badges?.length) || Boolean(item.actions?.length) || Boolean(item.links?.length) ? /* @__PURE__ */ jsxs30(Fragment15, {
          children: [
            item.links && item.links.length > 0 && /* @__PURE__ */ jsx45("nav", {
              ...stylex31.props(listStyles.links),
              "aria-label": `${item.title} links`,
              children: item.links.map((link, index2) => /* @__PURE__ */ jsx45(OperatorLink, {
                target: link.target,
                emphasis: props322.presentation === "attention" ? "action" : "normal",
                onOpenEntity: props322.onOpenEntity,
                onLaunch: props322.onLaunch,
                children: link.label
              }, `${link.label}:${index2}`))
            }),
            item.count !== undefined && /* @__PURE__ */ jsx45("span", {
              ...stylex31.props(listStyles.count),
              children: item.count
            }),
            item.badges?.map((badge, index2) => /* @__PURE__ */ jsx45(OperatorBadge, {
              density: components.density,
              tone: badge.tone,
              children: badge.label
            }, `${badge.label}:${index2}`)),
            /* @__PURE__ */ jsx45(Actions, {
              actions: item.actions ?? [],
              onAction: props322.onAction,
              subordinate: true,
              label: item.title,
              triggerLabel: item.actionsLabel
            })
          ]
        }) : undefined,
        children: /* @__PURE__ */ jsx45(OperatorRecordCopy, {
          density: components.density,
          lead: props322.presentation === "attention" && metadata.length > 0 ? /* @__PURE__ */ jsx45("small", {
            ...stylex31.props(listStyles.footerMetadata),
            children: /* @__PURE__ */ jsx45(OperatorMetadata, {
              values: metadata
            })
          }) : undefined,
          metadata: props322.presentation === "attention" ? [] : metadata,
          presentation: props322.presentation,
          primary: index === 0,
          clamp: master,
          title: item.link ? /* @__PURE__ */ jsx45(OperatorLink, {
            target: item.link,
            emphasis: "title",
            onOpenEntity: props322.onOpenEntity,
            onLaunch: props322.onLaunch,
            children: item.title
          }) : item.title,
          description: item.description && (item.tone === "warn" || item.tone === "error") && item.description.length > 160 ? /* @__PURE__ */ jsxs30("div", {
            ...stylex31.props(listStyles.controls),
            children: [
              /* @__PURE__ */ jsx45(OperatorRecordDescription, {
                text: item.description,
                density: components.density,
                clamp: true
              }),
              /* @__PURE__ */ jsx45(Disclosure, {
                title: item.title,
                triggerLabel: "Details",
                className: "operator-issue-details",
                children: /* @__PURE__ */ jsx45(OperatorSource, {
                  text: item.description,
                  density: components.density,
                  framed: false
                })
              })
            ]
          }) : item.description,
          children: item.tags && item.tags.length > 0 && /* @__PURE__ */ jsx45("span", {
            ...stylex31.props(listStyles.tags),
            children: item.tags.map((tag) => /* @__PURE__ */ jsx45(OperatorBadge, {
              density: components.density,
              children: tag
            }, tag))
          })
        })
      }, item.id);
    })
  });
}
function ListBlock(props322) {
  const [activeFilter, setActiveFilter] = useState14(props322.block.filter?.defaultValue ?? "all");
  const allValue = props322.block.filter?.allValue ?? "all";
  const items = props322.block.items.filter((item) => !props322.block.filter || activeFilter === allValue || item.filterValues?.includes(activeFilter));
  if (props322.block.items.length === 0) {
    return /* @__PURE__ */ jsx45("p", {
      ...stylex31.props(rendererLayoutStyles.empty),
      children: props322.block.empty
    });
  }
  return /* @__PURE__ */ jsxs30("div", {
    children: [
      props322.block.filter && /* @__PURE__ */ jsx45(OperatorSegmentedGroup, {
        "data-filter": "",
        role: "group",
        "aria-label": props322.block.filter.label,
        children: props322.block.filter.options.map((option) => /* @__PURE__ */ jsxs30(OperatorSegmentedButton, {
          type: "button",
          emphasis: option.emphasis === "gap" ? "attention" : undefined,
          "aria-pressed": activeFilter === option.value,
          "data-emphasis": option.emphasis,
          onClick: () => setActiveFilter(option.value),
          children: [
            option.label,
            option.count !== undefined ? ` (${option.count})` : ""
          ]
        }, option.value))
      }),
      items.length === 0 ? /* @__PURE__ */ jsx45("p", {
        ...stylex31.props(rendererLayoutStyles.empty),
        children: props322.block.empty
      }) : props322.block.presentation === "log" ? /* @__PURE__ */ jsx45(LogList, {
        items,
        onOpenEntity: props322.onOpenEntity,
        onLaunch: props322.onLaunch
      }) : /* @__PURE__ */ jsx45(ListItems, {
        items,
        presentation: props322.block.presentation,
        onAction: props322.onAction,
        onOpenEntity: props322.onOpenEntity,
        onLaunch: props322.onLaunch,
        openId: props322.openId
      })
    ]
  });
}
function dropActions(item) {
  return (item.actions ?? []).filter((action) => action.dropTarget !== undefined && action.disabled !== true);
}
function MatrixBlock(props332) {
  const host = useContext10(OperatorRendererHostContext);
  const [dragging, setDragging] = useState15(null);
  const [failure, setFailure] = useState15("");
  const columns = props332.openId !== undefined ? 1 : props332.block.columns ?? 2;
  const drop = async (action) => {
    setFailure("");
    try {
      const presented = presentedActionResult(action, await props332.onAction(action));
      if (presented)
        host.onDetachedActionResult?.(presented);
    } catch (error) {
      setFailure(actionFailureMessage(error));
    }
  };
  return /* @__PURE__ */ jsx46("div", {
    ...stylex32.props(rendererLayoutStyles.matrixFrame),
    children: /* @__PURE__ */ jsxs31("div", {
      ...stylex32.props(rendererLayoutStyles.matrix),
      "data-columns": columns,
      children: [
        failure && /* @__PURE__ */ jsx46("p", {
          ...stylex32.props(rendererLayoutStyles.error),
          role: "alert",
          children: failure
        }),
        props332.block.cells.map((cell) => {
          const action = dragging ? dropActions(dragging).find((candidate) => candidate.dropTarget === cell.id) : undefined;
          return /* @__PURE__ */ createElement8("section", {
            ...stylex32.props(rendererLayoutStyles.cell, action && rendererLayoutStyles.dropAllowed),
            key: cell.id,
            "data-tone": cell.tone ?? "neutral",
            "data-matrix-cell": "",
            "data-drop": action ? "allowed" : undefined,
            onDragOver: action ? (event) => event.preventDefault() : undefined,
            onDrop: action ? (event) => {
              event.preventDefault();
              setDragging(null);
              drop(action);
            } : undefined
          }, /* @__PURE__ */ jsx46("h3", {
            ...stylex32.props(rendererLayoutStyles.caption),
            children: cell.label
          }), cell.items.length === 0 ? /* @__PURE__ */ jsx46("p", {
            ...stylex32.props(rendererLayoutStyles.empty, rendererLayoutStyles.cellEmpty),
            children: cell.empty
          }) : /* @__PURE__ */ jsx46(ListItems, {
            items: cell.items,
            onAction: props332.onAction,
            onOpenEntity: props332.onOpenEntity,
            onLaunch: props332.onLaunch,
            openId: props332.openId,
            drag: {
              start: setDragging,
              end: () => setDragging(null)
            }
          }));
        })
      ]
    })
  });
}
var tableStyles = {
  compact: {
    k1xSpc: "x1s85apg xplwmzv xfsj286",
    $$css: true
  },
  scroll: {
    ks0D6T: "x193iq5w",
    k7Eaqz: "xeuugli",
    kXHlph: "xw2csxc",
    k1xSpc: "x1lliihq xplwmzv x22zvs4 xfsj286 x1a92eo6",
    kGO01o: "x18d9i69 x1aciil0 xs4y3db x1yy75ev x1yieemc",
    kwDfHU: "xsjhqdm x5zp4vj x1douzxv x3y8eqj xqwvrdo",
    k5wCbM: "xosa0jh xvwifah x1rfhg52 x1668a04 x1defwea",
    $$css: true
  },
  table: {
    kzqmXN: "xh8yej3",
    ks0D6T: "x193iq5w",
    kLvRdT: "x1mwwwfo",
    kMwMTN: "xgi1xjn",
    kGuDYH: "xfifm61",
    $$css: true
  },
  row: {
    k1xSpc: "xf5m44m x1lu4wmf x15zwrp0 x1fdxwjo x1kvcy9f",
    kWkggS: "xjbqb8w xd8d5gp",
    $$css: true
  },
  head: {
    kLKAdn: "xexx8yu",
    kGO01o: "xdvlbce",
    kpe85a: "x1xpa7k x1s4zo15",
    kE3dHu: "x1uhho1l xxakyfl",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "x1594w68",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1vz2964",
    k63SB2: "x1bgvhw5",
    kb6lSQ: "x1r16saa",
    kP9fke: "xtvhhri",
    khDVqt: "xuxw1ft",
    kXLuUW: "x16dsc37",
    k9WMMc: "xdpxx8g x1ffr0y8 xpebyx1",
    $$css: true
  },
  cell: {
    kLKAdn: "xz9dl7a",
    kGO01o: "xsag5q8",
    kpe85a: "x1xpa7k x1s4zo15",
    kE3dHu: "x1uhho1l xxakyfl",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xpqg30t",
    kMwMTN: "xgi1xjn xbd3v37",
    kGuDYH: "x4z9k3i xq648tx",
    k63SB2: "xo1l8bm xsnqk1y",
    kXLuUW: "xxymvpz",
    k9WMMc: "xdpxx8g x1ffr0y8 xpebyx1",
    $$css: true
  },
  gutter: {
    kE3dHu: "xzjhap9",
    $$css: true
  }
};
function TableBlock(props342) {
  const hasActions = props342.block.rows.some((row) => (row.actions?.length ?? 0) > 0);
  const gutter = props342.openId !== undefined;
  const compactRows = props342.block.rows.flatMap((row) => {
    if (!row.compact)
      return [];
    return [{
      id: row.id,
      title: row.compact.title,
      ...row.compact.description ? {
        description: row.compact.description
      } : {},
      ...row.compact.metadata ? {
        metadata: row.compact.metadata
      } : {},
      ...row.compact.badges ? {
        badges: row.compact.badges
      } : {},
      ...row.compact.count !== undefined ? {
        count: row.compact.count
      } : {},
      ...row.compact.tone ? {
        tone: row.compact.tone
      } : {},
      ...row.link ? {
        link: row.link
      } : {},
      ...row.actions ? {
        actions: row.actions
      } : {}
    }];
  });
  const hasUnannotatedRows = props342.block.rows.some((row) => !row.compact);
  const table = props342.block.rows.length === 0 ? /* @__PURE__ */ jsx47("p", {
    ...stylex33.props(rendererLayoutStyles.empty),
    children: props342.block.empty
  }) : /* @__PURE__ */ jsxs32(Fragment16, {
    children: [
      compactRows.length > 0 && /* @__PURE__ */ jsx47("div", {
        ...stylex33.props(tableStyles.compact),
        "data-compact-rows": "",
        children: /* @__PURE__ */ jsx47(ListItems, {
          items: compactRows,
          presentation: "activity",
          onAction: props342.onAction,
          onOpenEntity: props342.onOpenEntity,
          onLaunch: props342.onLaunch,
          openId: props342.openId
        })
      }),
      /* @__PURE__ */ jsx47("div", {
        ...stylex33.props(tableStyles.scroll),
        "data-table-scroll": "",
        ...compactRows.length > 0 ? {
          "data-has-unannotated": hasUnannotatedRows ? "true" : "false"
        } : {},
        children: /* @__PURE__ */ jsxs32("table", {
          ...stylex33.props(tableStyles.table),
          children: [
            /* @__PURE__ */ jsx47("thead", {
              children: /* @__PURE__ */ jsxs32("tr", {
                children: [
                  props342.block.columns.map((column, index) => /* @__PURE__ */ createElement9("th", {
                    ...stylex33.props(tableStyles.head, gutter && index === 0 && tableStyles.gutter),
                    key: column.key,
                    "data-align": column.align ?? "start"
                  }, column.label)),
                  hasActions && /* @__PURE__ */ jsx47("th", {
                    ...stylex33.props(tableStyles.head),
                    "data-align": "end",
                    children: "Actions"
                  })
                ]
              })
            }),
            /* @__PURE__ */ jsx47("tbody", {
              children: props342.block.rows.map((row) => /* @__PURE__ */ createElement9("tr", {
                ...stylex33.props(tableStyles.row, props342.openId === row.id && selectionStyles.current),
                key: row.id,
                ...row.compact ? {
                  "data-compact-row": "true"
                } : {},
                ...props342.openId === row.id ? {
                  "aria-current": "true"
                } : {}
              }, props342.block.columns.map((column, index) => {
                const value = displayCell(row.cells[column.key]);
                return /* @__PURE__ */ createElement9("td", {
                  ...stylex33.props(tableStyles.cell, gutter && index === 0 && tableStyles.gutter),
                  key: column.key,
                  "data-align": column.align ?? "start"
                }, index === 0 && row.link ? /* @__PURE__ */ jsx47(OperatorLink, {
                  target: row.link,
                  onOpenEntity: props342.onOpenEntity,
                  onLaunch: props342.onLaunch,
                  children: value
                }) : value);
              }), hasActions && /* @__PURE__ */ jsx47("td", {
                ...stylex33.props(tableStyles.cell),
                "data-align": "end",
                children: /* @__PURE__ */ jsx47(Actions, {
                  align: "end",
                  actions: row.actions ?? [],
                  onAction: props342.onAction,
                  subordinate: true
                })
              })))
            })
          ]
        })
      })
    ]
  });
  if (!props342.block.query)
    return table;
  return /* @__PURE__ */ jsxs32("div", {
    "data-table-collection": "",
    children: [
      /* @__PURE__ */ jsx47(QueryBlock, {
        block: props342.block.query,
        query: props342.query,
        onQueryChange: props342.onQueryChange
      }),
      table
    ]
  });
}
var spatialFrameStyles = {
  frame: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x1v2ro7d",
    k7Eaqz: "xeuugli",
    kogj98: "x1ghz6dp",
    kmVPX3: "xbxpdvy",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8tuc8h",
    kaIpWk: "xur7f20",
    kWkggS: "x18s3upu",
    $$css: true
  },
  canvas: {
    kVAEAm: "x1n2onr6",
    k7Eaqz: "xeuugli",
    kAzted: "x1mrxzx8",
    kVQacm: "xb3r6kr",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xy1lt07",
    kaIpWk: "xur7f20",
    kKwaWg: "xnhfnza",
    kWkggS: "x18s3upu",
    $$css: true
  },
  overlay: {
    kVAEAm: "x10l6tqk",
    kpwlN0: "x10a8y8t",
    kzqmXN: "xh8yej3",
    kZKoxP: "x5yr21d",
    $$css: true
  },
  boundary: {
    kDwRjp: "xbh8q5q",
    kjVXCG: "x4vhfi8",
    kfJifR: "xhr4kjn",
    kREpy8: "x13efnbd",
    $$css: true
  },
  zone: {
    kDwRjp: "x63ly0w",
    k5rJSQ: "xl9zam1",
    $$css: true
  },
  relationship: {
    kjVXCG: "x4vhfi8 xgw5xlg xgcfudb",
    kfJifR: "xnpr05h",
    kREpy8: "x13efnbd",
    $$css: true
  },
  center: {
    kVAEAm: "x10l6tqk",
    k87sOh: "xwa60dl",
    kbCHJM: "x1nrll8i",
    kY2c9j: "xhtitgo",
    ks0D6T: "x2aouup",
    kmVPX3: "x1jmcyos",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xmt0h0j",
    kaIpWk: "x1e6avla",
    kWkggS: "x18s3upu",
    kMwMTN: "xqvuw85",
    kMv6JI: "xa9opjo",
    kGuDYH: "x1k6wstc",
    k9WMMc: "x2b8uid",
    k3aq6I: "x11lhmoz",
    kHjlTd: "xj0a0fe",
    $$css: true
  }
};
var spatialContentStyles = {
  point: {
    kVAEAm: "x10l6tqk",
    kY2c9j: "xzkaem6 x1scvahe x1qm06za x110e2yq",
    k1xSpc: "xrvj5dj",
    kumcoG: "x175yr4d",
    kOIVth: "x1nejdyq",
    kGNEyG: "x6s0dn4",
    ks0D6T: "x16q51m2",
    kmVPX3: "x18juh3m",
    kMzoRj: "xc342km",
    kWkggS: "xiy2bcw",
    kMwMTN: "xgi1xjn x1711cle x1r2bfix x1s1kr4f",
    kMv6JI: "xa9opjo",
    kGuDYH: "xvwhms9",
    kLWn49: "x1u7k74",
    k9WMMc: "xdpxx8g",
    k3aq6I: "x11lhmoz",
    kkrTdU: "x1ypdohk",
    k1ekBW: "x1mz1wvm x4wkmsb",
    kIyJzY: "xgdialr",
    kAMwcw: "xwji4o3",
    kMeerF: "x1k57tk5 xcdb3qq x4xl6zf xiaifju",
    k3XXqK: "xaatb59",
    kjBf7l: "x100b2on",
    kInvED: "x1hl8ikr",
    kSiTet: "x1hc1fzr x64nxkd",
    $$css: true
  },
  dot: {
    kzqmXN: "x1wc42o8",
    kZKoxP: "xegnrdp",
    kMzoRj: "xdh2fpr",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1vw2y1n xjgjgpo xt7649k xu3iebo",
    kaIpWk: "x16rqkct",
    kWkggS: "x18s3upu",
    $$css: true
  },
  pointLabel: {
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  description: {
    kogj98: "xjgi5au",
    kMwMTN: "xgi1xjn",
    kGuDYH: "x1ct8sxb",
    kLWn49: "x1evy7pa",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  legend: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "x1u7gxyo",
    kogj98: "xe6w4ck",
    kmVPX3: "x1717udv",
    kMwMTN: "x1ar3pfp",
    kMv6JI: "xa9opjo",
    kGuDYH: "xvwhms9",
    kH6xsr: "x3ct3a4",
    $$css: true
  },
  legendItem: {
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    kLKAdn: "x1y1aw1k",
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "xvg7k2t",
    kah6P1: "x1cpjm7i",
    k1xSpc: "xtcx8v3 x1fhgk32",
    kzqmXN: "x1x7x01p",
    kZKoxP: "xf3jtlm",
    km5ZXQ: "xmz0esg",
    kMzoRj: "xz8fyzm",
    ksu8eU: "x1fo1fc9",
    kVAM5u: "x1x6ksa7",
    kaIpWk: "x9msap3",
    $$css: true
  },
  detail: {
    k1xSpc: "x78zum5 xvgho8r",
    kwnvtZ: "x1a02dak",
    kOIVth: "x167g77z",
    keoZOQ: "x1xmf6yo",
    kMwMTN: "x1ar3pfp",
    kGuDYH: "x1j6dyjg",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  detailTitle: {
    kogj98: "x8o5f6s",
    kMwMTN: "xqvuw85",
    kGuDYH: "x4nd1th",
    k63SB2: "xjgl48g",
    kb6lSQ: "x19vr2a4",
    kP9fke: "xel79qc",
    kMv6JI: "xv6m45y",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  detailText: {
    k7Eaqz: "xeuugli",
    kHjlTd: "xj0a0fe",
    $$css: true
  }
};
function radialPosition(distance, bearing) {
  const radians = (bearing - 90) * Math.PI / 180;
  const radius = distance * 45;
  return {
    x: 50 + Math.cos(radians) * radius,
    y: 50 + Math.sin(radians) * radius
  };
}
function spatialPositions(block) {
  const positions = new Map;
  if (block.layout === "cartesian") {
    for (const point of block.points) {
      positions.set(point.id, {
        x: point.x * 100,
        y: point.y * 100
      });
    }
    for (const zone of block.zones) {
      positions.set(zone.id, {
        x: zone.x * 100,
        y: zone.y * 100
      });
    }
  } else {
    for (const point of block.points) {
      positions.set(point.id, radialPosition(point.distance, point.bearing));
    }
  }
  return positions;
}
function SpatialBlock({
  block
}) {
  const positions = spatialPositions(block);
  const frame = stylex34.props(spatialFrameStyles.frame);
  return /* @__PURE__ */ jsxs33("figure", {
    ...frame,
    "data-ui-spatial": true,
    "aria-label": block.label,
    children: [
      /* @__PURE__ */ jsxs33("div", {
        ...stylex34.props(spatialFrameStyles.canvas),
        children: [
          /* @__PURE__ */ jsxs33("svg", {
            ...stylex34.props(spatialFrameStyles.overlay),
            viewBox: "0 0 1000 600",
            preserveAspectRatio: "none",
            "aria-hidden": "true",
            children: [
              block.layout === "radial" && block.strata.map((stratum) => /* @__PURE__ */ jsx48("ellipse", {
                ...stylex34.props(spatialFrameStyles.boundary),
                cx: "500",
                cy: "300",
                rx: stratum.maxDistance * 450,
                ry: stratum.maxDistance * 270
              }, stratum.id)),
              block.layout === "cartesian" && block.zones.map((zone) => /* @__PURE__ */ jsx48("circle", {
                ...stylex34.props(spatialFrameStyles.boundary, spatialFrameStyles.zone),
                cx: zone.x * 1000,
                cy: zone.y * 600,
                r: "72"
              }, zone.id)),
              (block.relationships ?? []).map((relationship, index) => {
                const source = positions.get(relationship.sourceId);
                const target = positions.get(relationship.targetId);
                if (!source || !target)
                  return null;
                return /* @__PURE__ */ jsx48("line", {
                  "data-tone": relationship.tone ?? "neutral",
                  ...stylex34.props(spatialFrameStyles.relationship),
                  x1: source.x * 10,
                  y1: source.y * 6,
                  x2: target.x * 10,
                  y2: target.y * 6
                }, `${relationship.sourceId}:${relationship.targetId}:${index}`);
              })
            ]
          }),
          block.layout === "radial" && /* @__PURE__ */ jsx48("span", {
            ...stylex34.props(spatialFrameStyles.center),
            "data-kind": block.centerKind,
            children: block.centerLabel
          }),
          /* @__PURE__ */ jsx48("div", {
            ...stylex34.props(spatialFrameStyles.overlay),
            role: "list",
            children: block.points.map((point) => {
              const position = positions.get(point.id);
              if (!position)
                return null;
              const details = "category" in point ? [point.category, ...point.details ?? []] : [point.kind, point.status, ...point.tags ?? [], ...point.details ?? []];
              return /* @__PURE__ */ jsxs33("button", {
                ...stylex34.props(spatialContentStyles.point),
                type: "button",
                role: "listitem",
                style: {
                  left: `${position.x}%`,
                  top: `${position.y}%`
                },
                "data-ui-spatial-point": point.id,
                "data-ui-spatial-related": JSON.stringify("relatedIds" in point ? point.relatedIds ?? [] : []),
                "data-tone": point.tone ?? "neutral",
                "aria-pressed": "false",
                "aria-controls": `${block.id}-detail-${point.id}`,
                title: `${point.label}: ${details.join(", ")}`,
                children: [
                  /* @__PURE__ */ jsx48("span", {
                    ...stylex34.props(spatialContentStyles.dot),
                    "aria-hidden": "true"
                  }),
                  /* @__PURE__ */ jsx48("span", {
                    ...stylex34.props(spatialContentStyles.pointLabel),
                    children: point.label
                  })
                ]
              }, point.id);
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs33("figcaption", {
        children: [
          /* @__PURE__ */ jsx48("p", {
            ...stylex34.props(spatialContentStyles.description),
            children: block.description
          }),
          /* @__PURE__ */ jsx48("ul", {
            ...stylex34.props(spatialContentStyles.legend),
            "aria-label": "Legend",
            children: block.legend.map((item, index) => /* @__PURE__ */ jsx48("li", {
              ...stylex34.props(spatialContentStyles.legendItem),
              "data-tone": item.tone ?? "neutral",
              children: item.label
            }, `${item.label}:${index}`))
          }),
          /* @__PURE__ */ jsx48("div", {
            "aria-live": "polite",
            children: block.points.map((point) => /* @__PURE__ */ jsxs33("article", {
              id: `${block.id}-detail-${point.id}`,
              "data-ui-spatial-detail": point.id,
              ...stylex34.props(spatialContentStyles.detail),
              hidden: true,
              children: [
                /* @__PURE__ */ jsx48("strong", {
                  ...stylex34.props(spatialContentStyles.detailTitle),
                  children: point.label
                }),
                /* @__PURE__ */ jsx48("span", {
                  ...stylex34.props(spatialContentStyles.detailText),
                  children: "category" in point ? point.category : `${point.kind} · ${point.status}`
                })
              ]
            }, point.id))
          })
        ]
      })
    ]
  });
}
function PanelBlock(props362) {
  switch (props362.block.type) {
    case "stats":
      return /* @__PURE__ */ jsx49(StatsBlock, {
        block: props362.block
      });
    case "key-values":
      return /* @__PURE__ */ jsx49(KeyValuesBlock, {
        block: props362.block
      });
    case "notice":
      return /* @__PURE__ */ jsx49(NoticeBlock, {
        block: props362.block
      });
    case "text":
      return /* @__PURE__ */ jsx49(TextBlock, {
        block: props362.block
      });
    case "group":
      return /* @__PURE__ */ jsx49(GroupBlock, {
        block: props362.block
      });
    case "flow":
      return /* @__PURE__ */ jsx49(FlowBlock, {
        block: props362.block
      });
    case "meters":
      return /* @__PURE__ */ jsx49(MetersBlock, {
        block: props362.block
      });
    case "series":
      return /* @__PURE__ */ jsx49(SeriesBlock, {
        block: props362.block
      });
    case "timeline":
      return /* @__PURE__ */ jsx49(TimelineBlock, {
        block: props362.block
      });
    case "progress":
      return /* @__PURE__ */ jsx49(ProgressBlock, {
        block: props362.block
      });
    case "query":
      return /* @__PURE__ */ jsx49(QueryBlock, {
        block: props362.block,
        query: props362.query,
        onQueryChange: props362.onQueryChange
      });
    case "links":
      return /* @__PURE__ */ jsx49(LinksBlock, {
        block: props362.block,
        onOpenEntity: props362.onOpenEntity,
        onLaunch: props362.onLaunch
      });
    case "list":
      return /* @__PURE__ */ jsx49(ListBlock, {
        block: props362.block,
        onAction: props362.onAction,
        onOpenEntity: props362.onOpenEntity,
        onLaunch: props362.onLaunch
      });
    case "table":
      return /* @__PURE__ */ jsx49(TableBlock, {
        block: props362.block,
        onAction: props362.onAction,
        onOpenEntity: props362.onOpenEntity,
        onLaunch: props362.onLaunch,
        query: props362.query,
        onQueryChange: props362.onQueryChange
      });
    case "matrix":
      return /* @__PURE__ */ jsx49(MatrixBlock, {
        block: props362.block,
        onAction: props362.onAction,
        onOpenEntity: props362.onOpenEntity,
        onLaunch: props362.onLaunch
      });
    case "spatial":
      return /* @__PURE__ */ jsx49(SpatialBlock, {
        block: props362.block
      });
    case "action":
      return /* @__PURE__ */ jsx49(OperatorActionButton, {
        action: props362.block,
        onAction: props362.onAction
      });
    case "actions":
      return /* @__PURE__ */ jsx49(Actions, {
        actions: props362.block.items,
        onAction: props362.onAction
      });
  }
}
function DetailBlock(props362) {
  const {
    block,
    ...handlers
  } = props362;
  const {
    query,
    onQueryChange
  } = handlers;
  const headingRef = useRef13(null);
  const requestedRaw = query[block.queryKey];
  const requested = typeof requestedRaw === "string" && requestedRaw !== "" ? requestedRaw : undefined;
  const open = block.open?.forId === requested ? block.open : undefined;
  const pending = requested !== undefined && open === undefined;
  useEffect15(() => {
    if (open)
      headingRef.current?.focus();
  }, [open]);
  const openItem = (itemId) => {
    onQueryChange({
      ...query,
      [block.queryKey]: itemId
    });
  };
  const closeItem = () => {
    const next = {
      ...query
    };
    delete next[block.queryKey];
    onQueryChange(next);
  };
  const master = block.master.type === "list" ? /* @__PURE__ */ jsx49(ListBlock, {
    block: block.master,
    onAction: props362.onAction,
    onOpenEntity: props362.onOpenEntity,
    onLaunch: props362.onLaunch,
    openId: requested
  }) : block.master.type === "matrix" ? /* @__PURE__ */ jsx49(MatrixBlock, {
    block: block.master,
    onAction: props362.onAction,
    onOpenEntity: props362.onOpenEntity,
    onLaunch: props362.onLaunch,
    openId: requested
  }) : /* @__PURE__ */ jsx49(TableBlock, {
    block: block.master,
    onAction: props362.onAction,
    onOpenEntity: props362.onOpenEntity,
    onLaunch: props362.onLaunch,
    query,
    onQueryChange,
    openId: requested
  });
  return /* @__PURE__ */ jsxs34("div", {
    ...stylex35.props(detailStyles.root, requested !== undefined && detailStyles.split),
    "data-detail": "",
    "data-open": requested === undefined ? "false" : "true",
    children: [
      /* @__PURE__ */ jsx49("section", {
        ...stylex35.props(detailStyles.master, requested !== undefined && detailStyles.hiddenMaster),
        "data-detail-master": "",
        "aria-label": "Items",
        children: /* @__PURE__ */ jsx49(OpenDetailContext.Provider, {
          value: openItem,
          children: master
        })
      }),
      requested !== undefined && /* @__PURE__ */ jsx49("section", {
        "data-operator-detail-pane": "",
        ...stylex35.props(detailStyles.pane),
        "aria-label": open ? open.title : "Detail",
        children: open ? /* @__PURE__ */ jsxs34(Fragment17, {
          children: [
            /* @__PURE__ */ jsx49("button", {
              type: "button",
              ...stylex35.props(detailStyles.back),
              "data-detail-back": "",
              onClick: closeItem,
              children: "← Back"
            }),
            /* @__PURE__ */ jsx49("h2", {
              ...stylex35.props(detailStyles.heading),
              ref: headingRef,
              tabIndex: -1,
              children: open.title
            }),
            /* @__PURE__ */ jsx49("div", {
              ...stylex35.props(detailStyles.body),
              children: open.blocks.map((panel, index) => /* @__PURE__ */ jsx49("section", {
                "data-block": panel.type,
                children: panel.type === "card" ? /* @__PURE__ */ jsx49(CardBlock, {
                  framed: false,
                  block: panel,
                  ...handlers
                }) : /* @__PURE__ */ jsx49(PanelBlock, {
                  block: panel,
                  ...handlers
                })
              }, panel.id ?? `${panel.type}:${index}`))
            })
          ]
        }) : /* @__PURE__ */ jsxs34(Fragment17, {
          children: [
            /* @__PURE__ */ jsx49("button", {
              type: "button",
              ...stylex35.props(detailStyles.back),
              "data-detail-back": "",
              onClick: closeItem,
              children: "← Back"
            }),
            /* @__PURE__ */ jsx49("p", {
              ...stylex35.props(rendererLayoutStyles.empty),
              "aria-live": "polite",
              children: pending ? "Loading…" : block.empty
            })
          ]
        })
      })
    ]
  });
}
function CardBlock(props362) {
  const {
    framed,
    block,
    ...handlers
  } = props362;
  const {
    components
  } = useContext11(OperatorRendererHostContext);
  const panels = block.blocks;
  const footerStart = panels.reduce((last, panel, index) => panel.type === "links" || panel.type === "actions" ? last : index, -1) + 1;
  const groupedFooter = panels.length - footerStart > 1;
  const renderPanel = (panel, index) => /* @__PURE__ */ jsx49("div", {
    "data-block": panel.type,
    children: /* @__PURE__ */ jsx49(PanelBlock, {
      block: panel,
      ...handlers
    })
  }, panel.id ?? `${panel.type}:${index}`);
  return /* @__PURE__ */ jsx49(OperatorCard, {
    label: block.label,
    metadata: block.metadata,
    summary: block.summary,
    framed,
    tone: block.tone,
    presentation: block.presentation,
    density: components.density,
    renderDisclosure: block.presentation === "disclosure" && block.disclosureLabel !== undefined ? (content) => /* @__PURE__ */ jsx49(components.Disclosure, {
      title: block.label,
      triggerLabel: block.disclosureLabel,
      triggerVariant: "outline",
      children: content
    }) : undefined,
    footer: groupedFooter ? panels.slice(footerStart).map((panel, index) => renderPanel(panel, footerStart + index)) : undefined,
    children: panels.slice(0, groupedFooter ? footerStart : panels.length).map(renderPanel)
  });
}
function ColumnsBlock(props362) {
  const {
    block,
    ...handlers
  } = props362;
  const {
    components
  } = useContext11(OperatorRendererHostContext);
  const region = (entries) => /* @__PURE__ */ jsx49(Fragment17, {
    children: entries.map((entry, index) => /* @__PURE__ */ jsx49("section", {
      ...stylex35.props(components.density === "comfortable" && index > 0 && !(entry.type === "card" && entry.presentation === "disclosure") && workspaceStyles.sectionAfter),
      "data-block": entry.type,
      children: entry.type === "card" ? /* @__PURE__ */ jsx49(CardBlock, {
        block: entry,
        ...handlers
      }) : /* @__PURE__ */ jsx49(PanelBlock, {
        block: entry,
        ...handlers
      })
    }, entry.id ?? `${entry.type}:${index}`))
  });
  return /* @__PURE__ */ jsx49(OperatorColumns, {
    density: components.density,
    joined: components.density === "comfortable",
    primary: region(block.primary),
    aside: region(block.aside)
  });
}
function ViewBlock(props362) {
  const {
    block,
    ...handlers
  } = props362;
  const tabDefault = block.type === "tabs" ? block.defaultTab : "";
  const tabQueryKey = block.type === "tabs" ? block.queryKey : undefined;
  const [localActiveTab, setLocalActiveTab] = useState16(tabDefault);
  useEffect15(() => {
    if (!tabQueryKey)
      setLocalActiveTab(tabDefault);
  }, [tabDefault, tabQueryKey]);
  const host = useContext11(OperatorRendererHostContext);
  switch (block.type) {
    case "columns":
      return /* @__PURE__ */ jsx49(ColumnsBlock, {
        block,
        ...handlers
      });
    case "card":
      return /* @__PURE__ */ jsx49(CardBlock, {
        block,
        ...handlers
      });
    case "detail":
      return /* @__PURE__ */ jsx49(DetailBlock, {
        block,
        ...handlers
      });
    case "tabs":
      break;
    default:
      return /* @__PURE__ */ jsx49(PanelBlock, {
        block,
        ...handlers
      });
  }
  const tabs = block.tabs.map((tab) => ({
    value: tab.id,
    label: tab.label,
    ...tab.count !== undefined ? {
      count: tab.count
    } : {},
    content: tab.blocks.map((child, index) => /* @__PURE__ */ createElement10("section", {
      ...stylex35.props(workspaceStyles.section, index > 0 && workspaceStyles.sectionAfter),
      key: child.id ?? `${child.type}:${index}`
    }, /* @__PURE__ */ jsx49(ViewBlock, {
      block: child,
      ...handlers
    })))
  }));
  if (host.renderAllTabs) {
    return /* @__PURE__ */ jsx49(StaticAllTabs, {
      id: `operator-${block.id}`,
      label: block.label,
      defaultValue: block.defaultTab,
      tabs
    });
  }
  const requestedTab = tabQueryKey ? handlers.query[tabQueryKey] : undefined;
  const activeTab = typeof requestedTab === "string" ? requestedTab : localActiveTab;
  const activeValue = tabs.some((tab) => tab.value === activeTab) ? activeTab : tabs[0]?.value ?? "";
  const {
    Tabs: Tabs2
  } = host.components;
  return /* @__PURE__ */ jsx49(Tabs2, {
    label: block.label,
    value: activeValue,
    tabs,
    onValueChange: (value) => {
      if (tabQueryKey) {
        handlers.onQueryChange({
          [tabQueryKey]: value
        });
      } else {
        setLocalActiveTab(value);
      }
    }
  });
}
var COMPACT_BLOCKS = new Set(["key-values", "group", "meters", "progress"]);
function blockSpan(type) {
  return COMPACT_BLOCKS.has(type) ? "compact" : "wide";
}
function OperatorViewRenderer(props37) {
  const [actionReceipt, setActionReceipt] = useState17(null);
  const {
    title,
    blocks
  } = props37.data.view;
  const [lead] = blocks;
  const totals = props37.renderHead !== false && props37.renderAllTabs !== true && lead?.type === "stats" ? lead : null;
  const bodyBlocks = totals ? blocks.slice(1) : blocks;
  const components = props37.components ?? CSS_COMPONENTS;
  const frame = stylex36.props(workspaceStyles.frame, props37.renderHead === false && workspaceStyles.embedded);
  const sections = stylex36.props(workspaceStyles.sections, components.density === "comfortable" && workspaceStyles.comfortableSections);
  const {
    kicker,
    description,
    status,
    primaryAction
  } = props37.data.view;
  const hasHead = Boolean(title) || Boolean(kicker) || Boolean(description) || totals !== null || status !== undefined || primaryAction !== undefined;
  return /* @__PURE__ */ jsx50(OperatorRendererHostContext.Provider, {
    value: {
      resolveLink: props37.resolveLink,
      onDetachedActionResult: setActionReceipt,
      renderAllTabs: props37.renderAllTabs === true,
      components
    },
    children: /* @__PURE__ */ jsxs35("main", {
      ...frame,
      "data-operator-view": "",
      "data-control-engine": components.engine,
      children: [
        props37.renderHead !== false && hasHead && /* @__PURE__ */ jsxs35("header", {
          ...stylex36.props(rendererLayoutStyles.head),
          children: [
            /* @__PURE__ */ jsxs35("div", {
              ...stylex36.props(rendererLayoutStyles.copy),
              children: [
                kicker && /* @__PURE__ */ jsx50("span", {
                  ...stylex36.props(rendererLayoutStyles.kicker),
                  children: kicker
                }),
                /* @__PURE__ */ jsx50("h2", {
                  ...stylex36.props(rendererLayoutStyles.title),
                  children: title
                }),
                description && /* @__PURE__ */ jsx50("p", {
                  ...stylex36.props(rendererLayoutStyles.description),
                  children: description
                })
              ]
            }),
            /* @__PURE__ */ jsxs35("div", {
              ...stylex36.props(rendererLayoutStyles.standing),
              children: [
                status && /* @__PURE__ */ jsxs35("strong", {
                  ...stylex36.props(rendererLayoutStyles.status),
                  "data-tone": status.tone ?? "neutral",
                  children: [
                    status.label,
                    status.detail && /* @__PURE__ */ jsx50("small", {
                      ...stylex36.props(rendererLayoutStyles.statusDetail),
                      children: status.detail
                    })
                  ]
                }),
                totals && /* @__PURE__ */ jsx50(StatsBlock, {
                  block: totals,
                  placement: "head"
                }),
                primaryAction && /* @__PURE__ */ jsx50(OperatorActionButton, {
                  action: primaryAction,
                  primary: true,
                  onAction: props37.onAction
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsxs35("div", {
          ...sections,
          "data-operator-blocks": "",
          children: [
            actionReceipt && /* @__PURE__ */ jsx50("section", {
              ...stylex36.props(workspaceStyles.section, workspaceStyles.wide),
              "data-block": "action",
              "data-span": "wide",
              children: /* @__PURE__ */ jsx50(ActionResult, {
                result: actionReceipt,
                onDismiss: () => setActionReceipt(null)
              })
            }),
            bodyBlocks.map((block, index) => /* @__PURE__ */ createElement11("section", {
              ...stylex36.props(workspaceStyles.section, blockSpan(block.type) === "wide" && workspaceStyles.wide, block.type === "query" && workspaceStyles.query),
              key: block.id ?? `${block.type}:${index}`,
              "data-block": block.type,
              "data-span": blockSpan(block.type)
            }, /* @__PURE__ */ jsx50(ViewBlock, {
              block,
              onAction: props37.onAction,
              onOpenEntity: props37.onOpenEntity,
              onLaunch: props37.onLaunch ?? (() => {}),
              query: props37.query ?? {},
              onQueryChange: props37.onQueryChange ?? (() => {})
            })))
          ]
        })
      ]
    })
  });
}
var operatorViewStylexCSS = `@keyframes xij6lzg-B{50%{opacity:.58;transform:scale(1.2);}}
@keyframes xukdt12-B{50%{opacity:.85;}}
@keyframes xvnk6pr-B{0%{opacity:0;transform:translateY(12px);}20%{opacity:.34;}82%{opacity:.24;}100%{opacity:0;transform:translateY(-24px);}}
@keyframes x1ixh1oh-B{from{opacity:0;transform:scale(0);}to{opacity:1;transform:scale(1);}}
@keyframes xqestwo-B{from{opacity:0;transform:scale(.4);}to{opacity:1;transform:scale(1);}}
@keyframes x5ou7kv-B{to{stroke-dashoffset:0;}}
.x10a8y8t:not(#\\#){inset:0}
.xg4khjk:not(#\\#){inset:15px 18px auto}
.x6mrcm:not(#\\#){inset:6px}
.x17y8zlc:not(#\\#){margin:0 -18px}
.x1fylewd:not(#\\#){margin:0 0 0 6px}
.x8o5f6s:not(#\\#){margin:0 0 11px}
.xjgi5au:not(#\\#){margin:0 0 12px}
.x1qe5pcq:not(#\\#){margin:0 0 20px}
.xwd23ue:not(#\\#){margin:0 0 4px}
.xzmzwx2:not(#\\#){margin:0 18px}
.x19bbpc0:not(#\\#){margin:0 auto}
.x1ghz6dp:not(#\\#){margin:0}
.x1l1fhan:not(#\\#){margin:11px 0 0}
.x1cpde12:not(#\\#){margin:2px 0 0}
.x1g76kxt:not(#\\#){margin:3px 0 0}
.xqe1szj:not(#\\#){margin:4px 0 0}
.x1pz56wa:not(#\\#){margin:5px 0 0}
.xe6w4ck:not(#\\#){margin:8px 0 0}
.x1j0re3k:not(#\\#){margin:auto 16px 16px}
.xhwt3jn:not(#\\#){padding:0 13px}
.x1csxjeb:not(#\\#){padding:0 14px}
.x1tzdv60:not(#\\#){padding:0 15px}
.x5b5r1n:not(#\\#){padding:0 18px}
.xst3r74:not(#\\#){padding:0 6px}
.x1astma3:not(#\\#){padding:0 9px}
.x1yel030:not(#\\#){padding:0 clamp(18px,4vw,58px)}
.x1717udv:not(#\\#){padding:0}
.x17mb830:not(#\\#){padding:11px 18px}
.x1bo8gzv:not(#\\#){padding:12px 0 0}
.x16euas4:not(#\\#){padding:12px 18px 14px}
.xc7ga6q:not(#\\#){padding:12px}
.xe2wrrw:not(#\\#){padding:13px 12px}
.xp0g775:not(#\\#){padding:13px 16px 15px}
.x1vgkc3a:not(#\\#){padding:13px 6px 13px 0}
.xbxpdvy:not(#\\#){padding:14px 16px 16px}
.xng7wty:not(#\\#){padding:14px 18px 16px}
.x1k10g7g:not(#\\#){padding:15px 16px 16px}
.x1g8o3q3:not(#\\#){padding:16px 0}
.x1m5bfbp:not(#\\#){padding:16px 18px 0}
.x1ctc5qj:not(#\\#){padding:16px 18px 18px}
.x3sov96:not(#\\#){padding:18px 0}
.xd5164:not(#\\#){padding:18px 18px 14px}
.x6vc9w5:not(#\\#){padding:18px 26px 0}
.x1glq3gq:not(#\\#){padding:18px 26px 60px}
.x1t7086c:not(#\\#){padding:22px 0}
.xggk2y7:not(#\\#){padding:24px}
.xjpj6cu:not(#\\#){padding:26px 26px 0}
.xdbnglg:not(#\\#){padding:26px 34px 40px}
.xor4a8r:not(#\\#){padding:26px}
.x10xs6qf:not(#\\#){padding:28px}
.xu19mh5:not(#\\#){padding:2px 5px 7px}
.x1dumkz1:not(#\\#){padding:2px 6px}
.xpzpvjg:not(#\\#){padding:2px 7px}
.xmfpazt:not(#\\#){padding:2px 8px}
.xbjd7y:not(#\\#){padding:2px 9px}
.x1i3ajwb:not(#\\#){padding:2px}
.x18juh3m:not(#\\#){padding:3px 6px}
.x1asu97y:not(#\\#){padding:3px 8px}
.x1x7i2cb:not(#\\#){padding:3px 9px}
.x9ms5i6:not(#\\#){padding:3px}
.x1o8uwn5:not(#\\#){padding:48px}
.x11onut9:not(#\\#){padding:4px 0 17px}
.x1toko95:not(#\\#){padding:4px 0 2px}
.x14odnwx:not(#\\#){padding:5px}
.xokocfn:not(#\\#){padding:6px 0}
.x1jmcyos:not(#\\#){padding:6px 9px}
.x1ruevkc:not(#\\#){padding:6px}
.x2lkgqm:not(#\\#){padding:7px 10px}
.x1sbvpl4:not(#\\#){padding:7px 11px}
.x1160tuk:not(#\\#){padding:8px 10px}
.x1q773pt:not(#\\#){padding:8px 11px}
.x1ica2du:not(#\\#){padding:9px 0}
.x1b28kx2:not(#\\#){padding:9px 16px 11px}
.x1jlzkty:not(#\\#){padding:9px 5px}
.x1sjuclm:not(#\\#){padding:clamp(24px,4vw,48px) 0 60px}
.x10e8r38:is([data-matrix-cell] li:last-child):not(#\\#){padding:14px 0 4px}
.x1xukwvs:is([data-matrix-cell] li):not(#\\#){padding:14px 0}
@media (max-width: 720px){.x1yemgb7.x1yemgb7:not(#\\#){margin:0}}
@media (max-width: 640px){.x1xnq73d.x1xnq73d:not(#\\#){padding:0 10px}}
@media (max-width: 720px){.xe3jge6.xe3jge6:not(#\\#){padding:0 10px}}
@media (max-width: 900px){.xb1114b.xb1114b:not(#\\#){padding:0}}
@media (max-width: 640px){.xfc0hut.xfc0hut:not(#\\#){padding:12px 0 40px}}
@media (max-width: 640px){.xg8tid0.xg8tid0:not(#\\#){padding:12px 14px 0}}
@media (max-width: 640px){.x10erhnk.x10erhnk:not(#\\#){padding:12px}}
@media (min-width: 641px){.x1ffza42.x1ffza42:not(#\\#){padding:12px}}
@media (max-width: 640px){.x1pnj9ld.x1pnj9ld:not(#\\#){padding:14px 14px 30px}}
@media (max-width: 640px){.xqqny65.xqqny65:not(#\\#){padding:14px}}
@media (max-width: 640px){.x11h1smq.x11h1smq:not(#\\#){padding:18px 14px 0}}
@media (max-width: 640px){.xwn745a.xwn745a:not(#\\#){padding:18px}}
@media (max-width: 900px){.x1cb063g.x1cb063g:not(#\\#){padding:20px 18px 28px}}
@media (max-width: 640px){.x1ab9136.x1ab9136:not(#\\#){padding:8px 2px 10px}}
@media (max-width: 640px){.xrutqb.xrutqb:not(#\\#){padding:max(4px,env(safe-area-inset-top)) 12px 4px}}
@media (min-width: 641px){.x17vqpdp.x17vqpdp:is([data-operator-action-popover] *):not(#\\#){padding:16px}}
.xqbhmck:not(#\\#):not(#\\#){background-position:calc(100% - 15px) calc(50% - 2px),calc(100% - 10px) calc(50% - 2px)}
.x2xzz1h:not(#\\#):not(#\\#){border-color:color-mix(in srgb,currentColor 24%,transparent)}
.x7k9j60:not(#\\#):not(#\\#){border-color:color-mix(in srgb,currentColor 30%,transparent)}
.xx1zzhd:not(#\\#):not(#\\#){border-color:color-mix(in srgb,currentColor 36%,transparent)}
.x1sqyqg8:not(#\\#):not(#\\#){border-color:color-mix(in srgb,var(--console-err) 40%,transparent)}
.x1ezim0c:not(#\\#):not(#\\#){border-color:color-mix(in srgb,var(--console-err) 55%,transparent)}
.xwpv6la:not(#\\#):not(#\\#){border-color:color-mix(in srgb,var(--console-ok) 35%,transparent)}
.xb3wpjg:not(#\\#):not(#\\#){border-color:color-mix(in srgb,var(--console-ok) 38%,transparent)}
.x1p4dqwe:not(#\\#):not(#\\#){border-color:color-mix(in srgb,var(--console-secondary) 38%,transparent)}
.xuy1tgj:not(#\\#):not(#\\#){border-color:color-mix(in srgb,var(--console-warn) 35%,transparent)}
.x1r7ld26:not(#\\#):not(#\\#){border-color:currentColor}
.x9r1u3d:not(#\\#):not(#\\#){border-color:transparent}
.xawfzfr:not(#\\#):not(#\\#){border-color:var(--console-accent)}
.xmt0h0j:not(#\\#):not(#\\#){border-color:var(--console-rule-accent)}
.x8tuc8h:not(#\\#):not(#\\#){border-color:var(--console-rule-strong)}
.xy1lt07:not(#\\#):not(#\\#){border-color:var(--console-rule)}
.x1vw2y1n:not(#\\#):not(#\\#){border-color:var(--console-text-muted)}
.x2u8bby:not(#\\#):not(#\\#){border-radius:0}
.x1xwekrv:not(#\\#):not(#\\#){border-radius:100px}
.x1q4ynmn:not(#\\#):not(#\\#){border-radius:10px}
.xixl9f9:not(#\\#):not(#\\#){border-radius:14px}
.x1cum3z5:not(#\\#):not(#\\#){border-radius:2px}
.x120k5d4:not(#\\#):not(#\\#){border-radius:4px 4px 8px 8px}
.x12oqio5:not(#\\#):not(#\\#){border-radius:4px}
.x16rqkct:not(#\\#):not(#\\#){border-radius:50%}
.x1sxf85j:not(#\\#):not(#\\#){border-radius:5px}
.x1kogg8i:not(#\\#):not(#\\#){border-radius:6px}
.xu4hgxq:not(#\\#):not(#\\#){border-radius:7px}
.x2s36sz:not(#\\#):not(#\\#){border-radius:8px 8px 4px 4px}
.xur7f20:not(#\\#):not(#\\#){border-radius:8px}
.x1e6avla:not(#\\#):not(#\\#){border-radius:999px}
.xhpnuu7:not(#\\#):not(#\\#){border-radius:9px}
.xbsl7fq:not(#\\#):not(#\\#){border-style:dashed}
.x1y0btm7:not(#\\#):not(#\\#){border-style:solid}
.xc342km:not(#\\#):not(#\\#){border-width:0}
.xmkeg23:not(#\\#):not(#\\#){border-width:1px}
.xdh2fpr:not(#\\#):not(#\\#){border-width:2px}
.x3psx0u:not(#\\#):not(#\\#){flex:0 0 auto}
.xkz0k9k:not(#\\#):not(#\\#){flex:0 1 auto}
.x845mor:not(#\\#):not(#\\#){flex:1 1 0%}
.x12lumcd:not(#\\#):not(#\\#){flex:1 1 auto}
.x98rzlu:not(#\\#):not(#\\#){flex:1}
.xxhr3t:not(#\\#):not(#\\#){gap:0}
.x883omv:not(#\\#):not(#\\#){gap:10px}
.x15gj94b:not(#\\#):not(#\\#){gap:11px}
.xkagz3p:not(#\\#):not(#\\#){gap:12px 24px}
.x1v2ro7d:not(#\\#):not(#\\#){gap:12px}
.x1avw0xy:not(#\\#):not(#\\#){gap:14px 18px}
.x1af02g3:not(#\\#):not(#\\#){gap:14px}
.x1qg7m3j:not(#\\#):not(#\\#){gap:15px}
.xiv87he:not(#\\#):not(#\\#){gap:16px 20px}
.xou54vl:not(#\\#):not(#\\#){gap:16px}
.x1lblyuz:not(#\\#):not(#\\#){gap:18px 28px}
.xaobbuh:not(#\\#):not(#\\#){gap:18px}
.x12mrbbr:not(#\\#):not(#\\#){gap:1px}
.x1c1vhfx:not(#\\#):not(#\\#){gap:20px}
.xmt3bw4:not(#\\#):not(#\\#){gap:22px}
.x1665zp3:not(#\\#):not(#\\#){gap:24px}
.x14i4cvt:not(#\\#):not(#\\#){gap:26px 40px}
.x1jaupxr:not(#\\#):not(#\\#){gap:26px}
.x33pbmt:not(#\\#):not(#\\#){gap:28px}
.x195vfkc:not(#\\#):not(#\\#){gap:2px}
.xseyljb:not(#\\#):not(#\\#){gap:30px}
.xv5gsod:not(#\\#):not(#\\#){gap:36px}
.x1ed6fcf:not(#\\#):not(#\\#){gap:3px}
.x1kxjhzz:not(#\\#):not(#\\#){gap:42px}
.xx06bmz:not(#\\#):not(#\\#){gap:4px 18px}
.x1jnr06f:not(#\\#):not(#\\#){gap:4px}
.x1nejdyq:not(#\\#):not(#\\#){gap:5px}
.x1u7gxyo:not(#\\#):not(#\\#){gap:6px 12px}
.x3phc52:not(#\\#):not(#\\#){gap:6px 14px}
.x1vtxxvk:not(#\\#):not(#\\#){gap:6px 16px}
.x17d4w8g:not(#\\#):not(#\\#){gap:6px}
.x1j9xkj6:not(#\\#):not(#\\#){gap:7px}
.xyqssrz:not(#\\#):not(#\\#){gap:8px 20px}
.x167g77z:not(#\\#):not(#\\#){gap:8px}
.xmmi0ta:not(#\\#):not(#\\#){gap:9px}
.x1osaytk:not(#\\#):not(#\\#){grid-column:1 / -1}
.xgkxs2y:not(#\\#):not(#\\#){grid-column:1}
.x1npkx4u:not(#\\#):not(#\\#){grid-column:2}
.x1k3v4rp:not(#\\#):not(#\\#){grid-column:3}
.xm5moh1:not(#\\#):not(#\\#){grid-column:auto}
.x1ms6mhf:not(#\\#):not(#\\#){grid-row:1}
.xe8uvvx:not(#\\#):not(#\\#){list-style:none}
.xg9jes1:not(#\\#):not(#\\#){margin-block:4px}
.x1a2a7pz:not(#\\#):not(#\\#){outline:none}
.xysyzu8:not(#\\#):not(#\\#){overflow:auto}
.xb3r6kr:not(#\\#):not(#\\#){overflow:hidden}
.x1rea2x4:not(#\\#):not(#\\#){overflow:visible}
.xp59q4u:not(#\\#):not(#\\#){padding-block:10px}
.xrii95j:not(#\\#):not(#\\#){padding-block:11px}
.x1b9wmvo:not(#\\#):not(#\\#){padding-block:15px}
.xj8oexa:not(#\\#):not(#\\#){padding-block:2px}
.xf4egzd:not(#\\#):not(#\\#){padding-block:3px}
.xifx94n:not(#\\#):not(#\\#){padding-block:5px}
.x1t0vds8:not(#\\#):not(#\\#){padding-block:6px}
.x11dh7js:not(#\\#):not(#\\#){padding-block:7px 5px}
.xknfcqp:not(#\\#):not(#\\#){padding-block:7px}
.x1vvogim:not(#\\#):not(#\\#){padding-block:8px}
.x1m7iz9m:not(#\\#):not(#\\#){padding-block:9px}
.xnjsko4:not(#\\#):not(#\\#){padding-inline:0}
.xfoe8qy:not(#\\#):not(#\\#){padding-inline:11px}
.xaope02:not(#\\#):not(#\\#){padding-inline:12px}
.xqin4a2:not(#\\#):not(#\\#){padding-inline:14px}
.x17qtykl:not(#\\#):not(#\\#){padding-inline:20px}
.x1q4txso:not(#\\#):not(#\\#){padding-inline:9px}
.x1ku5rj1:not(#\\#):not(#\\#){place-items:center}
.x1hl2dhg:not(#\\#):not(#\\#){text-decoration:none}
.x5gjymy:not(#\\#):not(#\\#){transition:background-color .12s ease,border-color .12s ease,color .12s ease,opacity .12s ease,transform .12s ease}
.x1oagamk:not(#\\#):not(#\\#){transition:background-color .12s ease,border-color .12s ease}
.x1p5amsn:not(#\\#):not(#\\#){transition:border-color .12s ease,box-shadow .12s ease}
.xzjk7dm:not(#\\#):not(#\\#){transition:fill .12s ease}
.x1gt6r2q:not(#\\#):not(#\\#){transition:transform .12s ease,background-color .12s ease}
.x16yjenj:is([data-state='checked']):not(#\\#):not(#\\#){border-color:var(--console-accent)}
.x1iom3s4:focus-visible:not(#\\#):not(#\\#){border-color:var(--console-accent)}
.x6cfppn:is([data-status=active] > *, [data-status=complete] > *):not(#\\#):not(#\\#){border-color:var(--console-accent)}
.xliqn1l:hover:not(:disabled):not(#\\#):not(#\\#){border-color:var(--console-accent)}
.xu3iebo:is([data-tone="error"] > *):not(#\\#):not(#\\#){border-color:var(--console-err)}
.xym8ms8:is([data-status=failed] > *):not(#\\#):not(#\\#){border-color:var(--console-err)}
.xjgjgpo:is([data-tone="good"] > *):not(#\\#):not(#\\#){border-color:var(--console-ok)}
.x19a6ijj:is([aria-selected="true"],[aria-pressed="true"]):not(#\\#):not(#\\#){border-color:var(--console-rule-accent)}
.xbghsdc:focus-visible:not(#\\#):not(#\\#){border-color:var(--console-rule-accent)}
.xt7649k:is([data-tone="warn"] > *):not(#\\#):not(#\\#){border-color:var(--console-warn)}
.xps7s55:is([data-operator-card-body] *):not(#\\#):not(#\\#){gap:12px}
.x1g79t40:is([data-operator-detail-pane] *):not(#\\#):not(#\\#){gap:16px}
.xvtq9v3:is([data-operator-blocks] > [data-block=links] *):not(#\\#):not(#\\#){gap:18px}
.x16dl9wz:focus-visible:not(#\\#):not(#\\#){outline:2px solid var(--console-accent)}
.x1f1sp5:hover:not(:disabled):not(#\\#):not(#\\#){outline:none}
.xcysz91:disabled:not(#\\#):not(#\\#){border-color:var(--console-rule-strong)}
.xck444f:user-invalid:not(#\\#):not(#\\#){border-color:var(--console-err)}
.x8bwlc1:hover:not(#\\#):not(#\\#){border-color:var(--console-accent)}
.xu43hr4:hover:not(#\\#):not(#\\#){border-color:var(--console-err)}
.x1jokge8:hover:not(#\\#):not(#\\#){border-color:var(--console-rule-accent)}
.xt0b8zv:hover:not(#\\#):not(#\\#){text-decoration:underline}
.xf77ohz:focus:not(#\\#):not(#\\#){border-color:var(--console-accent)}
@media (min-width: 641px){.xhesz8g.xhesz8g:not(#\\#):not(#\\#){border-color:var(--console-rule-accent)}}
@media (max-width: 640px){.x17i0p7j.x17i0p7j:not(#\\#):not(#\\#){border-radius:0}}
@media (min-width: 641px){.xsucau6.xsucau6:not(#\\#):not(#\\#){border-radius:8px}}
@media (max-width: 640px){.x1olvxk8.x1olvxk8:not(#\\#):not(#\\#){border-radius:9px}}
@media (max-width: 640px){.x1d3ddqg.x1d3ddqg:not(#\\#):not(#\\#){gap:10px}}
@media (max-width: 720px){.x1n3jums.x1n3jums:not(#\\#):not(#\\#){gap:10px}}
@media (max-width: 900px){.x13osz58.x13osz58:not(#\\#):not(#\\#){gap:12px 24px}}
@media (max-width: 640px){.xd9d3ul.xd9d3ul:not(#\\#):not(#\\#){gap:12px}}
@media (max-width: 640px){.x1lgz1aq.x1lgz1aq:not(#\\#):not(#\\#){gap:14px}}
@media (max-width: 900px){.x1tdawcz.x1tdawcz:not(#\\#):not(#\\#){gap:20px}}
@media (max-width: 640px){.xjgfjw9.xjgfjw9:not(#\\#):not(#\\#){gap:24px}}
@media (max-width: 900px){.x1mlu5rb.x1mlu5rb:not(#\\#):not(#\\#){gap:32px}}
@media (max-width: 640px){.x1kis1tw.x1kis1tw:not(#\\#):not(#\\#){gap:3px}}
@media (max-width: 720px){.x66wd9j.x66wd9j:not(#\\#):not(#\\#){gap:4px 12px}}
@media (max-width: 640px){.x15j3ira.x15j3ira:not(#\\#):not(#\\#){gap:4px}}
@media (max-width: 720px){.x1hsl0lv.x1hsl0lv:not(#\\#):not(#\\#){gap:7px 14px}}
@media (max-width: 640px){.x1dbyxhg.x1dbyxhg:not(#\\#):not(#\\#){gap:8px 12px}}
@media (max-width: 640px){.x1otypdl.x1otypdl:not(#\\#):not(#\\#){gap:8px}}
@media (max-width: 640px){.xdueovt.xdueovt:not(#\\#):not(#\\#){gap:9px}}
@media (max-width: 640px){.x62c7l.x62c7l:not(#\\#):not(#\\#){gap:var(--operator-sections-gap,26px 40px)}}
@media (max-width: 640px){.xqca30q.xqca30q:not(#\\#):not(#\\#){gap:var(--operator-sections-gap,28px)}}
@media (max-width: 720px){.x1mny9qk.x1mny9qk:not(#\\#):not(#\\#){grid-column:1 / -1}}
@media (max-width: 420px){.x16ohsbj.x16ohsbj:not(#\\#):not(#\\#){grid-column:1}}
@media (max-width: 720px){.xy0nd2e.xy0nd2e:not(#\\#):not(#\\#){grid-column:1}}
@media (max-width: 720px){.x1yfacwp.x1yfacwp:not(#\\#):not(#\\#){grid-column:2}}
@media (min-width: 420.01px) and (max-width: 720px){.xbzj6x0.xbzj6x0:not(#\\#):not(#\\#){grid-column:2}}
@media (max-width: 720px){.x9zojqa.x9zojqa:not(#\\#):not(#\\#){grid-row:2}}
@media (max-width: 640px){.x1qa1qnr.x1qa1qnr:not(#\\#):not(#\\#){padding-inline:18px}}
@media (prefers-reduced-motion: reduce){.x9kvfbb.x9kvfbb:not(#\\#):not(#\\#){transition:none}}
@media (min-width: 641px){.x8wqbq1.x8wqbq1:is([data-operator-action-popover] *):not(#\\#):not(#\\#){border-color:var(--console-rule-strong)}}
@media (min-width: 641px){.x1ga0ivm.x1ga0ivm:is([data-operator-action-popover] *):not(#\\#):not(#\\#){border-radius:9px}}
@media (prefers-reduced-motion: reduce){.x7iwzyl.x7iwzyl:hover:not(:disabled):not(#\\#):not(#\\#){outline:2px solid var(--console-on-accent)}}
@container operator (max-width: 640px){.x16qsdag.x16qsdag:not(#\\#):not(#\\#){gap:10px}}
@container operator (max-width: 720px){.x1k72cru.x1k72cru:not(#\\#):not(#\\#){gap:10px}}
@container operator (max-width: 640px){.x1unfst4.x1unfst4:not(#\\#):not(#\\#){gap:12px}}
@container operator-cell (max-width: 420px){.x5cqck7.x5cqck7:not(#\\#):not(#\\#){gap:12px}}
@container operator (max-width: 900px){.xpodh61.xpodh61:not(#\\#):not(#\\#){gap:32px}}
@container operator (max-width: 640px){.xv2j0n9.xv2j0n9:not(#\\#):not(#\\#){gap:3px}}
@container operator (max-width: 640px){.xyedrc3.xyedrc3:not(#\\#):not(#\\#){gap:var(--operator-sections-gap,26px 40px)}}
@container operator (max-width: 640px){.x1wlbpn8.x1wlbpn8:not(#\\#):not(#\\#){gap:var(--operator-sections-gap,28px)}}
.x1ua5tub:not(#\\#):not(#\\#):not(#\\#){-webkit-box-orient:vertical}
.xvmahel:not(#\\#):not(#\\#):not(#\\#){-webkit-font-smoothing:antialiased}
.x1h7i4cw:not(#\\#):not(#\\#):not(#\\#){-webkit-line-clamp:2}
.x1q9s9ta:not(#\\#):not(#\\#):not(#\\#){accent-color:var(--console-accent)}
.x10ukxgv:not(#\\#):not(#\\#):not(#\\#){align-content:start}
.x1pha0wt:not(#\\#):not(#\\#):not(#\\#){align-items:baseline}
.x6s0dn4:not(#\\#):not(#\\#):not(#\\#){align-items:center}
.xuk3077:not(#\\#):not(#\\#):not(#\\#){align-items:flex-end}
.x1cy8zhl:not(#\\#):not(#\\#):not(#\\#){align-items:flex-start}
.x7a106z:not(#\\#):not(#\\#):not(#\\#){align-items:start}
.x1qjc9v5:not(#\\#):not(#\\#):not(#\\#){align-items:stretch}
.x1oa3qoh:not(#\\#):not(#\\#):not(#\\#){align-self:auto}
.x7fd4wk:not(#\\#):not(#\\#):not(#\\#){align-self:end}
.xl8t4ro:not(#\\#):not(#\\#):not(#\\#){animation-duration:.55s}
.xxkxylk:not(#\\#):not(#\\#):not(#\\#){animation-duration:.5s}
.x10dgwld:not(#\\#):not(#\\#):not(#\\#){animation-duration:1.15s}
.x1q41ro2:not(#\\#):not(#\\#):not(#\\#){animation-duration:11s}
.xhzpukf:not(#\\#):not(#\\#):not(#\\#){animation-duration:4.6s}
.x16zzmm9:not(#\\#):not(#\\#):not(#\\#){animation-duration:5.2s}
.xskzprw:not(#\\#):not(#\\#):not(#\\#){animation-fill-mode:backwards}
.x1u6ievf:not(#\\#):not(#\\#):not(#\\#){animation-fill-mode:both}
.x10e4vud:not(#\\#):not(#\\#):not(#\\#){animation-fill-mode:forwards}
.xa4qsjk:not(#\\#):not(#\\#):not(#\\#){animation-iteration-count:infinite}
.x181y1b3:not(#\\#):not(#\\#):not(#\\#){animation-name:x1ixh1oh-B}
.xk7vdms:not(#\\#):not(#\\#):not(#\\#){animation-name:x5ou7kv-B}
.x1sris66:not(#\\#):not(#\\#):not(#\\#){animation-name:xij6lzg-B}
.x1ugrwat:not(#\\#):not(#\\#):not(#\\#){animation-name:xqestwo-B}
.xpoaoud:not(#\\#):not(#\\#):not(#\\#){animation-name:xukdt12-B}
.x1bjh57s:not(#\\#):not(#\\#):not(#\\#){animation-name:xvnk6pr-B}
.xwk33p5:not(#\\#):not(#\\#):not(#\\#){animation-timing-function:cubic-bezier(.2,.9,.3,1.4)}
.x1qvsx5j:not(#\\#):not(#\\#):not(#\\#){animation-timing-function:cubic-bezier(.3,.6,.3,1)}
.x4hg4is:not(#\\#):not(#\\#):not(#\\#){animation-timing-function:ease-in-out}
.xa3vuyk:not(#\\#):not(#\\#):not(#\\#){animation-timing-function:ease-out}
.x1esw782:not(#\\#):not(#\\#):not(#\\#){animation-timing-function:linear}
.xjyslct:not(#\\#):not(#\\#):not(#\\#){appearance:none}
.xpivpjv:not(#\\#):not(#\\#):not(#\\#){backdrop-filter:blur(4px)}
.xbjheo3:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,currentColor 13%,transparent)}
.xxvg2ug:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-bg-deep) 64%,transparent)}
.x779uuu:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-bg-deep) 68%,transparent)}
.xe04znv:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-card-soft) 32%,transparent)}
.xgwc49v:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-card-soft) 45%,transparent)}
.xfr4rvh:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-card) 62%,transparent)}
.xiy2bcw:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-card) 88%,transparent)}
.xu2kkqm:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-err) 12%,transparent)}
.x42um7s:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-err) 15%,transparent)}
.xdo6va6:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-err) 7%,transparent)}
.x1xlsm2u:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-frame) 94%,transparent)}
.x382npu:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-text) 4%,transparent)}
.x18jj7c1:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-text) 5%,transparent)}
.x1ghvq8m:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-text) 7%,transparent)}
.x1mh3lbe:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-warn) 15%,transparent)}
.xc1c755:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-warn) 7%,transparent)}
.xtwfq29:not(#\\#):not(#\\#):not(#\\#){background-color:currentColor}
.xjbqb8w:not(#\\#):not(#\\#):not(#\\#){background-color:transparent}
.x9kxhyz:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-accent-soft)}
.x15vqgvx:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-accent)}
.xlt2929:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-bg-deep)}
.xec3sqm:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-bg)}
.xbslqsl:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-card-soft)}
.x18s3upu:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-card)}
.x1dd94t5:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-frame)}
.x153t6mt:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-ok-soft)}
.x1wztykf:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-ok)}
.x3ee1ji:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-rule-strong)}
.xg47p5g:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-rule)}
.xyo362y:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-text-dim)}
.xcovpgk:not(#\\#):not(#\\#):not(#\\#){background-image:linear-gradient(135deg,color-mix(in srgb,var(--console-text) 2.5%,transparent),transparent 48%)}
.x6dee8v:not(#\\#):not(#\\#):not(#\\#){background-image:linear-gradient(135deg,var(--console-ok-soft),transparent 55%)}
.xesruxm:not(#\\#):not(#\\#):not(#\\#){background-image:linear-gradient(180deg,color-mix(in srgb,var(--console-card-soft) 42%,transparent),color-mix(in srgb,var(--console-frame) 52%,transparent))}
.x18wh80x:not(#\\#):not(#\\#):not(#\\#){background-image:linear-gradient(45deg,transparent 50%,var(--console-text-muted) 50%),linear-gradient(135deg,var(--console-text-muted) 50%,transparent 50%)}
.x1jfd41i:not(#\\#):not(#\\#):not(#\\#){background-image:linear-gradient(color-mix(in srgb,var(--console-secondary) 4%,transparent) 1px,transparent 1px),linear-gradient(90deg,color-mix(in srgb,var(--console-secondary) 4%,transparent) 1px,transparent 1px)}
.x1fk7bw7:not(#\\#):not(#\\#):not(#\\#){background-image:radial-gradient(circle at 36% 50%,color-mix(in srgb,var(--console-accent) 7%,transparent),transparent 32%),radial-gradient(circle at 58% 42%,color-mix(in srgb,var(--console-secondary) 13%,transparent),transparent 36%)}
.xnhfnza:not(#\\#):not(#\\#):not(#\\#){background-image:radial-gradient(circle at center,transparent 0 30%,var(--console-card-soft) 100%)}
.xiy17q3:not(#\\#):not(#\\#):not(#\\#){background-repeat:no-repeat}
.xopnk0n:not(#\\#):not(#\\#):not(#\\#){background-size:48px 48px}
.x6khlng:not(#\\#):not(#\\#):not(#\\#){background-size:5px 5px,5px 5px}
.x1mwwwfo:not(#\\#):not(#\\#):not(#\\#){border-collapse:collapse}
.xzvbwyp:not(#\\#):not(#\\#):not(#\\#){box-shadow:0 0 0 3px var(--console-bg-deep),0 0 0 4.5px color-mix(in srgb,currentColor 50%,transparent),0 0 16px 4px color-mix(in srgb,currentColor 55%,transparent)}
.xh2qvui:not(#\\#):not(#\\#):not(#\\#){box-shadow:0 0 0 5px color-mix(in srgb,currentColor 9%,transparent)}
.xohzo4b:not(#\\#):not(#\\#):not(#\\#){box-shadow:0 0 10px 1px color-mix(in srgb,currentColor 45%,transparent)}
.x11svnkv:not(#\\#):not(#\\#):not(#\\#){box-shadow:0 0 14px currentColor}
.xkeuntj:not(#\\#):not(#\\#):not(#\\#){box-shadow:0 0 28px color-mix(in srgb,var(--console-ok) 9%,transparent)}
.x17y309f:not(#\\#):not(#\\#):not(#\\#){box-shadow:0 0 7px color-mix(in srgb,currentColor 60%,transparent)}
.x1b33ckz:not(#\\#):not(#\\#):not(#\\#){box-shadow:0 0 7px color-mix(in srgb,currentColor 70%,transparent)}
.x1qk4p91:not(#\\#):not(#\\#):not(#\\#){box-shadow:0 18px 48px -22px var(--console-shadow-ink,color-mix(in srgb,var(--console-bg-deep) 76%,transparent))}
.xkv9d8c:not(#\\#):not(#\\#):not(#\\#){box-shadow:0 30px 70px -30px rgba(0,0,0,.8)}
.x1b3fvf2:not(#\\#):not(#\\#):not(#\\#){box-shadow:0 32px 80px -28px var(--console-shadow-ink,color-mix(in srgb,var(--console-bg-deep) 72%,transparent))}
.x1mpwnwh:not(#\\#):not(#\\#):not(#\\#){box-shadow:inset 0 0 0 1px var(--console-rule)}
.x1yrie1r:not(#\\#):not(#\\#):not(#\\#){box-shadow:inset 0 2px 24px rgba(0,0,0,.5)}
.xfv7mty:not(#\\#):not(#\\#):not(#\\#){box-shadow:inset 2px 0 0 var(--console-accent)}
.x1gnnqk1:not(#\\#):not(#\\#):not(#\\#){box-shadow:none}
.x9f619:not(#\\#):not(#\\#):not(#\\#){box-sizing:border-box}
.x1gj8qfm:not(#\\#):not(#\\#):not(#\\#){clip-path:none}
.x15rks2t:not(#\\#):not(#\\#):not(#\\#){color:currentColor}
.x1heor9g:not(#\\#):not(#\\#):not(#\\#){color:inherit}
.x1myn341:not(#\\#):not(#\\#):not(#\\#){color:var(--console-accent)}
.x1mel2pz:not(#\\#):not(#\\#):not(#\\#){color:var(--console-err)}
.x19k5i5u:not(#\\#):not(#\\#):not(#\\#){color:var(--console-ok)}
.x1um1dla:not(#\\#):not(#\\#):not(#\\#){color:var(--console-on-accent)}
.x724ina:not(#\\#):not(#\\#):not(#\\#){color:var(--console-secondary)}
.xgi1xjn:not(#\\#):not(#\\#):not(#\\#){color:var(--console-text-dim)}
.x1v3krkk:not(#\\#):not(#\\#):not(#\\#){color:var(--console-text-faint)}
.x1ar3pfp:not(#\\#):not(#\\#):not(#\\#){color:var(--console-text-muted)}
.xqvuw85:not(#\\#):not(#\\#):not(#\\#){color:var(--console-text)}
.x1ra7g20:not(#\\#):not(#\\#):not(#\\#){color:var(--console-warn)}
.x1wh94ac:not(#\\#):not(#\\#):not(#\\#){column-gap:40px}
.xmzwrfy:not(#\\#):not(#\\#):not(#\\#){container-name:operator-aside}
.x17il9kl:not(#\\#):not(#\\#):not(#\\#){container-name:operator-cell}
.xzxxqnc:not(#\\#):not(#\\#):not(#\\#){container-name:operator-matrix}
.xdy16ns:not(#\\#):not(#\\#):not(#\\#){container-name:operator-panel}
.x1foj65r:not(#\\#):not(#\\#):not(#\\#){container-name:operator}
.x12h1iku:not(#\\#):not(#\\#):not(#\\#){container-type:inline-size}
.xt0e3qv:not(#\\#):not(#\\#):not(#\\#){cursor:default}
.x1ypdohk:not(#\\#):not(#\\#):not(#\\#){cursor:pointer}
.x104kibb:not(#\\#):not(#\\#):not(#\\#){display:-webkit-box}
.x1lliihq:not(#\\#):not(#\\#):not(#\\#){display:block}
.x78zum5:not(#\\#):not(#\\#):not(#\\#){display:flex}
.xrvj5dj:not(#\\#):not(#\\#):not(#\\#){display:grid}
.x1rg5ohu:not(#\\#):not(#\\#):not(#\\#){display:inline-block}
.x3nfvp2:not(#\\#):not(#\\#):not(#\\#){display:inline-flex}
.xwz0xwf:not(#\\#):not(#\\#):not(#\\#){display:inline-grid}
.xtcx8v3:not(#\\#):not(#\\#):not(#\\#){display:list-item}
.x1s85apg:not(#\\#):not(#\\#):not(#\\#){display:none}
.xf5m44m:not(#\\#):not(#\\#):not(#\\#){display:table-row}
.x63ly0w:not(#\\#):not(#\\#):not(#\\#){fill:color-mix(in srgb,var(--console-accent) 5%,transparent)}
.x1rw6qo9:not(#\\#):not(#\\#):not(#\\#){fill:color-mix(in srgb,var(--console-accent) 72%,transparent)}
.x6p09lz:not(#\\#):not(#\\#):not(#\\#){fill:color-mix(in srgb,var(--console-secondary) 2.5%,transparent)}
.xjo5mhf:not(#\\#):not(#\\#):not(#\\#){fill:color-mix(in srgb,var(--console-secondary) 4%,transparent)}
.x1sgapc2:not(#\\#):not(#\\#):not(#\\#){fill:color-mix(in srgb,var(--console-secondary) 6%,transparent)}
.xbh8q5q:not(#\\#):not(#\\#):not(#\\#){fill:none}
.xy6m8k3:not(#\\#):not(#\\#):not(#\\#){fill:transparent}
.xgeoyvb:not(#\\#):not(#\\#):not(#\\#){fill:var(--console-accent-soft)}
.x8eu9n:not(#\\#):not(#\\#):not(#\\#){fill:var(--console-accent)}
.xp8jjoe:not(#\\#):not(#\\#):not(#\\#){fill:var(--console-err)}
.x1s7eawt:not(#\\#):not(#\\#):not(#\\#){fill:var(--console-ok)}
.x1gohjtw:not(#\\#):not(#\\#):not(#\\#){fill:var(--console-secondary)}
.x1r5g2pm:not(#\\#):not(#\\#):not(#\\#){fill:var(--console-text-dim)}
.xgpbuzi:not(#\\#):not(#\\#):not(#\\#){fill:var(--console-text-faint)}
.x1h8g7wf:not(#\\#):not(#\\#):not(#\\#){fill:var(--console-text-muted)}
.x1v1fulq:not(#\\#):not(#\\#):not(#\\#){fill:var(--console-warn)}
.x1gy9feu:not(#\\#):not(#\\#):not(#\\#){filter:drop-shadow(0 0 7px var(--console-accent))}
.x1l7klhg:not(#\\#):not(#\\#):not(#\\#){flex-basis:100%}
.xdl72j9:not(#\\#):not(#\\#):not(#\\#){flex-basis:auto}
.x3ieub6:not(#\\#):not(#\\#):not(#\\#){flex-direction:column-reverse}
.xdt5ytf:not(#\\#):not(#\\#):not(#\\#){flex-direction:column}
.x1q0g3np:not(#\\#):not(#\\#):not(#\\#){flex-direction:row}
.x2lah0s:not(#\\#):not(#\\#):not(#\\#){flex-shrink:0}
.xozqiw3:not(#\\#):not(#\\#):not(#\\#){flex-wrap:nowrap}
.x1a02dak:not(#\\#):not(#\\#):not(#\\#){flex-wrap:wrap}
.x18mqm2i:not(#\\#):not(#\\#):not(#\\#){float:right}
.xjb2p0i:not(#\\#):not(#\\#):not(#\\#){font-family:inherit}
.xssy22x:not(#\\#):not(#\\#):not(#\\#){font-family:var(--console-display)}
.xa9opjo:not(#\\#):not(#\\#):not(#\\#){font-family:var(--console-mono)}
.x5ddh9m:not(#\\#):not(#\\#):not(#\\#){font-family:var(--console-ui)}
.xv6m45y:not(#\\#):not(#\\#):not(#\\#){font-family:var(--operator-section-family,var(--console-mono))}
.x2hta5a:not(#\\#):not(#\\#):not(#\\#){font-family:var(--operator-section-family,var(--console-ui))}
.x1s31vzs:not(#\\#):not(#\\#):not(#\\#){font-size:10.5px}
.x1k6wstc:not(#\\#):not(#\\#):not(#\\#){font-size:10px}
.x1qt5hsa:not(#\\#):not(#\\#):not(#\\#){font-size:11.5px}
.x1j6dyjg:not(#\\#):not(#\\#):not(#\\#){font-size:11px}
.x1ct8sxb:not(#\\#):not(#\\#):not(#\\#){font-size:12.5px}
.xfifm61:not(#\\#):not(#\\#):not(#\\#){font-size:12px}
.x2ouz8m:not(#\\#):not(#\\#):not(#\\#){font-size:13.5px}
.x4z9k3i:not(#\\#):not(#\\#):not(#\\#){font-size:13px}
.xif65rj:not(#\\#):not(#\\#):not(#\\#){font-size:14px}
.x1jvydc1:not(#\\#):not(#\\#):not(#\\#){font-size:15px}
.x1j61zf2:not(#\\#):not(#\\#):not(#\\#){font-size:16px}
.x19d36u7:not(#\\#):not(#\\#):not(#\\#){font-size:17px}
.xosj86m:not(#\\#):not(#\\#):not(#\\#){font-size:18px}
.x1q7jzdg:not(#\\#):not(#\\#):not(#\\#){font-size:19px}
.xwsyq91:not(#\\#):not(#\\#):not(#\\#){font-size:20px}
.x1i1m3gp:not(#\\#):not(#\\#):not(#\\#){font-size:22px}
.x5heo1l:not(#\\#):not(#\\#):not(#\\#){font-size:23px}
.x1pvqxga:not(#\\#):not(#\\#):not(#\\#){font-size:24px}
.x3vlhr4:not(#\\#):not(#\\#):not(#\\#){font-size:27px}
.xneq65o:not(#\\#):not(#\\#):not(#\\#){font-size:28px}
.x1m6oxru:not(#\\#):not(#\\#):not(#\\#){font-size:34px}
.x155jak9:not(#\\#):not(#\\#):not(#\\#){font-size:38px}
.x6ijxsv:not(#\\#):not(#\\#):not(#\\#){font-size:7px}
.xlp3en2:not(#\\#):not(#\\#):not(#\\#){font-size:8.5px}
.xdzlmae:not(#\\#):not(#\\#):not(#\\#){font-size:8px}
.xfmn3hh:not(#\\#):not(#\\#):not(#\\#){font-size:9.5px}
.xvwhms9:not(#\\#):not(#\\#):not(#\\#){font-size:9px}
.x1qlqyl8:not(#\\#):not(#\\#):not(#\\#){font-size:inherit}
.x1vz2964:not(#\\#):not(#\\#):not(#\\#){font-size:var(--operator-eyebrow-size,9.5px)}
.x121jh6c:not(#\\#):not(#\\#):not(#\\#){font-size:var(--operator-eyebrow-size,9px)}
.xswp564:not(#\\#):not(#\\#):not(#\\#){font-size:var(--operator-secondary-size,28px)}
.x125tp1q:not(#\\#):not(#\\#):not(#\\#){font-size:var(--operator-section-size,14px)}
.x4nd1th:not(#\\#):not(#\\#):not(#\\#){font-size:var(--operator-section-size,9.5px)}
.x1k4tb9n:not(#\\#):not(#\\#):not(#\\#){font-style:italic}
.x1j61x8r:not(#\\#):not(#\\#):not(#\\#){font-style:normal}
.xj8fevo:not(#\\#):not(#\\#):not(#\\#){font-variant-numeric:normal}
.x1j4x3al:not(#\\#):not(#\\#):not(#\\#){font-variant-numeric:tabular-nums lining-nums}
.xss6m8b:not(#\\#):not(#\\#):not(#\\#){font-variant-numeric:tabular-nums}
.xo5mvrd:not(#\\#):not(#\\#):not(#\\#){font-variation-settings:"opsz" 72,"SOFT" 20}
.x62unnn:not(#\\#):not(#\\#):not(#\\#){font-variation-settings:"SOFT" 100,"opsz" 72}
.x1nymx6x:not(#\\#):not(#\\#):not(#\\#){font-variation-settings:"SOFT" 35,"opsz" 58}
.xfl3al2:not(#\\#):not(#\\#):not(#\\#){font-variation-settings:"SOFT" 35}
.x1nqv8xj:not(#\\#):not(#\\#):not(#\\#){font-variation-settings:"SOFT" 40}
.xkhxzli:not(#\\#):not(#\\#):not(#\\#){font-variation-settings:"SOFT" 70,"opsz" 40}
.x1umjory:not(#\\#):not(#\\#):not(#\\#){font-variation-settings:"SOFT" 70,"opsz" 48}
.x17owtcr:not(#\\#):not(#\\#):not(#\\#){font-variation-settings:"SOFT" 70,"opsz" 60}
.x3n8r9z:not(#\\#):not(#\\#):not(#\\#){font-variation-settings:"SOFT" 80,"opsz" 72}
.xo1l8bm:not(#\\#):not(#\\#):not(#\\#){font-weight:400}
.x17xjjk:not(#\\#):not(#\\#):not(#\\#){font-weight:430}
.xo1h6xc:not(#\\#):not(#\\#):not(#\\#){font-weight:460}
.x184j2wm:not(#\\#):not(#\\#):not(#\\#){font-weight:470}
.xk50ysn:not(#\\#):not(#\\#):not(#\\#){font-weight:500}
.x11zgcw:not(#\\#):not(#\\#):not(#\\#){font-weight:520}
.xh88oxj:not(#\\#):not(#\\#):not(#\\#){font-weight:550}
.xmvyi9x:not(#\\#):not(#\\#):not(#\\#){font-weight:560}
.xlpn31b:not(#\\#):not(#\\#):not(#\\#){font-weight:570}
.xseu7c4:not(#\\#):not(#\\#):not(#\\#){font-weight:580}
.x1s688f:not(#\\#):not(#\\#):not(#\\#){font-weight:600}
.x1im5e5j:not(#\\#):not(#\\#):not(#\\#){font-weight:620}
.x19s9jnd:not(#\\#):not(#\\#):not(#\\#){font-weight:650}
.x1xlr1w8:not(#\\#):not(#\\#):not(#\\#){font-weight:700}
.x1pd3egz:not(#\\#):not(#\\#):not(#\\#){font-weight:inherit}
.x1bgvhw5:not(#\\#):not(#\\#):not(#\\#){font-weight:var(--operator-eyebrow-weight,500)}
.x1e5oar2:not(#\\#):not(#\\#):not(#\\#){font-weight:var(--operator-secondary-weight,500)}
.xjgl48g:not(#\\#):not(#\\#):not(#\\#){font-weight:var(--operator-section-weight,500)}
.x17l7a04:not(#\\#):not(#\\#):not(#\\#){font-weight:var(--operator-section-weight,700)}
.xw1czmm:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:130px minmax(0,1fr)}
.x1pjqied:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:18px minmax(0,1fr) fit-content(30%)}
.x9ztcg1:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:52px 14px minmax(0,1fr)}
.xx9t13c:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:auto minmax(0,1fr) auto}
.x175yr4d:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:auto minmax(0,auto)}
.x1bu5on4:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,.9fr) minmax(0,1.1fr)}
.x1bf0hkk:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1.15fr) minmax(0,1fr) minmax(0,1fr) fit-content(35%)}
.x13ryq8l:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1.45fr) minmax(220px,1fr)}
.x1m2f7u7:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1.5fr) minmax(250px,.6fr)}
.x1ibodrf:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1fr) 72px 68px}
.xju1xpo:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1fr) auto}
.x1jxfsdd:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1fr) fit-content(40%)}
.x8tdwv4:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1fr) minmax(0,auto)}
.x1mkdm3x:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1fr)}
.xar548p:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,2.25fr) minmax(250px,.75fr)}
.xpr710q:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,2fr) minmax(270px,.86fr)}
.xnby9oq:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:repeat(2,minmax(0,1fr))}
.x185a7wo:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:repeat(3,minmax(0,1fr))}
.x1sipb5g:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:repeat(4,minmax(0,1fr))}
.x1g9xdvi:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:repeat(auto-fill,minmax(min(100%,220px),1fr))}
.x27jn57:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:repeat(auto-fill,minmax(min(100%,24rem),1fr))}
.x1jsv65m:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:repeat(auto-fit,minmax(min(100%,380px),1fr))}
.xp2hupy:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:repeat(auto-fit,minmax(min(128px,100%),1fr))}
.x1lelaru:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:repeat(auto-fit,minmax(min(150px,100%),1fr))}
.xc8icb0:not(#\\#):not(#\\#):not(#\\#){isolation:isolate}
.xl56j7k:not(#\\#):not(#\\#):not(#\\#){justify-content:center}
.x13a6bvl:not(#\\#):not(#\\#):not(#\\#){justify-content:flex-end}
.x1nhvcw1:not(#\\#):not(#\\#):not(#\\#){justify-content:flex-start}
.x1qughib:not(#\\#):not(#\\#):not(#\\#){justify-content:space-between}
.x4xo5sw:not(#\\#):not(#\\#):not(#\\#){justify-items:end}
.x1lqcxt8:not(#\\#):not(#\\#):not(#\\#){justify-self:start}
.x5sy3j4:not(#\\#):not(#\\#):not(#\\#){letter-spacing:-.01em}
.x1ixy4ik:not(#\\#):not(#\\#):not(#\\#){letter-spacing:-0.005em}
.xjat59b:not(#\\#):not(#\\#):not(#\\#){letter-spacing:-0.01em}
.x1xte0cv:not(#\\#):not(#\\#):not(#\\#){letter-spacing:-0.15px}
.x1eg57nh:not(#\\#):not(#\\#):not(#\\#){letter-spacing:.045em}
.x1vyo3qp:not(#\\#):not(#\\#):not(#\\#){letter-spacing:.04em}
.x2ujxvm:not(#\\#):not(#\\#):not(#\\#){letter-spacing:.05em}
.x1dgsrnt:not(#\\#):not(#\\#):not(#\\#){letter-spacing:.06em}
.xwhmn0f:not(#\\#):not(#\\#):not(#\\#){letter-spacing:.07em}
.x9pfba7:not(#\\#):not(#\\#):not(#\\#){letter-spacing:.08em}
.x1g5djsm:not(#\\#):not(#\\#):not(#\\#){letter-spacing:.09em}
.x7447wj:not(#\\#):not(#\\#):not(#\\#){letter-spacing:.12em}
.x2hcs4w:not(#\\#):not(#\\#):not(#\\#){letter-spacing:.13em}
.x1labic3:not(#\\#):not(#\\#):not(#\\#){letter-spacing:.14em}
.xa7ig63:not(#\\#):not(#\\#):not(#\\#){letter-spacing:.16em}
.x11fj6oh:not(#\\#):not(#\\#):not(#\\#){letter-spacing:.18em}
.x1dor1uw:not(#\\#):not(#\\#):not(#\\#){letter-spacing:.1em}
.x1qv67nb:not(#\\#):not(#\\#):not(#\\#){letter-spacing:.22em}
.xribhvm:not(#\\#):not(#\\#):not(#\\#){letter-spacing:.2em}
.x12oo3zp:not(#\\#):not(#\\#):not(#\\#){letter-spacing:0}
.x4gjf66:not(#\\#):not(#\\#):not(#\\#){letter-spacing:inherit}
.x1r16saa:not(#\\#):not(#\\#):not(#\\#){letter-spacing:var(--operator-eyebrow-tracking,.14em)}
.x12rpand:not(#\\#):not(#\\#):not(#\\#){letter-spacing:var(--operator-secondary-tracking,0)}
.x19vr2a4:not(#\\#):not(#\\#):not(#\\#){letter-spacing:var(--operator-section-spacing,.16em)}
.x1f41ap9:not(#\\#):not(#\\#):not(#\\#){line-height:1.05}
.x1159mfc:not(#\\#):not(#\\#):not(#\\#){line-height:1.1}
.x1uo3zyz:not(#\\#):not(#\\#):not(#\\#){line-height:1.15}
.x1u7k74:not(#\\#):not(#\\#):not(#\\#){line-height:1.2}
.xwn7fz2:not(#\\#):not(#\\#):not(#\\#){line-height:1.3}
.x1xfvgam:not(#\\#):not(#\\#):not(#\\#){line-height:1.35}
.x37zpob:not(#\\#):not(#\\#):not(#\\#){line-height:1.4}
.xfrs9s4:not(#\\#):not(#\\#):not(#\\#){line-height:1.45}
.x1evy7pa:not(#\\#):not(#\\#):not(#\\#){line-height:1.5}
.x1jjo3f5:not(#\\#):not(#\\#):not(#\\#){line-height:1.55}
.x1dbl2gt:not(#\\#):not(#\\#):not(#\\#){line-height:1.6}
.x11m8ghp:not(#\\#):not(#\\#):not(#\\#){line-height:1.65}
.xa7kkou:not(#\\#):not(#\\#):not(#\\#){line-height:1.7}
.xo5v014:not(#\\#):not(#\\#):not(#\\#){line-height:1}
.x15bjb6t:not(#\\#):not(#\\#):not(#\\#){line-height:inherit}
.xggjnk3:not(#\\#):not(#\\#):not(#\\#){line-height:normal}
.xd0avp8:not(#\\#):not(#\\#):not(#\\#){line-height:var(--operator-secondary-leading,1.3)}
.x3ct3a4:not(#\\#):not(#\\#):not(#\\#){list-style-type:none}
.xyqm7xq:not(#\\#):not(#\\#):not(#\\#){margin-inline-start:16px}
.xvc5jky:not(#\\#):not(#\\#):not(#\\#){margin-inline-start:auto}
.xao0n3f:not(#\\#):not(#\\#):not(#\\#){opacity:.13}
.x19pb5yz:not(#\\#):not(#\\#):not(#\\#){opacity:.24}
.xvpkmg4:not(#\\#):not(#\\#):not(#\\#){opacity:.25}
.x5dmra7:not(#\\#):not(#\\#):not(#\\#){opacity:.38}
.xf9vgkq:not(#\\#):not(#\\#):not(#\\#){opacity:.72}
.xg01cxk:not(#\\#):not(#\\#):not(#\\#){opacity:0}
.x1hc1fzr:not(#\\#):not(#\\#):not(#\\#){opacity:1}
.x9ek82g:not(#\\#):not(#\\#):not(#\\#){order:1}
.x14yy4lh:not(#\\#):not(#\\#):not(#\\#){order:2}
.x1itw484:not(#\\#):not(#\\#):not(#\\#){outline-color:var(--console-accent)}
.x100b2on:not(#\\#):not(#\\#):not(#\\#){outline-color:var(--console-rule-accent)}
.x2ssjo2:not(#\\#):not(#\\#):not(#\\#){outline-offset:-2px}
.xr2mjdv:not(#\\#):not(#\\#):not(#\\#){outline-offset:-4px}
.x1hl8ikr:not(#\\#):not(#\\#):not(#\\#){outline-offset:2px}
.x8wkva7:not(#\\#):not(#\\#):not(#\\#){outline-offset:6px}
.x1t137rt:not(#\\#):not(#\\#):not(#\\#){outline-style:none}
.xaatb59:not(#\\#):not(#\\#):not(#\\#){outline-style:solid}
.x1k57tk5:not(#\\#):not(#\\#):not(#\\#){outline-width:0}
.x1de99jn:not(#\\#):not(#\\#):not(#\\#){outline-width:2px}
.xj0a0fe:not(#\\#):not(#\\#):not(#\\#){overflow-wrap:anywhere}
.x1mzt3pk:not(#\\#):not(#\\#):not(#\\#){overflow-wrap:break-word}
.xsjhqdm:not(#\\#):not(#\\#):not(#\\#){overscroll-behavior-inline:auto}
.x1pqk8vl:not(#\\#):not(#\\#):not(#\\#){overscroll-behavior-inline:contain}
.x5zjp28:not(#\\#):not(#\\#):not(#\\#){padding-inline-end:30px}
.xsfy40s:not(#\\#):not(#\\#):not(#\\#){padding-inline-end:32px}
.x162tt16:not(#\\#):not(#\\#):not(#\\#){padding-inline-start:30px}
.x1x0jnz8:not(#\\#):not(#\\#):not(#\\#){paint-order:stroke}
.x10l6tqk:not(#\\#):not(#\\#):not(#\\#){position:absolute}
.xixxii4:not(#\\#):not(#\\#):not(#\\#){position:fixed}
.x1n2onr6:not(#\\#):not(#\\#):not(#\\#){position:relative}
.x1uhb9sk:not(#\\#):not(#\\#):not(#\\#){position:static}
.x288g5:not(#\\#):not(#\\#):not(#\\#){resize:vertical}
.xosa0jh:not(#\\#):not(#\\#):not(#\\#){scrollbar-width:auto}
.x1rohswg:not(#\\#):not(#\\#):not(#\\#){scrollbar-width:none}
.xnq1ati:not(#\\#):not(#\\#):not(#\\#){stroke-dasharray:1}
.xbw2l0c:not(#\\#):not(#\\#):not(#\\#){stroke-dasharray:2 2}
.x1gjz8bi:not(#\\#):not(#\\#):not(#\\#){stroke-dasharray:2 7}
.x10ozs9j:not(#\\#):not(#\\#):not(#\\#){stroke-dasharray:3 7}
.xl9zam1:not(#\\#):not(#\\#):not(#\\#){stroke-dasharray:4 6}
.x1b0q7pt:not(#\\#):not(#\\#):not(#\\#){stroke-dasharray:4 7}
.xaiuoaf:not(#\\#):not(#\\#):not(#\\#){stroke-dashoffset:1}
.x1owpc8m:not(#\\#):not(#\\#):not(#\\#){stroke-linecap:round}
.x160jiv6:not(#\\#):not(#\\#):not(#\\#){stroke-opacity:.22}
.xbu8dtm:not(#\\#):not(#\\#):not(#\\#){stroke-opacity:.23}
.x1jxw0no:not(#\\#):not(#\\#):not(#\\#){stroke-opacity:.24}
.xnh1ke0:not(#\\#):not(#\\#):not(#\\#){stroke-opacity:.34}
.xif8wax:not(#\\#):not(#\\#):not(#\\#){stroke-opacity:.48}
.x17z8gs:not(#\\#):not(#\\#):not(#\\#){stroke-width:.7}
.xunsu2d:not(#\\#):not(#\\#):not(#\\#){stroke-width:.8}
.x17oo0nu:not(#\\#):not(#\\#):not(#\\#){stroke-width:.85}
.x17mlvpq:not(#\\#):not(#\\#):not(#\\#){stroke-width:.9}
.x1dt3t4y:not(#\\#):not(#\\#):not(#\\#){stroke-width:1.2}
.xhr4kjn:not(#\\#):not(#\\#):not(#\\#){stroke-width:1.5}
.xnpr05h:not(#\\#):not(#\\#):not(#\\#){stroke-width:1}
.xqjr0vm:not(#\\#):not(#\\#):not(#\\#){stroke-width:3}
.x17ld789:not(#\\#):not(#\\#):not(#\\#){stroke-width:4}
.x1mjy2a4:not(#\\#):not(#\\#):not(#\\#){stroke:color-mix(in srgb,var(--console-warn) 70%,white)}
.x1jgmy94:not(#\\#):not(#\\#):not(#\\#){stroke:var(--console-bg-deep)}
.xdez00i:not(#\\#):not(#\\#):not(#\\#){stroke:var(--console-ok)}
.x4vhfi8:not(#\\#):not(#\\#):not(#\\#){stroke:var(--console-rule-strong)}
.x1qq6ajq:not(#\\#):not(#\\#):not(#\\#){stroke:var(--console-secondary)}
.x1n4f4kz:not(#\\#):not(#\\#):not(#\\#){stroke:var(--console-text-dim)}
.xnbuhn4:not(#\\#):not(#\\#):not(#\\#){stroke:var(--console-warn)}
.x2b8uid:not(#\\#):not(#\\#):not(#\\#){text-align:center}
.x16tdsg8:not(#\\#):not(#\\#):not(#\\#){text-align:inherit}
.xdpxx8g:not(#\\#):not(#\\#):not(#\\#){text-align:left}
.x1hr2gdg:not(#\\#):not(#\\#):not(#\\#){text-align:right}
.x1yc453h:not(#\\#):not(#\\#):not(#\\#){text-align:start}
.x1ua538i:not(#\\#):not(#\\#):not(#\\#){text-decoration-color:var(--console-rule-accent)}
.xkrqix3:not(#\\#):not(#\\#):not(#\\#){text-decoration-line:none}
.xlyipyv:not(#\\#):not(#\\#):not(#\\#){text-overflow:ellipsis}
.x5ftkge:not(#\\#):not(#\\#):not(#\\#){text-transform:inherit}
.x1kyqaxf:not(#\\#):not(#\\#):not(#\\#){text-transform:lowercase}
.x6mezaz:not(#\\#):not(#\\#):not(#\\#){text-transform:none}
.xtvhhri:not(#\\#):not(#\\#):not(#\\#){text-transform:uppercase}
.xel79qc:not(#\\#):not(#\\#):not(#\\#){text-transform:var(--operator-section-transform,uppercase)}
.xda060z:not(#\\#):not(#\\#):not(#\\#){text-underline-offset:3px}
.x1764fhq:not(#\\#):not(#\\#):not(#\\#){transform-box:fill-box}
.x1g0ag68:not(#\\#):not(#\\#):not(#\\#){transform-origin:center}
.x1c071of:not(#\\#):not(#\\#):not(#\\#){transform:none}
.x1omdec3:not(#\\#):not(#\\#):not(#\\#){transform:scale(1.5)}
.x3oybdh:not(#\\#):not(#\\#):not(#\\#){transform:scale(1)}
.x11lhmoz:not(#\\#):not(#\\#):not(#\\#){transform:translate(-50%,-50%)}
.xbryuvx:not(#\\#):not(#\\#):not(#\\#){transform:translateX(0)}
.x1uqg51p:not(#\\#):not(#\\#):not(#\\#){transform:translateY(-1px)}
.xavs3du:not(#\\#):not(#\\#):not(#\\#){transform:translateY(1px)}
.xgdialr:not(#\\#):not(#\\#):not(#\\#){transition-duration:.12s}
.xx6bhzk:not(#\\#):not(#\\#):not(#\\#){transition-duration:.15s}
.x13dflua:not(#\\#):not(#\\#):not(#\\#){transition-duration:.2s}
.x1eaenvl:not(#\\#):not(#\\#):not(#\\#){transition-property:background-color,border-color,color}
.x106061f:not(#\\#):not(#\\#):not(#\\#){transition-property:background-color,box-shadow}
.x15406qy:not(#\\#):not(#\\#):not(#\\#){transition-property:background-color}
.x163lptb:not(#\\#):not(#\\#):not(#\\#){transition-property:border-color,background-color,color}
.xrf8owv:not(#\\#):not(#\\#):not(#\\#){transition-property:color,border-color}
.xt3l3uh:not(#\\#):not(#\\#):not(#\\#){transition-property:color}
.x1mz1wvm:not(#\\#):not(#\\#):not(#\\#){transition-property:opacity,color}
.x11xpdln:not(#\\#):not(#\\#):not(#\\#){transition-property:transform}
.xwji4o3:not(#\\#):not(#\\#):not(#\\#){transition-timing-function:ease}
.x87ps6o:not(#\\#):not(#\\#):not(#\\#){user-select:none}
.x13efnbd:not(#\\#):not(#\\#):not(#\\#){vector-effect:non-scaling-stroke}
.xiygsch:not(#\\#):not(#\\#):not(#\\#){vertical-align:1px}
.xxymvpz:not(#\\#):not(#\\#):not(#\\#){vertical-align:middle}
.x16dsc37:not(#\\#):not(#\\#):not(#\\#){vertical-align:top}
.xeaf4i8:not(#\\#):not(#\\#):not(#\\#){white-space:normal}
.xuxw1ft:not(#\\#):not(#\\#):not(#\\#){white-space:nowrap}
.x1fj9vlw:not(#\\#):not(#\\#):not(#\\#){white-space:pre-line}
.x126k92a:not(#\\#):not(#\\#):not(#\\#){white-space:pre-wrap}
.x1vjfegm:not(#\\#):not(#\\#):not(#\\#){z-index:1}
.xfo81ep:not(#\\#):not(#\\#):not(#\\#){z-index:1000}
.x1bkdxzg:not(#\\#):not(#\\#):not(#\\#){z-index:1001}
.xp6lfbs:not(#\\#):not(#\\#):not(#\\#){z-index:1100}
.xhtitgo:not(#\\#):not(#\\#):not(#\\#){z-index:2}
.xzkaem6:not(#\\#):not(#\\#):not(#\\#){z-index:3}
.xat1s67.xat1s67:where(.x-default-marker:hover *):not(#\\#):not(#\\#):not(#\\#){color:var(--console-accent)}
.xozkggm.xozkggm:where(.x-default-marker:hover *):not(#\\#):not(#\\#):not(#\\#){transform:translate(2px,-1px)}
.x156vuz7:is([aria-selected="true"],[aria-pressed="true"]):not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-card-soft) 55%,transparent)}
.xpalnk2:is([data-timeline-active]):not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-accent-soft)}
.x1n1caiv:is([data-state='checked']):not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-accent)}
.xn4j7m4:is([data-status=active] > *, [data-status=complete] > *):not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-accent)}
.xvs6z26:hover:not(:disabled):not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-accent)}
.x1amwds0:is([data-status=failed] > *):not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-err)}
.x1bguay0:is([data-state='checked']):not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-on-accent)}
.x1foxddj:focus-visible:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-secondary-soft)}
.x7u1vw9:is([aria-pressed="true"]):not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-secondary-soft)}
.xxhr8im:is([aria-selected="true"],[aria-pressed="true"]):not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-text)}
.x1uqgcet:focus-visible:not(#\\#):not(#\\#):not(#\\#){box-shadow:-10px 0 0 var(--console-accent)}
.x1xyv72o:is([data-timeline-active]):not(#\\#):not(#\\#):not(#\\#){box-shadow:-8px 0 0 var(--console-accent-soft),8px 0 0 var(--console-accent-soft)}
.x1o00wks:focus-visible:not(#\\#):not(#\\#):not(#\\#){box-shadow:0 0 0 3px color-mix(in srgb,var(--console-accent) 18%,transparent)}
.x1x9skyz:focus-visible:not(#\\#):not(#\\#):not(#\\#){box-shadow:0 0 0 3px color-mix(in srgb,var(--console-accent) 20%,transparent)}
.x8a9xbt:focus-visible:not(#\\#):not(#\\#):not(#\\#){box-shadow:0 0 0 3px color-mix(in srgb,var(--console-accent) 24%,transparent)}
.x1a2sn02:focus-visible:not(#\\#):not(#\\#):not(#\\#){box-shadow:0 0 0 3px color-mix(in srgb,var(--console-accent) 28%,transparent)}
.xfmqteo:focus-visible:not(#\\#):not(#\\#):not(#\\#){box-shadow:0 0 0 3px color-mix(in srgb,var(--console-err) 24%,transparent)}
.xyx7rhw:is([data-status=active] > *):not(#\\#):not(#\\#):not(#\\#){box-shadow:0 0 0 3px var(--console-accent-soft)}
.x13hqkim:is([data-climate="paper"] *):not(#\\#):not(#\\#):not(#\\#){box-shadow:0 22px 40px -28px rgba(90,60,20,.28)}
.x18rpbmq:focus-visible:not(#\\#):not(#\\#):not(#\\#){box-shadow:inset 0 0 0 2px color-mix(in srgb,var(--console-accent) 35%,transparent)}
.x1m85y3v:is([data-climate="paper"] *):not(#\\#):not(#\\#):not(#\\#){box-shadow:inset 0 2px 18px rgba(90,60,20,.22)}
.x1r2bfix:focus-visible:not(#\\#):not(#\\#):not(#\\#){color:var(--console-accent)}
.x1s1kr4f:is([aria-pressed="true"], [data-ui-spatial-related-active]):not(#\\#):not(#\\#):not(#\\#){color:var(--console-accent)}
.x1mvgbya:is([data-tone="error"]):not(#\\#):not(#\\#):not(#\\#){color:var(--console-err)}
.x1vjhw47:is([data-status=failed] > *):not(#\\#):not(#\\#):not(#\\#){color:var(--console-err)}
.x2y8ynj:is([aria-selected="true"],[aria-pressed="true"]):not(#\\#):not(#\\#):not(#\\#){color:var(--console-frame)}
.xh9rmbx:is([data-tone="good"]):not(#\\#):not(#\\#):not(#\\#){color:var(--console-ok)}
.x1ezoiy0.x1ezoiy0:where(.x-default-marker:is([aria-selected="true"],[aria-pressed="true"]) *):not(#\\#):not(#\\#):not(#\\#){color:var(--console-text-dim)}
.x1lza6gs.x1lza6gs:where(.x-default-marker[aria-selected="true"] *):not(#\\#):not(#\\#):not(#\\#){color:var(--console-text-dim)}
.x1ibo89m:is([data-placeholder]):not(#\\#):not(#\\#):not(#\\#){color:var(--console-text-muted)}
.x1kxcxhl:focus-visible:not(#\\#):not(#\\#):not(#\\#){color:var(--console-text)}
.x72d8q6:is([data-state='active']):not(#\\#):not(#\\#):not(#\\#){color:var(--console-text)}
.x8bb6ue:is([aria-pressed="true"]):not(#\\#):not(#\\#):not(#\\#){color:var(--console-text)}
.xa4mcpc:is([aria-selected="true"],[aria-pressed="true"]):not(#\\#):not(#\\#):not(#\\#){color:var(--console-text)}
.xivsve2:is([aria-selected="true"]):not(#\\#):not(#\\#):not(#\\#){color:var(--console-text)}
.xn6wv7h:is([data-status=active] > *, [data-status=complete] > *):not(#\\#):not(#\\#):not(#\\#){color:var(--console-text)}
.x16a6thm:is([data-tone="warn"]):not(#\\#):not(#\\#):not(#\\#){color:var(--console-warn)}
.x1vkqd3q:is([aria-selected="true"],[aria-pressed="true"]):not(#\\#):not(#\\#):not(#\\#){color:var(--console-warn)}
.x1lp4ypu:is([data-ui-tabs-active] *):not(#\\#):not(#\\#):not(#\\#){display:none}
.xbckst3:is([data-operator-card-body] *):not(#\\#):not(#\\#):not(#\\#){display:none}
.xvgho8r:is([hidden]):not(#\\#):not(#\\#):not(#\\#){display:none}
.x126iy1i.x126iy1i:where(.x-default-marker[data-map-active="true"] *):not(#\\#):not(#\\#):not(#\\#){fill:color-mix(in srgb,var(--console-secondary) 6.5%,transparent)}
.xs9z77v:is([data-operator-blocks] > [data-block=links] *):not(#\\#):not(#\\#):not(#\\#){font-size:12.5px}
.xxdvuf2:is([aria-selected="true"],[aria-pressed="true"]):not(#\\#):not(#\\#):not(#\\#){font-weight:500}
.x1q3wkif:is([data-columns="2"]):not(#\\#):not(#\\#):not(#\\#){grid-template-columns:repeat(2,minmax(0,1fr))}
.x1w43bmf:is([data-operator-card-body] *):not(#\\#):not(#\\#):not(#\\#){grid-template-columns:repeat(2,minmax(0,1fr))}
.x1gbo546:is([data-columns="3"]):not(#\\#):not(#\\#):not(#\\#){grid-template-columns:repeat(3,minmax(0,1fr))}
.xkyyx2n:is([data-columns="4"]):not(#\\#):not(#\\#):not(#\\#){grid-template-columns:repeat(4,minmax(0,1fr))}
.x64nxkd:is([data-ui-spatial-active] *):not([aria-pressed="true"]):not([data-ui-spatial-related-active]):not(#\\#):not(#\\#):not(#\\#){opacity:.3}
.x1k4xm7o:is([data-disabled]):not(#\\#):not(#\\#):not(#\\#){opacity:.45}
.xxh1od1:focus-visible:not(#\\#):not(#\\#):not(#\\#){outline-color:var(--console-accent)}
.x7s97pk:focus-visible:not(#\\#):not(#\\#):not(#\\#){outline-offset:2px}
.x9v5kkp:focus-visible:not(#\\#):not(#\\#):not(#\\#){outline-style:solid}
.x4xl6zf:focus-visible:not(#\\#):not(#\\#):not(#\\#){outline-width:1px}
.xiaifju:is([aria-pressed="true"], [data-ui-spatial-related-active]):not(#\\#):not(#\\#):not(#\\#){outline-width:1px}
.x784prv:focus-visible:not(#\\#):not(#\\#):not(#\\#){outline-width:2px}
.xye1tj0:is([data-disabled]):not(#\\#):not(#\\#):not(#\\#){pointer-events:none}
.x1umrh6z.x1umrh6z:where(.x-default-marker[data-map-active="true"] *):not(#\\#):not(#\\#):not(#\\#){stroke-opacity:.58}
.xgw5xlg:is([data-tone="good"]):not(#\\#):not(#\\#):not(#\\#){stroke:var(--console-ok)}
.xgcfudb:is([data-tone="warn"]):not(#\\#):not(#\\#):not(#\\#){stroke:var(--console-warn)}
.x1ffr0y8:is([data-align="center"]):not(#\\#):not(#\\#):not(#\\#){text-align:center}
.xpebyx1:is([data-align="end"]):not(#\\#):not(#\\#):not(#\\#){text-align:right}
.x1kobeir:is(:hover > *):not(#\\#):not(#\\#):not(#\\#){transform:scale(1.35)}
.xu021ln:is([data-state='checked']):not(#\\#):not(#\\#):not(#\\#){transform:translateX(18px)}
.x1nlf60j:hover:not(:disabled):not(#\\#):not(#\\#):not(#\\#){transform:translateY(-1px)}
.x110e2yq:is([aria-pressed="true"], [data-ui-spatial-related-active]):not(#\\#):not(#\\#):not(#\\#){z-index:4}
.x1qm06za:focus-visible:not(#\\#):not(#\\#):not(#\\#){z-index:4}
.x79gikr:has(> details[open]):not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1fr)}
.xokuw57:has([data-row-link]:focus-visible):not(#\\#):not(#\\#):not(#\\#){outline-style:solid}
.xbd3v37:first-child:not(#\\#):not(#\\#):not(#\\#){color:var(--console-text)}
.xq648tx:first-child:not(#\\#):not(#\\#):not(#\\#){font-size:14px}
.xsnqk1y:first-child:not(#\\#):not(#\\#):not(#\\#){font-weight:500}
.x163vtw:disabled:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-card-soft)}
.x1bi1fg1:disabled:not(#\\#):not(#\\#):not(#\\#){color:var(--console-text-muted)}
.x1s07b3s:disabled:not(#\\#):not(#\\#):not(#\\#){cursor:not-allowed}
.xijokvz:disabled:not(#\\#):not(#\\#):not(#\\#){opacity:.5}
.xk0mbs4:disabled:not(#\\#):not(#\\#):not(#\\#){opacity:.55}
.x1fzehxr:disabled:not(#\\#):not(#\\#):not(#\\#){opacity:1}
.x1gl3shj:disabled:not(#\\#):not(#\\#):not(#\\#){transform:none}
.x10ve9f0:user-invalid:not(#\\#):not(#\\#):not(#\\#){box-shadow:0 0 0 3px color-mix(in srgb,var(--console-err) 14%,transparent)}
.xo6m4nm:hover:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-err) 12%,transparent)}
.xuvuc2f:hover:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-accent-soft)}
.xd8d5gp:hover:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-card)}
.x1uvu3ev:hover:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-rule-strong)}
.xgvbf8n:hover:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-rule)}
.x1i2kobs:hover:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-secondary-soft)}
.xz2iokx:hover:not(#\\#):not(#\\#):not(#\\#){color:var(--console-accent-dim)}
.x1711cle:hover:not(#\\#):not(#\\#):not(#\\#){color:var(--console-accent)}
.xhwcb5i:hover:not(#\\#):not(#\\#):not(#\\#){color:var(--console-text-dim)}
.x18m2ztq:hover:not(#\\#):not(#\\#):not(#\\#){color:var(--console-text)}
.xzavvr5:hover:not(#\\#):not(#\\#):not(#\\#){color:var(--console-warn)}
.xg7jwtm:hover:not(#\\#):not(#\\#):not(#\\#){fill:var(--console-accent)}
.xcdb3qq:hover:not(#\\#):not(#\\#):not(#\\#){outline-width:1px}
.x1sur9pj:hover:not(#\\#):not(#\\#):not(#\\#){text-decoration-line:underline}
.x14ow2ja:hover:not(#\\#):not(#\\#):not(#\\#){transform:translateY(-1px)}
.x1scvahe:hover:not(#\\#):not(#\\#):not(#\\#){z-index:4}
.xc3vbd0:focus:not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-err) 11%,transparent)}
.xs1gn80:focus:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-rule)}
.x6q9x63:focus:not(#\\#):not(#\\#):not(#\\#){box-shadow:0 0 0 3px color-mix(in srgb,var(--console-accent) 18%,transparent)}
.x4jg2hm:focus:not(#\\#):not(#\\#):not(#\\#){color:var(--console-err)}
.xs9chkp:focus:not(#\\#):not(#\\#):not(#\\#){color:var(--console-text)}
.x1x89ub9:hover:is([aria-selected="true"],[aria-pressed="true"]):not(#\\#):not(#\\#):not(#\\#){background-color:color-mix(in srgb,var(--console-card-soft) 55%,transparent)}
.x19ix0zw:hover:is([aria-selected="true"],[aria-pressed="true"]):not(#\\#):not(#\\#):not(#\\#){color:var(--console-frame)}
.xkfincm:hover:is([aria-selected="true"]):not(#\\#):not(#\\#):not(#\\#){color:var(--console-text)}
.x7bxtm6:hover:is([aria-selected="true"],[aria-pressed="true"]):not(#\\#):not(#\\#):not(#\\#){color:var(--console-warn)}
@media (max-width: 640px){.xp7j7s0.xp7j7s0:not(#\\#):not(#\\#):not(#\\#){align-items:center}}
@media (max-width: 420px){.x6ssbkw.x6ssbkw:not(#\\#):not(#\\#):not(#\\#){align-items:flex-start}}
@media (max-width: 640px){.xelgs58.xelgs58:not(#\\#):not(#\\#):not(#\\#){align-items:flex-start}}
@media (max-width: 720px){.x1pftkvw.x1pftkvw:not(#\\#):not(#\\#):not(#\\#){align-items:flex-start}}
@media (max-width: 640px){.x1fpodaz.x1fpodaz:not(#\\#):not(#\\#):not(#\\#){align-items:start}}
@media (max-width: 640px){.x1o3peri.x1o3peri:not(#\\#):not(#\\#):not(#\\#){align-items:stretch}}
@media (max-width: 720px){.x1943nhg.x1943nhg:not(#\\#):not(#\\#):not(#\\#){align-items:stretch}}
@media (max-width: 640px){.x1ryrld4.x1ryrld4:not(#\\#):not(#\\#):not(#\\#){align-self:start}}
@media (prefers-reduced-motion: reduce){.x1aquc0h.x1aquc0h:not(#\\#):not(#\\#):not(#\\#){animation-name:none}}
@media (min-width: 641px){.xkktd5z.xkktd5z:not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-accent-soft)}}
@media (max-width: 640px){.xlc8tcj.xlc8tcj:not(#\\#):not(#\\#):not(#\\#){box-shadow:none}}
@media (max-width: 720px){.x1uno8h5.x1uno8h5:not(#\\#):not(#\\#):not(#\\#){clip-path:inset(50%)}}
@media (max-width: 640px){.xfsj286.xfsj286:not(#\\#):not(#\\#):not(#\\#){display:block}}
@media (max-width: 640px){.x10acg2q.x10acg2q:not(#\\#):not(#\\#):not(#\\#){display:grid}}
@media (max-width: 720px){.x6i8fqm.x6i8fqm:not(#\\#):not(#\\#):not(#\\#){display:grid}}
@media (max-width: 900px){.x1dtk984.x1dtk984:not(#\\#):not(#\\#):not(#\\#){display:grid}}
@media (max-width: 640px){.x13v5x0x.x13v5x0x:not(#\\#):not(#\\#):not(#\\#){display:inline-flex}}
@media (max-width: 900px){.x168i3sl.x168i3sl:not(#\\#):not(#\\#):not(#\\#){display:inline-flex}}
@media (max-width: 640px){.xkaaz9w.xkaaz9w:not(#\\#):not(#\\#):not(#\\#){display:none}}
@media (max-width: 720px){.x49x15t.x49x15t:not(#\\#):not(#\\#):not(#\\#){display:none}}
@media (max-width: 900px){.xzd29fr.xzd29fr:not(#\\#):not(#\\#):not(#\\#){display:none}}
@media (max-width: 640px){.x1fdxwjo.x1fdxwjo:not(#\\#):not(#\\#):not(#\\#){display:table-row}}
@media (max-width: 720px){.x1gue55y.x1gue55y:not(#\\#):not(#\\#):not(#\\#){flex-basis:100%}}
@media (max-width: 640px){.x17cst73.x17cst73:not(#\\#):not(#\\#):not(#\\#){flex-direction:column}}
@media (max-width: 720px){.x1g3ag0e.x1g3ag0e:not(#\\#):not(#\\#):not(#\\#){flex-direction:column}}
@media (max-width: 900px){.xxsmavh.xxsmavh:not(#\\#):not(#\\#):not(#\\#){flex-wrap:nowrap}}
@media (max-width: 640px){.xzbubq.xzbubq:not(#\\#):not(#\\#):not(#\\#){flex-wrap:wrap}}
@media (max-width: 900px){.xvabu7y.xvabu7y:not(#\\#):not(#\\#):not(#\\#){flex-wrap:wrap}}
@media (max-width: 640px){.xxgfmko.xxgfmko:not(#\\#):not(#\\#):not(#\\#){font-size:10.5px}}
@media (max-width: 720px){.x1vq3b3y.x1vq3b3y:not(#\\#):not(#\\#):not(#\\#){font-size:10px}}
@media (max-width: 640px){.xqjcjlm.xqjcjlm:not(#\\#):not(#\\#):not(#\\#){font-size:12.5px}}
@media (max-width: 720px){.xo9lxqq.xo9lxqq:not(#\\#):not(#\\#):not(#\\#){font-size:12px}}
@media (max-width: 640px){.x1yzm3l3.x1yzm3l3:not(#\\#):not(#\\#):not(#\\#){font-size:13px}}
@media (max-width: 640px){.x1sgj8az.x1sgj8az:not(#\\#):not(#\\#):not(#\\#){font-size:15px}}
@media (max-width: 640px) and (not (pointer: coarse)){.xhhd8f.xhhd8f:not(#\\#):not(#\\#):not(#\\#){font-size:16px}}
@media (max-width: 640px){.xf2x79s.xf2x79s:not(#\\#):not(#\\#):not(#\\#){font-size:16px}}
@media (max-width: 720px){.xxae97u.xxae97u:not(#\\#):not(#\\#):not(#\\#){font-size:16px}}
@media (pointer: coarse){.x1yr6pw4.x1yr6pw4:not(#\\#):not(#\\#):not(#\\#){font-size:16px}}
@media (max-width: 720px){.xn29b5y.xn29b5y:not(#\\#):not(#\\#):not(#\\#){font-size:20px}}
@media (max-width: 640px){.x1kth5g4.x1kth5g4:not(#\\#):not(#\\#):not(#\\#){font-size:25px}}
@media (max-width: 900px){.x1mg0i68.x1mg0i68:not(#\\#):not(#\\#):not(#\\#){font-size:27px}}
@media (max-width: 720px){.x1ogbdcq.x1ogbdcq:not(#\\#):not(#\\#):not(#\\#){font-size:6.5px}}
@media (max-width: 640px){.xbewnxd.xbewnxd:not(#\\#):not(#\\#):not(#\\#){font-size:8.5px}}
@media (max-width: 640px){.x155ir8z.x155ir8z:not(#\\#):not(#\\#):not(#\\#){font-size:9px}}
@media (max-width: 640px){.x1i2bv8g.x1i2bv8g:not(#\\#):not(#\\#):not(#\\#){font-size:clamp(27px,8.5vw,36px)}}
@media (max-width: 640px){.x5z33oq.x5z33oq:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:1fr 1fr}}
@media (min-width: 420.01px) and (max-width: 720px){.xxljim5.xxljim5:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:auto minmax(0,1fr)}}
@media (max-width: 720px){.x159c1az.x159c1az:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1fr) fit-content(40%)}}
@media (max-width: 420px){.x1gc00kl.x1gc00kl:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1fr)}}
@media (max-width: 640px){.x4jmfmw.x4jmfmw:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1fr)}}
@media (max-width: 720px){.x57k0db.x57k0db:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1fr)}}
@media (max-width: 900px){.xirox3h.xirox3h:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1fr)}}
@media (max-width: 640px){.xou8obv.xou8obv:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:repeat(2,minmax(0,1fr))}}
@media (max-width: 720px){.x1otivht.x1otivht:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:repeat(3,minmax(0,1fr))}}
@media (min-width: 720.01px) and (max-width: 900px){.x11pl5mh.x11pl5mh:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:repeat(3,minmax(0,1fr))}}
@media (max-width: 640px){.xmn758v.xmn758v:not(#\\#):not(#\\#):not(#\\#){justify-content:flex-start}}
@media (max-width: 720px){.xx5kb6y.xx5kb6y:not(#\\#):not(#\\#):not(#\\#){justify-content:flex-start}}
@media (max-width: 640px){.x1s9bmkn.x1s9bmkn:not(#\\#):not(#\\#):not(#\\#){justify-content:space-between}}
@media (max-width: 640px){.x13bdqmg.x13bdqmg:not(#\\#):not(#\\#):not(#\\#){line-height:1.03}}
@media (max-width: 720px){.x1u6zlfl.x1u6zlfl:not(#\\#):not(#\\#):not(#\\#){line-height:1.4}}
@media (prefers-reduced-motion: reduce){.x16dpw5u.x16dpw5u:not(#\\#):not(#\\#):not(#\\#){opacity:1}}
@media (max-width: 640px){.x1iqbltf.x1iqbltf:not(#\\#):not(#\\#):not(#\\#){order:3}}
@media (max-width: 640px){.x3y8eqj.x3y8eqj:not(#\\#):not(#\\#):not(#\\#){overscroll-behavior-inline:auto}}
@media (max-width: 900px){.xbfx0k3.xbfx0k3:not(#\\#):not(#\\#):not(#\\#){overscroll-behavior-inline:contain}}
@media (max-width: 640px){.x1s77nak.x1s77nak:not(#\\#):not(#\\#):not(#\\#){padding-inline-end:44px}}
@media (max-width: 640px){.x1nck5sx.x1nck5sx:not(#\\#):not(#\\#):not(#\\#){position:absolute}}
@media (max-width: 720px){.xget08e.xget08e:not(#\\#):not(#\\#):not(#\\#){position:absolute}}
@media (min-width: 641px){.x14c6fbn.x14c6fbn:not(#\\#):not(#\\#):not(#\\#){position:static}}
@media (max-width: 640px){.x1668a04.x1668a04:not(#\\#):not(#\\#):not(#\\#){scrollbar-width:auto}}
@media (max-width: 900px){.xsbd0l1.xsbd0l1:not(#\\#):not(#\\#):not(#\\#){scrollbar-width:none}}
@media (prefers-reduced-motion: reduce){.x1nwy2jz.x1nwy2jz:not(#\\#):not(#\\#):not(#\\#){stroke-dashoffset:0}}
@media (max-width: 640px){.x1mji7za.x1mji7za:not(#\\#):not(#\\#):not(#\\#){transform:none}}
@media (max-width: 720px){.x1d7nh58.x1d7nh58:not(#\\#):not(#\\#):not(#\\#){transform:translateX(-15%)}}
@media (max-width: 720px){.x22pbl2.x22pbl2:not(#\\#):not(#\\#):not(#\\#){transform:translateX(-18%)}}
@media (prefers-reduced-motion: reduce){.x12w9bfk.x12w9bfk:not(#\\#):not(#\\#):not(#\\#){transition-duration:0s}}
@media (prefers-reduced-motion: reduce){.x4wkmsb.x4wkmsb:not(#\\#):not(#\\#):not(#\\#){transition-property:none}}
@media (max-width: 640px){.x1i1s3md.x1i1s3md:not(#\\#):not(#\\#):not(#\\#){white-space:normal}}
@media (min-width: 641px){.x9as3ks.x9as3ks:is([data-operator-action-popover] *):not(#\\#):not(#\\#):not(#\\#){background-color:var(--console-card)}}
@media (min-width: 641px){.x1yweesi.x1yweesi:is([data-operator-action-popover] *):not(#\\#):not(#\\#):not(#\\#){box-shadow:0 20px 50px -24px color-mix(in srgb,var(--console-text) 55%,transparent)}}
@media (max-width: 640px){.x1vbiuae.x1vbiuae:is([data-climate="paper"] *):not(#\\#):not(#\\#):not(#\\#){box-shadow:none}}
@media (max-width: 640px){.x1a92eo6.x1a92eo6:is([data-has-unannotated="false"]):not(#\\#):not(#\\#):not(#\\#){display:none}}
@media (max-width: 640px){.x1kvcy9f.x1kvcy9f:is([data-compact-row="true"]):not(#\\#):not(#\\#):not(#\\#){display:none}}
@media (max-width: 640px){.xqwvrdo.xqwvrdo:is([data-has-unannotated="true"]):not(#\\#):not(#\\#):not(#\\#){overscroll-behavior-inline:contain}}
@media (min-width: 641px){.x16e9dwd.x16e9dwd:is([data-operator-action-popover] *):not(#\\#):not(#\\#):not(#\\#){position:absolute}}
@media (max-width: 640px){.x1defwea.x1defwea:is([data-has-unannotated="true"]):not(#\\#):not(#\\#):not(#\\#){scrollbar-width:thin}}
@media (prefers-reduced-motion: reduce){.x6wgdar.x6wgdar:hover:not(:disabled):not(#\\#):not(#\\#):not(#\\#){transform:none}}
@media (min-width: 641px){.x1q652j.x1q652j:is([data-operator-action-popover] *):not(#\\#):not(#\\#):not(#\\#){z-index:10}}
@container operator (max-width: 640px){.x14p79m1.x14p79m1:not(#\\#):not(#\\#):not(#\\#){align-items:flex-start}}
@container operator (max-width: 640px){.x1xy9y68.x1xy9y68:not(#\\#):not(#\\#):not(#\\#){align-items:start}}
@container operator (max-width: 640px){.xmrrqfi.xmrrqfi:not(#\\#):not(#\\#):not(#\\#){align-items:stretch}}
@container operator (max-width: 720px){.x9awmtd.x9awmtd:not(#\\#):not(#\\#):not(#\\#){align-items:stretch}}
@container operator-cell (max-width: 420px){.x1ovenir.x1ovenir:not(#\\#):not(#\\#):not(#\\#){align-items:stretch}}
@container operator (max-width: 640px){.x1uk5d4i.x1uk5d4i:not(#\\#):not(#\\#):not(#\\#){align-self:start}}
@container operator (max-width: 640px){.xplwmzv.xplwmzv:not(#\\#):not(#\\#):not(#\\#){display:block}}
@container operator (max-width: 640px){.x1w305zg.x1w305zg:not(#\\#):not(#\\#):not(#\\#){display:grid}}
@container operator (max-width: 900px){.x1yu2ybr.x1yu2ybr:not(#\\#):not(#\\#):not(#\\#){display:inline-flex}}
@container operator (max-width: 900px){.xsu5lmx.xsu5lmx:not(#\\#):not(#\\#):not(#\\#){display:none}}
@container operator (max-width: 640px){.x1lu4wmf.x1lu4wmf:not(#\\#):not(#\\#):not(#\\#){display:table-row}}
@container operator (max-width: 640px){.xlrawni.xlrawni:not(#\\#):not(#\\#):not(#\\#){flex-direction:column}}
@container operator (max-width: 720px){.xlw4hyx.xlw4hyx:not(#\\#):not(#\\#):not(#\\#){flex-direction:column}}
@container operator-cell (max-width: 420px){.xyil5ud.xyil5ud:not(#\\#):not(#\\#):not(#\\#){flex-direction:column}}
@container operator (max-width: 640px){.x1i03alp.x1i03alp:not(#\\#):not(#\\#):not(#\\#){flex-wrap:wrap}}
@container operator (max-width: 640px){.x1c2rghm.x1c2rghm:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1fr)}}
@container operator (max-width: 900px){.xtpkkxw.xtpkkxw:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1fr)}}
@container operator-aside (min-width: 0px){.x1ram2ln.x1ram2ln:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1fr)}}
@container operator-matrix (max-width: 480px){.x16lgxdz.x16lgxdz:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1fr)}}
@container operator-matrix (min-width: 481px) and (max-width: 900px){.xchmvhn.xchmvhn:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1fr)}}
@container operator (max-width: 640px){.x1nae48y.x1nae48y:not(#\\#):not(#\\#):not(#\\#){grid-template-columns:repeat(2,minmax(0,1fr))}}
@container operator (max-width: 640px){.x1aoecvx.x1aoecvx:not(#\\#):not(#\\#):not(#\\#){justify-content:flex-start}}
@container operator-cell (max-width: 420px){.x6z9i88.x6z9i88:not(#\\#):not(#\\#):not(#\\#){justify-content:flex-start}}
@container operator (max-width: 640px){.xq86nrr.xq86nrr:not(#\\#):not(#\\#):not(#\\#){justify-content:space-between}}
@container operator (max-width: 640px){.x5zp4vj.x5zp4vj:not(#\\#):not(#\\#):not(#\\#){overscroll-behavior-inline:auto}}
@container operator (max-width: 640px){.x18of6z9.x18of6z9:not(#\\#):not(#\\#):not(#\\#){position:absolute}}
@container operator (max-width: 640px){.xvwifah.xvwifah:not(#\\#):not(#\\#):not(#\\#){scrollbar-width:auto}}
@container operator (max-width: 640px){.x1uv6r69.x1uv6r69:not(#\\#):not(#\\#):not(#\\#){white-space:normal}}
@container operator (max-width: 640px){.x15zwrp0.x15zwrp0:is([data-compact-row="true"]):not(#\\#):not(#\\#):not(#\\#){display:none}}
@container operator (max-width: 640px){.x22zvs4.x22zvs4:is([data-has-unannotated="false"]):not(#\\#):not(#\\#):not(#\\#){display:none}}
@container operator-matrix (max-width: 480px){.x1gjrsil.x1gjrsil:is([data-columns="2"], [data-columns="3"], [data-columns="4"]):not(#\\#):not(#\\#):not(#\\#){grid-template-columns:minmax(0,1fr)}}
@container operator-matrix (min-width: 481px) and (max-width: 900px){.x1mqdp8p.x1mqdp8p:is([data-columns="2"], [data-columns="3"], [data-columns="4"]):not(#\\#):not(#\\#):not(#\\#){grid-template-columns:repeat(2,minmax(0,1fr))}}
@container operator (max-width: 640px){.x1douzxv.x1douzxv:is([data-has-unannotated="true"]):not(#\\#):not(#\\#):not(#\\#){overscroll-behavior-inline:contain}}
@container operator (max-width: 640px){.x1rfhg52.x1rfhg52:is([data-has-unannotated="true"]):not(#\\#):not(#\\#):not(#\\#){scrollbar-width:thin}}
.x16stqrj:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-bottom-color:transparent}
.xna4lh4:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-bottom-color:var(--console-rule-strong)}
.xpqg30t:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-bottom-color:var(--console-rule)}
.x1594w68:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-bottom-color:var(--console-text)}
.x1q0q8m5:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-bottom-style:solid}
.x1qhh985:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-bottom-width:0}
.xso031l:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-bottom-width:1px}
.xlxy82:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-bottom-width:2px}
.x1g4hjc:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-color:transparent}
.xju8803:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-color:var(--console-err)}
.xan25v:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-color:var(--console-ok)}
.xlsyykk:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-color:var(--console-rule-strong)}
.xz6lizu:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-color:var(--console-rule)}
.xs4majh:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-color:var(--console-text-muted)}
.xzxeg27:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-color:var(--console-warn)}
.xsxj2vf:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-style:dashed}
.x19ypqd9:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-style:solid}
.xyj58a3:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-width:0}
.xe0pwq:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-width:1px}
.x19sr0n1:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-width:2px}
.x1vo0akb:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-width:3px}
.x3a9l4s:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-right-color:var(--console-rule)}
.x32b0ac:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-right-style:solid}
.xgfja2r:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-right-width:0}
.xs1s249:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-right-width:1px}
.xltl5i9:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-top-color:var(--console-rule-strong)}
.xvg7k2t:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-top-color:var(--console-rule)}
.x172wxxo:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-top-color:var(--console-text-muted)}
.x13fuv20:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-top-style:solid}
.x972fbf:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-top-width:0}
.x178xt8z:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-top-width:1px}
.xamhcws:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-top-width:2px}
.x1ey2m1c:not(#\\#):not(#\\#):not(#\\#):not(#\\#){bottom:0}
.xrb244j:not(#\\#):not(#\\#):not(#\\#):not(#\\#){bottom:6px}
.x5yr21d:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:100%}
.x1dr9wh:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:108px}
.x1kpxq89:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:12px}
.xhjk10j:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:140px}
.xlup9mm:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:16px}
.xmix8c7:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:18px}
.xjm9jq1:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:1px}
.xxk0z11:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:24px}
.x1fgtraw:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:28px}
.x10w6t97:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:32px}
.xc9qbxq:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:36px}
.x5kalc8:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:42px}
.xqu0tyb:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:4px}
.x1ycjhwn:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:5px}
.x1x0gksc:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:62px}
.xols6we:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:6px}
.xuzvuw4:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:78px}
.x1hagigm:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:7px}
.xdk7pt:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:8px}
.xegnrdp:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:9px}
.xt7dq6l:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:auto}
.x1nrll8i:not(#\\#):not(#\\#):not(#\\#):not(#\\#){left:50%}
.xxwu3sf:not(#\\#):not(#\\#):not(#\\#):not(#\\#){left:6px}
.x1rgg377:not(#\\#):not(#\\#):not(#\\#):not(#\\#){left:9px}
.x1aqb8qb:not(#\\#):not(#\\#):not(#\\#):not(#\\#){left:calc(100% - 19px)}
.x1jyxor1:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-bottom:-1px}
.xat24cr:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-bottom:0}
.xyorhqc:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-bottom:10px}
.xod5an3:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-bottom:12px}
.x1u7kmwd:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-bottom:14px}
.x1yztbdb:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-bottom:16px}
.xieb3on:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-bottom:20px}
.xzueoph:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-bottom:6px}
.xfitlp5:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-bottom:9px}
.xj3b58b:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-left:0}
.x16vho4v:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-left:6px}
.x8x9d4c:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-left:auto}
.x15ku74s:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-right:6px}
.x193lsj1:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-right:9px}
.xifccgj:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-top:-6px}
.x1anpbxc:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-top:10px}
.x1aawmmo:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-top:11px}
.x14vqqas:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-top:12px}
.xvijh9v:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-top:1px}
.xaqh0s9:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-top:26px}
.xr9ek0c:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-top:2px}
.xg87l8a:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-top:32px}
.x7r5mf7:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-top:3px}
.x1ok221b:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-top:5px}
.x1k70j0n:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-top:6px}
.x1rhet7l:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-top:7px}
.x1xmf6yo:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-top:8px}
.xzbgwbi:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-top:9px}
.xgw0a1n:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-height:min(52vh,40rem)}
.xojfs98:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-height:min(84dvh,720px)}
.xlz9g7p:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-height:var(--radix-dropdown-menu-content-available-height,320px)}
.x1yy5vjr:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-height:var(--radix-select-content-available-height,320px)}
.x193iq5w:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:100%}
.x2aouup:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:120px}
.x186ixgm:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:1440px}
.x16q51m2:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:150px}
.x8jryan:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:40%}
.x1qbr2yc:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:44ch}
.x1y8h3ww:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:45%}
.x148vls7:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:46ch}
.x15qx0h6:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:55ch}
.x1qp14f0:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:66ch}
.xw7nakj:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:calc(100vw - 32px)}
.x1x1rfll:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:none}
.x2lwn1j:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:0}
.x1us19tq:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:100%}
.xe0p6wg:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:28px}
.x21xpn4:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:32px}
.xu97haq:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:34px}
.x1dby22o:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:360px}
.xu0aao5:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:36px}
.x141feeh:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:38px}
.xse5ku5:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:39px}
.x1ba4aug:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:40px}
.xgujvf1:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:42px}
.x5mc7k8:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:480px}
.x1wxaq2x:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:48px}
.xgqnoi5:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:560px}
.x8nclml:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:64px}
.xcr9lap:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:66px}
.xefclja:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:88px}
.x1edz59j:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:96px}
.x65nank:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:auto}
.x1mrxzx8:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:clamp(280px,42vw,480px)}
.x1eguyfn:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:var(--console-touch)}
.xeuugli:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-width:0}
.x5w4yej:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-width:160px}
.xfb3i0g:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-width:180px}
.xg3ba1e:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-width:25px}
.x1fns5xo:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-width:40px}
.x113rx6s:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-width:var(--radix-select-trigger-width,180px)}
.xw2csxc:not(#\\#):not(#\\#):not(#\\#):not(#\\#){overflow-x:auto}
.x101abm8:not(#\\#):not(#\\#):not(#\\#):not(#\\#){overflow-x:clip}
.x1plvlek:not(#\\#):not(#\\#):not(#\\#):not(#\\#){overflow-x:visible}
.x1odjw0f:not(#\\#):not(#\\#):not(#\\#):not(#\\#){overflow-y:auto}
.xryxfnj:not(#\\#):not(#\\#):not(#\\#):not(#\\#){overflow-y:visible}
.x18d9i69:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-bottom:0}
.x1a8lsjc:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-bottom:10px}
.xsag5q8:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-bottom:12px}
.x1l90r2v:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-bottom:16px}
.x1120s5i:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-bottom:2px}
.xs9asl8:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-bottom:5px}
.xwib8y2:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-bottom:8px}
.xdvlbce:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-bottom:9px}
.x1uhho1l:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-left:0}
.x1lqa7cf:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-left:10px}
.xzjhap9:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-left:14px}
.xnm25rq:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-left:16px}
.x5tiur9:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-left:20px}
.x6wrskw:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-left:4px}
.x163pfp:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-left:8px}
.x1xpa7k:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-right:0}
.xcicffo:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-right:10px}
.x19tmk5i:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-right:14px}
.xyfqnmn:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-right:16px}
.x1s7jvk7:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-right:20px}
.xmzs88n:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-right:4px}
.xy13l1i:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-right:8px}
.xexx8yu:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-top:0}
.xz9dl7a:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-top:12px}
.xyamay9:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-top:16px}
.x1p5oq8j:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-top:24px}
.x7sb2j6:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-top:28px}
.x1nn3v0j:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-top:2px}
.x123j3cw:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-top:5px}
.x1y1aw1k:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-top:8px}
.x44moml:not(#\\#):not(#\\#):not(#\\#):not(#\\#){right:14px}
.x13vifvy:not(#\\#):not(#\\#):not(#\\#):not(#\\#){top:0}
.xuivejd:not(#\\#):not(#\\#):not(#\\#):not(#\\#){top:14px}
.xwa60dl:not(#\\#):not(#\\#):not(#\\#):not(#\\#){top:50%}
.xh8yej3:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:100%}
.xsmyaan:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:12px}
.x6jxa94:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:14px}
.x1kky2od:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:16px}
.x1xp8n7a:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:18px}
.xgd8bvy:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:28px}
.xfo62xy:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:2px}
.x1td3qas:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:32px}
.x14qfxbe:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:36px}
.x10h3iyq:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:42px}
.x1ftt334:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:5px}
.xeepkih:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:62px}
.x1v4s8kt:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:6px}
.xgbm1jk:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:78px}
.xci0xqf:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:7px}
.x1ghds7r:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:8.5rem}
.x1xc55vz:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:8px}
.x1wc42o8:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:9px}
.x14atkfc:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:auto}
.xeq5yr9:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:fit-content}
.xvi13v7:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:min(100%,280px)}
.x10fmqn2:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:min(1280px,96vw)}
.xv9tjks:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:min(520px,calc(100vw - 32px))}
.x9redfm:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:min(720px,100%)}
.x1xiyr0g:is([aria-selected="true"]):not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-bottom-color:var(--console-accent)}
.xtobj18:is([data-state='active']):not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-bottom-color:var(--console-accent)}
.x1z10cro:is([data-matrix-cell] li:last-child):not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-bottom-width:0}
.xkzz1zq:is([data-tone=error]):not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-color:var(--console-err)}
.x178oq3p:focus-visible:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-color:var(--console-secondary)}
.x1qdoa1:is([aria-pressed="true"]):not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-color:var(--console-secondary)}
.xoy5xpq:is([data-tone="error"]):not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-top-color:var(--console-err)}
.xvw7cn:is([data-tone="good"]):not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-top-color:var(--console-ok)}
.x1qaj2f5:is([data-tone="warn"]):not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-top-color:var(--console-warn)}
.xxfsjeb:is(details[open] > summary):not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-bottom:14px}
.x15m6qhz:is([open]):not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-bottom:16px}
.x1s4zo15:not(:last-child):not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-right:40px}
.x1e5dqpa:first-child:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-width:0}
.x1g31smg:first-child:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-top-width:0}
.x17ezhci:first-child:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-top:2px}
.xxakyfl:last-child:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-left:20px}
.xdeuen4:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-color:var(--console-secondary)}
@media (max-width: 640px){.x1lclwwd.x1lclwwd:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-bottom-left-radius:0}}
@media (max-width: 640px){.xgrp7ii.xgrp7ii:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-bottom-right-radius:0}}
@media (max-width: 640px){.x171z6dy.x171z6dy:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-width:0}}
@media (max-width: 720px){.x1n97idq.x1n97idq:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-left-width:0}}
@media (max-width: 640px){.x13ymtvt.x13ymtvt:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-right-width:0}}
@media (max-width: 720px){.xnc2tav.xnc2tav:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-top-width:1px}}
@media (max-width: 640px){.x1imafyg.x1imafyg:not(#\\#):not(#\\#):not(#\\#):not(#\\#){bottom:0}}
@media (max-width: 720px){.xwj557x.xwj557x:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:1px}}
@media (max-width: 640px){.x1iwbelc.x1iwbelc:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:26px}}
@media (max-width: 640px){.x1fkvin3.x1fkvin3:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:44px}}
@media (max-width: 420px){.x1li4m8q.x1li4m8q:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:54px}}
@media (max-width: 420px){.x14vkcg0.x14vkcg0:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:68px}}
@media (max-width: 640px){.x1b4kqk5.x1b4kqk5:not(#\\#):not(#\\#):not(#\\#):not(#\\#){height:96px}}
@media (max-width: 640px){.x172uiah.x172uiah:not(#\\#):not(#\\#):not(#\\#):not(#\\#){left:0}}
@media (max-width: 640px){.xzzd6q.xzzd6q:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-bottom:10px}}
@media (max-width: 640px){.x703316.x703316:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-left:0}}
@media (max-width: 720px){.xzbafmd.xzbafmd:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-left:0}}
@media (max-width: 640px){.xtwf3lw.xtwf3lw:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-right:18px}}
@media (max-width: 640px){.xxnk3sr.xxnk3sr:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-height:min(88dvh,760px)}}
@media (max-width: 720px){.xjjsibu.xjjsibu:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:100%}}
@media (max-width: 640px){.xb4vn5r.xb4vn5r:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:145px}}
@media (max-width: 640px){.xyv2k2f.xyv2k2f:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:50ch}}
@media (max-width: 640px){.xeyi6kz.xeyi6kz:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:none}}
@media (max-width: 720px){.x15a9oh8.x15a9oh8:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:none}}
@media (max-width: 720px){.xxt49dy.xxt49dy:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:0}}
@media (max-width: 720px){.x1en03wu.x1en03wu:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:260px}}
@media (max-width: 720px){.xql4057.xql4057:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:270px}}
@media (max-width: 720px){.xa6uzjl.xa6uzjl:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:320px}}
@media (max-width: 720px){.xsz8nvi.xsz8nvi:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:36px}}
@media (max-width: 640px){.x1c4ya5t.x1c4ya5t:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:44px}}
@media (max-width: 720px){.x1xb6689.x1xb6689:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:44px}}
@media (max-width: 640px){.xn3zsfb.xn3zsfb:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:auto}}
@media (max-width: 640px){.xdnb5l2.xdnb5l2:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:calc(58px + env(safe-area-inset-top))}}
@media (max-width: 640px){.x126n28w.x126n28w:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-height:var(--console-touch)}}
@media (max-width: 640px){.x1wkdlc4.x1wkdlc4:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-width:44px}}
@media (max-width: 640px){.x160ygfx.x160ygfx:not(#\\#):not(#\\#):not(#\\#):not(#\\#){min-width:var(--console-touch)}}
@media (max-width: 900px){.xm9l3w6.xm9l3w6:not(#\\#):not(#\\#):not(#\\#):not(#\\#){overflow-x:auto}}
@media (max-width: 640px){.xdayf2q.xdayf2q:not(#\\#):not(#\\#):not(#\\#):not(#\\#){overflow-x:visible}}
@media (max-width: 640px){.x1yy75ev.x1yy75ev:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-bottom:0}}
@media (max-width: 640px){.xu4eg61.xu4eg61:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-bottom:10px}}
@media (max-width: 640px){.x1ckun3f.x1ckun3f:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-bottom:8px}}
@media (max-width: 640px){.x1lak8av.x1lak8av:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-bottom:calc(20px + env(safe-area-inset-bottom))}}
@media (max-width: 720px){.xj0nzd3.xj0nzd3:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-left:11px}}
@media (max-width: 640px){.x1tkp2ng.x1tkp2ng:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-left:14px}}
@media (max-width: 640px){.x1316j.x1316j:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-left:24px}}
@media (max-width: 640px){.x33yvzk.x33yvzk:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-right:0}}
@media (max-width: 720px){.x1jt3kna.x1jt3kna:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-right:11px}}
@media (max-width: 640px){.x2egep.x2egep:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-top:10px}}
@media (max-width: 640px){.xugsc6q.xugsc6q:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-top:var(--operator-sections-padding-top,24px)}}
@media (max-width: 640px){.xz59zry.xz59zry:not(#\\#):not(#\\#):not(#\\#):not(#\\#){top:4px}}
@media (max-width: 640px){.xl7365u.xl7365u:not(#\\#):not(#\\#):not(#\\#):not(#\\#){top:auto}}
@media (max-width: 640px){.x1dbdljh.x1dbdljh:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:100%}}
@media (max-width: 720px){.x1w3b8m9.x1w3b8m9:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:140%}}
@media (max-width: 720px){.xn7okfr.xn7okfr:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:155%}}
@media (max-width: 720px){.x1dtpofi.x1dtpofi:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:1px}}
@media (max-width: 640px){.xjjy2jw.xjjy2jw:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:26px}}
@media (max-width: 640px){.xzy26m8.xzy26m8:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:44px}}
@media (max-width: 420px){.xbfdvwu.xbfdvwu:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:54px}}
@media (max-width: 420px){.xuwcrnf.xuwcrnf:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:68px}}
@media (max-width: 640px){.x9nnsnq.x9nnsnq:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:auto}}
@media (min-width: 641px){.x6imu0b.x6imu0b:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:min(720px,100%)}}
@media (max-width: 640px){.x1yieemc.x1yieemc:is([data-has-unannotated="true"]):not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-bottom:5px}}
@media (min-width: 641px){.x10spfxb.x10spfxb:is([data-operator-action-popover] *):not(#\\#):not(#\\#):not(#\\#):not(#\\#){right:0}}
@media (min-width: 641px){.x126usnh.x126usnh:is([data-operator-action-popover] *):not(#\\#):not(#\\#):not(#\\#):not(#\\#){top:calc(100% + 10px)}}
@media (min-width: 641px){.xq4oo3n.xq4oo3n:is([data-operator-action-popover] *):not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:min(720px,calc(100vw - 80px))}}
@media (max-width: 720px){.x6gzigo.x6gzigo:first-child:not(#\\#):not(#\\#):not(#\\#):not(#\\#){border-top-width:0}}
@container operator (max-width: 640px){.xxdgi2x.xxdgi2x:not(#\\#):not(#\\#):not(#\\#):not(#\\#){left:0}}
@container operator (max-width: 640px){.x1m2ds42.x1m2ds42:not(#\\#):not(#\\#):not(#\\#):not(#\\#){margin-left:0}}
@container operator (max-width: 720px){.x1uikkot.x1uikkot:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:100%}}
@container operator-cell (max-width: 420px){.xdq2x6k.xdq2x6k:not(#\\#):not(#\\#):not(#\\#):not(#\\#){max-width:100%}}
@container operator (max-width: 640px){.x10774h0.x10774h0:not(#\\#):not(#\\#):not(#\\#):not(#\\#){overflow-x:visible}}
@container operator (max-width: 640px){.x1aciil0.x1aciil0:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-bottom:0}}
@container operator (max-width: 640px){.xm1vsfr.xm1vsfr:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-bottom:8px}}
@container operator (max-width: 640px){.xcxuj3u.xcxuj3u:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-left:14px}}
@container operator (max-width: 640px){.x1h1edae.x1h1edae:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-left:24px}}
@container operator (max-width: 640px){.x11uxfgx.x11uxfgx:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-right:0}}
@container operator (max-width: 640px){.x1tkkb8.x1tkkb8:not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-top:var(--operator-sections-padding-top,24px)}}
@container operator (max-width: 640px){.x190b9kf.x190b9kf:not(#\\#):not(#\\#):not(#\\#):not(#\\#){top:4px}}
@container operator (max-width: 640px){.x1amo615.x1amo615:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:100%}}
@container operator-aside (min-width: 0px){.x10x3x5a.x10x3x5a:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:100%}}
@container operator (max-width: 640px){.xe0affe.xe0affe:not(#\\#):not(#\\#):not(#\\#):not(#\\#){width:auto}}
@container operator (max-width: 640px){.xs4y3db.xs4y3db:is([data-has-unannotated="true"]):not(#\\#):not(#\\#):not(#\\#):not(#\\#){padding-bottom:5px}}
.xarstr8:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{inset:0}
.xxx281p:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{inset:0}
.x1x6ksa7:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{border-color:currentColor}
.x9msap3:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{border-radius:50%}
.xbmcqy5:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::-moz-progress-bar{border-radius:999px}
.xdyxp2i:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::-webkit-progress-bar{border-radius:999px}
.xeqdbg4:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::-webkit-progress-value{border-radius:999px}
.x1fo1fc9:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{border-style:solid}
.xz8fyzm:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{border-width:1px}
.xl5i350:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{flex:1}
.x15h7rrt:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{background-color:currentColor}
.x1h2yhso:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::-webkit-progress-value{background-color:var(--console-accent)}
.x1qjdyzq:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::-moz-progress-bar{background-color:var(--console-accent)}
.x1y3k7d7:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{background-color:var(--console-rule-strong)}
.xrtr2zh:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{background-color:var(--console-rule-strong)}
.x15jglqw:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::-webkit-progress-bar{background-color:var(--console-rule)}
.x12rlhj3:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{background-image:linear-gradient(90deg,var(--console-bg-deep),transparent 11%,transparent 91%,var(--console-bg-deep))}
.x1c3dc77:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{background-image:radial-gradient(ellipse at 50% 0%,transparent 0%,transparent 45%,var(--console-bg-deep) 110%)}
.x16luk3d:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3CfeColorMatrix type='saturate' values='0'/%3E%3CfeComponentTransfer%3E%3CfeFuncA type='linear' slope='0.035'/%3E%3C/feComponentTransfer%3E%3C/filter%3E%3Crect width='120' height='120' filter='url(%23n)'/%3E%3C/svg%3E")}
.x139fdmx:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='180' height='180'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.6 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>")}
.x12jnsxg:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{box-shadow:0 0 0 4px color-mix(in srgb,currentColor 14%,transparent)}
.x3lbmcd:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::placeholder{color:var(--console-text-faint)}
.x1wku8z5:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::placeholder{color:var(--console-text-muted)}
.x1cpjm7i:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{content:""}
.x1s928wv:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{content:""}
.x1is36l8:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{content:"+"}
.x13k4006:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{cursor:pointer}
.x1fhgk32:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{display:inline-block}
.x15ozc13:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{display:none}
.x1h1zc6f:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{display:none}
.x1i5lizr:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::-webkit-details-marker{display:none}
.xfk6m8:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::-webkit-scrollbar{display:none}
.xtbmc8j:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{flex-shrink:0}
.x1cg4o4v:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{mix-blend-mode:normal}
.xan9qf5:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{mix-blend-mode:overlay}
.x1ifdjg0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{opacity:.035}
.x1dd49dr:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{opacity:.5}
.x1y5f1pj:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{opacity:.55}
.xf8owqi:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{opacity:.58}
.x2q1x1w:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{pointer-events:none}
.xkk1bqk:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{pointer-events:none}
.x1j6awrg:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{position:absolute}
.x1fjj3yw:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{position:fixed}
.x1g2j9el:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{position:fixed}
.x1r0yslu:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{z-index:0}
.x2hztxu:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{z-index:0}
.xgyh6op:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{z-index:999}
.x1f1btj5:is([data-climate="paper"] *):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{background-image:radial-gradient(ellipse at 50% -10%,rgba(255,250,235,.6) 0%,transparent 40%,var(--console-bg-deep) 115%)}
.x1461opg:is(details[open] > summary):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{content:"−"}
.xesi0um:is([data-climate="paper"] *):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{mix-blend-mode:multiply}
.x1ubcw10:is([data-climate="paper"] *):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{mix-blend-mode:normal}
.x37q5d8:is([data-climate="paper"] *):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{opacity:.06}
.x8z062v:is([data-climate="paper"] *):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{opacity:.5}
.xnyr4az:is([data-climate="paper"] *):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{opacity:.7}
.xguj015:last-child:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{content:none}
.xcock1l:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{height:1px}
.xy80zi5:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{height:1px}
.xf3jtlm:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{height:7px}
.x12bpigw:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{left:14px}
.xmz0esg:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{margin-right:5px}
.x1gz4iox:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{margin-right:7px}
.x1o45bfl:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{min-width:8px}
.x14cqbmr:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{right:12px}
.x5jc7rz:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{top:5px}
.x1x7x01p:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::before{width:7px}
@media (max-width: 640px){.x1ujw8yj.x1ujw8yj:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{bottom:-5px}}
@media (max-width: 640px){.x15t6rfx.x15t6rfx:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{height:auto}}
@media (max-width: 640px){.x1e70te5.x1e70te5:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{left:4px}}
@media (max-width: 640px){.x194c2x1.x194c2x1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{right:auto}}
@media (max-width: 640px){.x1wdcn98.x1wdcn98:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{top:14px}}
@media (max-width: 640px){.x1prkmhq.x1prkmhq:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{width:1px}}
@container operator (max-width: 640px){.xxw6uw7.xxw6uw7:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{bottom:-5px}}
@container operator (max-width: 640px){.xpldujj.xpldujj:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{height:auto}}
@container operator (max-width: 640px){.x44p448.x44p448:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{left:4px}}
@container operator (max-width: 640px){.x2e6dpv.x2e6dpv:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{right:auto}}
@container operator (max-width: 640px){.x7hj2ou.x7hj2ou:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{top:14px}}
@container operator (max-width: 640px){.x1ll1jh2.x1ll1jh2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::after{width:1px}}`;
export {
  ConfirmDialog2 as ConfirmDialog,
  OperatorActionButton,
  OperatorActionLink,
  OperatorActionLinks,
  OperatorCanvas,
  OperatorCard,
  OperatorChecks,
  OperatorChoiceButton,
  OperatorChoiceCount,
  OperatorChoiceGroup,
  OperatorChoiceLabel,
  OperatorChoiceSearch,
  OperatorChoiceToggle,
  OperatorChoiceTools,
  OperatorColumns,
  OperatorDisclosure,
  OperatorDocumentBody,
  OperatorFacts,
  OperatorFooter,
  OperatorFooterLink,
  OperatorFrame,
  OperatorHeader,
  OperatorHeaderButton,
  OperatorHeaderLink,
  OperatorMapCanvas,
  OperatorMapCircle,
  OperatorMapCoordinates,
  OperatorMapCount,
  OperatorMapEmpty,
  OperatorMapFrame,
  OperatorMapGraphic,
  OperatorMapGroup,
  OperatorMapIndex,
  OperatorMapIndexItem,
  OperatorMapLegend,
  OperatorMapLegendItem,
  OperatorMapLegendNote,
  OperatorMapPath,
  OperatorMapSummary,
  OperatorMapText,
  OperatorMasthead,
  OperatorNotice,
  OperatorPage,
  OperatorPanel,
  OperatorPanelEmpty,
  OperatorPanelGrid,
  OperatorPanelList,
  OperatorPanelListItem,
  OperatorPanelParagraph,
  OperatorPanelStatus,
  OperatorReadiness,
  OperatorRecordCopy,
  OperatorSection,
  OperatorSectionHeading,
  OperatorSectionTab,
  OperatorSectionTabs,
  OperatorSections,
  OperatorSegmentedButton,
  OperatorSegmentedGroup,
  OperatorStats,
  OperatorStatusDot,
  OperatorStatusList,
  OperatorStatusPill,
  OperatorStatusSummary,
  OperatorSteps,
  OperatorSummaryItem,
  OperatorSummaryList,
  OperatorSummaryMetadata,
  OperatorSummarySeparator,
  OperatorSummaryTag,
  OperatorSummaryTags,
  OperatorTabButton,
  OperatorTabCount,
  OperatorTabStrip,
  OperatorViewRenderer,
  operatorApplicationDocumentClasses,
  operatorViewStylexCSS
};
